/**
 * Taken from https://www.twilio.com/docs/documents/76/twilio-error-codes.json
 */
const errorCodes = [
    {
        date_created: "2020-01-15T18:56:07.000+0000",
        solutions: "* Check the other details of the debugger alert. The alert may indicate which parameter contains the unsupported value.\r\n* Update your application/configuration to ensure a URI with appropriate parameters is sent.",
        causes: '* If using the "secure" parameter, allowed values are "true" and "false". Any other value will be treated as "false" and trigger this warning.',
        description: 'Twilio parses certain standard URI parameters, such as the "transport" parameter, as well as Twilio-specific parameters such as "secure".',
        const_partition: "1",
        docs: '## WARNING - 32114\r\n\r\n### SIP: Unsupported parameter value\r\n\r\nA URI parameter contains an unsupported value and will be ignored Twilio parses certain standard URI parameters, such as the "transport" parameter, as well as Twilio-specific parameters such as "secure".\r\n\r\n#### Possible Causes\r\n* If using the "secure" parameter, allowed values are "true" and "false". Any other value will be treated as "false" and trigger this warning.\r\n\r\n#### Possible Solutions\r\n* Check the other details of the debugger alert. The alert may indicate which parameter contains the unsupported value.\r\n* Update your application/configuration to ensure a URI with appropriate parameters is sent.',
        code: 32114,
        log_level: "WARNING",
        last_updated: "2020-01-15T18:59:07.000+0000",
        message: "SIP: Unsupported parameter value",
        log_type: "APPLICATION",
        secondary_message: "A URI parameter contains an unsupported value and will be ignored",
        product: null,
    },
    {
        date_created: "2020-01-14T21:15:31.000+0000",
        solutions: "No action required.",
        causes: "Operation was canceled",
        description: "Operation was canceled",
        const_partition: "1",
        docs: "## WARNING - 45306\r\n\r\n### Meeting was canceled\r\n\r\n Operation was canceled\r\n\r\n#### Possible Causes\r\nOperation was canceled\r\n\r\n#### Possible Solutions\r\nNo action required.",
        code: 45306,
        log_level: "WARNING",
        last_updated: "2020-01-14T21:15:31.000+0000",
        message: "Meeting was canceled",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2020-01-14T21:14:37.000+0000",
        solutions: "Retry operation.",
        causes: "Inactive user",
        description: "No media response from user",
        const_partition: "1",
        docs: "## WARNING - 45305\r\n\r\n###  No answer from Participant\r\n\r\n No media response from user\r\n\r\n#### Possible Causes\r\nInactive user\r\n\r\n#### Possible Solutions\r\nRetry operation.",
        code: 45305,
        log_level: "WARNING",
        last_updated: "2020-01-14T21:14:37.000+0000",
        message: " No answer from Participant",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2020-01-14T21:13:41.000+0000",
        solutions: "Retry operation.",
        causes: "Flex encountered a timeout error",
        description: "Internal timeout error",
        const_partition: "1",
        docs: "## ERROR - 45304\r\n\r\n### Internal timeout error\r\n\r\n Internal timeout error\r\n\r\n#### Possible Causes\r\nFlex encountered a timeout error\r\n\r\n#### Possible Solutions\r\nRetry operation.",
        code: 45304,
        log_level: "ERROR",
        last_updated: "2020-01-14T21:13:41.000+0000",
        message: "Internal timeout error",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2020-01-14T21:12:48.000+0000",
        solutions: "Disconnect media and retry.",
        causes: "User was already engaged on the media channel",
        description: "User was busy and could not connect to media",
        const_partition: "1",
        docs: "## WARNING - 45303\r\n\r\n### Participant was busy\r\n\r\n User was busy and could not connect to media\r\n\r\n#### Possible Causes\r\nUser was already engaged on the media channel\r\n\r\n#### Possible Solutions\r\nDisconnect media and retry.",
        code: 45303,
        log_level: "WARNING",
        last_updated: "2020-01-14T21:12:48.000+0000",
        message: "Participant was busy",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2020-01-14T21:11:50.000+0000",
        solutions: "Please verify user connectivity and retry",
        causes: "Bad connectivity, User error",
        description: "User was disconnected from media before setting up Meeting",
        const_partition: "1",
        docs: "## WARNING - 45302\r\n\r\n### Participant was disconnected before setting up Meeting\r\n\r\n User was disconnected from media before setting up Meeting\r\n\r\n#### Possible Causes\r\nBad connectivity, User error\r\n\r\n#### Possible Solutions\r\nPlease verify user connectivity and retry",
        code: 45302,
        log_level: "WARNING",
        last_updated: "2020-01-14T21:11:50.000+0000",
        message: "Participant was disconnected before setting up Meeting",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2020-01-14T21:10:52.000+0000",
        solutions: "No further information available.",
        causes: "Flex encountered a service error when connecting to a user",
        description: "Error occurred when connecting to a user",
        const_partition: "1",
        docs: "## ERROR - 45301\r\n\r\n### Error occurred when connecting to a Meeting Participant\r\n\r\n Error occurred when connecting to a user\r\n\r\n#### Possible Causes\r\nFlex encountered a service error when connecting to a user\r\n\r\n#### Possible Solutions\r\nNo further information available.",
        code: 45301,
        log_level: "ERROR",
        last_updated: "2020-01-14T21:10:52.000+0000",
        message: "Error occurred when connecting to a Meeting Participant",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2020-01-07T20:48:23.000+0000",
        solutions: 'The required parameters for the connector are listed in the "Description" section of the connector.\r\nThe parameters should be passed inside the `<Pay>` verb.\r\n\r\nExample:\r\n```\r\n<Pay>\r\n  <Parameter name="Parameter Name" value="Parameter Value" />\r\n</Pay\r\n```',
        causes: "The connector needs a specific Parameter in the `<Pay>` verb",
        description: "A 64015 Error is an indication that the configured connector for the payment method is missing one of the Parameter needed in the `<Pay>` verb.",
        const_partition: "1",
        docs: '## ERROR - 64015\r\n\r\n### Pay: `<Pay>` verb is missing a needed Parameter\r\n\r\n A 64015 Error is an indication that the configured connector for the payment method is missing one of the Parameter needed in the `<Pay>` verb.\r\n\r\n#### Possible Causes\r\nThe connector needs a specific Parameter in the `<Pay>` verb\r\n\r\n#### Possible Solutions\r\nThe required parameters for the connector are listed in the "Description" section of the connector.\r\nThe parameters should be passed inside the `<Pay>` verb.\r\n\r\nExample:\r\n```\r\n<Pay>\r\n  <Parameter name="Parameter Name" value="Parameter Value" />\r\n</Pay\r\n```',
        code: 64015,
        log_level: "ERROR",
        last_updated: "2020-01-07T20:48:23.000+0000",
        message: "Pay: `<Pay>` verb is missing a needed Parameter",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-12-31T18:59:36.000+0000",
        solutions: "* Learn more about Alpha Sender ID registration requirements [here](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n* Use [this form](https://twiliodoer.secure.force.com/SenderId) to register a Sender ID for the destination country.\r\n* If you are sending OTP/2FA codes consider using [Twilio Verify or Authy](https://www.twilio.com/authy) which will automatically take care of all applicable registrations.\r\n* To disable these alerts please [open a support ticket](https://www.twilio.com/console/support/tickets/create).",
        causes: "* The recipient you are sending a message to is on a network that requires alphanumeric sender ID pre-registration, and our records indicate that your sender ID is not registered.",
        description: "You sent a message (message SID: SMXXXXX) to a mobile number in a country that requires Alphanumeric Sender ID pre-registration. Our records indicate that you do not have a registered Alphanumeric Sender ID for this country. This can result in lower delivery quality.\r\n\r\nIf you are sending transactional SMS (like OTP/auth codes, account-related alerts) you should pre-register for the best possible delivery quality.",
        const_partition: "1",
        docs: "## WARNING - 30018\r\n\r\n### Destination carrier requires sender ID pre-registration\r\n\r\n You sent a message (message SID: SMXXXXX) to a mobile number in a country that requires Alphanumeric Sender ID pre-registration. Our records indicate that you do not have a registered Alphanumeric Sender ID for this country. This can result in lower delivery quality.\r\n\r\nIf you are sending transactional SMS (like OTP/auth codes, account-related alerts) you should pre-register for the best possible delivery quality.\r\n\r\n#### Possible Causes\r\n* The recipient you are sending a message to is on a network that requires alphanumeric sender ID pre-registration, and our records indicate that your sender ID is not registered.\r\n\r\n#### Possible Solutions\r\n* Learn more about Alpha Sender ID registration requirements [here](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n* Use [this form](https://twiliodoer.secure.force.com/SenderId) to register a Sender ID for the destination country.\r\n* If you are sending OTP/2FA codes consider using [Twilio Verify or Authy](https://www.twilio.com/authy) which will automatically take care of all applicable registrations.\r\n* To disable these alerts please [open a support ticket](https://www.twilio.com/console/support/tickets/create).",
        code: 30018,
        log_level: "WARNING",
        last_updated: "2020-01-15T21:17:30.000+0000",
        message: "Destination carrier requires sender ID pre-registration",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-12-30T18:13:28.000+0000",
        solutions: "Update your API key permissions",
        causes: "SendGrid API key have no send emails privileges",
        description: "SendGrid Authenticated user is not authorized to send mail",
        const_partition: "1",
        docs: "## ERROR - 60604\r\n\r\n### SendGrid Authenticated user is not authorized to send mail\r\n\r\nSendGrid Authenticated user is not authorized to send mail SendGrid Authenticated user is not authorized to send mail\r\n\r\n#### Possible Causes\r\nSendGrid API key have no send emails privileges\r\n\r\n#### Possible Solutions\r\nUpdate your API key permissions",
        code: 60604,
        log_level: "ERROR",
        last_updated: "2019-12-30T18:13:28.000+0000",
        message: "SendGrid Authenticated user is not authorized to send mail",
        log_type: "APPLICATION",
        secondary_message: "SendGrid Authenticated user is not authorized to send mail",
        product: "Verify",
    },
    {
        date_created: "2019-12-30T18:04:42.000+0000",
        solutions: "Upgrade your Sendgrid subscription ",
        causes: "Sent too many emails verifications",
        description: "SendGrid maximum credits exceeded",
        const_partition: "1",
        docs: "## ERROR - 60603\r\n\r\n### SendGrid maximum credits exceeded\r\n\r\nSendGrid maximum credits exceeded SendGrid maximum credits exceeded\r\n\r\n#### Possible Causes\r\nSent too many emails verifications\r\n\r\n#### Possible Solutions\r\nUpgrade your Sendgrid subscription ",
        code: 60603,
        log_level: "ERROR",
        last_updated: "2019-12-30T18:04:42.000+0000",
        message: "SendGrid maximum credits exceeded",
        log_type: "APPLICATION",
        secondary_message: "SendGrid maximum credits exceeded",
        product: "Verify",
    },
    {
        date_created: "2019-12-24T18:51:35.000+0000",
        solutions: "Ensure that the Number Type value is spelled correctly or is an acceptable Number Type in the Regulations LIST resource",
        causes: "The Number Type is malformed or is not an acceptable value.",
        description: "An invalid End-User Type is included in the request to filter the Regulations LIST resource.",
        const_partition: "1",
        docs: "## ERROR - 22213\r\n\r\n### Invalid Number Type in request\r\n\r\n An invalid End-User Type is included in the request to filter the Regulations LIST resource.\r\n\r\n#### Possible Causes\r\nThe Number Type is malformed or is not an acceptable value.\r\n\r\n#### Possible Solutions\r\nEnsure that the Number Type value is spelled correctly or is an acceptable Number Type in the Regulations LIST resource",
        code: 22213,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:51:35.000+0000",
        message: "Invalid Number Type in request",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:50:51.000+0000",
        solutions: "Ensure that the End-User Type value is spelled correctly or is present in the End-User Type LIST resource.",
        causes: "The End-User Type is malformed or is not an acceptable value.",
        description: "An invalid End-User Type is included in the request to filter the Regulations LIST resource.",
        const_partition: "1",
        docs: "## ERROR - 22212\r\n\r\n### Invalid End-User Type in request\r\n\r\n An invalid End-User Type is included in the request to filter the Regulations LIST resource.\r\n\r\n#### Possible Causes\r\nThe End-User Type is malformed or is not an acceptable value.\r\n\r\n#### Possible Solutions\r\nEnsure that the End-User Type value is spelled correctly or is present in the End-User Type LIST resource.",
        code: 22212,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:50:51.000+0000",
        message: "Invalid End-User Type in request",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:49:40.000+0000",
        solutions: "Resend the request including the FriendlyName",
        causes: "The FriendlyName is missing from the POST LIST request to create a new Supporting Document.",
        description: "The request to create a new Supporting Document instance did not contain a FriendlyName",
        const_partition: "1",
        docs: "## ERROR - 22211\r\n\r\n### Cannot create a Supporting Document with no FriendlyName\r\n\r\n The request to create a new Supporting Document instance did not contain a FriendlyName\r\n\r\n#### Possible Causes\r\nThe FriendlyName is missing from the POST LIST request to create a new Supporting Document.\r\n\r\n#### Possible Solutions\r\nResend the request including the FriendlyName",
        code: 22211,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:49:40.000+0000",
        message: "Cannot create a Supporting Document with no FriendlyName",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:48:41.000+0000",
        solutions: "Refer to the Supporting Document Types LIST resource to find the correct name type for your request.",
        causes: "Either the Type string was malformed or the Supporting Document Type name does not exist.",
        description: "A Supporting Document instance was requested to be created with no `Type` specified",
        const_partition: "1",
        docs: "## ERROR - 22210\r\n\r\n### Cannot create a Supporting Document with no Type\r\n\r\n A Supporting Document instance was requested to be created with no `Type` specified\r\n\r\n#### Possible Causes\r\nEither the Type string was malformed or the Supporting Document Type name does not exist.\r\n\r\n#### Possible Solutions\r\nRefer to the Supporting Document Types LIST resource to find the correct name type for your request.",
        code: 22210,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:48:41.000+0000",
        message: "Cannot create a Supporting Document with no Type",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:47:32.000+0000",
        solutions: "Please refer to the Supporting Documents REST Public API documentation for the update instance resource to pick from an allowed status enum list.",
        causes: "The status enum may be malformed or incorrect.",
        description: "An invalid status enum was sent in an update Supporting Document reques",
        const_partition: "1",
        docs: "## ERROR - 22209\r\n\r\n### Invalid status enum in Supporting Document update request\r\n\r\n An invalid status enum was sent in an update Supporting Document reques\r\n\r\n#### Possible Causes\r\nThe status enum may be malformed or incorrect.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Supporting Documents REST Public API documentation for the update instance resource to pick from an allowed status enum list.",
        code: 22209,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:47:32.000+0000",
        message: "Invalid status enum in Supporting Document update request",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:46:52.000+0000",
        solutions: "Send the attributes in the update request followed with a status update in another request.",
        causes: "The Supporting Documents status cannot have both the status and the attributes in the same update request.",
        description: "Both the Supporting Documents status and the attributes were present in the update request.",
        const_partition: "1",
        docs: "## ERROR - 22208\r\n\r\n### Supporting Document status and attributes cannot be updated in the same request\r\n\r\n Both the Supporting Documents status and the attributes were present in the update request.\r\n\r\n#### Possible Causes\r\nThe Supporting Documents status cannot have both the status and the attributes in the same update request.\r\n\r\n#### Possible Solutions\r\nSend the attributes in the update request followed with a status update in another request.",
        code: 22208,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:46:52.000+0000",
        message: "Supporting Document status and attributes cannot be updated in the same request",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:46:11.000+0000",
        solutions: "Check to see if the JSON is valid and resend the request.",
        causes: "The JSON was invalid.",
        description: "The attributes JSON string provided was not valid or parsing otherwise failed.",
        const_partition: "1",
        docs: "## ERROR - 22207\r\n\r\n### Unable to parse attributes JSON\r\n\r\n The attributes JSON string provided was not valid or parsing otherwise failed.\r\n\r\n#### Possible Causes\r\nThe JSON was invalid.\r\n\r\n#### Possible Solutions\r\nCheck to see if the JSON is valid and resend the request.",
        code: 22207,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:46:11.000+0000",
        message: "Unable to parse attributes JSON",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:45:30.000+0000",
        solutions: "Please refer to the Supporting Documents LIST or End-User LIST resources to find the correct Supporting Document SID or End-User SID to assign as an item to a Bundle.",
        causes: "The SID belongs to a different object group that is not allowed to be assigned as an item to a Bundle.",
        description: "The object_sid provided was not a Supporting Document Sid or an End-User Sid",
        const_partition: "1",
        docs: "## ERROR - 22206\r\n\r\n### Attempting to add invalid object type to bundle\r\n\r\n The object_sid provided was not a Supporting Document Sid or an End-User Sid\r\n\r\n#### Possible Causes\r\nThe SID belongs to a different object group that is not allowed to be assigned as an item to a Bundle.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Supporting Documents LIST or End-User LIST resources to find the correct Supporting Document SID or End-User SID to assign as an item to a Bundle.",
        code: 22206,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:45:30.000+0000",
        message: "Attempting to add invalid object type to bundle",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:44:35.000+0000",
        solutions: "Please refer to the Supporting Documents LIST or End-User LIST resources to find the correct Supporting Document SID or End-User SID to assign as an item to a Bundle.",
        causes: "The object_sid may be malformed or belonging to a different account.",
        description: "You are attempting to add an invalid object_sid to the Bundle.",
        const_partition: "1",
        docs: "## ERROR - 22205\r\n\r\n### Attempting to assign invalid object_sid to Bundle\r\n\r\n You are attempting to add an invalid object_sid to the Bundle.\r\n\r\n#### Possible Causes\r\nThe object_sid may be malformed or belonging to a different account.\r\n\r\n#### Possible Solutions\r\nPlease refer to the Supporting Documents LIST or End-User LIST resources to find the correct Supporting Document SID or End-User SID to assign as an item to a Bundle.",
        code: 22205,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:44:35.000+0000",
        message: "Attempting to assign invalid object_sid to Bundle",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:43:46.000+0000",
        solutions: "Remove the status update parameter or remove the property update(s) in the request.",
        causes: "Status update and a property update are in the same request",
        description: "Bundle status and properties cannot be updated in the same request",
        const_partition: "1",
        docs: "## ERROR - 22204\r\n\r\n### Bundle status and properties cannot be updated in the same request\r\n\r\n Bundle status and properties cannot be updated in the same request\r\n\r\n#### Possible Causes\r\nStatus update and a property update are in the same request\r\n\r\n#### Possible Solutions\r\nRemove the status update parameter or remove the property update(s) in the request.",
        code: 22204,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:43:46.000+0000",
        message: "Bundle status and properties cannot be updated in the same request",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:42:45.000+0000",
        solutions: "Refer to the Bundle REST API status section for which statuses you are able to choose from.",
        causes: "Bundle status is not a valid option from the enum values",
        description: "Bundle Status provided by user didn't parse into the accepted enum valuesf",
        const_partition: "1",
        docs: "## ERROR - 22203\r\n\r\n### Unable to parse bundle status\r\n\r\n Bundle Status provided by user didn't parse into the accepted enum valuesf\r\n\r\n#### Possible Causes\r\nBundle status is not a valid option from the enum values\r\n\r\n#### Possible Solutions\r\nRefer to the Bundle REST API status section for which statuses you are able to choose from.",
        code: 22203,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:42:45.000+0000",
        message: "Unable to parse bundle status",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:41:59.000+0000",
        solutions: "* Please ensure you are passing a regulation sid or phone number country and type\r\n* If you need to know which regulation sid or phone number country and type to use, please refer to the Regulations REST API.",
        causes: "The regulation sid or phone number country and type are missing from the request.",
        description: "No regulation sid or phone number country and type was provided",
        const_partition: "1",
        docs: "## ERROR - 22202\r\n\r\n### No regulation sid or phone number country and type was provided\r\n\r\n No regulation sid or phone number country and type was provided\r\n\r\n#### Possible Causes\r\nThe regulation sid or phone number country and type are missing from the request.\r\n\r\n#### Possible Solutions\r\n* Please ensure you are passing a regulation sid or phone number country and type\r\n* If you need to know which regulation sid or phone number country and type to use, please refer to the Regulations REST API.",
        code: 22202,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:41:59.000+0000",
        message: "No regulation sid or phone number country and type was provided",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:40:58.000+0000",
        solutions: "Use the Regulations LIST resource with filters to find the correct Number Group.",
        causes: "The regulation sid may be misspelled or belong to another account.",
        description: "No regulation sid found for the given number group",
        const_partition: "1",
        docs: "## ERROR - 22201\r\n\r\n### No regulation sid found for the given number group\r\n\r\n No regulation sid found for the given number group\r\n\r\n#### Possible Causes\r\nThe regulation sid may be misspelled or belong to another account.\r\n\r\n#### Possible Solutions\r\nUse the Regulations LIST resource with filters to find the correct Number Group.",
        code: 22201,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:40:58.000+0000",
        message: "No regulation sid found for the given number group",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T18:39:44.000+0000",
        solutions: "Ensure that the End-User Type value or Number Type value is spelled correctly or is an acceptable value from the End-User Type LIST resource or Number Type LIST resource.",
        causes: "The End-User Type or Number Type is malformed or is not an acceptable value.",
        description: "An invalid End-User Type or Number Type is included in the request to create a Bundle.",
        const_partition: "1",
        docs: "## ERROR - 22200\r\n\r\n### Invalid End-User Type or Number Type\r\n\r\n An invalid End-User Type or Number Type is included in the request to create a Bundle.\r\n\r\n#### Possible Causes\r\nThe End-User Type or Number Type is malformed or is not an acceptable value.\r\n\r\n#### Possible Solutions\r\nEnsure that the End-User Type value or Number Type value is spelled correctly or is an acceptable value from the End-User Type LIST resource or Number Type LIST resource.",
        code: 22200,
        log_level: "ERROR",
        last_updated: "2019-12-24T18:39:44.000+0000",
        message: "Invalid End-User Type or Number Type",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-12-24T17:19:35.000+0000",
        solutions: "do not use app Hash with channel other than SMS",
        causes: "The customer is using App Hash without SMS channel",
        description: "App hash can only be used with SMS channel",
        const_partition: "1",
        docs: "## ERROR - 60602\r\n\r\n### App hash can only be used with SMS channel\r\n\r\nApp hash can only be used with SMS channel App hash can only be used with SMS channel\r\n\r\n#### Possible Causes\r\nThe customer is using App Hash without SMS channel\r\n\r\n#### Possible Solutions\r\ndo not use app Hash with channel other than SMS",
        code: 60602,
        log_level: "ERROR",
        last_updated: "2019-12-24T17:20:58.000+0000",
        message: "App hash can only be used with SMS channel",
        log_type: "APPLICATION",
        secondary_message: "App hash can only be used with SMS channel",
        product: "Verify",
    },
    {
        date_created: "2019-12-11T23:12:34.000+0000",
        solutions: "CPS limits may be too low",
        causes: "The call timed out before system could complete the call",
        description: "The call timed out before system could complete the call",
        const_partition: "1",
        docs: "## ERROR - 22001\r\n\r\n### Call timed out\r\n\r\n The call timed out before system could complete the call\r\n\r\n#### Possible Causes\r\nThe call timed out before system could complete the call\r\n\r\n#### Possible Solutions\r\nCPS limits may be too low",
        code: 22001,
        log_level: "ERROR",
        last_updated: "2019-12-11T23:12:34.000+0000",
        message: "Call timed out",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-12-06T20:21:57.000+0000",
        solutions: "Contact support@twilio.com to get whitelisted.",
        causes: "Your account has not been whitelisted to create verifications towards China",
        description: "Messages to China require use case vetting, please contact support@twilio.com to get whitelisted.",
        const_partition: "1",
        docs: "## ERROR - 60220\r\n\r\n### Messages to China require use case vetting\r\n\r\n Messages to China require use case vetting, please contact support@twilio.com to get whitelisted.\r\n\r\n#### Possible Causes\r\nYour account has not been whitelisted to create verifications towards China\r\n\r\n#### Possible Solutions\r\nContact support@twilio.com to get whitelisted.",
        code: 60220,
        log_level: "ERROR",
        last_updated: "2019-12-06T20:21:57.000+0000",
        message: "Messages to China require use case vetting",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-11-27T22:14:31.000+0000",
        solutions: "Add the required placeholders",
        causes: "Missing placeholders {{twilio_code}} or {{twilio_message}}",
        description: "SendGrid Template does not contain required placeholders",
        const_partition: "1",
        docs: "## ERROR - 60219\r\n\r\n### SendGrid Template does not contain required placeholders\r\n\r\n SendGrid Template does not contain required placeholders\r\n\r\n#### Possible Causes\r\nMissing placeholders {{twilio_code}} or {{twilio_message}}\r\n\r\n#### Possible Solutions\r\nAdd the required placeholders",
        code: 60219,
        log_level: "ERROR",
        last_updated: "2019-11-27T22:14:31.000+0000",
        message: "SendGrid Template does not contain required placeholders",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-11-27T22:01:05.000+0000",
        solutions: "Log into SendGrid's dashboard and activate the template, or select a different template",
        causes: "The provided template is not active",
        description: "SendGrid Template is not active",
        const_partition: "1",
        docs: "## ERROR - 60218\r\n\r\n### SendGrid Template is not active\r\n\r\n SendGrid Template is not active\r\n\r\n#### Possible Causes\r\nThe provided template is not active\r\n\r\n#### Possible Solutions\r\nLog into SendGrid's dashboard and activate the template, or select a different template",
        code: 60218,
        log_level: "ERROR",
        last_updated: "2019-11-27T22:01:05.000+0000",
        message: "SendGrid Template is not active",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-11-27T21:52:13.000+0000",
        solutions: "Delete/update Mailers that you are not using at the moment",
        causes: "Your account has reached the max number of Mailers",
        description: "Max number of mailers per account reached",
        const_partition: "1",
        docs: "## ERROR - 60215\r\n\r\n### Max number of mailers per account reached\r\n\r\n Max number of mailers per account reached\r\n\r\n#### Possible Causes\r\nYour account has reached the max number of Mailers\r\n\r\n#### Possible Solutions\r\nDelete/update Mailers that you are not using at the moment",
        code: 60215,
        log_level: "ERROR",
        last_updated: "2019-11-27T21:52:13.000+0000",
        message: "Max number of mailers per account reached",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-11-21T19:24:40.000+0000",
        solutions: "* Ensure all Twilio numbers and Messaging Services on your account are set to use the POST method when handling incoming messages.",
        causes: "* The Incoming Message Webhook is set to the GET method for your Twilio phone number or Messaging Service.",
        description: "Message Redaction is enabled for your account. Using GET requests to handle incoming messages is not compatible with either Message Body Redaction or Phone Number Redaction.",
        const_partition: "1",
        docs: "## WARNING - 23006\r\n\r\n### Message Redaction Incompatible Configuration: Inbound Webhook GET Requests\r\n\r\n Message Redaction is enabled for your account. Using GET requests to handle incoming messages is not compatible with either Message Body Redaction or Phone Number Redaction.\r\n\r\n#### Possible Causes\r\n* The Incoming Message Webhook is set to the GET method for your Twilio phone number or Messaging Service.\r\n\r\n#### Possible Solutions\r\n* Ensure all Twilio numbers and Messaging Services on your account are set to use the POST method when handling incoming messages.",
        code: 23006,
        log_level: "WARNING",
        last_updated: "2019-12-11T01:14:43.000+0000",
        message: "Message Redaction Incompatible Configuration: Inbound Webhook GET Requests",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-11-21T19:23:09.000+0000",
        solutions: "* Disable Fallback to Long Code on your Messaging Services using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/sms/services/api).\r\n* If Fallback to Long Code functionality is needed, implement this functionality in your own application.",
        causes: "* You have Fallback to Long Code enabled on your Messaging Service. Fallback to Long Code requires Twilio to retain non-redacted phone numbers of recipients, and is incompatible with Phone Number Redaction.",
        description: "Phone Number Redaction is enabled for your account. Fallback to Long Code is not compatible with Phone Number Redaction and should be disabled.",
        const_partition: "1",
        docs: "## WARNING - 23005\r\n\r\n### Phone Number Redaction Incompatible Configuration: Fallback to Long Code\r\n\r\n Phone Number Redaction is enabled for your account. Fallback to Long Code is not compatible with Phone Number Redaction and should be disabled.\r\n\r\n#### Possible Causes\r\n* You have Fallback to Long Code enabled on your Messaging Service. Fallback to Long Code requires Twilio to retain non-redacted phone numbers of recipients, and is incompatible with Phone Number Redaction.\r\n\r\n#### Possible Solutions\r\n* Disable Fallback to Long Code on your Messaging Services using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/sms/services/api).\r\n* If Fallback to Long Code functionality is needed, implement this functionality in your own application.",
        code: 23005,
        log_level: "WARNING",
        last_updated: "2019-12-11T01:22:33.000+0000",
        message: "Phone Number Redaction Incompatible Configuration: Fallback to Long Code",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-11-21T19:22:03.000+0000",
        solutions: '* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a blacklist in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your "STOP" blacklist so they can receive messages from you again.\r\n* Once you are ready to disable Twilio\'s built-in opt-out handling and process the above keywords in your own application, please reach out to support@twilio.com to disable all Twilio keyword handling for your account, including Advanced Opt-Out.',
        causes: "* You have Advanced Opt-Out enabled on your Messaging Service. Advanced Opt-Out requires Twilio to save non-redacted phone numbers of customers who have opted out, and is incompatible with Phone Number Redaction.",
        description: "Phone Number Redaction is enabled for your account. Advanced Opt-Out is not compatible with Phone Number Redaction and should be disabled.",
        const_partition: "1",
        docs: '## WARNING - 23004\r\n\r\n### Message Redaction Incompatible Configuration: Advanced Opt-Out\r\n\r\n Phone Number Redaction is enabled for your account. Advanced Opt-Out is not compatible with Phone Number Redaction and should be disabled.\r\n\r\n#### Possible Causes\r\n* You have Advanced Opt-Out enabled on your Messaging Service. Advanced Opt-Out requires Twilio to save non-redacted phone numbers of customers who have opted out, and is incompatible with Phone Number Redaction.\r\n\r\n#### Possible Solutions\r\n* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a blacklist in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your "STOP" blacklist so they can receive messages from you again.\r\n* Once you are ready to disable Twilio\'s built-in opt-out handling and process the above keywords in your own application, please reach out to support@twilio.com to disable all Twilio keyword handling for your account, including Advanced Opt-Out.',
        code: 23004,
        log_level: "WARNING",
        last_updated: "2019-12-11T01:25:46.000+0000",
        message: "Message Redaction Incompatible Configuration: Advanced Opt-Out",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-11-21T19:20:34.000+0000",
        solutions: "* Disable Sticky Sender on your Messaging Services using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/sms/services/api).\r\n* If Sticky Sender functionality is needed, implement this functionality in your own application.",
        causes: "* You have Sticky Sender enabled on your Messaging Service. Sticky Sender requires Twilio to save the non-redacted phone numbers of recipients, and is incompatible with Phone Number Redaction.",
        description: "Phone Number Redaction is enabled for your account. Sticky Sender is not compatible with Phone Number Redaction and should be disabled.",
        const_partition: "1",
        docs: "## WARNING - 23003\r\n\r\n### Message Redaction Incompatible Configuration: Sticky Sender\r\n\r\n Phone Number Redaction is enabled for your account. Sticky Sender is not compatible with Phone Number Redaction and should be disabled.\r\n\r\n#### Possible Causes\r\n* You have Sticky Sender enabled on your Messaging Service. Sticky Sender requires Twilio to save the non-redacted phone numbers of recipients, and is incompatible with Phone Number Redaction.\r\n\r\n#### Possible Solutions\r\n* Disable Sticky Sender on your Messaging Services using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/sms/services/api).\r\n* If Sticky Sender functionality is needed, implement this functionality in your own application.",
        code: 23003,
        log_level: "WARNING",
        last_updated: "2019-12-11T01:22:39.000+0000",
        message: "Message Redaction Incompatible Configuration: Sticky Sender",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-11-21T19:18:52.000+0000",
        solutions: "* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a blacklist in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your \"STOP\" blacklist so they can receive messages from you again.\r\n* Once you are ready to disable Twilio's built-in opt-out handling and process the above keywords in your own application, please reach out to support@twilio.com to disable Twilio's built-in opt-out keyword handling for your account.",
        causes: "* Twilio is currently set to handle opt-out keywords for short code numbers on your account. Twilio's opt-out handling requires Twilio to save non-redacted phone numbers of users who have opted out, and is incompatible with Phone Number Redaction.",
        description: 'Phone Number Redaction is enabled for your account. Twilio\'s default opt-out keyword handling ("SMS STOP filtering") is not compatible with Phone Number Redaction and should be disabled.',
        const_partition: "1",
        docs: '## WARNING - 23002\r\n\r\n### Message Redaction Incompatible Configuration: Short code "STOP" filtering\r\n\r\n Phone Number Redaction is enabled for your account. Twilio\'s default opt-out keyword handling ("SMS STOP filtering") is not compatible with Phone Number Redaction and should be disabled.\r\n\r\n#### Possible Causes\r\n* Twilio is currently set to handle opt-out keywords for short code numbers on your account. Twilio\'s opt-out handling requires Twilio to save non-redacted phone numbers of users who have opted out, and is incompatible with Phone Number Redaction.\r\n\r\n#### Possible Solutions\r\n* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a blacklist in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your "STOP" blacklist so they can receive messages from you again.\r\n* Once you are ready to disable Twilio\'s built-in opt-out handling and process the above keywords in your own application, please reach out to support@twilio.com to disable Twilio\'s built-in opt-out keyword handling for your account.',
        code: 23002,
        log_level: "WARNING",
        last_updated: "2019-12-11T01:25:16.000+0000",
        message: 'Message Redaction Incompatible Configuration: Short code "STOP" filtering',
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-11-21T15:59:24.000+0000",
        solutions: "Create a SendGrid mailer and associate it with this service before using the email channel. [Detailed instructions available here.](https://www.twilio.com/docs/verify/tutorials/email)",
        causes: "No mailer is associated with the Verify Service.\r\n\r\n**Note:** Email channel is in development and will be generally available by March 2020. We will approve a select number of customers to preview the email channel before the general release. Please contact [sales@twilio.com](mailto:sales@twilio.com) to join the pilot.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 60217\r\n\r\n### Invalid Service configuration: Associate a Mailer with the Service before using the Email channel.\r\n\r\n \r\n\r\n#### Possible Causes\r\nNo mailer is associated with the Verify Service.\r\n\r\n**Note:** Email channel is in development and will be generally available by March 2020. We will approve a select number of customers to preview the email channel before the general release. Please contact [sales@twilio.com](mailto:sales@twilio.com) to join the pilot.\r\n\r\n#### Possible Solutions\r\nCreate a SendGrid mailer and associate it with this service before using the email channel. [Detailed instructions available here.](https://www.twilio.com/docs/verify/tutorials/email)",
        code: 60217,
        log_level: "ERROR",
        last_updated: "2019-11-26T20:02:12.000+0000",
        message: "Invalid Service configuration: Associate a Mailer with the Service before using the Email channel.",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-11-21T14:30:38.000+0000",
        solutions: "Check the callback URL",
        causes: "Invalid callback URL or Internal Server Error",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 52311\r\n\r\n### Delivery callback invocation failed\r\n\r\nNotify is unable to invoke the given callback \r\n\r\n#### Possible Causes\r\nInvalid callback URL or Internal Server Error\r\n\r\n#### Possible Solutions\r\nCheck the callback URL",
        code: 52311,
        log_level: "ERROR",
        last_updated: "2019-11-21T14:31:47.000+0000",
        message: "Delivery callback invocation failed",
        log_type: "TWILIO",
        secondary_message: "Notify is unable to invoke the given callback",
        product: "Notify",
    },
    {
        date_created: "2019-11-21T11:27:40.000+0000",
        solutions: "User shouldn't decline invite if he was already added to channel.",
        causes: "User was added directly to the channel and his invite was removed so he can't decline it.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 50602\r\n\r\n### Programmable Chat: Cannot decline invite when already channel member.\r\n\r\nSpecified user is already member of this channel so his invitation is not present. \r\n\r\n#### Possible Causes\r\nUser was added directly to the channel and his invite was removed so he can't decline it.\r\n\r\n#### Possible Solutions\r\nUser shouldn't decline invite if he was already added to channel.",
        code: 50602,
        log_level: "ERROR",
        last_updated: "2019-11-21T11:27:40.000+0000",
        message: "Programmable Chat: Cannot decline invite when already channel member.",
        log_type: "APPLICATION",
        secondary_message: "Specified user is already member of this channel so his invitation is not present.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-11-20T09:34:19.000+0000",
        solutions: "Confirm that the Identity passed in the request is not already invited to the intended channel.",
        causes: "User with specified Identity already invited to this Channel.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 50212\r\n\r\n### Programmable Chat: User already invited\r\n\r\nUser with specified Identity already invited to this Channel \r\n\r\n#### Possible Causes\r\nUser with specified Identity already invited to this Channel.\r\n\r\n#### Possible Solutions\r\nConfirm that the Identity passed in the request is not already invited to the intended channel.",
        code: 50212,
        log_level: "ERROR",
        last_updated: "2019-11-20T09:34:53.000+0000",
        message: "Programmable Chat: User already invited",
        log_type: "TWILIO",
        secondary_message: "User with specified Identity already invited to this Channel",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-11-15T00:21:58.000+0000",
        solutions: "- Build a new Bundle that satisfies the regulations of the phone number.\r\n- Contact Twilio Support.",
        causes: "- No Bundle was provided\r\n- No Bundle was that satisfies the locality requirement for this phone number type\r\n- Depending on the country, number type, and end-user type, the regulations will be different compared to other phone numbers",
        description: "To provision this number you must supply the Bundle with End-User information and Supporting Documents to comply with local telecom regulations. \r\n\r\nPreviously the IncomingPhoneNumbers API would let you provision the phone number without providing a Bundle, however, you are now required to pass in a BundleSid that satisfies the requirement for the phone number. This is because Twilio needs to know which Bundle containing End-User information and Supporting Documents will be assigned to the phone number to meet regulatory requirements for that country and type of phone number.",
        const_partition: "1",
        docs: "## ERROR - 21649\r\n\r\n### Phone Number Requires a Bundle\r\n\r\n To provision this number you must supply the Bundle with End-User information and Supporting Documents to comply with local telecom regulations. \r\n\r\nPreviously the IncomingPhoneNumbers API would let you provision the phone number without providing a Bundle, however, you are now required to pass in a BundleSid that satisfies the requirement for the phone number. This is because Twilio needs to know which Bundle containing End-User information and Supporting Documents will be assigned to the phone number to meet regulatory requirements for that country and type of phone number.\r\n\r\n#### Possible Causes\r\n- No Bundle was provided\r\n- No Bundle was that satisfies the locality requirement for this phone number type\r\n- Depending on the country, number type, and end-user type, the regulations will be different compared to other phone numbers\r\n\r\n#### Possible Solutions\r\n- Build a new Bundle that satisfies the regulations of the phone number.\r\n- Contact Twilio Support.",
        code: 21649,
        log_level: "ERROR",
        last_updated: "2019-11-15T04:55:19.000+0000",
        message: "Phone Number Requires a Bundle",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-11-05T18:40:31.000+0000",
        solutions: "* Flow should be updated to use only the supported trigger types for this widget\r\n* For Send To Flex widget, only incoming call and incoming chat are supported",
        causes: "* Flow was triggered by an incoming event that isn't supported for this widget",
        description: "An error occurred when Studio tried to run a widget that is not supported for the trigger type.",
        const_partition: "1",
        docs: "## WARNING - 81020\r\n\r\n### Unsupported Trigger Type\r\n\r\nStudio widget executed by unsupported trigger type An error occurred when Studio tried to run a widget that is not supported for the trigger type.\r\n\r\n#### Possible Causes\r\n* Flow was triggered by an incoming event that isn't supported for this widget\r\n\r\n#### Possible Solutions\r\n* Flow should be updated to use only the supported trigger types for this widget\r\n* For Send To Flex widget, only incoming call and incoming chat are supported",
        code: 81020,
        log_level: "WARNING",
        last_updated: "2019-11-05T18:40:31.000+0000",
        message: "Unsupported Trigger Type",
        log_type: "APPLICATION",
        secondary_message: "Studio widget executed by unsupported trigger type",
        product: "Studio",
    },
    {
        date_created: "2019-10-10T20:34:31.000+0000",
        solutions: "Turn on the device and enable RCS",
        causes: "Device is switched off",
        description: "The specified phone number cannot be reached by RBM at this time.",
        const_partition: "1",
        docs: "## ERROR - 63036\r\n\r\n### The specified phone number cannot be reached by RBM at this time.\r\n\r\n The specified phone number cannot be reached by RBM at this time.\r\n\r\n#### Possible Causes\r\nDevice is switched off\r\n\r\n#### Possible Solutions\r\nTurn on the device and enable RCS",
        code: 63036,
        log_level: "ERROR",
        last_updated: "2019-10-10T20:34:31.000+0000",
        message: "The specified phone number cannot be reached by RBM at this time.",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-10-10T20:30:35.000+0000",
        solutions: "If device is RCS capable, accept invitation to become a tester",
        causes: "Device is not RCS capable or recipient has not accepted to become a tester",
        description: "This operation is blocked because the RBM agent has not launched and the recipient has not been invited and accepted the invitation to become a tester.",
        const_partition: "1",
        docs: "## ERROR - 63035\r\n\r\n### This operation is blocked because the RBM agent has not launched and the recipient has not been invited and accepted the invitation to become a tester.\r\n\r\n This operation is blocked because the RBM agent has not launched and the recipient has not been invited and accepted the invitation to become a tester.\r\n\r\n#### Possible Causes\r\nDevice is not RCS capable or recipient has not accepted to become a tester\r\n\r\n#### Possible Solutions\r\nIf device is RCS capable, accept invitation to become a tester",
        code: 63035,
        log_level: "ERROR",
        last_updated: "2019-10-10T20:30:35.000+0000",
        message: "This operation is blocked because the RBM agent has not launched and the recipient has not been invited and accepted the invitation to become a tester.",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-10-08T18:54:28.000+0000",
        solutions: "* Try to separate out your logs into individual messages",
        causes: "* You have logged a message field that exceeds a total of 5000 allowed bytes",
        description: "A debug-event was too large to be published to Twilio Debugger.",
        const_partition: "1",
        docs: "## WARNING - 90004\r\n\r\n### Message Truncated\r\n\r\n A debug-event was too large to be published to Twilio Debugger.\r\n\r\n#### Possible Causes\r\n* You have logged a message field that exceeds a total of 5000 allowed bytes\r\n\r\n#### Possible Solutions\r\n* Try to separate out your logs into individual messages",
        code: 90004,
        log_level: "WARNING",
        last_updated: "2019-10-08T18:54:28.000+0000",
        message: "Message Truncated",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-09-30T15:35:54.000+0000",
        solutions: "Set recordingStatusCallback to a valid URL or leave blank to disable callbacks.",
        causes: "The recording status callback URL you provided is not valid.",
        description: "A recording was initiated using an invalid URL for the recordingStatusCallback parameter.\r\nThe recording will be processed, but status notifications will not be sent.",
        const_partition: "1",
        docs: "## WARNING - 13256\r\n\r\n### Invalid recordingStatusCallback URL\r\n\r\n A recording was initiated using an invalid URL for the recordingStatusCallback parameter.\r\nThe recording will be processed, but status notifications will not be sent.\r\n\r\n#### Possible Causes\r\nThe recording status callback URL you provided is not valid.\r\n\r\n#### Possible Solutions\r\nSet recordingStatusCallback to a valid URL or leave blank to disable callbacks.",
        code: 13256,
        log_level: "WARNING",
        last_updated: "2019-09-30T15:35:54.000+0000",
        message: "Invalid recordingStatusCallback URL",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-09-26T11:48:14.000+0000",
        solutions: "Please refresh your browser and retry your Webchat experience.",
        causes: "Adding a user to the Chat Channel has timed out waiting for a response from Twilio Chat.",
        description: "Adding user to Chat Channel has failed because of a timeout",
        const_partition: "1",
        docs: "## ERROR - 45209\r\n\r\n### Adding a user to the Chat Channel has timed out waiting for a response from Twilio Chat.\r\n\r\n Adding user to Chat Channel has failed because of a timeout\r\n\r\n#### Possible Causes\r\nAdding a user to the Chat Channel has timed out waiting for a response from Twilio Chat.\r\n\r\n#### Possible Solutions\r\nPlease refresh your browser and retry your Webchat experience.",
        code: 45209,
        log_level: "ERROR",
        last_updated: "2019-09-26T11:56:32.000+0000",
        message: "Adding a user to the Chat Channel has timed out waiting for a response from Twilio Chat.",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-09-26T11:43:18.000+0000",
        solutions: "Please use the existing active Chat Channel, mark the Channel as inactive by setting Channel Attributes status to 'inactive', remove the Chat Channel or use a different unique name. ",
        causes: "An Active Chat Channel already exists with this unique name - new Channel not created. ",
        description: null,
        const_partition: "1",
        docs: "## WARNING - 45208\r\n\r\n### Chat Channel with this unique name already exists\r\n\r\n \r\n\r\n#### Possible Causes\r\nAn Active Chat Channel already exists with this unique name - new Channel not created. \r\n\r\n#### Possible Solutions\r\nPlease use the existing active Chat Channel, mark the Channel as inactive by setting Channel Attributes status to 'inactive', remove the Chat Channel or use a different unique name. ",
        code: 45208,
        log_level: "WARNING",
        last_updated: "2019-09-26T11:43:18.000+0000",
        message: "Chat Channel with this unique name already exists",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-09-26T11:43:01.000+0000",
        solutions: "Please check that Agents are not part of large number of inactive Channels/Tasks, review any custom programmability you may have in Flex UI (please review Flex Documentation). You can control the Chat Channels and Members through Programmable Chat API. You can also change the Channel Limit in Twilio Programmable Chat Console but keep in mind this cannot be extended indefinitely. ",
        causes: "Flex Agents as part of standard Flex Orchestration are removed from Chat Channels once they are done working a specific Task related to a Channel. Possible cause to this error is that this orchestration is not working or Flex is unaware that the Custom Task Channel used has chat capabilities. ",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45207\r\n\r\n### Chat User per Chat Channel limit reached. User is part of too many Chat Channels.\r\n\r\n \r\n\r\n#### Possible Causes\r\nFlex Agents as part of standard Flex Orchestration are removed from Chat Channels once they are done working a specific Task related to a Channel. Possible cause to this error is that this orchestration is not working or Flex is unaware that the Custom Task Channel used has chat capabilities. \r\n\r\n#### Possible Solutions\r\nPlease check that Agents are not part of large number of inactive Channels/Tasks, review any custom programmability you may have in Flex UI (please review Flex Documentation). You can control the Chat Channels and Members through Programmable Chat API. You can also change the Channel Limit in Twilio Programmable Chat Console but keep in mind this cannot be extended indefinitely. ",
        code: 45207,
        log_level: "ERROR",
        last_updated: "2019-09-26T11:43:01.000+0000",
        message: "Chat User per Chat Channel limit reached. User is part of too many Chat Channels.",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-09-26T11:42:45.000+0000",
        solutions: "No further action is necessary however please verify your business logic to avoid duplicate requests.",
        causes: "The request could not be completed due to a conflict as the Chat User is already part of the desired Chat Channel. This is possibly related to duplicate requests to Twilio Flex.",
        description: null,
        const_partition: "1",
        docs: "## WARNING - 45206\r\n\r\n### Chat User is already a member of the Chat Channel\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request could not be completed due to a conflict as the Chat User is already part of the desired Chat Channel. This is possibly related to duplicate requests to Twilio Flex.\r\n\r\n#### Possible Solutions\r\nNo further action is necessary however please verify your business logic to avoid duplicate requests.",
        code: 45206,
        log_level: "WARNING",
        last_updated: "2019-09-26T11:42:45.000+0000",
        message: "Chat User is already a member of the Chat Channel",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-09-26T11:41:41.000+0000",
        solutions: "Please ensure you have correctly configured a Flex Flow related to your Messaging Channel (e.g. sms) and Integration Type (e.g. studio). You can use the Flex API or Flex Console to do this.",
        causes: "The Flex Flow referenced in this request or related Messaging request cannot be found.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45205\r\n\r\n### Requested Flex Flow is not found\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe Flex Flow referenced in this request or related Messaging request cannot be found.\r\n\r\n#### Possible Solutions\r\nPlease ensure you have correctly configured a Flex Flow related to your Messaging Channel (e.g. sms) and Integration Type (e.g. studio). You can use the Flex API or Flex Console to do this.",
        code: 45205,
        log_level: "ERROR",
        last_updated: "2019-09-26T11:41:41.000+0000",
        message: "Requested Flex Flow is not found",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50512\n\n### Conversations: Message media size is too large\nThe requested multimedia attachment size exceeds the allowed limit.\n\n#### Possible Causes\n* The size of multimedia attachment you are trying to send is not acceptable for this conversation.\n\n#### Possible Solutions\n* Make sure that the size of multimedia attachments co form to channel limitations. Check for media size constraints in [API documentation](https://www.twilio.com/docs/conversations/conversations-limits#media-limits).\n\n",
        code: 50512,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Message media size is too large",
        log_type: "null",
        secondary_message: "The requested multimedia attachment size exceeds the allowed limit.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50511\n\n### Conversations: Invalid message media content type\nAn invalid multimedia attachment content type was supplied.\n\n#### Possible Causes\n* The MIME content type of multimedia attachment you are trying to send is not acceptable for this conversation.\n\n#### Possible Solutions\n* Make sure that the content type of multimedia attachments conform to channel constraints. Check for accepted MIME types in [API documentation](https://www.twilio.com/docs/conversations/conversations-limits#media-limits).  \n\n",
        code: 50511,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Invalid message media content type",
        log_type: "null",
        secondary_message: "An invalid multimedia attachment content type was supplied.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50510\n\n### Conversations: Invalid message media SID\nAn invalid multimedia attachment SID was supplied for this message.\n\n#### Possible Causes\n* MediaSid parameter provided with the request does not match a valid media SID pattern (MExx).\n\n#### Possible Solutions\n* Add a valid MediaSid parameter to the API request and supply a media SID that is uploaded under your service instance.\n\n",
        code: 50510,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Invalid message media SID",
        log_type: "null",
        secondary_message: "An invalid multimedia attachment SID was supplied for this message.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50433\n\n### Conversations: Participant already exists\nThe requested Chat participant is already mapped to a conversation.\n\n#### Possible Causes\n* You are attempting to add a Programmable Chat participant to a conversation that already has another participant with the same identity.\n\n#### Possible Solutions\n* [Retrieve a list](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#read-multiple-conversationparticipant-resources) of existing participants in this conversation and remove the one with the same identity using [REST API](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#delete-a-conversationparticipant-resource).\n* Perhaps it's not an issue, and we can continue as-is. Instead of adding a new participant, reuse the existing one, potentially [update its attributes](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#update-a-conversationparticipant-resource) if necessary.\n",
        code: 50433,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Participant already exists",
        log_type: "null",
        secondary_message: "The requested Chat participant is already mapped to a conversation.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50432\n\n### Conversations: Participant not found\nThe requested conversation participant SID was not found.\n\n#### Possible Causes\n* The participant SID you are requesting does not exist in this conversation.\n\n#### Possible Solutions\n* Check that the requested participant SID is not misspelled.\n* Check that the requested participant SID was added to this conversation. Use REST API to [fetch a list](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#read-multiple-conversationparticipant-resources) of existing conversation participants.\n\n",
        code: 50432,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Participant not found",
        log_type: "null",
        secondary_message: "The requested conversation participant SID was not found.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50431\n\n### Conversations: Participant SID not provided\nConversation participant SID parameter is required but was not provided.\n\n#### Possible Causes\n* The API expected a participant SID input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add a valid participant SID parameter to the API request and confirm that it is not misspelled.\n\n",
        code: 50431,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Participant SID not provided",
        log_type: "null",
        secondary_message: "Conversation participant SID parameter is required but was not provided.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50430\n\n### Conversations: Participant is not a member of conversation\nThe requested participant is not a member of this conversation.\n\n#### Possible Causes\n* The requested participant was removed from this conversation, or was never added to it.\n* The requested participant SID is misspelled.\n* The requested participant is a member of a different conversation.\n\n#### Possible Solutions\n* Ensure that the participant is added to the conversation. Use API to [create a new participant](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#add-a-conversation-participant-sms).\n\n",
        code: 50430,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Participant is not a member of conversation",
        log_type: "null",
        secondary_message: "The requested participant is not a member of this conversation.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50418\n\n### Conversations: Non-Chat participants limit exceeded\nThe total number of SMS, WhatsApp, or other non-Chat participants in this conversation exceeds the allowed limit.\n\n#### Possible Causes\n* You are trying to add more non-Chat participants than allowed in this conversation. [Maximum number](https://www.twilio.com/docs/conversations/conversations-limits) of conversation participants is 50.\n\n#### Possible Solutions\n* Retrieve a [list of current participants](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#read-multiple-conversationparticipant-resources) in this conversation and [remove](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#delete-a-conversationparticipant-resource) the ones that are no longer required.\n\n",
        code: 50418,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Non-Chat participants limit exceeded",
        log_type: "null",
        secondary_message: "The total number of SMS, WhatsApp, or other non-Chat participants in this conversation exceeds the allowed limit.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50417\n\n### Conversations: Participants limit exceeded\nThe total number of participants in this conversation exceeds the limit.\n\n#### Possible Causes\n* You are trying to add more native Programmable Chat participants than allowed in this conversation. Maximum number of conversation participants is 100 by default, can be increased to 1000 programmatically.\n\n#### Possible Solutions\n* Increase the [maximum limit](https://www.twilio.com/docs/chat/rest/service-resource#update-a-service-resource) by using Developer Console or REST API. Up to [1000 participants](https://www.twilio.com/docs/conversations/conversations-limits) are supported.\n* Retrieve a [list of current participants](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#read-multiple-conversationparticipant-resources) in this conversation and [remove](https://www.twilio.com/docs/conversations/api/conversation-participant-resource#delete-a-conversationparticipant-resource) the ones that are no longer required.\n* Consider reusing participant identity across multiple clients, if user behavior is similar and data may be shared.\n\n",
        code: 50417,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Participants limit exceeded",
        log_type: "null",
        secondary_message: "The total number of participants in this conversation exceeds the allowed limit.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50416\n\n### Conversations: Participant and proxy address pair is already in use\nThe requested participant and proxy address pair is already registered in the system.\n\n#### Possible Causes\n* You are attempting to map a non-Chat (e.g. SMS) conversation member with participant address and proxy address that are already assigned to an active conversation. For example, there may be only one unique mapping between your conversation participant's public phone number and internal (proxying) Twilio phone number, in order to route inbound messages correctly.\n\n#### Possible Solutions\n* [Locate](https://www.twilio.com/docs/conversations/api/conversation-resource#read-multiple-conversation-resources) a conflicting active conversation that has an identical participant added to it. Either [delete](https://www.twilio.com/docs/conversations/api/conversation-resource#delete-a-conversation-resource) old conversations completely if you don't need the message history, or just remove the participant that uses these numbers in a previous conversation.\n\n",
        code: 50416,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Participant and proxy address pair is already in use",
        log_type: "null",
        secondary_message: "The requested participant and proxy address pair is already registered in the system.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50415\n\n### Conversations: Proxy address is not WhatsApp enabled sender\nThe requested participant proxy address is not a correctly configured WhatsApp number.\n\n#### Possible Causes\n* Provided MessagingBinding.ProxyAddress parameter contains a participant number that is not recognized as a valid WhatsApp number.\n\n#### Possible Solutions\n* Ensure that MessagingBinding.ProxyAddress is an [on-boarded WhatsApp number](https://www.twilio.com/docs/sms/whatsapp/api) assigned to your number pool.\n\n",
        code: 50415,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Proxy address is not WhatsApp enabled sender",
        log_type: "null",
        secondary_message: "The requested participant proxy address is not a correctly configured WhatsApp number.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50414\n\n### Conversations: Participant address type does not match proxy address type\nThe provided participant address mismatches the proxy address channel type.\n\n#### Possible Causes\n* MessagingBinding.Address and MessagingBinding.ProxyAddress passed to the API do not belong to the same communication channel.\n\n#### Possible Solutions\n* Ensure that both MessagingBinding.Address and MessagingBinding.ProxyAddress are both of the same type, e.g. both SMS or both WhatsApp.\n\n",
        code: 50414,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Participant address type does not match proxy address type",
        log_type: "null",
        secondary_message: "The provided participant address mismatches the proxy address channel type.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50413\n\n### Conversations: Account is not authorized to use proxy address\nYour account is not authorized to use the requested proxy address.\n\n#### Possible Causes\n* The provided conversation proxy address is not allowed to be used under your account.\n\n#### Possible Solutions\n* Check that MessagingBinding.ProxyAddress parameter passed to API contains a proxy address that belongs to your account. For example, use a Twilio phone number that is purchased under the same project.\n\n",
        code: 50413,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Account is not authorized to use proxy address",
        log_type: "null",
        secondary_message: "Your account is not authorized to use the requested proxy address.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50412\n\n### Conversations: Participant proxy address is empty\nThe provided participant proxy address parameter must not be empty.\n\n#### Possible Causes\n* MessagingBinding.ProxyAddress parameter provided with the request contains an empty string.\n\n#### Possible Solutions\n* Add a non-empty MessagingBinding.ProxyAddress parameter to the API request and supply a valid participant proxy address matching your desired channel, e.g. SMS, MMS or WhatsApp.\n\n",
        code: 50412,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Participant proxy address is empty",
        log_type: "null",
        secondary_message: "The provided participant proxy address parameter must not be empty.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50411\n\n### Conversations: Participant address is empty\nThe provided participant public address parameter must not be empty.\n\n#### Possible Causes\n* MessagingBinding.Address parameter provided with the request contains an empty string.\n\n#### Possible Solutions\n* Add a non-empty MessagingBinding.Address parameter to the API request and supply a valid participant address matching your desired channel, e.g. SMS, MMS or WhatsApp.\n\n",
        code: 50411,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Participant address is empty",
        log_type: "null",
        secondary_message: "The provided participant public address parameter must not be empty.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50409\n\n### Conversations: Participant address equals proxy address\nThe supplied participant address must not equal its proxy address.\n\n#### Possible Causes\n* When requesting a participant to be added to a conversation, you specified the identical participant address and its proxy address parameters.\n\n#### Possible Solutions\n* Provide a participant's public address (e.g. user's SMS/MMS number) different from a conversation proxy number (e.g. Twilio SMS/MMS number) when adding a participant to the conference.\n\n",
        code: 50409,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Participant address equals proxy address",
        log_type: "null",
        secondary_message: "The supplied participant address must not equal its proxy address.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50408\n\n### Conversations: Invalid participant proxy address\nAn invalid participant proxy address was supplied.\n\n#### Possible Causes\n* Participant MessagingBinding.ProxyAddress parameter provided with the request is not a valid conversation proxy address.\n\n#### Possible Solutions\n* Check that the length of MessagingBinding.ProxyAddress parameter does not exceed 256 characters.\n* Ensure that MessagingBinding.ProxyAddress parameter contains an address with valid syntax (e.g. SMS phone numbers must follow [E.164 format](https://www.twilio.com/docs/glossary/what-e164)).\n\n",
        code: 50408,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Invalid participant proxy address",
        log_type: "null",
        secondary_message: "An invalid participant proxy address was supplied.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50407\n\n### Conversations: Invalid messaging binding address\nAn invalid participant public address was supplied.\n\n#### Possible Causes\n* Participant MessagingBinding.Address parameter provided with the request is not a valid participant address.\n\n#### Possible Solutions\n* Check that the length of MessagingBinding.Address parameter does not exceed 256 characters.\n* Ensure that MessagingBinding.Address parameter contains an address with valid syntax (e.g. SMS phone numbers must follow [E.164 format](https://www.twilio.com/docs/glossary/what-e164)).\n\n",
        code: 50407,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Invalid messaging binding address",
        log_type: "null",
        secondary_message: "An invalid participant public address was supplied.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50373\n\n### Conversations: No Messaging Service assigned to Conversation\nThis Conversation does not have an assigned Messaging Service, therefore cannot accept non-chat participants.\n\n#### Possible Causes\n* You may be attempting to add a non-Chat participant (e.g. on SMS) to a channel from Programmable Chat. As Chat precedes the Conversations product, these channels first need to be provided a Messaging Service before they can access SMS, WhatsApp, or other channels.\n\n#### Possible Solutions\n* Update the Conversation with any existing Messaging Service SID on your account. After that, you will be able to add non-Chat participants and continue the conversation with them involved.\n  \n\n",
        code: 50373,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "No Messaging Service assigned to Conversation",
        log_type: "null",
        secondary_message: "This Conversation does not have an assigned Messaging Service, therefore cannot accept non-chat participants.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50372\n\n### Conversations: Conversation webhook URL is too long\nThe length of provided conversation webhook URL exceeds the limit.\n\n#### Possible Causes\n* Your API request contains a parameter containing the URL that is longer than 512 characters.\n\n#### Possible Solutions\n* Provide a shorter webhook URL with your API request.\n\n",
        code: 50372,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Conversation webhook URL is too long",
        log_type: "null",
        secondary_message: "The length of provided conversation webhook URL exceeds the limit.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50371\n\n### Conversations: Conversation webhook trigger not provided\nScoped webhook trigger keywords are required but were not provided.\n\n#### Possible Causes\n* The API expected at least one Configuration.Triggers input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add a one or more valid Configuration.Triggers parameters to the API request and confirm that they are not misspelled.\n\n",
        code: 50371,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Conversation webhook trigger not provided",
        log_type: "null",
        secondary_message: "Scoped webhook trigger keywords are required but were not provided.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50370\n\n### Conversations: Conversation webhook filter not provided\nScoped webhook filter parameter is required but was not provided.\n\n#### Possible Causes\n* The API expected at least one Configuration.Filters input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add one or more valid Configuration.Filters parameters to the API request and confirm that they are not misspelled.\n\n",
        code: 50370,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Conversation webhook filter not provided",
        log_type: "null",
        secondary_message: "Scoped webhook filter parameter is required but was not provided.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50369\n\n### Conversations: Conversation webhook URL not provided\nConversation webhook URL parameter is required but was not provided.\n\n#### Possible Causes\n* The API expected a Configuration.Url input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add a valid Configuration.Url parameter to the API request and confirm that it is not misspelled.\n\n",
        code: 50369,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Conversation webhook URL not provided",
        log_type: "null",
        secondary_message: "Conversation webhook URL parameter is required but was not provided.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50368\n\n### Conversations: Conversation webhook type not provided\nConversation webhook target parameter is required but was not provided.\n\n#### Possible Causes\n* The API expected a Target input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add a valid Target parameter to the API request and confirm that it is not misspelled.\n\n",
        code: 50368,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Conversation webhook type not provided",
        log_type: "null",
        secondary_message: "Conversation webhook target parameter is required but was not provided.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50367\n\n### Conversations: Invalid conversation webhook flow SID\nAn invalid conversation webhook flow SID was supplied.\n\n#### Possible Causes\n* Webhook Configuration.FlowSid parameter provided with the request does not match a valid Studio flow SID pattern (FWxx).\n\n#### Possible Solutions\n* Add a valid Configuration.FlowSid parameter to the API request and supply a Studio flow SID that exists under your account.\n\n",
        code: 50367,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Invalid conversation webhook flow SID",
        log_type: "null",
        secondary_message: "An invalid conversation webhook flow SID was supplied.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50366\n\n### Conversations: Invalid conversation webhook trigger\nAn invalid conversation webhook trigger keyword was supplied.\n\n#### Possible Causes\n* One of Configuration.Triggers keywords provided with the request is an empty string.\n* One of Configuration.Triggers keywords provided with the request exceeds the maximum length limit of 248 characters.\n\n#### Possible Solutions\n* Ensure that a list of valid Configuration.Triggers keywords are passed to the API request.\n\n",
        code: 50366,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Invalid conversation webhook trigger",
        log_type: "null",
        secondary_message: "An invalid conversation webhook trigger keyword was supplied.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50365\n\n### Conversations: Invalid conversation webhook filter\nAn invalid conversation webhook filter was supplied.\n\n#### Possible Causes\n* One of Configuration.Filters webhook parameters provided with the request does represent a valid webhook action filter.\n\n#### Possible Solutions\n* Ensure that a list of valid Configuration.Filters parameters are passed to the API request, refer to the list of [supported actions](https://www.twilio.com/docs/conversations/conversations-webhooks#webhook-action-triggers).\n\n",
        code: 50365,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Invalid conversation webhook filter",
        log_type: "null",
        secondary_message: "An invalid conversation webhook filter was supplied.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50364\n\n### Conversations: Invalid conversation webhook type\nAn invalid conversation webhook target was supplied.\n\n#### Possible Causes\n* Webhook Target parameter provided with the request does not match any of valid targets: webhook, studio, trigger.\n\n#### Possible Solutions\n* Add a valid Target parameter to the webhook API request and supply one of the supported targets.\n\n",
        code: 50364,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Invalid conversation webhook type",
        log_type: "null",
        secondary_message: "An invalid conversation webhook target was supplied.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50363\n\n### Conversations: Invalid conversation webhook SID\nAn invalid conversation webhook SID was supplied.\n\n#### Possible Causes\n* Webhook SID parameter provided with the request does not match a valid SID pattern (WHxx).\n\n#### Possible Solutions\n* Add a valid Webhook SID parameter to the API request and supply a SID that exists under your account.\n\n",
        code: 50363,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Invalid conversation webhook SID",
        log_type: "null",
        secondary_message: "An invalid conversation webhook SID was supplied.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50362\n\n### Conversations: Too many conversation webhook triggers\nThe number of keywords used to trigger the webhook configured for this conversation would have exceeded the limit.\n\n#### Possible Causes\nYou are attempting to add more than 5 keywords as triggers for this webhook.\n\n#### Possible Solutions\n* Retrieve a list of the [existing keywords](https://www.twilio.com/docs/conversations/api/conversation-scoped-webhook-resource#fetch-a-conversationscopedwebhook-resource) used as triggers and remove the ones that are redundant or obsolete.\n* Consider creating a new scoped webhook with an alternative set of trigger keywords.\n\n",
        code: 50362,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Too many conversation webhook triggers",
        log_type: "null",
        secondary_message: "The number of keywords used to trigger the webhook configured for this conversation exceeds the limit.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50361\n\n### Conversations: Too many conversation webhooks\nThe limit for conversation-scoped webhooks is five; this request would have created a sixth, and is thus rejected.\n\n#### Possible Causes\nYou may have forgotten to remove other webhooks before adding this one. Alternatively, your use-case may include scenarios requiring more than five.\n\n#### Possible Solutions\n* Retrieve a list of the [existing webhooks](https://www.twilio.com/docs/conversations/api/conversation-scoped-webhook-resource#read-multiple-conversationscopedwebhook-resources) for this conversation and [remove](https://www.twilio.com/docs/conversations/api/conversation-scoped-webhook-resource#delete-a-conversationscopedwebhook-resource) the ones that are redundant or obsolete.\n* Consider combining some of the [existing webhooks](https://www.twilio.com/docs/conversations/api/conversation-scoped-webhook-resource#read-multiple-conversationscopedwebhook-resources) and forward events to a single destination.\n* Consider using [global webhooks](https://www.twilio.com/docs/conversations/api/conversation-webhook-resource) instead of conversation-scoped hooks.\n",
        code: 50361,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Too many conversation webhooks",
        log_type: "null",
        secondary_message: "The number of webhooks configured for this conversation exceeds the limit.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50360\n\n### Conversations: Conversation webhook not found\nThe requested webhook SID was not found.\n\n#### Possible Causes\n* The conversation webhook SID you are requesting does not exist in that conversation.\n\n#### Possible Solutions\n* Check that the requested webhook SID is actually a Webhook SID, and is not misspelled (prefix should be WH).\n* Check that the requested webhook SID belongs to the targeted conversation.\n",
        code: 50360,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Conversation webhook not found",
        log_type: "null",
        secondary_message: "The requested webhook SID was not found.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50351\n\n### Conversations: Conversation SID not provided\nConversation SID parameter is required but was not provided.\n\n#### Possible Causes\nYour API request did not include a ConversationSid form parameter.\n\n#### Possible Solutions\nAdd a valid ConversationSid parameter to the API request, making sure you haven't spelled the parameter name wrong.\n\n",
        code: 50351,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Conversation SID not provided",
        log_type: "null",
        secondary_message: "Conversation SID parameter is required but was not provided.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50350\n\n### Conversations: Conversation not found\nThe requested conversation SID was not found.\n\n#### Possible Causes\nThe conversation SID you are requesting does not exist under your account.\n\n#### Possible Solutions\n* Check that you have provided a Conversation SID and not some other SID (should have the prefix CH).\n* Check that the requested conversation SID belongs to the account that your REST request has targeted.\n\n",
        code: 50350,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Conversation not found",
        log_type: "null",
        secondary_message: "The requested conversation SID was not found.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-24T00:00:00.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50342\n\n### Conversations: Messaging service does not belong to account\nThe requested messaging service SID does not belong to your account.\n\n#### Possible Causes\nYou may have copied/pasted incorrectly, or your API request targeted a different account (e.g. if you have several Projects or several Twilio accounts).\n\n#### Possible Solutions\nDouble-check the Messaging Service SID, confirming that it belongs to your account. Check whether you are authenticating against Twilio with the same account. With these matching, the request will succeed.\n\n",
        code: 50342,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Messaging service does not belong to account",
        log_type: "null",
        secondary_message: "The requested messaging service SID does not belong to your account.",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-09-20T04:53:05.000+0000",
        solutions: "* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a blacklist in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your \"STOP\" blacklist so they can receive messages from you again.\r\n* Once you are ready to disable Twilio's built-in opt-out handling and process the above keywords in your own application, please reach out to support@twilio.com to disable Twilio's built-in opt-out keyword handling for your account.",
        causes: "* Twilio is currently set to handle opt-out keywords for long code numbers on your account. Twilio's opt-out handling requires Twilio to save non-redacted phone numbers of users who have opted out, and is incompatible with Phone Number Redaction.",
        description: 'Phone Number Redaction is enabled for your account. Twilio\'s default opt-out keyword handling ("SMS STOP filtering") is not compatible with Phone Number Redaction and should be disabled.',
        const_partition: "1",
        docs: "## WARNING - 23001\r\n\r\n### Message Redaction Incompatible Configuration: Long code STOP filtering\r\n\r\n Phone Number Redaction is enabled for your account. Twilio's default opt-out keyword handling (\"SMS STOP filtering\") is not compatible with Phone Number Redaction and should be disabled.\r\n\r\n#### Possible Causes\r\n* Twilio is currently set to handle opt-out keywords for long code numbers on your account. Twilio's opt-out handling requires Twilio to save non-redacted phone numbers of users who have opted out, and is incompatible with Phone Number Redaction.\r\n\r\n#### Possible Solutions\r\n* To resolve this issue, your application needs to be able to handle [opt-out keyword messages](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) from end users.\r\n* Users who reply STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT should be added to a blacklist in your application to ensure you do not send them any further messages, unless they opt-in again.\r\n* Users who reply HELP or INFO should be sent an informational message about your application or service.\r\n* Users who reply START, YES, or UNSTOP should be removed from your \"STOP\" blacklist so they can receive messages from you again.\r\n* Once you are ready to disable Twilio's built-in opt-out handling and process the above keywords in your own application, please reach out to support@twilio.com to disable Twilio's built-in opt-out keyword handling for your account.",
        code: 23001,
        log_level: "WARNING",
        last_updated: "2019-12-11T01:25:26.000+0000",
        message: "Message Redaction Incompatible Configuration: Long code STOP filtering",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-09-19T19:38:52.000+0000",
        solutions: "* Disable PSD2 for this Verify Service\r\n* Use SMS channel",
        causes: "* Verify Service has PSD2 enabled",
        description: "Call channel is not supported when using PSD2",
        const_partition: "1",
        docs: "## ERROR - 60214\r\n\r\n### Call channel is not supported when using PSD2\r\n\r\n Call channel is not supported when using PSD2\r\n\r\n#### Possible Causes\r\n* Verify Service has PSD2 enabled\r\n\r\n#### Possible Solutions\r\n* Disable PSD2 for this Verify Service\r\n* Use SMS channel",
        code: 60214,
        log_level: "ERROR",
        last_updated: "2019-09-19T19:38:52.000+0000",
        message: "Call channel is not supported when using PSD2",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-09-16T09:03:27.000+0000",
        solutions: '* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the recordings.',
        causes: "There was an internal failure when processing your request. This action will not be retried.",
        description: "Despite our best efforts, we have failed to delete some or all of the selected recordings. The operation has been cancelled.",
        const_partition: "1",
        docs: '## ERROR - 16110\r\n\r\n### Internal failure when bulk deleting recordings from your account\r\n\r\n Despite our best efforts, we have failed to delete some or all of the selected recordings. The operation has been cancelled.\r\n\r\n#### Possible Causes\r\nThere was an internal failure when processing your request. This action will not be retried.\r\n\r\n#### Possible Solutions\r\n* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the recordings.',
        code: 16110,
        log_level: "ERROR",
        last_updated: "2019-09-16T09:03:27.000+0000",
        message: "Internal failure when bulk deleting recordings from your account",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-09-13T17:39:18.000+0000",
        solutions: "The application must register via Voice.register(...) on Android or [TwilioVoice registerWithAccessToken:deviceToken:completion:] on iOS to stop receiving cancel push notification messages.",
        causes: "The identity associated with the Twilio Voice SDK is still registered to receive cancel push notification messages.",
        description: "This version of the SDK no longer supports processing cancel push notification messages. You must register via Voice.register(...) on Android or [TwilioVoice registerWithAccessToken:deviceToken:completion:] on iOS with this version of the SDK to stop receiving cancel push notification messages. Cancellations are now handled internally and reported to you on behalf of the SDK.",
        const_partition: "1",
        docs: "## ERROR - 31302\r\n\r\n### Unsupported Cancel Message Error\r\n\r\n This version of the SDK no longer supports processing cancel push notification messages. You must register via Voice.register(...) on Android or [TwilioVoice registerWithAccessToken:deviceToken:completion:] on iOS with this version of the SDK to stop receiving cancel push notification messages. Cancellations are now handled internally and reported to you on behalf of the SDK.\r\n\r\n#### Possible Causes\r\nThe identity associated with the Twilio Voice SDK is still registered to receive cancel push notification messages.\r\n\r\n#### Possible Solutions\r\nThe application must register via Voice.register(...) on Android or [TwilioVoice registerWithAccessToken:deviceToken:completion:] on iOS to stop receiving cancel push notification messages.",
        code: 31302,
        log_level: "ERROR",
        last_updated: "2019-09-13T17:39:18.000+0000",
        message: "Unsupported Cancel Message Error",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-09-09T23:18:54.000+0000",
        solutions: "* Check if the custom plugins URL has been set correctly \r\n* The custom plugin URL must return a valid JSON object\r\nMore details [here](https://www.twilio.com/docs/flex/deploying-plugins#deploying-flex-plugins-from-your-own-cdn) for more information",
        causes: "* An invalid content type or no content being returned when we try to retrieve the plugins using the Custom Plugins URL.",
        description: "Could not fetch plugins from Provided Plugins URL",
        const_partition: "1",
        docs: "## ERROR - 90003\r\n\r\n### Unable to fetch plugins from the Custom Plugins URL\r\n\r\n Could not fetch plugins from Provided Plugins URL\r\n\r\n#### Possible Causes\r\n* An invalid content type or no content being returned when we try to retrieve the plugins using the Custom Plugins URL.\r\n\r\n#### Possible Solutions\r\n* Check if the custom plugins URL has been set correctly \r\n* The custom plugin URL must return a valid JSON object\r\nMore details [here](https://www.twilio.com/docs/flex/deploying-plugins#deploying-flex-plugins-from-your-own-cdn) for more information",
        code: 90003,
        log_level: "ERROR",
        last_updated: "2019-09-09T23:18:54.000+0000",
        message: "Unable to fetch plugins from the Custom Plugins URL",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-09-05T22:28:53.000+0000",
        solutions: "Content size should be within carrier limit",
        causes: "Content size exceeded carrier limit",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 30019\r\n\r\n### Content size exceeds carrier limit\r\n\r\nMessage failed because the size of the content associated with the message exceeded carrier limit \r\n\r\n#### Possible Causes\r\nContent size exceeded carrier limit\r\n\r\n#### Possible Solutions\r\nContent size should be within carrier limit",
        code: 30019,
        log_level: "ERROR",
        last_updated: "2019-09-05T22:30:13.000+0000",
        message: "Content size exceeds carrier limit",
        log_type: "APPLICATION",
        secondary_message: "Message failed because the size of the content associated with the message exceeded carrier limit",
        product: "Programmable SMS",
    },
    {
        date_created: "2019-09-05T21:45:40.000+0000",
        solutions: "Verify the number was entered correctly. \r\n\r\nhttps://en.wikipedia.org/wiki/E.164\r\n\r\nhttps://en.wikipedia.org/wiki/North_American_Numbering_Plan",
        causes: "Incorrect `From` number entered",
        description: "`From` number (caller ID) must be valid, assigned, and not on the do-not-originate (DNO) list.",
        const_partition: "1",
        docs: "## ERROR - 32206\r\n\r\n### SIP: Invalid From number (caller ID)\r\n\r\n `From` number (caller ID) must be valid, assigned, and not on the do-not-originate (DNO) list.\r\n\r\n#### Possible Causes\r\nIncorrect `From` number entered\r\n\r\n#### Possible Solutions\r\nVerify the number was entered correctly. \r\n\r\nhttps://en.wikipedia.org/wiki/E.164\r\n\r\nhttps://en.wikipedia.org/wiki/North_American_Numbering_Plan",
        code: 32206,
        log_level: "ERROR",
        last_updated: "2019-12-18T00:59:29.000+0000",
        message: "SIP: Invalid From number (caller ID)",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2019-09-04T18:03:23.000+0000",
        solutions: "* Send your message over a longer period of time, rather than sending in bursts",
        causes: "* Carrier is experiencing congestion in MMS traffic",
        description: "A 30017 error is an indicator that the downstream carrier is experiencing performance issues due to high traffic. During times of carrier network congestion, we re-try the request, and return this error if the request is not accepted.",
        const_partition: "1",
        docs: "## ERROR - 30017\r\n\r\n### Carrier network congestion\r\n\r\nMessage request was rejected because the carrier has high traffic. A 30017 error is an indicator that the downstream carrier is experiencing performance issues due to high traffic. During times of carrier network congestion, we re-try the request, and return this error if the request is not accepted.\r\n\r\n#### Possible Causes\r\n* Carrier is experiencing congestion in MMS traffic\r\n\r\n#### Possible Solutions\r\n* Send your message over a longer period of time, rather than sending in bursts",
        code: 30017,
        log_level: "ERROR",
        last_updated: "2019-09-04T18:03:23.000+0000",
        message: "Carrier network congestion",
        log_type: "CARRIER",
        secondary_message: "Message request was rejected because the carrier has high traffic.",
        product: "Programmable SMS",
    },
    {
        date_created: "2019-08-29T18:32:59.000+0000",
        solutions: "Use only Voice URL or embedded twiml, not both, in the request",
        causes: "Both Voice URL and embedded twiml are provided in the request",
        description: "Twiml cannot be set if Voice URL is set",
        const_partition: "1",
        docs: "## ERROR - 32019\r\n\r\n### Twiml cannot be set if Voice URL is set\r\n\r\n Twiml cannot be set if Voice URL is set\r\n\r\n#### Possible Causes\r\nBoth Voice URL and embedded twiml are provided in the request\r\n\r\n#### Possible Solutions\r\nUse only Voice URL or embedded twiml, not both, in the request",
        code: 32019,
        log_level: "ERROR",
        last_updated: "2019-08-29T18:32:59.000+0000",
        message: "Twiml cannot be set if Voice URL is set",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-08-29T18:31:19.000+0000",
        solutions: "Reduce the size of the twiml embedded in the request",
        causes: "Twiml size exceeded maximum allowed value",
        description: "Twiml size exceeded maximum allowed value",
        const_partition: "1",
        docs: "## ERROR - 32018\r\n\r\n### Twiml size exceeded maximum allowed value\r\n\r\n Twiml size exceeded maximum allowed value\r\n\r\n#### Possible Causes\r\nTwiml size exceeded maximum allowed value\r\n\r\n#### Possible Solutions\r\nReduce the size of the twiml embedded in the request",
        code: 32018,
        log_level: "ERROR",
        last_updated: "2019-08-29T18:31:19.000+0000",
        message: "Twiml size exceeded maximum allowed value",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-08-29T17:37:50.000+0000",
        solutions: "* For more information on understanding what does and does not constitute a SIP call leg, please see [Understanding SIP Call Legs](https://www.twilio.com/docs/voice/twiml/refer#understanding-call-legs).\r\n* While invoking Refer on a SIP leg is unique in that it removes Twilio from the call path, the effect of transferring a call to another party can be accomplished on all leg types by simply using the Dial verb to call the other party.",
        causes: "* Your application attempted to invoke the Refer verb on a PSTN or Twilio Client call leg.",
        description: "The Refer verb is only allowed on SIP call legs, e.g. you can refer an incoming SIP call that originate from SIP infrastructure or an outbound call to a SIP destination. Calls to or from other destinations, such as a phone number or Twilio Client cannot be referred.",
        const_partition: "1",
        docs: "## ERROR - 13801\r\n\r\n### Refer not allowed on non-SIP call legs\r\n\r\nThe Refer verb can only be invoked on a SIP call leg. The Refer verb is only allowed on SIP call legs, e.g. you can refer an incoming SIP call that originate from SIP infrastructure or an outbound call to a SIP destination. Calls to or from other destinations, such as a phone number or Twilio Client cannot be referred.\r\n\r\n#### Possible Causes\r\n* Your application attempted to invoke the Refer verb on a PSTN or Twilio Client call leg.\r\n\r\n#### Possible Solutions\r\n* For more information on understanding what does and does not constitute a SIP call leg, please see [Understanding SIP Call Legs](https://www.twilio.com/docs/voice/twiml/refer#understanding-call-legs).\r\n* While invoking Refer on a SIP leg is unique in that it removes Twilio from the call path, the effect of transferring a call to another party can be accomplished on all leg types by simply using the Dial verb to call the other party.",
        code: 13801,
        log_level: "ERROR",
        last_updated: "2019-11-21T18:32:53.000+0000",
        message: "Refer not allowed on non-SIP call legs",
        log_type: "APPLICATION",
        secondary_message: "The Refer verb can only be invoked on a SIP call leg.",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-08-23T03:55:11.000+0000",
        solutions: 'Make sure a "AVSName" Parameter element exists inside the <Pay> verb.\r\n\r\nExample:\r\n```\r\n<Pay paymentMethod="ach-debit" ...>\r\n  <Parameter name="AVSName" value="john smith" />\r\n</Pay\r\n```\r\n',
        causes: "Electronic Check Processing requires a name.",
        description: 'A 64014 Error is an indication that the provided paymentMethod attribute "ach-debit" was used, but the AVSName Parameter was not found inside the <Pay> verb.',
        const_partition: "1",
        docs: '## ERROR - 64014\r\n\r\n### Pay: ECP/ACH requires AVSName Parameter in the <Pay> verb.\r\n\r\n A 64014 Error is an indication that the provided paymentMethod attribute "ach-debit" was used, but the AVSName Parameter was not found inside the <Pay> verb.\r\n\r\n#### Possible Causes\r\nElectronic Check Processing requires a name.\r\n\r\n#### Possible Solutions\r\nMake sure a "AVSName" Parameter element exists inside the <Pay> verb.\r\n\r\nExample:\r\n```\r\n<Pay paymentMethod="ach-debit" ...>\r\n  <Parameter name="AVSName" value="john smith" />\r\n</Pay\r\n```\r\n',
        code: 64014,
        log_level: "ERROR",
        last_updated: "2019-08-23T03:55:11.000+0000",
        message: "Pay: ECP/ACH requires AVSName Parameter in the <Pay> verb.",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-08-20T19:14:59.000+0000",
        solutions: "* Ensure that you have put log messages appropriately in your plugin to reduce the number errors being published\r\n* There could be errors outside of your plugins, within Twilio that are causing it to throw errors\r\n* Use `try/catch` around methods and handle exceptions gracefully\r\n* Use `.catch` for all HTTP requests to handle exceptions gracefully",
        causes: "* Your Flex Application is sending too many errors to the Twilio Debugger\r\n* Your Flex Plugin is misconfigured causing a lot of errors to be published",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 90002\r\n\r\n### Too Many Errors\r\n\r\nYour Flex application has exceeded the publish rate limit of errors per second. Only a partial set of errors have been published instead. \r\n\r\n#### Possible Causes\r\n* Your Flex Application is sending too many errors to the Twilio Debugger\r\n* Your Flex Plugin is misconfigured causing a lot of errors to be published\r\n\r\n#### Possible Solutions\r\n* Ensure that you have put log messages appropriately in your plugin to reduce the number errors being published\r\n* There could be errors outside of your plugins, within Twilio that are causing it to throw errors\r\n* Use `try/catch` around methods and handle exceptions gracefully\r\n* Use `.catch` for all HTTP requests to handle exceptions gracefully",
        code: 90002,
        log_level: "ERROR",
        last_updated: "2019-08-20T19:14:59.000+0000",
        message: "Too Many Errors",
        log_type: "APPLICATION",
        secondary_message: "Your Flex application has exceeded the publish rate limit of errors per second. Only a partial set of errors have been published instead.",
        product: "Flex",
    },
    {
        date_created: "2019-08-19T22:20:28.000+0000",
        solutions: "Re-attempt with media of size 5 MB or less.",
        causes: "The specified message media exceeds the maximum size limit.",
        description: "The specified message media exceeds the maximum size limit. You may re-attempt with media of size 5 MB or less.",
        const_partition: "1",
        docs: "## ERROR - 63034\r\n\r\n### Media exceeds size limit\r\n\r\n The specified message media exceeds the maximum size limit. You may re-attempt with media of size 5 MB or less.\r\n\r\n#### Possible Causes\r\nThe specified message media exceeds the maximum size limit.\r\n\r\n#### Possible Solutions\r\nRe-attempt with media of size 5 MB or less.",
        code: 63034,
        log_level: "ERROR",
        last_updated: "2019-08-19T22:42:26.000+0000",
        message: "Media exceeds size limit",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-08-15T21:57:00.000+0000",
        solutions: "*",
        causes: "*",
        description: "A valid \u2018from\u2019 parameter was not passed to the \u2018supervise\u2019 instruction",
        const_partition: "1",
        docs: "## ERROR - 40148\r\n\r\n### Invalid \u2018supervise\u2019 instruction\r\n\r\n A valid \u2018from\u2019 parameter was not passed to the \u2018supervise\u2019 instruction\r\n\r\n#### Possible Causes\r\n*\r\n\r\n#### Possible Solutions\r\n*",
        code: 40148,
        log_level: "ERROR",
        last_updated: "2019-08-15T21:57:00.000+0000",
        message: "Invalid \u2018supervise\u2019 instruction",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "TaskRouter",
    },
    {
        date_created: "2019-08-14T23:43:57.000+0000",
        solutions: "Check your calling number to ensure it is valid. ",
        causes: "The calling number may be invalid",
        description: "Carrier blocked call due to calling number (caller ID) being invalid or receiving poor reputation from an analytics vendor. ",
        const_partition: "1",
        docs: "## ERROR - 32017\r\n\r\n### PSTN: Carrier blocked call due to calling number (caller ID)\r\n\r\n Carrier blocked call due to calling number (caller ID) being invalid or receiving poor reputation from an analytics vendor. \r\n\r\n#### Possible Causes\r\nThe calling number may be invalid\r\n\r\n#### Possible Solutions\r\nCheck your calling number to ensure it is valid. ",
        code: 32017,
        log_level: "ERROR",
        last_updated: "2019-08-14T23:43:57.000+0000",
        message: "PSTN: Carrier blocked call due to calling number (caller ID)",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-08-13T12:08:41.000+0000",
        solutions: 'Please reduce the scope of the composition by excluding some of the sources.\r\nIf not possible, please <a href="/help/contact">contact us</a> and provide a description of the media files you are attempting to compose.',
        causes: "Due to fixed hardware constraints, Twilio is not able to compose all the media tracks specified in the composition create request.",
        description: "The combined size of the media sources passed to the composition is too large to process.",
        const_partition: "1",
        docs: '## ERROR - 53633\r\n\r\n### Composition is too large\r\n\r\nThe composition job did not start The combined size of the media sources passed to the composition is too large to process.\r\n\r\n#### Possible Causes\r\nDue to fixed hardware constraints, Twilio is not able to compose all the media tracks specified in the composition create request.\r\n\r\n#### Possible Solutions\r\nPlease reduce the scope of the composition by excluding some of the sources.\r\nIf not possible, please <a href="/help/contact">contact us</a> and provide a description of the media files you are attempting to compose.',
        code: 53633,
        log_level: "ERROR",
        last_updated: "2019-08-13T12:08:41.000+0000",
        message: "Composition is too large",
        log_type: "APPLICATION",
        secondary_message: "The composition job did not start",
        product: "Programmable Video",
    },
    {
        date_created: "2019-08-07T00:57:57.000+0000",
        solutions: "Test your JSON response against the Actions Schema (https://carnelian-neanderthal-8008.twil.io/assets/ActionsSchema.json)",
        causes: "Actions JSON does not comply with the Actions Schema (https://carnelian-neanderthal-8008.twil.io/assets/ActionsSchema.json)",
        description: "Autopilot Actions Configured on the Task are Invalid",
        const_partition: "1",
        docs: "## ERROR - 90100\r\n\r\n### Invalid Autopilot Actions JSON\r\n\r\n Autopilot Actions Configured on the Task are Invalid\r\n\r\n#### Possible Causes\r\nActions JSON does not comply with the Actions Schema (https://carnelian-neanderthal-8008.twil.io/assets/ActionsSchema.json)\r\n\r\n#### Possible Solutions\r\nTest your JSON response against the Actions Schema (https://carnelian-neanderthal-8008.twil.io/assets/ActionsSchema.json)",
        code: 90100,
        log_level: "ERROR",
        last_updated: "2019-08-07T00:57:57.000+0000",
        message: "Invalid Autopilot Actions JSON",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Understand",
    },
    {
        date_created: "2019-07-31T10:56:23.000+0000",
        solutions: "* Verify network load",
        causes: "* The server has an upstream bandwidth restriction",
        description: null,
        const_partition: "1",
        docs: "## WARNING - 31930\r\n\r\n### Stream - Media - Buffer Overflow\r\n\r\nAudio is discarded due to a congestion control condition (restricted bandwidth) in the WebSocket upstream \r\n\r\n#### Possible Causes\r\n* The server has an upstream bandwidth restriction\r\n\r\n#### Possible Solutions\r\n* Verify network load",
        code: 31930,
        log_level: "WARNING",
        last_updated: "2019-08-06T16:04:30.000+0000",
        message: "Stream - Media - Buffer Overflow",
        log_type: "APPLICATION",
        secondary_message: "Audio is discarded due to a congestion control condition (restricted bandwidth) in the WebSocket upstream",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-31T10:56:03.000+0000",
        solutions: "* Verify the URL in TwiML is correct ",
        causes: "* URL schema is malformed",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 31923\r\n\r\n### Stream - WebSocket - Malformed URL\r\n\r\n \r\n\r\n#### Possible Causes\r\n* URL schema is malformed\r\n\r\n#### Possible Solutions\r\n* Verify the URL in TwiML is correct ",
        code: 31923,
        log_level: "ERROR",
        last_updated: "2019-08-06T16:04:00.000+0000",
        message: "Stream - WebSocket - Malformed URL",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-31T10:55:53.000+0000",
        solutions: "* Verify the schema in TwiML URL is wss",
        causes: "* URL schema is not supported",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 31922\r\n\r\n### Stream - WebSocket - URL Schema Not Supported\r\n\r\nThe URL schema is not supported by Programmable Streams \r\n\r\n#### Possible Causes\r\n* URL schema is not supported\r\n\r\n#### Possible Solutions\r\n* Verify the schema in TwiML URL is wss",
        code: 31922,
        log_level: "ERROR",
        last_updated: "2019-08-06T16:03:54.000+0000",
        message: "Stream - WebSocket - URL Schema Not Supported",
        log_type: "APPLICATION",
        secondary_message: "The URL schema is not supported by Programmable Streams",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-31T10:55:41.000+0000",
        solutions: "* Verify related error logs in server application",
        causes: "* The server found an internal error",
        description: "See next references for more details:\r\n* https://tools.ietf.org/html/rfc6455#section-7.4.1\r\n* https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent",
        const_partition: "1",
        docs: "## ERROR - 31921\r\n\r\n### Stream - WebSocket - Close Error\r\n\r\nThe server has closed the WebSocket connection due to protocol error See next references for more details:\r\n* https://tools.ietf.org/html/rfc6455#section-7.4.1\r\n* https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent\r\n\r\n#### Possible Causes\r\n* The server found an internal error\r\n\r\n#### Possible Solutions\r\n* Verify related error logs in server application",
        code: 31921,
        log_level: "ERROR",
        last_updated: "2019-08-06T16:03:51.000+0000",
        message: "Stream - WebSocket - Close Error",
        log_type: "APPLICATION",
        secondary_message: "The server has closed the WebSocket connection due to protocol error",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-31T10:55:22.000+0000",
        solutions: "* Verify WebSocket protocol is enabled in the server\r\n* Verify the path in TwiML URL is actually the one supporting WebSocket",
        causes: "* The server does not support WebSocket\r\n* The WebSocket protocol is not enabled for the requested URL",
        description: "The server has returned an HTTP code different from 101 to the connection request sent by stream\r\n\r\nSee https://tools.ietf.org/html/rfc6455#section-4 for details.",
        const_partition: "1",
        docs: "## ERROR - 31920\r\n\r\n### Stream - WebSocket - Handshake Error\r\n\r\nThe WebSocket protocol handshake was declined by the server The server has returned an HTTP code different from 101 to the connection request sent by stream\r\n\r\nSee https://tools.ietf.org/html/rfc6455#section-4 for details.\r\n\r\n#### Possible Causes\r\n* The server does not support WebSocket\r\n* The WebSocket protocol is not enabled for the requested URL\r\n\r\n#### Possible Solutions\r\n* Verify WebSocket protocol is enabled in the server\r\n* Verify the path in TwiML URL is actually the one supporting WebSocket",
        code: 31920,
        log_level: "ERROR",
        last_updated: "2019-08-06T16:03:46.000+0000",
        message: "Stream - WebSocket - Handshake Error",
        log_type: "APPLICATION",
        secondary_message: "The WebSocket protocol handshake was declined by the server",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-31T10:55:06.000+0000",
        solutions: "* Verify the server has enabled SSL\r\n* Verify the port in TwiML URL is actually the one supporting SSL\r\n* Verify the certificate is correct and accepted by HTTP clients",
        causes: "* Server doesn\u2019t support SSL\r\n* Stream is trying to connect the wrong port\r\n* Protocol or SSL handshake has failed",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 31910\r\n\r\n### Stream - WebSocket - SSL Protocol Error\r\n\r\nThe server doesn\u2019t support SSL, can\u2019t provide a secure connection or the SSL handshake has failed \r\n\r\n#### Possible Causes\r\n* Server doesn\u2019t support SSL\r\n* Stream is trying to connect the wrong port\r\n* Protocol or SSL handshake has failed\r\n\r\n#### Possible Solutions\r\n* Verify the server has enabled SSL\r\n* Verify the port in TwiML URL is actually the one supporting SSL\r\n* Verify the certificate is correct and accepted by HTTP clients",
        code: 31910,
        log_level: "ERROR",
        last_updated: "2019-08-06T16:03:43.000+0000",
        message: "Stream - WebSocket - SSL Protocol Error",
        log_type: "APPLICATION",
        secondary_message: "The server doesn\u2019t support SSL, can\u2019t provide a secure connection or the SSL handshake has failed",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-31T10:54:15.000+0000",
        solutions: "* Verify the TwiML URL is correct\r\n* Verify server process is up and running",
        causes: "* The stream is trying to connect the wrong port\r\n* The WebSocket server is down",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 31902\r\n\r\n### Stream - WebSocket - Connection Refused\r\n\r\nThe WebSocket connection request sent by the stream is refused by the server host \r\n\r\n#### Possible Causes\r\n* The stream is trying to connect the wrong port\r\n* The WebSocket server is down\r\n\r\n#### Possible Solutions\r\n* Verify the TwiML URL is correct\r\n* Verify server process is up and running",
        code: 31902,
        log_level: "ERROR",
        last_updated: "2019-08-06T16:03:37.000+0000",
        message: "Stream - WebSocket - Connection Refused",
        log_type: "APPLICATION",
        secondary_message: "The WebSocket connection request sent by the stream is refused by the server host",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-31T10:54:00.000+0000",
        solutions: "* Verify server connectivity\r\n* Verify server process is up and running\r\n* Verify the TwiML URL is correct\r\n* Verify intermediate elements are routing traffic",
        causes: "* WebSocket server is not connected\r\n* WebSocket server is down\r\n* Bad IP address provided in the TwiML URL\r\n* Intermediate elements (like ngrok) are not routing traffic",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 31901\r\n\r\n### Stream - WebSocket - Connection Timeout\r\n\r\nThe WebSocket connection request sent by the stream didn't receive any response from the server \r\n\r\n#### Possible Causes\r\n* WebSocket server is not connected\r\n* WebSocket server is down\r\n* Bad IP address provided in the TwiML URL\r\n* Intermediate elements (like ngrok) are not routing traffic\r\n\r\n#### Possible Solutions\r\n* Verify server connectivity\r\n* Verify server process is up and running\r\n* Verify the TwiML URL is correct\r\n* Verify intermediate elements are routing traffic",
        code: 31901,
        log_level: "ERROR",
        last_updated: "2019-08-06T16:03:35.000+0000",
        message: "Stream - WebSocket - Connection Timeout",
        log_type: "APPLICATION",
        secondary_message: "The WebSocket connection request sent by the stream didn't receive any response from the server",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-31T10:52:27.000+0000",
        solutions: "Unknown",
        causes: "Unknown",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 31900\r\n\r\n### Stream - Unknown Error\r\n\r\nThis stream has failed due to an unknown cause \r\n\r\n#### Possible Causes\r\nUnknown\r\n\r\n#### Possible Solutions\r\nUnknown",
        code: 31900,
        log_level: "ERROR",
        last_updated: "2019-08-06T16:03:28.000+0000",
        message: "Stream - Unknown Error",
        log_type: "TWILIO",
        secondary_message: "This stream has failed due to an unknown cause",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-31T10:43:10.000+0000",
        solutions: "* Verify server process is up and running\r\n* Verify if there is any related connection error in the server logs\r\n* Verify the server is connected and intermediate elements are routing traffic",
        causes: "* WebSocket server is down\r\n* WebSocket server has experienced a problem causing the connection to close\r\n* Connection has been lost",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 31903\r\n\r\n### Stream - WebSocket - Connection Broken Pipe\r\n\r\nThe WebSocket connection has been abruptly closed by the server \r\n\r\n#### Possible Causes\r\n* WebSocket server is down\r\n* WebSocket server has experienced a problem causing the connection to close\r\n* Connection has been lost\r\n\r\n#### Possible Solutions\r\n* Verify server process is up and running\r\n* Verify if there is any related connection error in the server logs\r\n* Verify the server is connected and intermediate elements are routing traffic",
        code: 31903,
        log_level: "ERROR",
        last_updated: "2019-09-26T16:19:05.000+0000",
        message: "Stream - WebSocket - Connection Broken Pipe",
        log_type: "APPLICATION",
        secondary_message: "The WebSocket connection has been abruptly closed by the server",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-29T12:33:56.000+0000",
        solutions: "Increase TTL for notification or try again later",
        causes: "Notification took too much time or there are too many notifications",
        description: "Notification expired during processing",
        const_partition: "1",
        docs: "## ERROR - 52310\r\n\r\n### Notification TTL has expired\r\n\r\n Notification expired during processing\r\n\r\n#### Possible Causes\r\nNotification took too much time or there are too many notifications\r\n\r\n#### Possible Solutions\r\nIncrease TTL for notification or try again later",
        code: 52310,
        log_level: "ERROR",
        last_updated: "2019-07-29T12:33:56.000+0000",
        message: "Notification TTL has expired",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Notify",
    },
    {
        date_created: "2019-07-29T08:29:08.000+0000",
        solutions: '* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the recordings.',
        causes: "There was an internal failure when processing your request. This action will not be retried.",
        description: "Despite our best efforts, we have failed to delete some or all of the selected recordings. The operation has been cancelled.",
        const_partition: "1",
        docs: '## ERROR - 53663\r\n\r\n### Internal failure when bulk deleting recordings from your account\r\n\r\n Despite our best efforts, we have failed to delete some or all of the selected recordings. The operation has been cancelled.\r\n\r\n#### Possible Causes\r\nThere was an internal failure when processing your request. This action will not be retried.\r\n\r\n#### Possible Solutions\r\n* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the recordings.',
        code: 53663,
        log_level: "ERROR",
        last_updated: "2019-07-29T08:29:08.000+0000",
        message: "Internal failure when bulk deleting recordings from your account",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2019-07-26T17:32:32.000+0000",
        solutions: "Make sure the Connector supports the defined paymentMethod attribute.",
        causes: "The targeted Payment Connector did not support the paymentMethod. For instance, a credit card might have been supplied but the Connector did not support Credit Cards.",
        description: "A 64013 Error is an indication that the provided paymentMethod attribute was not supported by the Connector.",
        const_partition: "1",
        docs: "## ERROR - 64013\r\n\r\n### Pay: Connector does not support supplied paymentMethod attribute.\r\n\r\n A 64013 Error is an indication that the provided paymentMethod attribute was not supported by the Connector.\r\n\r\n#### Possible Causes\r\nThe targeted Payment Connector did not support the paymentMethod. For instance, a credit card might have been supplied but the Connector did not support Credit Cards.\r\n\r\n#### Possible Solutions\r\nMake sure the Connector supports the defined paymentMethod attribute.",
        code: 64013,
        log_level: "ERROR",
        last_updated: "2019-07-26T17:32:32.000+0000",
        message: "Pay: Connector does not support supplied paymentMethod attribute.",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-25T22:53:29.000+0000",
        solutions: "Skip sending messages to this user.",
        causes: "Recipient has blocked your number.",
        description: "Recipient blocked to receive message",
        const_partition: "1",
        docs: "## ERROR - 63033\r\n\r\n### Recipient blocked to receive message\r\n\r\n Recipient blocked to receive message\r\n\r\n#### Possible Causes\r\nRecipient has blocked your number.\r\n\r\n#### Possible Solutions\r\nSkip sending messages to this user.",
        code: 63033,
        log_level: "ERROR",
        last_updated: "2019-07-25T23:03:52.000+0000",
        message: "Recipient blocked to receive message",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-07-25T22:52:16.000+0000",
        solutions: "Skip sending messages to this user.",
        causes: "Failed to send message because this user's phone number is part of an experiment.",
        description: "User's number is part of an experiment",
        const_partition: "1",
        docs: "## ERROR - 63032\r\n\r\n### We cannot send this message to this user because of a WhatsApp limitation. \r\n\r\nUser's number is part of an experiment. User's number is part of an experiment\r\n\r\n#### Possible Causes\r\nFailed to send message because this user's phone number is part of an experiment.\r\n\r\n#### Possible Solutions\r\nSkip sending messages to this user.",
        code: 63032,
        log_level: "ERROR",
        last_updated: "2019-08-13T17:27:43.000+0000",
        message: "We cannot send this message to this user because of a WhatsApp limitation. ",
        log_type: "CARRIER",
        secondary_message: "User's number is part of an experiment.",
        product: "Programmable SMS",
    },
    {
        date_created: "2019-07-17T20:20:38.000+0000",
        solutions: "Enter a valid model",
        causes: "Invalid model",
        description: "## Warning - 13334\r\n\r\n### Gather: Invalid model value",
        const_partition: "1",
        docs: "## WARNING - 13334\r\n\r\n### Gather: Invalid model value\r\n\r\n ## Warning - 13334\r\n\r\n### Gather: Invalid model value\r\n\r\n#### Possible Causes\r\nInvalid model\r\n\r\n#### Possible Solutions\r\nEnter a valid model",
        code: 13334,
        log_level: "WARNING",
        last_updated: "2019-07-17T20:20:38.000+0000",
        message: "Gather: Invalid model value",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-17T20:19:01.000+0000",
        solutions: "Enter valid profanity filter",
        causes: "Profanity filter is invalid",
        description: "## Warning - 13333\r\n\r\n### Gather: Invalid profanityFilter value",
        const_partition: "1",
        docs: "## WARNING - 13333\r\n\r\n### Gather: Invalid profanityFilter value\r\n\r\n ## Warning - 13333\r\n\r\n### Gather: Invalid profanityFilter value\r\n\r\n#### Possible Causes\r\nProfanity filter is invalid\r\n\r\n#### Possible Solutions\r\nEnter valid profanity filter",
        code: 13333,
        log_level: "WARNING",
        last_updated: "2019-07-17T20:19:01.000+0000",
        message: "Gather: Invalid profanityFilter value",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-07-12T21:33:41.000+0000",
        solutions: "Correct the channels `To` destination number",
        causes: "Incorrect `To` and `From` number in channels message",
        description: "Channels message should not have same From and To number",
        const_partition: "1",
        docs: "## ERROR - 63031\r\n\r\n### Channels message cannot have same From and To\r\n\r\n Channels message should not have same From and To number\r\n\r\n#### Possible Causes\r\nIncorrect `To` and `From` number in channels message\r\n\r\n#### Possible Solutions\r\nCorrect the channels `To` destination number",
        code: 63031,
        log_level: "ERROR",
        last_updated: "2019-07-12T21:36:26.000+0000",
        message: "Channels message cannot have same From and To",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-07-08T11:50:13.000+0000",
        solutions: "Please check your request details. Flex Channel is created automatically on inbound messages and can be created by developer via Flex API for outbound use cases.",
        causes: "Flex Channel could not be found. ",
        description: null,
        const_partition: "1",
        docs: "## WARNING - 45204\r\n\r\n### Requested Flex Chat Channel is not found\r\n\r\n \r\n\r\n#### Possible Causes\r\nFlex Channel could not be found. \r\n\r\n#### Possible Solutions\r\nPlease check your request details. Flex Channel is created automatically on inbound messages and can be created by developer via Flex API for outbound use cases.",
        code: 45204,
        log_level: "WARNING",
        last_updated: "2019-09-26T11:40:53.000+0000",
        message: "Requested Flex Chat Channel is not found",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-07-08T11:49:22.000+0000",
        solutions: "Chat User is created automatically by Flex for any inbound end customer requests and automatically when an Agent connects to Flex where that Agent already does not have a Chat User. Chat User is synchronized to Identity Provider provided information (via SSO) on role and name. Please try again and ensure that the relevant Chat Users are not removed in your own implementations. ",
        causes: "Chat User related to a Chat Channel could not be found. ",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45203\r\n\r\n### Requested Chat User not found\r\n\r\n \r\n\r\n#### Possible Causes\r\nChat User related to a Chat Channel could not be found. \r\n\r\n#### Possible Solutions\r\nChat User is created automatically by Flex for any inbound end customer requests and automatically when an Agent connects to Flex where that Agent already does not have a Chat User. Chat User is synchronized to Identity Provider provided information (via SSO) on role and name. Please try again and ensure that the relevant Chat Users are not removed in your own implementations. ",
        code: 45203,
        log_level: "ERROR",
        last_updated: "2019-09-26T11:40:28.000+0000",
        message: "Requested Chat User not found",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-07-08T11:33:15.000+0000",
        solutions: "Revise and verify the configuration. If everything is as expected then contact Customer Support to review your use case.",
        causes: "A Flex component was not configured correctly.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45009\r\n\r\n### Configuration Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nA Flex component was not configured correctly.\r\n\r\n#### Possible Solutions\r\nRevise and verify the configuration. If everything is as expected then contact Customer Support to review your use case.",
        code: 45009,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:17:47.000+0000",
        message: "Configuration Error",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-07-08T11:30:06.000+0000",
        solutions: "Please verify the request details and ensure Flex setup and preconditions for this request have been met before trying again. ",
        causes: "The server is not able to process the request due to something that is perceived to be a client error (e.g. malformed request syntax or invalid request message).",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45008\r\n\r\n### Unprocessable Request\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe server is not able to process the request due to something that is perceived to be a client error (e.g. malformed request syntax or invalid request message).\r\n\r\n#### Possible Solutions\r\nPlease verify the request details and ensure Flex setup and preconditions for this request have been met before trying again. ",
        code: 45008,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:25:50.000+0000",
        message: "Unprocessable Request",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-07-08T11:27:47.000+0000",
        solutions: "Check that accessed resource is set correctly.",
        causes: "Requested resource could not be found.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45006\r\n\r\n### Resource Not Found\r\n\r\n \r\n\r\n#### Possible Causes\r\nRequested resource could not be found.\r\n\r\n#### Possible Solutions\r\nCheck that accessed resource is set correctly.",
        code: 45006,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:22:15.000+0000",
        message: "Resource Not Found",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-07-05T11:13:01.000+0000",
        solutions: '* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the compositions.',
        causes: "There was an internal failure when processing your request. This action will not be retried.",
        description: "Despite our best efforts, we have failed to delete some or all of the selected compositions. The operation has been cancelled.",
        const_partition: "1",
        docs: '## ERROR - 53617\r\n\r\n### Internal failure when bulk deleting compositions from your account\r\n\r\n Despite our best efforts, we have failed to delete some or all of the selected compositions. The operation has been cancelled.\r\n\r\n#### Possible Causes\r\nThere was an internal failure when processing your request. This action will not be retried.\r\n\r\n#### Possible Solutions\r\n* Please retry the delete operation with the same parameters.\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and which filter was used to select the compositions.',
        code: 53617,
        log_level: "ERROR",
        last_updated: "2019-07-05T11:17:25.000+0000",
        message: "Internal failure when bulk deleting compositions from your account",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2019-07-02T08:43:53.000+0000",
        solutions: "Please verify the current status of the resource to see if desired updates are already present in the system and that the request does not contain information that conflicts with the current state.",
        causes: "The request could not be completed due to a conflict with the current state of the target resource.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45007\r\n\r\n### Resource Conflict Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request could not be completed due to a conflict with the current state of the target resource.\r\n\r\n#### Possible Solutions\r\nPlease verify the current status of the resource to see if desired updates are already present in the system and that the request does not contain information that conflicts with the current state.",
        code: 45007,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:22:31.000+0000",
        message: "Resource Conflict Error",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-06-27T18:49:50.000+0000",
        solutions: "* Send template message without the media component\r\n* Check url for correctness for url previews",
        causes: "* Media message not supported with template messages\r\n* No URL to support preview",
        description: "### Media messages are not supported with template (structured) messages. Please check your message and try sending a template message without the media\r\n### URL preview messages sent with incorrect URL format",
        const_partition: "1",
        docs: "## ERROR - 63030\r\n\r\n### Unsupported parameter for type of channels message\r\n\r\n ### Media messages are not supported with template (structured) messages. Please check your message and try sending a template message without the media\r\n### URL preview messages sent with incorrect URL format\r\n\r\n#### Possible Causes\r\n* Media message not supported with template messages\r\n* No URL to support preview\r\n\r\n#### Possible Solutions\r\n* Send template message without the media component\r\n* Check url for correctness for url previews",
        code: 63030,
        log_level: "ERROR",
        last_updated: "2019-06-27T18:49:57.000+0000",
        message: "Unsupported parameter for type of channels message",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-06-17T17:49:15.000+0000",
        solutions: "* Verify that your Out-of-Session callback URL is valid and that your server is correctly processing Out-of-Session callbacks from Proxy.\r\n* Please read over the [Out-Of-Session Callback guide] (https://www.twilio.com/docs/proxy/out-session-callback-response-guide) for more detailed information.",
        causes: "* Your Out-of-Session callback URL is invalid.",
        description: "Callback to Out-of-Session handler returned a non-success status code.",
        const_partition: "1",
        docs: "## ERROR - 80913\r\n\r\n### Out-Of-Session Callback Error\r\n\r\n Callback to Out-of-Session handler returned a non-success status code.\r\n\r\n#### Possible Causes\r\n* Your Out-of-Session callback URL is invalid.\r\n\r\n#### Possible Solutions\r\n* Verify that your Out-of-Session callback URL is valid and that your server is correctly processing Out-of-Session callbacks from Proxy.\r\n* Please read over the [Out-Of-Session Callback guide] (https://www.twilio.com/docs/proxy/out-session-callback-response-guide) for more detailed information.",
        code: 80913,
        log_level: "ERROR",
        last_updated: "2019-07-30T16:45:46.000+0000",
        message: "Out-Of-Session Callback Error",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Proxy",
    },
    {
        date_created: "2019-06-17T17:28:02.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "## Error - 81019",
        code: 81019,
        log_level: "ERROR",
        last_updated: "2019-06-17T17:28:02.000+0000",
        message: "Used deprecated 2008-08-01 API",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2019-06-13T20:42:47.000+0000",
        solutions: "* If your application can use a different header name, use an X- prefixed header name, e.g. if you want to use the name `Customer-Info`, see if your application can be configured to use `X-Customer-Info` instead.",
        causes: "* SIP header name not supported on the Twilio platform.",
        description: "The SIP header you asked Twilio to stamp was omitted because it is not supported on the Twilio platform.\r\n\r\nTwilio supports extension headers beginning with an X- prefix. Your extension header name cannot begin with the prefix `X-Twilio`.",
        const_partition: "1",
        docs: "## WARNING - 32113\r\n\r\n### SIP: Header name is not allowed\r\n\r\n The SIP header you asked Twilio to stamp was omitted because it is not supported on the Twilio platform.\r\n\r\nTwilio supports extension headers beginning with an X- prefix. Your extension header name cannot begin with the prefix `X-Twilio`.\r\n\r\n#### Possible Causes\r\n* SIP header name not supported on the Twilio platform.\r\n\r\n#### Possible Solutions\r\n* If your application can use a different header name, use an X- prefixed header name, e.g. if you want to use the name `Customer-Info`, see if your application can be configured to use `X-Customer-Info` instead.",
        code: 32113,
        log_level: "WARNING",
        last_updated: "2019-07-17T01:04:24.000+0000",
        message: "SIP: Header name is not allowed",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-06-13T20:37:16.000+0000",
        solutions: "* If you are generating SIP headers from user input, ensure your application properly accounts for non-alphanumeric characters such as punctuation and whitespace, as well as international characters.",
        causes: "* If you specified headers in a SIP URI, invalid characters were most likely introduced by an escaped character. Escaped characters in SIP URIs are defined by a percent sign (%) followed by two hexadecimal digits specifying a character code.",
        description: "The header you asked Twilio to stamp was omitted because it contains illegal characters in its _value_. Including this header would have resulting in Twilio generating a message that runs contrary to the SIP specification.",
        const_partition: "1",
        docs: "## WARNING - 32112\r\n\r\n### SIP: Invalid header value\r\n\r\n The header you asked Twilio to stamp was omitted because it contains illegal characters in its _value_. Including this header would have resulting in Twilio generating a message that runs contrary to the SIP specification.\r\n\r\n#### Possible Causes\r\n* If you specified headers in a SIP URI, invalid characters were most likely introduced by an escaped character. Escaped characters in SIP URIs are defined by a percent sign (%) followed by two hexadecimal digits specifying a character code.\r\n\r\n#### Possible Solutions\r\n* If you are generating SIP headers from user input, ensure your application properly accounts for non-alphanumeric characters such as punctuation and whitespace, as well as international characters.",
        code: 32112,
        log_level: "WARNING",
        last_updated: "2019-07-17T01:02:09.000+0000",
        message: "SIP: Invalid header value",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-06-13T20:34:41.000+0000",
        solutions: "* Ensure that your SIP URI is formed correctly. Header names should generally only consist of alphanumeric characters and hyphens.",
        causes: "* If you specified headers in a SIP URI, invalid characters were most likely introduced by an escaped character. Escaped characters in SIP URIs are defined by a percent sign (%) followed by two hexadecimal digits specifying a character code.",
        description: "The header you asked Twilio to stamp was omitted because it contains illegal characters in its _name_. Including this header would have resulting in Twilio generating a message that runs contrary to the SIP specification.\r\n\r\nThe set of legal characters for a header name is defined in [RFC 3261](https://tools.ietf.org/html/rfc3261).",
        const_partition: "1",
        docs: "## WARNING - 32111\r\n\r\n### SIP: Invalid header name\r\n\r\n The header you asked Twilio to stamp was omitted because it contains illegal characters in its _name_. Including this header would have resulting in Twilio generating a message that runs contrary to the SIP specification.\r\n\r\nThe set of legal characters for a header name is defined in [RFC 3261](https://tools.ietf.org/html/rfc3261).\r\n\r\n#### Possible Causes\r\n* If you specified headers in a SIP URI, invalid characters were most likely introduced by an escaped character. Escaped characters in SIP URIs are defined by a percent sign (%) followed by two hexadecimal digits specifying a character code.\r\n\r\n#### Possible Solutions\r\n* Ensure that your SIP URI is formed correctly. Header names should generally only consist of alphanumeric characters and hyphens.",
        code: 32111,
        log_level: "WARNING",
        last_updated: "2019-07-17T01:03:03.000+0000",
        message: "SIP: Invalid header name",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-06-13T20:30:14.000+0000",
        solutions: "* If you specify SIP headers in your URI, ensure any non-alphanumeric characters in the header values are escaped. For example, to add a User-to-User header with value `0A1B2C3D;encoding=hex`, you must encode this into the URI as `User-to-User=0A1B2C3D%3Bencoding%3Dhex`.",
        causes: "* The user-portion of the URI contains invalid characters. The user-info portion allows alphanumeric characters, hyphens, underscores, and a small number of additional punctuation characters.\r\n* A URI header or parameter value contains punctuation or whitespace that is not escaped.",
        description: "Twilio cannot understand parts of your SIP URI. This may be due to invalid characters appearing in the user, params, or headers portion. While Twilio may still attempt to complete your call, the parts of the URI that are invalid will be ignored.\r\n\r\nThe format for a valid SIP URI is defined in [RFC 3261](https://tools.ietf.org/html/rfc3261).",
        const_partition: "1",
        docs: "## WARNING - 32110\r\n\r\n### SIP: URI is formatted incorrectly\r\n\r\nYour SIP URI cannot be parsed unambiguously. Twilio cannot understand parts of your SIP URI. This may be due to invalid characters appearing in the user, params, or headers portion. While Twilio may still attempt to complete your call, the parts of the URI that are invalid will be ignored.\r\n\r\nThe format for a valid SIP URI is defined in [RFC 3261](https://tools.ietf.org/html/rfc3261).\r\n\r\n#### Possible Causes\r\n* The user-portion of the URI contains invalid characters. The user-info portion allows alphanumeric characters, hyphens, underscores, and a small number of additional punctuation characters.\r\n* A URI header or parameter value contains punctuation or whitespace that is not escaped.\r\n\r\n#### Possible Solutions\r\n* If you specify SIP headers in your URI, ensure any non-alphanumeric characters in the header values are escaped. For example, to add a User-to-User header with value `0A1B2C3D;encoding=hex`, you must encode this into the URI as `User-to-User=0A1B2C3D%3Bencoding%3Dhex`.",
        code: 32110,
        log_level: "WARNING",
        last_updated: "2019-07-17T01:02:48.000+0000",
        message: "SIP: URI is formatted incorrectly",
        log_type: "APPLICATION",
        secondary_message: "Your SIP URI cannot be parsed unambiguously.",
        product: null,
    },
    {
        date_created: "2019-06-13T01:44:53.000+0000",
        solutions: "* Ensure the phone number dialed is formatted correctly.",
        causes: "* The outbound call was made with a phone number that has an invalid format.",
        description: "The provided phone number is malformed.",
        const_partition: "1",
        docs: "## ERROR - 31484\r\n\r\n### Address Incomplete\r\n\r\n The provided phone number is malformed.\r\n\r\n#### Possible Causes\r\n* The outbound call was made with a phone number that has an invalid format.\r\n\r\n#### Possible Solutions\r\n* Ensure the phone number dialed is formatted correctly.",
        code: 31484,
        log_level: "ERROR",
        last_updated: "2019-07-17T00:57:41.000+0000",
        message: "Address Incomplete",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-06-12T00:30:52.000+0000",
        solutions: "- Add an address that satisfies the locality requirement.\r\n- Contact Twilio Support.",
        causes: "- No address was provided \r\n- No address was that satisfies the locality requirement for this phone number type.\r\n- Depending on the country and number type, this may be an address in the same country or same geographic area as the number being purchased.",
        description: "To purchase this number you must supply the Address of the user of this phone number.  Previously the IncomingPhoneNumbers API would look at your account for an appropriate address, however, you are now required to pass in an AddressSid that satisfies the requirement for the phone number.  This is because Twilio needs to know which address will be operating the phone number to meet regulatory requirements for that country and type of phone number.",
        const_partition: "1",
        docs: "## ERROR - 21631\r\n\r\n### Phone Number Requires an Address\r\n\r\n To purchase this number you must supply the Address of the user of this phone number.  Previously the IncomingPhoneNumbers API would look at your account for an appropriate address, however, you are now required to pass in an AddressSid that satisfies the requirement for the phone number.  This is because Twilio needs to know which address will be operating the phone number to meet regulatory requirements for that country and type of phone number.\r\n\r\n#### Possible Causes\r\n- No address was provided \r\n- No address was that satisfies the locality requirement for this phone number type.\r\n- Depending on the country and number type, this may be an address in the same country or same geographic area as the number being purchased.\r\n\r\n#### Possible Solutions\r\n- Add an address that satisfies the locality requirement.\r\n- Contact Twilio Support.",
        code: 21631,
        log_level: "ERROR",
        last_updated: "2019-08-20T09:31:13.000+0000",
        message: "Phone Number Requires an Address",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2019-06-07T17:35:16.000+0000",
        const_partition: "1",
        docs: "## Error - 60213\r\n### A Messaging Configuration already exists for the given country\r\n\r\n#### Possible Causes\r\n* You have already configured the given country.\r\n\r\n#### Possible Solutions\r\n* Try updating the Messaging Configuration instead.",
        code: 60213,
        log_level: "ERROR",
        last_updated: "2019-06-07T17:35:16.000+0000",
        message: "A Messaging Configuration already exists for the given country",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-06-07T17:15:10.000+0000",
        const_partition: "1",
        docs: "## Error - 60212\r\n### Too many concurrent requests for phone number\r\n#### Possible Causes\r\nYour application is initiating many verifications in a short period of time for the same phone number.\r\n#### Possible Solutions\r\n* Check if your application is being the target of fraudulent traffic.\r\n* Review your implementation.",
        code: 60212,
        log_level: "ERROR",
        last_updated: "2019-06-07T17:15:10.000+0000",
        message: "Too many concurrent requests for phone number",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-05-22T22:53:50.000+0000",
        const_partition: "1",
        docs: "## Error - 53404\r\n\r\n### No supported codec\r\n\r\nRaised whenever the intersection of codecs supported by the Client and the Server (or, in peer-to-peer, the Client and another Participant) is empty.",
        code: 53404,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:53:50.000+0000",
        message: "No supported codec",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:53:08.000+0000",
        const_partition: "1",
        docs: "## Error - 53403\r\n\r\n### Server is unable to apply a remote media description\r\n\r\nRaised whenever the Server receives a remote media description but is unable to apply it.",
        code: 53403,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:53:08.000+0000",
        message: "Server is unable to apply a remote media description",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:52:32.000+0000",
        const_partition: "1",
        docs: "## Error - 53401\r\n\r\n### Server is unable to create or apply a local media description\r\n\r\nRaised whenever the Server is unable to create or apply a local media description.",
        code: 53401,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:52:32.000+0000",
        message: "Server is unable to create or apply a local media description",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:50:35.000+0000",
        const_partition: "1",
        docs: "## Error - 31604\r\n\r\n### Does Not Exist Anywhere\r\n\r\nThe requested callee does not exist anywhere.",
        code: 31604,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:50:44.000+0000",
        message: "Does Not Exist Anywhere",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:49:29.000+0000",
        const_partition: "1",
        docs: "## Error - 31603\r\n\r\n### Decline\r\n\r\nThe callee does not wish to participate in the call.",
        code: 31603,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:49:29.000+0000",
        message: "Decline",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:48:42.000+0000",
        const_partition: "1",
        docs: "## Error - 31600\r\n\r\n### Busy Everywhere \r\n\r\nAll possible destinations are busy.",
        code: 31600,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:48:42.000+0000",
        message: "Busy Everywhere",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:47:58.000+0000",
        const_partition: "1",
        docs: "## Error - 31530\r\n\r\n### DNS Resolution Error\r\n\r\nCould not connect to the server.",
        code: 31530,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:47:58.000+0000",
        message: "DNS Resolution Error",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:47:14.000+0000",
        const_partition: "1",
        docs: "## Error - 31504\r\n\r\n### Gateway Timeout \r\n\r\nThe server, while acting as a gateway or proxy, did not receive a timely response from an upstream server.",
        code: 31504,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:47:26.000+0000",
        message: "Gateway Timeout",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:46:25.000+0000",
        const_partition: "1",
        docs: "## Error - 31503\r\n\r\n### Service Unavailable\r\n\r\nThe server is currently unable to handle the request due to a temporary overloading or maintenance of the server.",
        code: 31503,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:46:25.000+0000",
        message: "Service Unavailable",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:44:55.000+0000",
        const_partition: "1",
        docs: "## Error - 31502\r\n\r\n### Bad Gateway \r\n\r\nThe server is acting as a gateway or proxy, and received an invalid response from a downstream server while attempting to fulfill the request.",
        code: 31502,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:45:42.000+0000",
        message: "Bad Gateway",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:44:23.000+0000",
        const_partition: "1",
        docs: "## Error - 31500\r\n\r\n### Internal Server Error\r\n\r\nThe server could not fulfill the request due to some unexpected condition.",
        code: 31500,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:44:23.000+0000",
        message: "Internal Server Error",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:41:43.000+0000",
        const_partition: "1",
        docs: "## Error - 31487\r\n\r\n### Request Terminated\r\n\r\nThe request has terminated as a result of a bye or cancel.",
        code: 31487,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:41:43.000+0000",
        message: "Request Terminated",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:40:25.000+0000",
        const_partition: "1",
        docs: "## Error - 31486\r\n\r\n### Busy Here\r\n\r\nThe callee is busy.",
        code: 31486,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:41:14.000+0000",
        message: "Busy Here",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:38:19.000+0000",
        const_partition: "1",
        docs: "## Error - 31481\r\n\r\n### Call/Transaction Does Not Exist \r\n\r\nThe call no longer exists.",
        code: 31481,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:38:19.000+0000",
        message: "Call/Transaction Does Not Exist",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:37:50.000+0000",
        const_partition: "1",
        docs: "## Error - 31480\r\n\r\n### Temporarily Unavailable\r\n\r\nThe callee is currently unavailable.",
        code: 31480,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:37:50.000+0000",
        message: "Temporarily Unavailable",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:34:37.000+0000",
        const_partition: "1",
        docs: "## Error - 31429\r\n\r\n### Too Many Requests\r\n\r\nToo many requests were sent in a given amount of time.",
        code: 31429,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:36:25.000+0000",
        message: "Too Many Requests",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:33:19.000+0000",
        const_partition: "1",
        docs: "## Error - 31426\r\n\r\n### Upgrade Required\r\n\r\nThis error is raised when an HTTP 426 response is received. The reason for this is most likely because of an incompatible TLS version. To mitigate this, you may need to upgrade the OS or download a more recent version of the SDK.",
        code: 31426,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:33:19.000+0000",
        message: "Upgrade Required",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:21:23.000+0000",
        const_partition: "1",
        docs: "## Error - 31409\r\n\r\n### Conflict\r\n\r\nThe request could not be processed because of a conflict in the current state of the resource. Another request may be in progress.",
        code: 31409,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:21:23.000+0000",
        message: "Conflict",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:20:33.000+0000",
        const_partition: "1",
        docs: "## Error - 31408\r\n\r\n### Request Timeout\r\n\r\nA request timeout occurred.",
        code: 31408,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:20:33.000+0000",
        message: "Request Timeout",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:12:50.000+0000",
        const_partition: "1",
        docs: "## Error - 31404\r\n\r\n### Not Found \r\n\r\nThe server has not found anything matching the request.",
        code: 31404,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:15:19.000+0000",
        message: "Not Found",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:12:20.000+0000",
        const_partition: "1",
        docs: "## Error - 31403\r\n\r\n### Forbidden\r\n\r\nThe server understood the request, but is refusing to fulfill it.",
        code: 31403,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:12:20.000+0000",
        message: "Forbidden",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-22T22:11:40.000+0000",
        const_partition: "1",
        docs: "## Error - 31400\r\n\r\n### Bad Request \r\n\r\nThe request could not be understood due to malformed syntax.",
        code: 31400,
        log_level: "ERROR",
        last_updated: "2019-05-22T22:11:40.000+0000",
        message: "Bad Request",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-16T23:55:54.000+0000",
        const_partition: "1",
        docs: "## Error - 31009\r\n\r\n### Transport error\r\n\r\nNo transport available to send or receive messages.",
        code: 31009,
        log_level: "ERROR",
        last_updated: "2019-05-16T23:57:58.000+0000",
        message: "Transport error",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-05-16T19:09:54.000+0000",
        solutions: "Please check your destination number/handset and retry the number",
        causes: "The receiver failed to download the template",
        description: "The receiver failed to download the template\r\n",
        const_partition: "1",
        docs: "## ERROR - 63029\r\n\r\n### The receiver failed to download the template\r\n\r\n The receiver failed to download the template\r\n\r\n\r\n#### Possible Causes\r\nThe receiver failed to download the template\r\n\r\n#### Possible Solutions\r\nPlease check your destination number/handset and retry the number",
        code: 63029,
        log_level: "ERROR",
        last_updated: "2019-06-25T16:55:21.000+0000",
        message: "The receiver failed to download the template",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-05-16T19:08:26.000+0000",
        const_partition: "1",
        docs: "### Number of parameters provided does not match the expected number of parameters\r\n\r\n#### Possible Causes \r\n* Number of parameters provided does not match the expected number of parameters",
        code: 63028,
        log_level: "ERROR",
        last_updated: "2019-05-16T19:08:26.000+0000",
        message: "Number of parameters provided does not match the expected number of parameters",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-05-16T19:07:17.000+0000",
        const_partition: "1",
        docs: "### Template does not exist for a language and locale\r\n\r\n#### Possible Causes \r\n* Template does not exist for a language and locale",
        code: 63027,
        log_level: "ERROR",
        last_updated: "2019-05-16T19:08:54.000+0000",
        message: "Template does not exist for a language and locale",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-05-08T15:28:24.000+0000",
        const_partition: "1",
        docs: "## Error - 60211\r\n### Bucket with the given Interval already exists\r\n#### Possible Causes\r\nYou have already configured that Max number of requests for this `Interval`\r\n#### Possible Solutions\r\n* Delete/Update Bucket that has this same `Interval`",
        code: 60211,
        log_level: "ERROR",
        last_updated: "2019-05-08T15:32:32.000+0000",
        message: "Bucket with the given Interval already exists",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-05-08T15:26:21.000+0000",
        const_partition: "1",
        docs: "## Error - 60210\r\n### Max Buckets per Rate limit reached\r\n#### Possible Causes\r\nYour Rate limit has reached the max number of Buckets\r\n#### Possible Solutions\r\n* Delete/update Buckets that you are not using at the moment\r\n* Create a new Rate limit and add the desired Buckets to the new Rate limit",
        code: 60210,
        log_level: "ERROR",
        last_updated: "2019-05-08T15:26:21.000+0000",
        message: "Max Buckets per Rate limit reached",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-05-08T15:23:07.000+0000",
        const_partition: "1",
        docs: "## Error - 60208\r\n### Rate limit with that `UniqueName` already exists\r\n#### Possible Causes\r\nYou tried to create a rate limit with a `UniqueName` that already exists for the specified service\r\n#### Possible Solutions\r\n* Use a different `UniqueName`\r\n* Create a new service and create a rate limit with the desired `UniqueName`",
        code: 60208,
        log_level: "ERROR",
        last_updated: "2019-05-08T15:23:12.000+0000",
        message: "Rate limit with that UniqueName already exists",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-05-08T15:21:08.000+0000",
        const_partition: "1",
        docs: "## Error - 60207\r\n### Max rate limits per service reached \r\n#### Possible Causes\r\nYour service has reached the max number of rate limits\r\n#### Possible Solutions\r\n* Delete/update rate limits that you are not using at the moment\r\n* Create a new service and add the desired rate limit to the new service",
        code: 60207,
        log_level: "ERROR",
        last_updated: "2019-05-08T15:21:12.000+0000",
        message: "Max rate limits per service reached ",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-05-07T22:18:42.000+0000",
        const_partition: "1",
        docs: "| Code  | Description | Explanation | Causes | Solutions |\r\n| ------  | ----------- | ----------- | ------ | --------- |\r\n| 53215  | Subscribe Rule(s) invalid | Raised by the server when a Subscribe Rule is invalid. | \u2022 An empty set of rules `[]` is not allowed. | \u2022 Ensure the set of rules has at least one rule. |\r\n| | | | \u2022 A rule containing `all` must have a value of `true` and must not contain any other expression. | \u2022 If you include `all` in a rule, the only other allowed field is `type`. |\r\n| | | | \u2022 A rule must contain a `type` field. | \u2022 Ensure every rule has a `type` field. |\r\n| | | | \u2022 If `kind` is used, it must be one of `audio`, `video` or `data`. | \u2022 Ensure `kind` is one of the valid enum values. |\r\n| | | | \u2022 A maximum of 20 rules are allowed per subscriber. | \u2022 Limit the number of rules to 20 or fewer. |",
        code: 53215,
        log_level: "ERROR",
        last_updated: "2019-05-07T22:20:34.000+0000",
        message: "Invalid Subscribe Rule(s)",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2019-05-07T18:18:07.000+0000",
        const_partition: "1",
        docs: "## Error - 60209\r\n### UniqueName format is invalid\r\n#### Possible Causes\r\n`UniqueName` only supports alphanumeric characters and `-`, `_` or `.` \r\n#### Possible Solutions\r\n* Remove unsupported characters from `UniqueName`",
        code: 60209,
        log_level: "ERROR",
        last_updated: "2019-05-08T15:24:41.000+0000",
        message: "UniqueName format is invalid",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-05-03T11:47:56.000+0000",
        const_partition: "1",
        docs: "Auth failure",
        code: 51215,
        log_level: "ERROR",
        last_updated: "2019-05-03T11:47:56.000+0000",
        message: "Twilsock: Unauthorized",
        secondary_message: "Auth failure",
        product: null,
    },
    {
        date_created: "2019-05-03T11:46:20.000+0000",
        const_partition: "1",
        docs: "Too many requests",
        code: 51202,
        log_level: "ERROR",
        last_updated: "2019-05-03T11:46:20.000+0000",
        message: "Twilsock : CPS, Too many requests",
        secondary_message: "Too many requests",
        product: null,
    },
    {
        date_created: "2019-05-03T11:45:30.000+0000",
        const_partition: "1",
        docs: "Too many connection requests for this account.",
        code: 51201,
        log_level: "ERROR",
        last_updated: "2019-05-03T11:45:30.000+0000",
        message: "Twilsock : CPS, Init per Account",
        secondary_message: "Too many connection requests for this account.",
        product: null,
    },
    {
        date_created: "2019-04-11T18:36:06.000+0000",
        const_partition: "1",
        docs: "## Error - 12301\r\n\r\n### Invalid Upload Content-Type\r\n\r\nTwilio is unable to process the Content-Type of the uploaded file. Please make sure the uploaded file is valid and supported.\r\n\r\n#### Possible Causes\r\n* Unsupported file format\r\n* File is malformed\r\n\r\n",
        code: 12301,
        log_level: "ERROR",
        last_updated: "2019-04-11T18:36:06.000+0000",
        message: "Invalid Upload Content-Type",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-04-10T21:32:19.000+0000",
        const_partition: "1",
        docs: "## Error - 21630\r\n\r\n### Cannot mutate Address that is linked to a verified Document.\r\n",
        code: 21630,
        log_level: "ERROR",
        last_updated: "2019-04-10T21:32:19.000+0000",
        message: "Cannot mutate Address that is linked to a verified Document.",
        secondary_message: "Cannot mutate Address that is linked to a verified Document.",
        product: "Phone Numbers",
    },
    {
        date_created: "2019-04-09T17:32:00.000+0000",
        const_partition: "1",
        docs: "## Error - 90000\r\n\r\n### Uncaught Flex JavaScript Exception\r\nA JavaScript error has occurred within Flex UI.\r\n\r\n#### Possible Causes\r\n* There may have been an issue initializing Flex\r\n* There may be an uncaught exception within a Flex plugin",
        code: 90000,
        log_level: "ERROR",
        last_updated: "2019-04-09T17:32:00.000+0000",
        message: "Uncaught Flex JavaScript Exception",
        secondary_message: "A client-side JavaScript exception occurred within the Flex UI",
        product: "Flex",
    },
    {
        date_created: "2019-04-09T06:47:13.000+0000",
        const_partition: "1",
        docs: "## Error - 54507\r\n\r\n### Sync: Invalid query\r\nValid query expression is expected.\r\n\r\n#### Possible Causes\r\n* You made a typo.\r\n* You've made a programming error that produces a corrupt expression (where usually the expression is valid).\r\n\r\n#### Possible Solutions\r\n* Check that you're adhering to the right format. Query expressions must be specified in infix notation in the form `field operator \"value\"`.\r\n* Check that you're using supported operators. Please review https://www.twilio.com/docs/sync/live-query for a list of supported operators and query examples examples.",
        code: 54507,
        log_level: "ERROR",
        last_updated: "2019-04-09T06:47:13.000+0000",
        message: "Invalid query",
        secondary_message: "Valid query expression is expected",
        product: "Sync",
    },
    {
        date_created: "2019-04-09T06:40:33.000+0000",
        const_partition: "1",
        docs: "## Error - 54502\r\n\r\n### Sync: Invalid index name\r\nThe specified index doesn't exist, therefore cannot be queried.\r\n\r\n#### Possible Causes\r\n* You may have made a typo.\r\n* You may have made a programming error that yields the empty string in place of a valid index name.\r\n\r\n#### Possible Solutions\r\n* Please review https://www.twilio.com/docs/sync/live-query for the currently supported list of indices, and make sure your code consumes one of those. There is no facility to create your own index today.",
        code: 54502,
        log_level: "ERROR",
        last_updated: "2019-04-09T06:40:33.000+0000",
        message: "Invalid index name",
        secondary_message: "The specified index does not exist",
        product: "Sync",
    },
    {
        date_created: "2019-03-28T17:33:55.000+0000",
        const_partition: "1",
        docs: "### Channel returned an invalid request error\r\n\r\n#### Possible Causes \r\n*   Twilio could not process your error because the channel provider failed to receive capabilities for your request.",
        code: 63011,
        log_level: "ERROR",
        last_updated: "2019-03-28T17:33:55.000+0000",
        message: "Invalid Request: Twilio encountered an error while processing your request",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-03-28T08:32:32.000+0000",
        const_partition: "1",
        docs: "## Error - 54419\r\n\r\n### Sync: Number of subscriptions per connection is over the limit\r\nAn SDK attempted to open and listen for updates for more than 2000 objects.\r\n\r\n#### Possible Causes\r\n* A programming error has generated many queries in place of one.\r\n* Your app has created too many LiveQueries over time (often a problem in single-page apps).\r\n\r\n#### Possible Solutions\r\n* Make sure you're only issuing queries for information that you need.\r\n* When your UI no longer needs a query, use the `close()` method on the LiveQuery object to unsubscribe and release the corresponding Sync resources. See the [SDK Documentation](https://www.twilio.com/docs/sync/javascript-sdk-changelog) for details.",
        code: 54419,
        log_level: "ERROR",
        last_updated: "2019-04-09T06:22:52.000+0000",
        message: "Number of subscriptions per connection is over the limit",
        secondary_message: "An SDK attempted to open and listen for updates for more than 2000 objects",
        product: "Sync",
    },
    {
        date_created: "2019-03-28T08:31:03.000+0000",
        const_partition: "1",
        docs: "## Error - 54509\r\n\r\n### Sync: Query expression contains too many operators\r\nThe query expression must contain less than 30 operators.\r\n\r\n#### Possible Causes\r\n* The query expression contains 30 or more operators, probably a user-facing edge case or a programming error.\r\n\r\n#### Possible Solutions\r\n* Rewrite the query or the code generating it to use fewer operators or issue separate queries. You can use any combination of the following operators: `and`, `or`, `in`, `eq`, `not_in`, `not_eq `, `contains`, however overall number of operators in any query expression must be less than 30.",
        code: 54509,
        log_level: "ERROR",
        last_updated: "2019-04-09T06:51:34.000+0000",
        message: "Query expression contains too many operators",
        secondary_message: "The query expression must contain less than 30 operators",
        product: "Sync",
    },
    {
        date_created: "2019-03-28T08:29:58.000+0000",
        const_partition: "1",
        docs: "## Error - 54510\r\n\r\n### Sync: Query expression contains an array with too many items\r\nAny array within query expression must contain less than 30 items.\r\n\r\n#### Possible Causes\r\n* The query expression contains an array with 30 or more elements.\r\n\r\n#### Possible Solutions\r\n* Rewrite your queries (or the code generating them) such that arrays never contain more than 30 items.",
        code: 54510,
        log_level: "ERROR",
        last_updated: "2019-04-09T06:54:29.000+0000",
        message: "Query expression contains an array with too many items",
        secondary_message: "Any array within query expression must contain less than 30 items",
        product: "Sync",
    },
    {
        date_created: "2019-03-27T23:19:38.000+0000",
        const_partition: "1",
        docs: "## Error - 60206\r\n### 'Amount' & 'Payee' params are required\r\n#### Possible Causes\r\nYour service has the `Psd2Enabled ` flag which requires you to send the 'Amount' & 'Payee' params when creating a verification\r\n#### Possible Solutions\r\n* Make sure that you send the 'Amount' & 'Payee' params\r\n* Set the `Psd2Enabled ` flag on your Verification Service to `false`.",
        code: 60206,
        log_level: "ERROR",
        last_updated: "2019-03-27T23:19:38.000+0000",
        message: "'Amount' & 'Payee' params are required",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2019-03-27T13:31:56.000+0000",
        const_partition: "1",
        docs: "## Error - 51131\r\n\r\n### Authentication failed",
        code: 51131,
        log_level: "ERROR",
        last_updated: "2019-05-17T10:03:24.000+0000",
        message: "Twilsock: Authentication failed",
        secondary_message: "N/A",
        product: null,
    },
    {
        date_created: "2019-03-27T13:31:20.000+0000",
        const_partition: "1",
        docs: "## Error - 51130\r\n\r\n### Token is invalid!",
        code: 51130,
        log_level: "ERROR",
        last_updated: "2019-05-20T08:27:32.000+0000",
        message: "Twilsock: Token is invalid!",
        secondary_message: "Token is invalid!",
        product: null,
    },
    {
        date_created: "2019-03-27T13:30:51.000+0000",
        const_partition: "1",
        docs: "## Error - 51129\r\n\r\n### Too many messages per account\r\n\r\n#### Possible Causes \r\nNumber of messages for this account is higher than expected!\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your account's limits.",
        code: 51129,
        log_level: "ERROR",
        last_updated: "2019-05-20T08:27:16.000+0000",
        message: "Twilsock: Too many messages per account",
        secondary_message: "Number of messages for this account is higher than expected!",
        product: null,
    },
    {
        date_created: "2019-03-27T13:30:16.000+0000",
        const_partition: "1",
        docs: "## Error - 51128\r\n\r\n### Too many messages per connection\r\n\r\n#### Possible Causes \r\nNumber of messages for one connection is higher than expected!\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your account's limits.",
        code: 51128,
        log_level: "ERROR",
        last_updated: "2019-05-20T08:26:12.000+0000",
        message: "Twilsock: Too many messages per connection",
        secondary_message: "Number of messages for one connection is higher than expected!",
        product: null,
    },
    {
        date_created: "2019-03-27T13:29:43.000+0000",
        const_partition: "1",
        docs: "## Error - 51127\r\n\r\n### Twilsock: PNC limit hit",
        code: 51127,
        log_level: "ERROR",
        last_updated: "2019-05-20T08:25:03.000+0000",
        message: "Twilsock: PNC limit has been",
        secondary_message: "N/A",
        product: null,
    },
    {
        date_created: "2019-03-27T13:29:14.000+0000",
        const_partition: "1",
        docs: "## Error - 51126\r\n\r\n### DNC limit has been reached",
        code: 51126,
        log_level: "ERROR",
        last_updated: "2019-05-20T08:23:01.000+0000",
        message: "Twilsock: DNC limit has been reached",
        secondary_message: "DNC limit has been reached",
        product: null,
    },
    {
        date_created: "2019-03-27T13:24:48.000+0000",
        const_partition: "1",
        docs: "## Error - 51125\r\n\r\n### Too many updates\r\n\r\n#### Possible Causes \r\nNumber of updates for this account is higher than expected!\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your account's limits.",
        code: 51125,
        log_level: "ERROR",
        last_updated: "2019-05-20T08:22:04.000+0000",
        message: "Twilsock: Too many updates",
        secondary_message: "Number of updates for this account is higher than expected!",
        product: null,
    },
    {
        date_created: "2019-03-27T13:24:10.000+0000",
        const_partition: "1",
        docs: "## Error - 51124\r\n\r\n### Too many connections\r\n\r\n#### Possible Causes \r\nNumber of connections for this account is higher than expected!\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your account's limits.",
        code: 51124,
        log_level: "ERROR",
        last_updated: "2019-05-20T07:38:58.000+0000",
        message: "Twilsock: Too many connections",
        secondary_message: "Number of connections for this account is higher than expected!",
        product: null,
    },
    {
        date_created: "2019-03-27T13:23:13.000+0000",
        const_partition: "1",
        docs: "## Error - 51123\r\n\r\n### Upstream not resolved\r\n\r\n#### Possible Causes \r\nSpecified upstream couldn't be resolved.\r\n\r\n#### Possible Solutions\r\nVerify that upstream is valid and passed correctly. ",
        code: 51123,
        log_level: "ERROR",
        last_updated: "2019-05-20T07:36:30.000+0000",
        message: "Twilsock: Upstream not resolved",
        secondary_message: "Specified upstream couldn't be resolved.",
        product: null,
    },
    {
        date_created: "2019-03-27T13:22:30.000+0000",
        const_partition: "1",
        docs: "## Error - 51122\r\n\r\n### Authentication failed\r\n\r\n#### Possible Causes \r\nMissing or wrong information provided as credentials.\r\n\r\n#### Possible Solutions\r\nConfirm your credentials are correct and being passed correctly.",
        code: 51122,
        log_level: "ERROR",
        last_updated: "2019-05-20T07:33:53.000+0000",
        message: "Twilsock: Authentication failed",
        secondary_message: "Authentication failed.",
        product: null,
    },
    {
        date_created: "2019-03-27T13:21:21.000+0000",
        const_partition: "1",
        docs: "## Error - 51121\r\n\r\n### Token expiration time exceeds maximum\r\n\r\n#### Possible Causes \r\nToken expiration time exceeds max allowed amount.\r\n\r\n#### Possible Solutions\r\nUse a proper expiration time to fit into the allowed range.\r\n\r\nTo check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51121,
        log_level: "ERROR",
        last_updated: "2019-05-20T08:29:03.000+0000",
        message: "Twilsock: Token expiration time exceeds maximum",
        secondary_message: "Token expiration time exceeds max allowed amount.",
        product: null,
    },
    {
        date_created: "2019-03-27T13:11:57.000+0000",
        const_partition: "1",
        docs: "## Error - 51120\r\n\r\n### Token is not valid yet",
        code: 51120,
        log_level: "ERROR",
        last_updated: "2019-05-20T07:14:20.000+0000",
        message: "Twilsock: Token is not valid yet",
        secondary_message: "Token is not valid yet",
        product: null,
    },
    {
        date_created: "2019-03-27T13:10:01.000+0000",
        const_partition: "1",
        docs: "## Error - 51119\r\n\r\n### Token expired\r\n\r\n#### Possible Causes \r\nThe token has been expired.\r\n\r\n#### Possible Solutions\r\nPlease use a valid token.\r\n\r\nTo check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51119,
        log_level: "ERROR",
        last_updated: "2019-05-20T07:13:49.000+0000",
        message: "Twilsock: Token expired",
        secondary_message: "The token has been expired.",
        product: null,
    },
    {
        date_created: "2019-03-27T13:08:56.000+0000",
        const_partition: "1",
        docs: "## Error - 51118\r\n\r\n### Invalid claim set\r\n\r\n#### Possible Causes \r\nClaim set provided in token is invalid.\r\n\r\n#### Possible Solutions\r\nVerify the token has a valid claim set.\r\n\r\nTo check whether the token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51118,
        log_level: "ERROR",
        last_updated: "2019-05-20T07:12:56.000+0000",
        message: "Twilsock: Invalid claim set",
        secondary_message: "Claim set provided in token is invalid.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:55:10.000+0000",
        const_partition: "1",
        docs: "## Error - 51117\r\n\r\n### Invalid access token signature\r\n\r\n#### Possible Causes \r\nThe token has an invalid signature.\r\n\r\n#### Possible Solutions\r\nConfirm a valid and signed token is being passed.\r\n\r\nTo check whether signed correctly, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51117,
        log_level: "ERROR",
        last_updated: "2019-05-20T07:07:48.000+0000",
        message: "Twilsock: Invalid access token signature",
        secondary_message: "The token has an invalid signature.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:53:17.000+0000",
        const_partition: "1",
        docs: "## Error - 51116\r\n\r\n### Invalid access token grants\r\n\r\n#### Possible Causes \r\nProvided token has invalid grants.\r\n\r\n#### Possible Solutions\r\nConfirm valid grants are being passed in the token.\r\n\r\nTo check whether the token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51116,
        log_level: "ERROR",
        last_updated: "2019-05-20T07:03:08.000+0000",
        message: "Twilsock: Invalid access token grants",
        secondary_message: "Provided token has invalid grants.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:49:52.000+0000",
        const_partition: "1",
        docs: "## Error - 51115\r\n\r\n### Invalid access token subject\r\n\r\n#### Possible Causes \r\nSubject provided in the token is invalid.\r\n\r\n#### Possible Solutions\r\nConfirm a valid token is being passed with a valid subject. \r\n\r\nTo check whether the token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51115,
        log_level: "ERROR",
        last_updated: "2019-05-20T07:00:53.000+0000",
        message: "Twilsock: Invalid access token subject",
        secondary_message: "Subject provided in the token is invalid.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:48:37.000+0000",
        const_partition: "1",
        docs: "## Error - 51114\r\n\r\n### Invalid access token header\r\n\r\n#### Possible Causes \r\nThe token has an invalid header.\r\n\r\n#### Possible Solutions\r\nConfirm a valid token is being passed in the request.\r\n\r\nTo check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51114,
        log_level: "ERROR",
        last_updated: "2019-05-20T06:59:47.000+0000",
        message: "Twilsock: Invalid access token header",
        secondary_message: "The token has an invalid header.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:47:41.000+0000",
        const_partition: "1",
        docs: "## Error - 51113\r\n\r\n### Product usage is not enabled\r\n\r\n#### Possible Causes \r\nProduct usage is not enabled.",
        code: 51113,
        log_level: "ERROR",
        last_updated: "2019-05-20T08:28:27.000+0000",
        message: "Twilsock: Product usage is not enabled",
        secondary_message: "Product usage is not enabled.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:46:58.000+0000",
        const_partition: "1",
        docs: "## Error - 51112\r\n\r\n### Product usage disabled\r\n\r\n#### Possible Causes \r\nProduct usage has been disabled for this instance.\r\n\r\n#### Possible Solutions\r\nIf you are sure the service instance and product are correct, please contact with Customer Support.",
        code: 51112,
        log_level: "ERROR",
        last_updated: "2019-05-17T11:58:15.000+0000",
        message: "Twilsock: Product usage disabled",
        secondary_message: "Product usage has been disabled for this instance.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:46:23.000+0000",
        const_partition: "1",
        docs: "## Error - 51111\r\n\r\n### Service instance limit has been reached\r\n\r\n#### Possible Causes \r\nService instance limit has been reached for the specified account.\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your account's service Instance limits.",
        code: 51111,
        log_level: "ERROR",
        last_updated: "2019-05-17T11:50:49.000+0000",
        message: "Twilsock: Service instance limit reached",
        secondary_message: "Service instance limit has been reached for the specified account.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:14:32.000+0000",
        const_partition: "1",
        docs: "## Error - 51110\r\n\r\n### Token contains multiple grants of same product\r\n\r\n#### Possible Causes \r\nDuplication of grants for the same product.\r\n\r\n#### Possible Solutions\r\nRemove duplications of products from grants section in the token. \r\n\r\nTo verify the token being passed, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51110,
        log_level: "ERROR",
        last_updated: "2019-05-17T11:50:00.000+0000",
        message: "Twilsock: Token contains multiple grants of same product",
        secondary_message: "Duplication of grants for the same product.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:13:23.000+0000",
        const_partition: "1",
        docs: "## Error - 51109\r\n\r\n### Service instance is under legal hold\r\n\r\n#### Possible Causes \r\nSpecified service instance is under legal hold.\r\n\r\n#### Possible Solutions\r\nPlease use a different service instance.",
        code: 51109,
        log_level: "ERROR",
        last_updated: "2019-05-17T11:48:06.000+0000",
        message: "Twilsock: Service instance is under legal hold",
        secondary_message: "Specified service instance is under legal hold.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:12:36.000+0000",
        const_partition: "1",
        docs: "## Error - 51108\r\n\r\n### Service instance disabled\r\n\r\n#### Possible Causes \r\nService instance is disabled.\r\n\r\n#### Possible Solutions\r\nPlease use a different service instance.",
        code: 51108,
        log_level: "ERROR",
        last_updated: "2019-05-17T11:47:30.000+0000",
        message: "Twilsock: Service instance disabled",
        secondary_message: "Service instance is disabled.",
        product: null,
    },
    {
        date_created: "2019-03-27T12:10:58.000+0000",
        const_partition: "1",
        docs: "## Error - 51107\r\n\r\n### Service can't be used",
        code: 51107,
        log_level: "ERROR",
        last_updated: "2019-05-17T11:45:53.000+0000",
        message: "Twilsock: Service can't be used",
        secondary_message: "Service can't be used",
        product: null,
    },
    {
        date_created: "2019-03-27T12:09:36.000+0000",
        const_partition: "1",
        docs: "## Error - 51106\r\n\r\n### Active product doesn't match with service instance product\r\n\r\n#### Possible Causes \r\nPassed service instance belongs to another product.\r\n\r\n#### Possible Solutions\r\nVerify matching product and service instance is selected.",
        code: 51106,
        log_level: "ERROR",
        last_updated: "2019-05-17T11:45:17.000+0000",
        message: "Twilsock: Active product doesn't match with service instance product",
        secondary_message: "Passed service instance belongs to another product.",
        product: null,
    },
    {
        date_created: "2019-03-27T11:57:48.000+0000",
        const_partition: "1",
        docs: "## Error - 51105\r\n\r\n### Token doesn't contain identity\r\n\r\n#### Possible Causes \r\nThe token doesn't have an identity specified.\r\n\r\n#### Possible Solutions\r\nConfirm that there is an identity field in the token. To check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51105,
        log_level: "ERROR",
        last_updated: "2019-05-17T11:28:56.000+0000",
        message: "Twilsock: Token doesn't contain identity",
        secondary_message: "The token doesn't have an identity specified.",
        product: null,
    },
    {
        date_created: "2019-03-27T11:54:21.000+0000",
        const_partition: "1",
        docs: "## Error - 51104\r\n\r\n### Token doesn't contain service instance\r\n\r\n#### Possible Causes \r\nThe token doesn't have a service instance.\r\n\r\n#### Possible Solutions\r\nConfirm a service instance is being passed in the token. \r\nTo check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51104,
        log_level: "ERROR",
        last_updated: "2019-05-17T10:02:45.000+0000",
        message: "Twilsock: Token doesn't contain service instance",
        secondary_message: "The token doesn't have a service instance.",
        product: null,
    },
    {
        date_created: "2019-03-27T11:50:31.000+0000",
        const_partition: "1",
        docs: "## Error - 51103\r\n\r\n### Token doesn't contain required grants section\r\n\r\n#### Possible Causes \r\nNo grants section is specified in the token and grants section is required.\r\n\r\n#### Possible Solutions\r\nConfirm grants section exists and valid in the token. \r\nTo check whether the access token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io).",
        code: 51103,
        log_level: "ERROR",
        last_updated: "2019-05-17T09:50:53.000+0000",
        message: "Twilsock: Token doesn't contain required grants section",
        secondary_message: "No grants section is specified in the token and grants section is required.",
        product: null,
    },
    {
        date_created: "2019-03-27T11:39:20.000+0000",
        const_partition: "1",
        docs: "## Error - 51102\r\n\r\n### Service instance SID not specified\r\n\r\n#### Possible Causes \r\nNo service instance SID specified and couldn't be generated.\r\n\r\n#### Possible Solutions\r\nConfirm a service instance SID is being passed in the request. ",
        code: 51102,
        log_level: "ERROR",
        last_updated: "2019-05-17T09:50:41.000+0000",
        message: "Twilsock: Service instance SID not specified",
        secondary_message: "Service instance SID is not specified and couln't be generated.",
        product: null,
    },
    {
        date_created: "2019-03-27T11:22:53.000+0000",
        const_partition: "1",
        docs: "## Error - 51101\r\n\r\n### Service instance not found\r\n\r\n#### Possible Causes \r\nService instance specified in the request does not exist.\r\n\r\n#### Possible Solutions\r\nConfirm a valid service instance is being passed in the request. ",
        code: 51101,
        log_level: "ERROR",
        last_updated: "2019-05-17T09:50:32.000+0000",
        message: "Twilsock: Service instance not found",
        secondary_message: "Service instance specified in the request does not exist.",
        product: null,
    },
    {
        date_created: "2019-03-20T15:52:46.000+0000",
        solutions: "Verify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to review your use case and limits.",
        causes: "Your application is requesting Flex API resources at a rate that is higher than expected.",
        description: "The rate of access to this resource exceeds the prescribed limits.",
        const_partition: "1",
        docs: "## ERROR - 45010\r\n\r\n### Rate Limit Exceeded\r\n\r\n The rate of access to this resource exceeds the prescribed limits.\r\n\r\n#### Possible Causes\r\nYour application is requesting Flex API resources at a rate that is higher than expected.\r\n\r\n#### Possible Solutions\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to review your use case and limits.",
        code: 45010,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:23:06.000+0000",
        message: "Rate Limit Exceeded",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2019-03-12T20:46:41.000+0000",
        const_partition: "1",
        docs: "## Error - 32219\r\n\r\n### SIP: Redirect failed\r\nTwilio could not process the SIP 30x response from your SIP server.\r\n\r\n#### Possible Causes\r\n*    Max redirect limit reached.\r\n*    Redirection is not allowed in the call to the registered SIP endpoint.\r\n*    Redirect target in the Contact header of the SIP 30x response is not a valid SIP URI.\r\n*    Redirect target is a private IP address.\r\n*    Redirect target is a Twilio domain such as \\*.sip.twilio.com or \\*.pstn.twilio.com.\r\n*    Redirect target is an IP in the blacklist.\r\n",
        code: 32219,
        log_level: "ERROR",
        last_updated: "2019-03-18T20:18:02.000+0000",
        message: "SIP: Redirect failed",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2019-03-11T18:43:55.000+0000",
        const_partition: "1",
        docs: "## Error - 21712\r\n\r\n### Phone Number or Short Code is associated with another Messaging Service.\r\n\r\nA Twilio phone number or short code can only be associated with one Messaging Service at a time.\r\n\r\nPlease delete the number from its existing Messaging Service before attempting to add it to a new Messaging Service. [See here](https://www.twilio.com/docs/sms/services/api/phonenumber-resource?code-sample=code-delete-phone-number&code-language=curl&code-sdk-version=json) for a code sample. Removing a Twilio number from a Messaging Service will not remove the number from your account.",
        code: 21712,
        log_level: "ERROR",
        last_updated: "2019-03-11T18:43:55.000+0000",
        message: "Phone Number or Short Code is associated with another Messaging Service.",
        secondary_message: "You have tried to assign a Twilio phone number or short code to a Messaging Service, but the number is already associated with a different Messaging Service.",
        product: "Programmable SMS",
    },
    {
        date_created: "2019-03-01T21:24:07.000+0000",
        const_partition: "1",
        docs: "## Error - 16099\r\n\r\n### Unexpected conference status\r\n\r\nThe requested conference is in an unexpected state for the desired operation.",
        code: 16099,
        log_level: "ERROR",
        last_updated: "2019-03-01T21:24:07.000+0000",
        message: "Unexpected conference status",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-03-01T21:22:31.000+0000",
        const_partition: "1",
        docs: "## Error - 16022\r\n\r\n### Conference does not exist or is completed\r\n\r\nThe requested conference sid or friendly name refers to a non-existent or completed conference.",
        code: 16022,
        log_level: "ERROR",
        last_updated: "2019-03-01T21:22:31.000+0000",
        message: "Conference does not exist or is completed",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-03-01T21:19:28.000+0000",
        const_partition: "1",
        docs: "## Error - 16021\r\n\r\n### Failed to join conference due to account concurrency limit exceeded\r\n\r\nA conference participant could not be created, as the account is currently at or above its concurrency limit.",
        code: 16021,
        log_level: "ERROR",
        last_updated: "2019-03-01T21:20:46.000+0000",
        message: "Failed to join conference due to account concurrency limit exceeded",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-03-01T21:15:13.000+0000",
        const_partition: "1",
        docs: "## Error - 16020\r\n\r\n### Conference is full\r\n\r\nA participant has attempted to join a conference that has reached its maximum participant capacity.\r\n\r\nPlease refer to https://www.twilio.com/docs/voice/twiml/conference for documentation on conference participant capacity.",
        code: 16020,
        log_level: "ERROR",
        last_updated: "2019-03-01T21:15:23.000+0000",
        message: "Conference is full",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-03-01T21:13:16.000+0000",
        const_partition: "1",
        docs: "## Error - 16011\r\n\r\n### Conference Event: Error Response to Callback URL\r\n\r\nTwilio received an error response when attempting to send a conference event to the provided callback URL.",
        code: 16011,
        log_level: "ERROR",
        last_updated: "2019-03-01T21:13:16.000+0000",
        message: "Conference Event: Error Response to Callback URL",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-03-01T21:11:00.000+0000",
        const_partition: "1",
        docs: "## Error - 16010\r\n\r\n### Conference Event: Internal Twilio Error\r\n\r\nTwilio experienced an unexpected internal error in attempting to deliver a conference event to the provided call back URL.",
        code: 16010,
        log_level: "ERROR",
        last_updated: "2019-03-01T21:11:00.000+0000",
        message: "Conference Event: Internal Twilio Error",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-03-01T21:07:56.000+0000",
        const_partition: "1",
        docs: "## Error - 16003\r\n\r\n### Could not recognize conference sid or friendly name\r\n\r\nTwilio could not recognize the provided conference sid or friendly name.  Please see https://www.twilio.com/docs/voice/twiml/conference for more documentation.",
        code: 16003,
        log_level: "ERROR",
        last_updated: "2019-03-01T21:11:58.000+0000",
        message: "Could not recognize conference sid or friendly name",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-03-01T21:02:11.000+0000",
        const_partition: "1",
        docs: "## Error - 16002\r\n\r\n### Failed to validate conference attributes\r\n\r\nThe provided conference attributes are invalid.",
        code: 16002,
        log_level: "ERROR",
        last_updated: "2019-03-01T21:02:11.000+0000",
        message: "Failed to validate conference attributes",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-03-01T21:01:20.000+0000",
        const_partition: "1",
        docs: "## Error - 16001\r\n\r\n### Conference is not bridged\r\n\r\nThe conference you have tried to access is not currently active.",
        code: 16001,
        log_level: "ERROR",
        last_updated: "2019-03-01T21:01:20.000+0000",
        message: "Conference is not bridged",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T22:07:25.000+0000",
        const_partition: "1",
        docs: "## Error - 64012\r\n\r\n### Pay: Payment Gateway rejected the card.\r\n\r\nA 64012 Error is an indication that the provided card was rejected by the Payment Gateway.\r\n\r\n#### Possible Causes\r\n* The card used was rejected by the Payment Gateway.\r\n\r\n#### Possible Solutions\r\n* Check the PaymentError in the response for more detailed information from the Payment Gateway.\r\n* Prompt the user about the card information again.",
        code: 64012,
        log_level: "ERROR",
        last_updated: "2019-02-26T22:07:25.000+0000",
        message: "Pay: Payment Gateway rejected the card.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T22:05:45.000+0000",
        const_partition: "1",
        docs: "## Error - 64011\r\n\r\n### Pay: Connector does not support the requested currency.\r\n\r\nA 64011 Error is an indication that the value provided in the currency attribute is not supported by this &lt;Pay&gt; Connector.\r\n\r\n#### Possible Causes\r\n* currency is an invalid currency code.\r\n* currency is not supported by the &lt;Pay&gt; Connector.\r\n",
        code: 64011,
        log_level: "ERROR",
        last_updated: "2019-02-26T22:06:31.000+0000",
        message: "Pay: Connector does not support the requested currency.",
        secondary_message: "The currency attribute had a value that the Connector did not support.",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T22:04:37.000+0000",
        const_partition: "1",
        docs: "## Error - 64010\r\n\r\n### Pay: Payment Gateway rejected token creation.\r\n\r\nA 64010 Error is an indication that the request to create token was rejected by the Payment Gateway. \r\n\r\n#### Possible Solutions\r\n* Please see the data returned in the with webhook to action url for more details.  \r\n* Reach out to your Payment Gateway support for more assistance.\r\n",
        code: 64010,
        log_level: "ERROR",
        last_updated: "2019-02-26T22:04:37.000+0000",
        message: "Pay: Payment Gateway rejected token creation.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T22:03:48.000+0000",
        const_partition: "1",
        docs: "## Error - 64009\r\n\r\n### Pay: Twilio is no longer authorized to initiate transactions on your behalf.\r\n\r\nA 64009 Error is an indication that the credentials provided in connector configuration no longer allow Twilio\r\nto perform requests on behalf of your account.\r\n\r\n#### Possible Causes\r\n* The Twilio application had its privileges revoked from your account.\r\n\r\n#### Possible Solutions\r\n* Create a new connector configuration and run through the scenario where you authorize Twilio to make requests on your behalf again.",
        code: 64009,
        log_level: "ERROR",
        last_updated: "2019-02-26T22:03:48.000+0000",
        message: "Pay: Twilio is no longer authorized to initiate transactions on your behalf.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T22:02:35.000+0000",
        const_partition: "1",
        docs: "## Error - 64008\r\n\r\n### Pay: Payment Gateway rejected charge creation.\r\n\r\nA 64008 Error is an indication that the request attempted to perform a charge of a credit card\r\nbut the attempt failed because the connector returned an error.\r\n\r\n#### Possible Causes\r\n* The &lt;Pay&gt; Connector returned an error.\r\n\r\n#### Possible Solutions\r\n* Please see the data returned in the with webhook to action url for more details.  \r\n* Reach out to your Payment Gateway support for more assistance.",
        code: 64008,
        log_level: "ERROR",
        last_updated: "2019-02-26T22:02:35.000+0000",
        message: "Pay: Payment Gateway rejected charge creation.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T21:59:00.000+0000",
        const_partition: "1",
        docs: '## Error - 64007\r\n\r\n### Pay: Connector does not support creating charge.\r\n\r\n Error is an indication that the request to tokenize credit card failed because the connector does not support tokenization.\r\n\r\nA 64007 Error is an indication that the request to create a charge on the credit card failed because the connector does not support making charges.\r\n\r\n#### Possible Causes\r\n* The paymentConnector attribute points to a Connector that does not support charging.\r\n\r\n#### Possible Solutions\r\n* Make sure that the paymentConnector matches a &lt;Pay&gt; Connector that supports charging.\r\n* If tokenization was intended, please change the chargeAmount attribute. Please see <A HREF="/docs/voice/twiml/pay#chargeamount">this API documentation</A> for more details.',
        code: 64007,
        log_level: "ERROR",
        last_updated: "2019-02-26T21:59:00.000+0000",
        message: "Pay: Connector does not support creating charge.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T21:57:11.000+0000",
        const_partition: "1",
        docs: '## Error - 64006\r\n\r\n### Pay: Connector does not support token type.\r\n\r\n Error is an indication that the request to tokenize credit card failed because the connector does not support tokenization.\r\n\r\nA 64006 Error is an indication that the request to tokenize of a particular type is not supported by the &lt;Pay&gt; connector.  For instance, tokenType="one-time" was used but\r\nonly tokenType="reusable" is supported.\r\n\r\n#### Possible Causes\r\n* The paymentConnector attribute points to a Connector that does not support the requested type of tokenization.\r\n\r\n#### Possible Solutions\r\n* Make sure that the paymentConnector matches a &lt;Pay&gt; Connector that supports the tokenization type you want.\r\n* Make sure you specify the tokenType that matches what you want to perform.',
        code: 64006,
        log_level: "ERROR",
        last_updated: "2019-02-26T21:57:11.000+0000",
        message: "Pay: Connector does not support token type.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T21:56:31.000+0000",
        const_partition: "1",
        docs: '## Error - 64005\r\n\r\n### Pay: Connector does not support tokenization.\r\n\r\nA 64005 Error is an indication that the request to tokenize credit card failed because the connector does not support tokenization.\r\n\r\n#### Possible Causes\r\n* The paymentConnector attribute points to Connector that does not support tokenization.\r\n* The chargeAmount attribute in the Pay Verb TwiML was 0 (or omitted) and you intended to charge.\r\n\r\n#### Possible Solutions\r\n* Make sure that the paymentConnector matches a &lt;Pay&gt; Connector that supports tokenization.\r\n* If a charge was intended, please change the chargeAmount attribute and provided a positive value. Please see <A HREF="/docs/voice/twiml/pay#chargeamount">this API documentation</A> for more details.',
        code: 64005,
        log_level: "ERROR",
        last_updated: "2019-02-26T21:56:31.000+0000",
        message: "Pay: Connector does not support tokenization.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T21:55:41.000+0000",
        const_partition: "1",
        docs: '## Error - 64004\r\n\r\n### Pay: Invalid paymentConnector attribute in TwiML.\r\n\r\nA 64004 Error is an indication that the value provided with paymentConnector attribute of Pay verb\r\ndoes not match to a Pay Connector configuration. See the <A HREF="/docs/voice/twiml/pay#paymentconnector">Pay Verb</A> API Reference.\r\n\r\n#### Possible Solutions\r\n* Make sure that the paymentConnector matches a Unique Name in the &lt;Pay&gt; Connector. Go to <A HREF="/console/voice/pay-connectors">this page</A> for a list of your Connectors.',
        code: 64004,
        log_level: "ERROR",
        last_updated: "2019-02-26T21:55:41.000+0000",
        message: "Pay: Invalid paymentConnector attribute in TwiML.",
        secondary_message: "paymentConnector attribute provided does not reference a connector configuration.",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T21:54:09.000+0000",
        const_partition: "1",
        docs: "## Error - 64003\r\n\r\n### Pay: Invalid charge amount.\r\n\r\nA 64003 Error is an indication that the charge amount is invalid. \r\n\r\n#### Possible Causes\r\n* The chargeAmount attribute has a number of decimals that does not conform to the currency type. For example, more than 2 decimals were provided for US Dollars .\r\n* chargeAmount attribute is negative.\r\n\r\n#### Possible Solutions\r\n* Make sure the charge amount has correct number of decimal values.\r\n* Make sure the charge amount is a positive value.",
        code: 64003,
        log_level: "ERROR",
        last_updated: "2019-02-26T21:54:09.000+0000",
        message: "Pay: Invalid charge amount.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T21:53:28.000+0000",
        const_partition: "1",
        docs: '## Error - 64002\r\n\r\n### Pay: Service unavailable.\r\n\r\nA 64002 Error is an indication that there is an internal server error and some internal services failed.\r\n\r\n#### Possible Causes\r\n* Some internal services in Twilio were not available.\r\n* Payment provider not available.\r\n\r\n#### Possible Solutions\r\n* Try to retry the request.\r\n*   If the error persists, please <a href="/help/contact">contact us</a> and we can help you resolve the issue. \r\n*   Note the time of the error and what you were trying to do when it occurred.',
        code: 64002,
        log_level: "ERROR",
        last_updated: "2019-05-02T19:28:57.000+0000",
        message: "Pay: Service unavailable.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-26T21:51:39.000+0000",
        const_partition: "1",
        docs: "## Error - 64001\r\n\r\n### Pay: Configuration Error\r\n\r\nA 64001 Error is an indication there is something wrong with the &lt;Pay&gt; connector configuration.\r\n\r\n#### Possible Causes \r\n* Credentials were removed from configuration.\r\n* Credentials were modified and are not matching the Connector Type.\r\n* Configuration is missing Credentials.\r\n* Configuration contains invalid attributes.\r\n\r\n#### Possible Solutions\r\n* Recreate your &lt;Pay&gt; connector configuration.",
        code: 64001,
        log_level: "ERROR",
        last_updated: "2019-02-26T21:51:39.000+0000",
        message: "Pay: Configuration Error",
        secondary_message: "Failed to retrieve connector configuration.",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-25T19:34:31.000+0000",
        const_partition: "1",
        docs: "### Channel sender content flagged as spam\r\n\r\n#### Possible Causes \r\n* Sender content was flagged as spam. Please check the content of the message.",
        code: 63026,
        log_level: "ERROR",
        last_updated: "2019-02-25T19:34:31.000+0000",
        message: "Channel sender content flagged as spam",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-02-25T19:33:21.000+0000",
        const_partition: "1",
        docs: "### Media already exists\r\n\r\n#### Possible Causes \r\n* The media content already exists. Conflict in uploading the media.",
        code: 63025,
        log_level: "ERROR",
        last_updated: "2019-02-25T22:58:38.000+0000",
        message: "Media already exists",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-02-25T19:31:58.000+0000",
        const_partition: "1",
        docs: "### Invalid message recipient\r\n\r\n#### Possible Causes \r\n* Message recipient could not be verified",
        code: 63024,
        log_level: "ERROR",
        last_updated: "2019-02-25T22:58:14.000+0000",
        message: "Invalid message recipient",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-02-25T19:30:40.000+0000",
        const_partition: "1",
        docs: "### Channel generic error\r\n\r\n#### Possible Causes \r\n* Twilio encountered a generic error for your message.",
        code: 63023,
        log_level: "ERROR",
        last_updated: "2019-02-25T19:30:40.000+0000",
        message: "Channel generic error",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-02-25T19:29:14.000+0000",
        const_partition: "1",
        docs: "### Invalid vname certificate\r\n\r\n#### Possible Causes \r\n* The vname cert for your business account was invalid. Please reach out to support to verify the cert.",
        code: 63022,
        log_level: "ERROR",
        last_updated: "2019-02-25T22:57:19.000+0000",
        message: "Invalid vname certificate",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-02-25T19:28:04.000+0000",
        const_partition: "1",
        docs: "### Channel invalid content error\r\n\r\n#### Possible Causes \r\n* Message has invalid content. Please verify the content and re send the message",
        code: 63021,
        log_level: "ERROR",
        last_updated: "2019-02-25T19:28:04.000+0000",
        message: "Channel invalid content error",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-02-25T19:26:54.000+0000",
        const_partition: "1",
        docs: "### Business Manager Account Error\r\n\r\n#### Possible Causes \r\n* Please use Facebook Business Manager to accept an invitation from Twilio to send messages on your behalf. Also verify the WhatsApp billing account associated with your business",
        code: 63020,
        log_level: "ERROR",
        last_updated: "2019-02-25T22:56:54.000+0000",
        message: "Twilio encountered a Business Manager account error",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-02-25T19:24:34.000+0000",
        const_partition: "1",
        docs: "### Media failed to download\r\n\r\n#### Possible Causes \r\n* Twilio failed to download the media from the sender. Please check the media content before retrying",
        code: 63019,
        log_level: "ERROR",
        last_updated: "2019-02-25T19:24:34.000+0000",
        message: "Twilio failed to download the media from the sender",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-02-20T07:24:45.000+0000",
        const_partition: "1",
        docs: "### Rate limit exceeded for Channel\r\n\r\n#### Possible Causes \r\n* Your account is sending messages at a higher combined rate than configured for your account.\r\n* Your WhatsApp number has exceeded the rate limit imposed by WhatsApp. For more information, see [WhatsApp Rate Limiting](https://support.twilio.com/hc/en-us/articles/360024008153-WhatsApp-Rate-Limiting)",
        code: 63018,
        log_level: "ERROR",
        last_updated: "2019-05-31T21:24:03.000+0000",
        message: "Rate limit exceeded for Channel",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-02-13T23:08:34.000+0000",
        const_partition: "1",
        docs: "### Rate limit exceeded\r\n\r\n#### Possible Causes \r\n* Your account or subaccounts are sending messages at a higher combined rate than 2000 messages-per-second.",
        code: 63017,
        log_level: "ERROR",
        last_updated: "2019-02-13T23:08:34.000+0000",
        message: "Rate limit exceeded",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-02-12T23:59:52.000+0000",
        const_partition: "1",
        docs: "## Error - 80620\r\n\r\n### Chat Configured Proxy Identifier Not Found\r\n\r\nReceived a chat message for a proxy identifier that does not exist in your Proxy pool\r\n\r\n#### Possible Causes\r\n* You removed a Flex number from your Proxy pool ",
        code: 80620,
        log_level: "ERROR",
        last_updated: "2019-02-12T23:59:52.000+0000",
        message: "Chat Configured Proxy Identifier Not Found",
        secondary_message: "Received a chat message for a proxy identifier that does not exist in your Proxy pool",
        product: "Proxy",
    },
    {
        date_created: "2019-02-12T23:56:58.000+0000",
        const_partition: "1",
        docs: "## Error - 80619\r\n\r\n### Chat Channel Attribute Error\r\n\r\nChat Channel was not found or did not have expected attributes (twilioNumber, serviceNumber, status, proxySession) required for Proxy integration.  If you are using the same Chat service for both Flex and non-Flex use-cases, this is expected for non-flex messages and you can probably ignore this event.\r\n",
        code: 80619,
        log_level: "ERROR",
        last_updated: "2019-02-12T23:56:58.000+0000",
        message: "Chat Channel Attribute Error",
        secondary_message: null,
        product: "Proxy",
    },
    {
        date_created: "2019-02-12T23:53:23.000+0000",
        const_partition: "1",
        docs: "## Error - 80618\r\n\r\n### Chat Integration Error\r\n\r\nA Chat component was not configured correctly for integration with Proxy Service\r\n\r\n#### Possible Causes \r\n* You manually deleted a Chat Channel or Proxy Session\r\n* You removed or changed the Chat Channel Sid setting in your Proxy Service\r\n",
        code: 80618,
        log_level: "ERROR",
        last_updated: "2019-02-12T23:53:23.000+0000",
        message: "Chat Integration Error",
        secondary_message: "A Chat element was not configured correctly for Proxy",
        product: "Proxy",
    },
    {
        date_created: "2019-02-12T23:50:50.000+0000",
        const_partition: "1",
        docs: "## Error - 80617 \r\n\r\n### Flex Configuration Error\r\n\r\nA Flex component was not configured correctly.\r\n\r\n#### Possible Causes \r\n* You made changes to one of your Flex phone numbers\r\n* You are trying to use a phone number with Flex but have not created a Flex Flow for that number\r\n* You manually deleted a Chat Channel or Proxy Session\r\n* You removed or changed the Chat Channel Sid setting in your Proxy Service\r\n",
        code: 80617,
        log_level: "ERROR",
        last_updated: "2019-02-12T23:50:50.000+0000",
        message: "Flex Configuration Error",
        secondary_message: "A Flex component was not configured correctly",
        product: "Proxy",
    },
    {
        date_created: "2019-02-07T20:04:51.000+0000",
        const_partition: "1",
        docs: "## Error - 16109\r\n\r\n### Voice Recording: Cannot fetch .mp3 encrypted recording\r\n\r\nRecording cannot be retrieved in .mp3 format when call recording encryption feature is enabled on the account.  Please re-request with .wav format.",
        code: 16109,
        log_level: "ERROR",
        last_updated: "2019-02-07T20:04:51.000+0000",
        message: "Voice Recording: Cannot fetch .mp3 encrypted recording",
        secondary_message: "Recording cannot be retrieved in .mp3 format when call recording encryption feature is enabled on the account.  Please request with .wav format.",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-07T13:07:42.000+0000",
        const_partition: "1",
        docs: "## Error - 30016\r\n\r\n### 'To' and 'From' channel types are incompatible\r\n\r\nThe To or From attributes have channel prefixes what are incompatible\r\n\r\n#### Possible Causes \r\n*  Attempt to send a message to one channel but use 'From' address for another channel\r\n\r\n#### Possible Solutions\r\n*  Check the To and From attributes channel prefixes",
        code: 30016,
        log_level: "ERROR",
        last_updated: "2019-02-07T13:07:42.000+0000",
        message: "'To' and 'From' channel types are incompatible",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-02-06T13:22:43.000+0000",
        const_partition: "1",
        docs: "## Error - 50004\r\n\r\n### Programmable Chat: Unique Name too long\r\n\r\n#### Possible Causes \r\n*  Specified unique name is too long\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid UniqueName is being passed in request. ",
        code: 50004,
        log_level: "ERROR",
        last_updated: "2019-02-06T13:23:44.000+0000",
        message: "Programmable Chat: Unique Name too long",
        secondary_message: "Specified unique name is too long",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-02-06T13:20:59.000+0000",
        const_partition: "1",
        docs: "## Error - 50003\r\n\r\n### Programmable Chat: Friendly name too long\r\n\r\n#### Possible Causes \r\n*  Specified friendly name is too long\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid FriendlyName is being passed in request. ",
        code: 50003,
        log_level: "ERROR",
        last_updated: "2019-02-06T13:23:24.000+0000",
        message: "Programmable Chat: Friendly name too long",
        secondary_message: "Specified friendly name is too long",
        product: "Programmable Chat",
    },
    {
        date_created: "2019-02-04T23:25:55.000+0000",
        const_partition: "1",
        docs: "## Error - 21234\r\n\r\n### Invalid Machine Detection configuration value\r\n\r\nYou attempted to initiate an outbound call, but you provided a Machine Detection configuration value that is not allowed",
        code: 21234,
        log_level: "ERROR",
        last_updated: "2019-02-13T22:52:18.000+0000",
        message: "Invalid Machine Detection configuration value",
        secondary_message: "You attempted to initiate an outbound call, but you provided a Machine Detection configuration value that is not allowed",
        product: "Programmable Voice",
    },
    {
        date_created: "2019-02-04T18:37:33.000+0000",
        const_partition: "1",
        docs: "## Error - 11242\r\n\r\n### HTTP connection over Twilio Interconnect is not allowed\r\n\r\nYour account has not been enabled for HTTP connections over Twilio Interconnect.\r\n\r\n#### Possible Solutions\r\n* Correct the 'r' (region) parameter in the fragment part of the URL, the one after '#'. Remove those with the '-ix' suffix.\r\n* Contact Twilio <a href=\"/help/contact\">customer support</a> to inquire further.\r\n",
        code: 11242,
        log_level: "ERROR",
        last_updated: "2019-02-04T18:37:33.000+0000",
        message: "HTTP connection over Twilio Interconnect is not allowed",
        secondary_message: "Your account has not been enabled for HTTP connections over Twilio Interconnect.",
        product: null,
    },
    {
        date_created: "2019-02-04T18:35:12.000+0000",
        solutions: "* Correct the 'e' parameter in the fragment part of the URL, the one after '#'.",
        causes: "* The edge location(s) specified in the 'e' parameter of your connection settings are not currently supported by Twilio.",
        description: "There was an error connecting to the URL due to an unsupported edge location parameter.",
        const_partition: "1",
        docs: "## ERROR - 11241\r\n\r\n### HTTP connection edge location is not supported\r\n\r\n There was an error connecting to the URL due to an unsupported edge location parameter.\r\n\r\n#### Possible Causes\r\n* The edge location(s) specified in the 'e' parameter of your connection settings are not currently supported by Twilio.\r\n\r\n#### Possible Solutions\r\n* Correct the 'e' parameter in the fragment part of the URL, the one after '#'.",
        code: 11241,
        log_level: "ERROR",
        last_updated: "2019-07-30T23:43:11.000+0000",
        message: "HTTP connection edge location is not supported",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-02-04T18:34:22.000+0000",
        solutions: "* Correct the 'e' parameter in the fragment part of the URL, the one after '#'.",
        causes: "* The edge location(s) specified in the 'e' parameter of your connection settings are not valid",
        description: "There was an error connecting to the URL due to an invalid edge location parameter.",
        const_partition: "1",
        docs: "## ERROR - 11240\r\n\r\n### HTTP connection edge location is invalid\r\n\r\n There was an error connecting to the URL due to an invalid edge location parameter.\r\n\r\n#### Possible Causes\r\n* The edge location(s) specified in the 'e' parameter of your connection settings are not valid\r\n\r\n#### Possible Solutions\r\n* Correct the 'e' parameter in the fragment part of the URL, the one after '#'.",
        code: 11240,
        log_level: "ERROR",
        last_updated: "2019-07-31T00:00:07.000+0000",
        message: "HTTP connection edge location is invalid",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-02-01T15:37:51.000+0000",
        const_partition: "1",
        docs: "### 53405: Media connection failed or Media activity ceased\r\n\r\nRaised by the Client or Server whenever a media connection fails or raised by the Client whenever it detects that media has stopped flowing.",
        code: 53405,
        log_level: "ERROR",
        last_updated: "2019-02-01T15:37:51.000+0000",
        message: "Media connection failed or Media activity ceased",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2019-01-31T00:29:58.000+0000",
        const_partition: "1",
        docs: "## Error - 11243\r\n\r\n### HTTP retry policy is invalid\r\nOne or more retry policies specified in the \u2018rp\u2019 parameter of your connection settings are invalid.\r\n\r\n#### Possible Solutions\r\n*  Correct the 'rp' (retry policy) parameter in the fragment part of the URL, the one after '#'.",
        code: 11243,
        log_level: "ERROR",
        last_updated: "2019-01-31T00:29:58.000+0000",
        message: "HTTP retry policy is invalid",
        secondary_message: "One or more retry policies specified in the \u2018rp\u2019 parameter of your connection settings are invalid.",
        product: null,
    },
    {
        date_created: "2019-01-31T00:28:56.000+0000",
        const_partition: "1",
        docs: "## Error - 11203\r\n\r\n### HTTP communication total time out triggered\r\nAll attempts to communicate with your web server were timed out. You set the total timeout using the tt parameter in the URL fragment identifier.\r\n\r\n#### Possible Solutions\r\n*  Adjust the 'tt' (total timeout) parameter in the fragment part of the URL, the one after '#'.",
        code: 11203,
        log_level: "ERROR",
        last_updated: "2019-02-04T18:32:39.000+0000",
        message: "HTTP communication total time out triggered",
        secondary_message: "All attempts to communicate with your web server were timed out.",
        product: null,
    },
    {
        date_created: "2019-01-30T22:49:37.000+0000",
        const_partition: "1",
        docs: "# Error - 20426\r\n\r\n## Upgrade Required\r\nThe server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol.\r\n\r\n### TLS and cipher suite upgrade requirements\r\nIn moving towards a more secure posture with regards to [TLS](https://en.wikipedia.org/wiki/Transport_Layer_Security), we require that all new accounts must use TLS v1.2 or later. All customers must use TLS > 1.2 starting June 26, 2019.\r\n\r\nCustomers running older operating systems or legacy network software may need to upgrade their systems to be compatible with these changes. If you've received Error 20426, you likely need to upgrade your system.\r\n\r\nTo learn more about these changes, see our support site's FAQ on [Twilio REST API\u2019s TLS and Cipher Suite Security Changes](https://support.twilio.com/hc/en-us/articles/360007820133-FAQ-Twilio-REST-API-s-TLS-and-Cipher-Suite-Security-Changes-for-June-2019)\r\n\r\n### Tips for upgrading your environment\r\nTo learn more about Twilio's TLS and cipher requirements, please reference [this support article](https://support.twilio.com/hc/en-us/articles/360006751753-Tips-for-Upgrading-Your-Environment-to-Support-Twilio-REST-API-s-TLS-and-Strong-Cipher-Suite-Changes) where you can learn more about understanding failure signatures, which components to upgrade, and verifying your upgrade.",
        code: 20426,
        log_level: "ERROR",
        last_updated: "2019-04-18T15:45:28.000+0000",
        message: "Upgrade Required",
        secondary_message: "The server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol.",
        product: null,
    },
    {
        date_created: "2019-01-30T22:44:42.000+0000",
        const_partition: "1",
        docs: "## Error Code 20011\r\n\r\n### Invalid TLS version\r\n\r\nThe request was rejected because it was not correctly configured to use TLSv1.2. All new accounts are [required to use TLSv1.2 with supported ciphers suites](https://support.twilio.com/hc/en-us/articles/360007724794). \r\n\r\n#### Possible Solutions:\r\n* Reconfigure request to use a supported cipher suite for TLSv1.2\r\n* Review these [tips for upgrading your environment to TLSv1.2](https://support.twilio.com/hc/en-us/articles/360006751753)",
        code: 20011,
        log_level: "ERROR",
        last_updated: "2019-01-30T22:44:42.000+0000",
        message: "Invalid TLS version",
        secondary_message: "Service requires TLSv1.2 ",
        product: null,
    },
    {
        date_created: "2019-01-30T22:43:25.000+0000",
        const_partition: "1",
        docs: "## Error Code 20012\r\n\r\n### Invalid TLSv1.2 Cipher Suite\r\n\r\nThe request was rejected because it was not correctly configured to use TLSv1.2. All new accounts are [required to use TLSv1.2 with supported ciphers suites](https://support.twilio.com/hc/en-us/articles/360007724794). \r\n\r\n#### Possible Solutions:\r\n* Reconfigure request to use a supported cipher suite for TLSv1.2\r\n* Review these [tips for upgrading your environment to TLSv1.2](https://support.twilio.com/hc/en-us/articles/360006751753)\r\n\r\n#### Supported Cipher Suites:\r\n* ECDHE-RSA-AES128-GCM-SHA256\r\n* ECDHE-RSA-AES128-SHA256\r\n* ECDHE-ECDSA-AES256-GCM-SHA384\r\n* ECDHE-RSA-AES256-GCM-SHA384\r\n* ECDHE-ECDSA-AES256-SHA384\r\n* ECDHE-RSA-AES256-SHA384\r\n* AES128-GCM-SHA256\r\n* AES128-SHA256\r\n* AES256-GCM-SHA384\r\n* AES256-SHA256",
        code: 20012,
        log_level: "ERROR",
        last_updated: "2019-01-30T22:43:25.000+0000",
        message: "Invalid TLSv1.2 Cipher Suite",
        secondary_message: "Request is not configured with a PCI compliant cipher suite",
        product: null,
    },
    {
        date_created: "2019-01-30T19:26:43.000+0000",
        solutions: "* [Send a WhatsApp message using a template](https://www.twilio.com/docs/sms/whatsapp/api#send-a-whatsapp-message-using-a-template)",
        causes: "* This message failed to be delivered to the user because it was sent outside the allowed conversation window. For messages initiated by the business, you must use pre-defined templates.\r\n* If you are sending a media message with text, you should be in the window for the message to go through unless you use pre-defined templates for the text only messages. Media and template messages are not currently supported.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 63016\r\n\r\n### Failed to send freeform message because you are outside the allowed window. Please use a Template.\r\n\r\n \r\n\r\n#### Possible Causes\r\n* This message failed to be delivered to the user because it was sent outside the allowed conversation window. For messages initiated by the business, you must use pre-defined templates.\r\n* If you are sending a media message with text, you should be in the window for the message to go through unless you use pre-defined templates for the text only messages. Media and template messages are not currently supported.\r\n\r\n#### Possible Solutions\r\n* [Send a WhatsApp message using a template](https://www.twilio.com/docs/sms/whatsapp/api#send-a-whatsapp-message-using-a-template)",
        code: 63016,
        log_level: "ERROR",
        last_updated: "2019-07-18T14:53:54.000+0000",
        message: "Failed to send freeform message because you are outside the allowed window. Please use a Template.",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2019-01-30T16:40:47.000+0000",
        const_partition: "1",
        docs: "## Error - 30015\r\n\r\n### Non-supported channel type is used\r\n\r\nThe To or From attributes have an unsupported prefix for channel\r\n\r\n#### Possible Causes \r\n*  empty channel prefix for an attribute that requires a prefix\r\n*  non-existing prefix for an attribute that requires a prefix\r\n\r\n#### Possible Solutions\r\n*  Check the To/From attributes channel prefix\r\n",
        code: 30015,
        log_level: "ERROR",
        last_updated: "2019-01-30T16:40:47.000+0000",
        message: "Non-supported channel type is used",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-01-30T16:36:24.000+0000",
        const_partition: "1",
        docs: '## Error - 30014 \r\n\r\n### "To" attributes are Invalid\r\n\r\nThe To attribute list is invalid or empty\r\n\r\n#### Possible Causes \r\n*  empty list\r\n*  to long list\r\n\r\n#### Possible Solutions\r\n*  Check the number of To attributes \r\n',
        code: 30014,
        log_level: "ERROR",
        last_updated: "2019-01-30T16:36:24.000+0000",
        message: "'To' attributes are Invalid",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-01-30T16:17:11.000+0000",
        const_partition: "1",
        docs: "## Error - 20423\r\n\r\n### Invalid SID\r\n\r\nThe request contained at least one parameter what is incorrect SID but has to be.\r\n\r\n#### Is the request safe to retry?\r\n\r\nA 422 request is never processed and is always safe to retry.",
        code: 20423,
        log_level: "ERROR",
        last_updated: "2019-01-30T16:17:11.000+0000",
        message: "Invalid SID",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-01-30T16:11:48.000+0000",
        const_partition: "1",
        docs: "## Error - 20422\r\n\r\n### Invalid Parameter\r\n\r\nThe request contained malformed or semantically incorrect parameters.\r\n\r\nCommon occurrences:\r\n\r\n* Lacking a specified `Content-Type` header field\r\n* Invalid or missing XML data\r\n* Invalid parameter type or value\r\n\r\n#### Is the request safe to retry?\r\n\r\nA 422 request is never processed and is always safe to retry.",
        code: 20422,
        log_level: "ERROR",
        last_updated: "2019-01-30T16:11:48.000+0000",
        message: "Invalid Parameter",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2019-01-25T23:48:54.000+0000",
        const_partition: "1",
        docs: "## Error\r\n\r\n### Flex Configuration Error\r\n\r\nA Flex component was not configured correctly.  Please reach out to Flex support.",
        code: 80505,
        log_level: "ERROR",
        last_updated: "2019-01-25T23:48:54.000+0000",
        message: "Flex Configuration Error",
        secondary_message: "A Flex component was not configured correctly",
        product: "Proxy",
    },
    {
        date_created: "2019-01-24T20:49:47.000+0000",
        const_partition: "1",
        docs: "## Error - 31208\r\n\r\n### User denied access to microphone.\r\n\r\nUser denied access to microphone.",
        code: 31208,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:49:47.000+0000",
        message: "User denied access to microphone.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:48:52.000+0000",
        const_partition: "1",
        docs: "## Error - 31207\r\n\r\n### JWT token expiration too long.\r\n\r\nJWT token expiration too long.",
        code: 31207,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:48:52.000+0000",
        message: "JWT token expiration too long.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:48:09.000+0000",
        const_partition: "1",
        docs: "## Error - 31206\r\n\r\n### Rate exceeded authorized limit.\r\n\r\nRate exceeded authorized limit.",
        code: 31206,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:48:09.000+0000",
        message: "Rate exceeded authorized limit.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:47:32.000+0000",
        const_partition: "1",
        docs: "## Error - 31205\r\n\r\n### JWT token expired.\r\n\r\nJWT token expired.",
        code: 31205,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:47:32.000+0000",
        message: "JWT token expired.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:46:52.000+0000",
        const_partition: "1",
        docs: "## Error - 31204\r\n\r\n### Invalid JWT token.\r\n\r\nInvalid JWT token.",
        code: 31204,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:46:52.000+0000",
        message: "Invalid JWT token.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:46:12.000+0000",
        const_partition: "1",
        docs: "## Error - 31203\r\n\r\n### No valid account.\r\n\r\nNo valid account.",
        code: 31203,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:46:12.000+0000",
        message: "No valid account.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:45:37.000+0000",
        const_partition: "1",
        docs: "## Error - 31202\r\n\r\n### JWT signature validation failed.\r\n\r\nJWT signature validation failed.",
        code: 31202,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:45:37.000+0000",
        message: "JWT signature validation failed.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:44:47.000+0000",
        const_partition: "1",
        docs: "## Error - 31105\r\n\r\n### Invalid client name.\r\n\r\nInvalid client name.",
        code: 31105,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:44:47.000+0000",
        message: "Invalid client name.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:44:13.000+0000",
        const_partition: "1",
        docs: "## Error - 31104\r\n\r\n### Invalid bridge token.\r\n\r\nInvalid bridge token.",
        code: 31104,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:44:13.000+0000",
        message: "Invalid bridge token.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:43:12.000+0000",
        const_partition: "1",
        docs: "## Error - 31103\r\n\r\n### Length of parameters cannot exceed MAX_PARAM_LENGTH.\r\n\r\nLength of parameters cannot exceed MAX_PARAM_LENGTH.",
        code: 31103,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:43:12.000+0000",
        message: "Length of parameters cannot exceed MAX_PARAM_LENGTH.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:42:24.000+0000",
        const_partition: "1",
        docs: "## Error - 31102\r\n\r\n### Authorization token missing in request.\r\n\r\nAuthorization token missing in request.",
        code: 31102,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:42:24.000+0000",
        message: "Authorization token missing in request.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:41:46.000+0000",
        const_partition: "1",
        docs: "## Error - 31101\r\n\r\n### Missing parameter array in request.\r\n\r\nMissing parameter array in request.",
        code: 31101,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:41:46.000+0000",
        message: "Missing parameter array in request.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:38:09.000+0000",
        const_partition: "1",
        docs: "## Error - 31002\r\n\r\n### Connection declined.\r\n\r\nConnection declined.",
        code: 31002,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:38:09.000+0000",
        message: "Connection declined.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T20:36:49.000+0000",
        const_partition: "1",
        docs: "## Error - 31001\r\n\r\n### Application not found.\r\n\r\nApplication not found.",
        code: 31001,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:37:06.000+0000",
        message: "Application not found.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T19:56:33.000+0000",
        const_partition: "1",
        docs: "## Error - 31100\r\n\r\n### Malformed request\r\n\r\nThe request could not be understood due to malformed syntax.",
        code: 31100,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:34:06.000+0000",
        message: "Malformed request",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T19:53:51.000+0000",
        const_partition: "1",
        docs: "## Error - 31106\r\n\r\n### Invalid data\r\n\r\nThe provided data was not valid.",
        code: 31106,
        log_level: "ERROR",
        last_updated: "2019-01-24T19:53:51.000+0000",
        message: "Invalid data",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T19:32:46.000+0000",
        const_partition: "1",
        docs: "## Error - 31301\r\n\r\n### Registration error\r\n\r\nAn error occurred during registration",
        code: 31301,
        log_level: "ERROR",
        last_updated: "2019-01-24T19:32:46.000+0000",
        message: "Registration error",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T19:30:23.000+0000",
        const_partition: "1",
        docs: "## Error - 31008\r\n\r\n### Call cancelled\r\n\r\nUnable to answer because the call has ended",
        code: 31008,
        log_level: "ERROR",
        last_updated: "2019-01-24T19:30:23.000+0000",
        message: "Call cancelled",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T19:29:27.000+0000",
        const_partition: "1",
        docs: "## Error - 31006\r\n\r\n### Audio device error\r\n\r\nUnable to start the audio device",
        code: 31006,
        log_level: "ERROR",
        last_updated: "2019-01-24T19:29:27.000+0000",
        message: "Audio device error",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T19:28:32.000+0000",
        const_partition: "1",
        docs: "## Error - 31005\r\n\r\n### Connection error\r\n\r\nA connection error occurred during the call",
        code: 31005,
        log_level: "ERROR",
        last_updated: "2019-01-24T20:38:53.000+0000",
        message: "Connection error",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-24T19:26:00.000+0000",
        const_partition: "1",
        docs: "## Error - 31003\r\n\r\n### Connection timeout\r\n\r\nThe server could not produce a response within a suitable amount of time",
        code: 31003,
        log_level: "ERROR",
        last_updated: "2019-01-24T19:27:38.000+0000",
        message: "Connection timeout",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2019-01-22T10:42:13.000+0000",
        const_partition: "1",
        docs: "## Error - 30013\r\n\r\n## Message Time To Live is too big\r\n\r\n### Possible Causes \r\nTTL specified in the request is too big\r\n\r\n### Possible Solutions\r\nSpecify a smaller TTL\r\n",
        code: 30013,
        log_level: "ERROR",
        last_updated: "2019-01-22T10:42:13.000+0000",
        message: "TTL is too big",
        secondary_message: "Message Time To Live is too big",
        product: null,
    },
    {
        date_created: "2019-01-22T10:39:38.000+0000",
        const_partition: "1",
        docs: "## Error - 30012\r\n\r\n## Message Time To Live is too small\r\n\r\n### Possible Causes \r\nTTL specified in the request is too small\r\n\r\n### Possible Solutions\r\nSpecify a bigger TTL\r\n",
        code: 30012,
        log_level: "ERROR",
        last_updated: "2019-01-22T10:39:38.000+0000",
        message: "TTL is too small",
        secondary_message: "Message Time To Live is too small",
        product: null,
    },
    {
        date_created: "2019-01-07T13:50:02.000+0000",
        const_partition: "1",
        docs: "## Error - 54011\r\n\r\n### Sync: Invalid TTL\r\nThe TTL value in seconds must either be empty or an integer between 0 and 31 536 000 (1 year).\r\n\r\n#### Possible Causes\r\n* The value supplied for the TTL parameter does not fall into the valid range.\r\n\r\n#### Possible Solutions\r\n* Confirm a valid TTL parameter is being passed in your request.",
        code: 54011,
        log_level: "ERROR",
        last_updated: "2019-01-08T08:07:48.000+0000",
        message: "Invalid TTL",
        secondary_message: "The TTL value in seconds must either be empty or an integer between 0 and 31 536 000 (1 year).",
        product: "Sync",
    },
    {
        date_created: "2018-12-06T20:10:12.000+0000",
        const_partition: "1",
        docs: "## Error - 60205\r\n### SMS is not supported by landline phone number\r\n#### Possible Causes\r\nYou have attempted to send the verification code to phone number that does not support SMS.\r\n#### Possible Solutions\r\n* Make sure the number you are sending a verification to is a valid mobile phone number\r\n* Disable validating phone numbers using the Twilio API setting `SkipSmsToLandlines` on your Verification Service to `false`.",
        code: 60205,
        log_level: "ERROR",
        last_updated: "2018-12-06T20:10:12.000+0000",
        message: "SMS is not supported by landline phone number",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2018-12-04T05:30:07.000+0000",
        const_partition: "1",
        docs: '## Error - 40151\r\n\r\n### Call API Error - Invalid instruction issued on a task being transferred\r\n\r\n#### Possible Causes \r\n*  Instruction is not acceptable for transferred tasks \r\n*  Internal Twilio API error. \r\n\r\n#### Possible Solutions\r\n*  Make certain that instruction is accept, reject, conference, or supervise\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference"\r\n}\r\n```',
        code: 40151,
        log_level: "ERROR",
        last_updated: "2018-12-04T05:34:13.000+0000",
        message: "TaskRouter->Invalid instruction",
        secondary_message: "Invalid instruction issued on a task being transferred. Valid instructions are: ACCEPT, REJECT, CONFERENCE, SUPERVISE",
        product: "TaskRouter",
    },
    {
        date_created: "2018-12-03T19:12:13.000+0000",
        const_partition: "1",
        docs: '## Error - 40136\r\n\r\n### The Reservation must currently be Pending - Conference Instruction\r\n\r\n#### Possible Causes \r\n*  The Reservation has been moved to a non-Pending state.\r\n\r\n#### Possible Solutions\r\n*  Make certain that the Reservation is currently Pending. \r\n\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"to": "client:alice",\r\n\t"from": "+18001234567"\r\n}\r\n```',
        code: 40136,
        log_level: "ERROR",
        last_updated: "2018-12-03T19:12:13.000+0000",
        message: "TaskRouter->Conference",
        secondary_message: "Conference Instruction can only be issued on a currently pending reservation.",
        product: "TaskRouter",
    },
    {
        date_created: "2018-11-28T16:47:44.000+0000",
        const_partition: "1",
        docs: "## Warning - 16101\r\n\r\n### Voice Recording : Unavailable because duration is too short\r\n\r\nRecording is unavailable because the duration was shorter than the minimum required duration.",
        code: 16101,
        log_level: "WARNING",
        last_updated: "2018-11-28T16:47:44.000+0000",
        message: "Voice Recording : Unavailable because duration is too short",
        secondary_message: "Recording is unavailable because the duration was shorter than the minimum required duration.",
        product: "Programmable Voice",
    },
    {
        date_created: "2018-11-28T16:42:38.000+0000",
        const_partition: "1",
        docs: "## Warning - 16102\r\n\r\n### Voice Recording: Unavailable because recording is silent\r\n\r\nRecording was detected as silent and not stored.  As a result, it is unavailable for access.",
        code: 16102,
        log_level: "WARNING",
        last_updated: "2018-11-28T16:46:42.000+0000",
        message: "Voice Recording: Unavailable because recording is silent",
        secondary_message: "Recording was detected as silent and not stored.  As a result, it is unavailable for access.",
        product: "Programmable Voice",
    },
    {
        date_created: "2018-11-22T05:06:25.000+0000",
        const_partition: "1",
        docs: "## Warning\r\n\r\n### No Available Unused Proxy\r\n\r\nThis Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for {identifier}. All matching proxies for this Participant are already in use in other Sessions.",
        code: 80208,
        log_level: "ERROR",
        last_updated: "2018-11-22T05:06:25.000+0000",
        message: "No Available Unused Proxy",
        secondary_message: "This Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for {identifier}. All matching proxies for this Participant are already in use in other Sessions.",
        product: "Proxy",
    },
    {
        date_created: "2018-11-21T09:25:29.000+0000",
        const_partition: "1",
        docs: "## Error - 54010\r\n\r\n### Sync: No parameters specified\r\nExpected at least 1 optional parameter, but none were provided.\r\n\r\n#### Possible Causes\r\n* The request expected at least 1 optional parameter, but none was provided.\r\n\r\n#### Possible Solutions\r\n* Add a parameter or confirm that the existing parameters are not misspelled.",
        code: 54010,
        log_level: "ERROR",
        last_updated: "2018-11-21T09:29:38.000+0000",
        message: "No parameters specified",
        secondary_message: "Expected at least 1 optional parameter, but none were provided.",
        product: "Sync",
    },
    {
        date_created: "2018-11-20T19:40:20.000+0000",
        const_partition: "1",
        docs: "## Error - 60204 \r\n\r\n### Service does not support this feature\r\n\r\nYou attempted to use a premium feature but this feature is not enabled in your Service. Further authorization required. Contact Twilio Sales (https://www.twilio.com/help/sales) to have this feature enabled. ",
        code: 60204,
        log_level: "ERROR",
        last_updated: "2018-11-30T19:41:37.000+0000",
        message: "Service does not support this feature",
        secondary_message: "Your service does not have access to this feature.",
        product: "Verify",
    },
    {
        date_created: "2018-11-20T19:39:41.000+0000",
        solutions: "* Complete a verification lifecycle by calling the [Verification Check endpoint](https://www.twilio.com/docs/verify/api/verification-check).\r\n* For use with [custom codes](https://www.twilio.com/docs/verify/api/customization-options) you can manually approve or cancel the verification by calling the [Verification Update endpoint](https://www.twilio.com/docs/verify/api/verification#update-a-verification-status).\r\n* **For testing** you can manually cancel the verification by calling the [Verification Update endpoint](https://www.twilio.com/docs/verify/api/verification#update-a-verification-status).\r\n\r\nIf you identify a delivery issue, please contact [support@twilio.com](mailto:support@twilio.com).",
        causes: "* You have attempted to send the verification code more than 5 times and have reached the limit.\r\n* You have not [checked the verification](https://www.twilio.com/docs/verify/api/verification-check).",
        description: "This rate limit is triggered when the verification lifecycle (sending and checking) is not completed.",
        const_partition: "1",
        docs: "## ERROR - 60203\r\n\r\n### Max send attempts reached.\r\n\r\n This rate limit is triggered when the verification lifecycle (sending and checking) is not completed.\r\n\r\n#### Possible Causes\r\n* You have attempted to send the verification code more than 5 times and have reached the limit.\r\n* You have not [checked the verification](https://www.twilio.com/docs/verify/api/verification-check).\r\n\r\n#### Possible Solutions\r\n* Complete a verification lifecycle by calling the [Verification Check endpoint](https://www.twilio.com/docs/verify/api/verification-check).\r\n* For use with [custom codes](https://www.twilio.com/docs/verify/api/customization-options) you can manually approve or cancel the verification by calling the [Verification Update endpoint](https://www.twilio.com/docs/verify/api/verification#update-a-verification-status).\r\n* **For testing** you can manually cancel the verification by calling the [Verification Update endpoint](https://www.twilio.com/docs/verify/api/verification#update-a-verification-status).\r\n\r\nIf you identify a delivery issue, please contact [support@twilio.com](mailto:support@twilio.com).",
        code: 60203,
        log_level: "ERROR",
        last_updated: "2019-09-26T15:20:50.000+0000",
        message: "Max send attempts reached.",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2018-11-20T19:38:55.000+0000",
        const_partition: "1",
        docs: "## Error - 60202\r\n\r\n### Max verification check attempts reached\r\n\r\n#### Possible Causes\r\n\r\nYou have attempted to check a verification more than 5 times and have reached the limit.\r\n\r\n#### Possible Solutions\r\n* You have 5 attempts to check a verification code, after that you will need to wait until the current verification expires to create a new verification.",
        code: 60202,
        log_level: "ERROR",
        last_updated: "2018-11-30T19:08:24.000+0000",
        message: "Max check attempts reached",
        secondary_message: null,
        product: "Verify",
    },
    {
        date_created: "2018-10-23T23:30:26.000+0000",
        const_partition: "1",
        docs: "## ERROR - 13750\r\n\r\n### Twiml verb not supported in this version of the API\r\nYour version of the API does not support this feature. Please use version 2010-04-01 or later.",
        code: 13750,
        log_level: "ERROR",
        last_updated: "2018-10-23T23:30:26.000+0000",
        message: "Twiml verb not supported by this API version.",
        secondary_message: "Your version of the API does not support this feature. Please use version 2010-04-01 or later.",
        product: "Programmable Voice",
    },
    {
        date_created: "2018-10-16T06:00:40.000+0000",
        solutions: "Check that resource to be updated is set correctly.",
        causes: "The request could not be completed due to a conflict with the current state of the resource.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45202\r\n\r\n### Resource Already Exists\r\n\r\n \r\n\r\n#### Possible Causes\r\nThe request could not be completed due to a conflict with the current state of the resource.\r\n\r\n#### Possible Solutions\r\nCheck that resource to be updated is set correctly.",
        code: 45202,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:23:43.000+0000",
        message: "Resource Already Exists",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2018-10-16T06:00:03.000+0000",
        solutions: "Check that accessed resource is set correctly.",
        causes: "Requested resource could not be found.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45201\r\n\r\n### Resource Not Found\r\n\r\n \r\n\r\n#### Possible Causes\r\nRequested resource could not be found.\r\n\r\n#### Possible Solutions\r\nCheck that accessed resource is set correctly.",
        code: 45201,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:23:35.000+0000",
        message: "Resource Not Found",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2018-10-10T16:26:34.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50341\n\n### Conversations: Invalid messaging service SID\nAn invalid messaging service SID was supplied.\n\n#### Possible Causes\nThe MessagingServiceSid provided with the request does not match a valid SID pattern (MGxx).\n\n#### Possible Solutions\nVerify that the SID provided is prefixed with MG and is not missing digits. Your messaging services can be enumerated at https://twilio.com/console/sms/services.\n",
        code: 50341,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Invalid messaging service SID",
        log_type: "null",
        secondary_message: "An invalid messaging service SID was supplied.",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T16:22:28.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50340\n\n### Conversations: Messaging service SID not provided\nMessaging service SID parameter is required but was not provided with an API request.\n\n#### Possible Causes\n* The API expected a MessagingServiceSid input parameter, but it was either not provided or was misspelled.\n\n#### Possible Solutions\n* Add a valid MessagingServiceSid parameter to the API request and confirm that it is not misspelled.\n\n",
        code: 50340,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Messaging service SID not provided",
        log_type: "null",
        secondary_message: "Messaging service SID parameter is required but was not provided with an API request.",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T16:18:32.000+0000",
        const_partition: "1",
        docs: "## Error - 50332\r\n\r\n### Programmable Chat: Channel webhook url too long\r\n\r\n#### Possible Causes \r\n*  Channel webhook url provided in request is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50332,
        log_level: "ERROR",
        last_updated: "2018-10-10T16:18:32.000+0000",
        message: "Programmable Chat: Channel webhook url too long",
        secondary_message: "Channel webhook url provided in request is too long",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T16:15:40.000+0000",
        const_partition: "1",
        docs: "## Error - 50331\r\n\r\n### Programmable Chat: Channel webhook trigger not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain parameter for channel webhook trigger.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50331,
        log_level: "ERROR",
        last_updated: "2018-10-10T16:23:16.000+0000",
        message: "Programmable Chat: Channel webhook trigger not provided",
        secondary_message: "Request does not contain parameter for webhook trigger",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T16:12:22.000+0000",
        const_partition: "1",
        docs: "## Error - 50330\r\n\r\n### Programmable Chat: Channel webhook filter not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain parameter for channel webhook filter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50330,
        log_level: "ERROR",
        last_updated: "2018-10-10T16:23:09.000+0000",
        message: "Programmable Chat: Channel webhook filter not provided",
        secondary_message: "Request does not contain parameter for webhook filter",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T16:09:45.000+0000",
        const_partition: "1",
        docs: "## Error - 50329\r\n\r\n### Programmable Chat: Channel webhook url not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain parameter for channel webhook url.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50329,
        log_level: "ERROR",
        last_updated: "2018-10-10T16:09:45.000+0000",
        message: "Programmable Chat: Channel webhook url not provided",
        secondary_message: "Request does not contain parameter for webhook url",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T16:01:49.000+0000",
        const_partition: "1",
        docs: "## Error - 50328\r\n\r\n### Programmable Chat: Channel webhook type not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain parameter for channel webhook type.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50328,
        log_level: "ERROR",
        last_updated: "2018-10-10T16:01:49.000+0000",
        message: "Programmable Chat: Channel webhook type not provided",
        secondary_message: "Request does not contain parameter for webhook type",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T15:59:50.000+0000",
        const_partition: "1",
        docs: "## Error - 50327\r\n\r\n### Programmable Chat: Invalid channel webhook flow sid\r\n\r\n#### Possible Causes \r\n*  Request does not contain correct parameter for channel webhook flow sid.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50327,
        log_level: "ERROR",
        last_updated: "2018-10-10T15:59:50.000+0000",
        message: "Programmable Chat: Invalid channel webhook flow sid",
        secondary_message: "Request does not contain correct parameter for webhook flow sid",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T15:53:29.000+0000",
        const_partition: "1",
        docs: "## Error - 50326\r\n\r\n### Programmable Chat: Invalid channel webhook trigger\r\n\r\n#### Possible Causes \r\n*  Request does not contain correct parameter for channel webhook trigger.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50326,
        log_level: "ERROR",
        last_updated: "2018-10-10T16:05:11.000+0000",
        message: "Programmable Chat: Invalid channel webhook trigger",
        secondary_message: "Request does not contain correct parameter for webhook trigger",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T15:31:42.000+0000",
        const_partition: "1",
        docs: "## Error - 50325\r\n\r\n### Programmable Chat: Invalid channel webhook filter\r\n\r\n#### Possible Causes \r\n*  Request does not contain correct parameter for channel webhook filter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50325,
        log_level: "ERROR",
        last_updated: "2018-10-10T15:31:42.000+0000",
        message: "Programmable Chat: Invalid channel webhook filter",
        secondary_message: "Request does not contain correctly formatted parameter for webhook filter",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T15:20:55.000+0000",
        const_partition: "1",
        docs: "## Error - 50324\r\n\r\n### Programmable Chat: Invalid channel webhook type\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for channel webhook type.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50324,
        log_level: "ERROR",
        last_updated: "2018-10-10T15:20:55.000+0000",
        message: "Invalid channel webhook type",
        secondary_message: "Request does not contain correctly formatted parameter for channel webhook type",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T15:05:29.000+0000",
        const_partition: "1",
        docs: "## Error - 50323\r\n\r\n### Programmable Chat: Invalid channel webhook sid\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for channel webhook sid\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50323,
        log_level: "ERROR",
        last_updated: "2018-10-10T15:05:29.000+0000",
        message: "Programmable Chat: Invalid channel webhook sid",
        secondary_message: "Request does not contain correctly formatted parameter for channel webhook sid",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T12:33:59.000+0000",
        const_partition: "1",
        docs: "## Error - 50322\r\n\r\n### Programmable Chat: Too many channel webhook triggers\r\n\r\n#### Possible Causes \r\n*  Triggers limit exceeded for given channel webhook.\r\n\r\n#### Possible Solutions\r\n*  Reduce number of triggers for given channel webhook before creating new one.",
        code: 50322,
        log_level: "ERROR",
        last_updated: "2018-10-10T13:17:20.000+0000",
        message: "Programmable Chat: Too many channel webhook triggers",
        secondary_message: "Triggers limit exceeded for given channel webhook",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T12:31:33.000+0000",
        const_partition: "1",
        docs: "## Error - 50321\r\n\r\n### Programmable Chat: Too many channel webhooks\r\n\r\n#### Possible Causes \r\n*  Webhooks limit exceeded for given channel.\r\n\r\n#### Possible Solutions\r\n*  Reduce number of webhooks for channel before creating new one.",
        code: 50321,
        log_level: "ERROR",
        last_updated: "2018-10-10T12:31:33.000+0000",
        message: "Programmable Chat: Too many channel webhooks",
        secondary_message: "Webhooks limit exceeded for given channel",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T12:07:09.000+0000",
        const_partition: "1",
        docs: "## Error - 50320\r\n\r\n### Programmable Chat: Channel webhook not found\r\n\r\n#### Possible Causes \r\n*  Specified channel webhook does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid channel webhook SID is provided in request.",
        code: 50320,
        log_level: "ERROR",
        last_updated: "2018-10-10T12:14:21.000+0000",
        message: "Programmable Chat: Channel webhook not found",
        secondary_message: "Specified channel webhook does not exist",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T11:43:38.000+0000",
        solutions: "null",
        causes: "null",
        description: "null",
        const_partition: "1",
        docs: "\n## Error - 50211\n\n### Conversations: Identity parameter not acceptable for this Participant\nParticipants on SMS, WhatsApp or other non-Chat channels cannot have Identities.\n\n#### Possible Causes\nThis error is fired when the parameter *Identity* is provided together with either:\n* MessagingBinding.Address,\n* MessagingBinding.ProxyAddress, or\n* both of the above.\n\nAs the error indicates, such a combination is not allowed. You can provide either an address binding or an Identity, but not both.\n\n#### Possible Solutions\n* Avoid using both Identity and MessagingBinding.Address parameters when creating a Conversation participant. Instead, distinguish the use-case for your participants upfront and supply either the Identity for users of Programmable Chat Web/iOS/Android SDKs, or MessagingBinding.Address for non-Chat users such as SMS, MMS, WhatsApp, etc.\n",
        code: 50211,
        log_level: "error",
        last_updated: "2019-12-03T08:14:14.289Z",
        message: "Identity parameter not acceptable for this Participant",
        log_type: "null",
        secondary_message: "Participants on SMS, WhatsApp or other non-Chat channels cannot have Identities.",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T11:27:41.000+0000",
        const_partition: "1",
        docs: "## Error - 50210\r\n\r\n### Programmable Chat: Invalid notification level\r\n\r\n#### Possible Causes \r\n* Specified notification level does not exist.\r\n\r\n#### Possible Solutions\r\n* Confirm a valid notification level is being passed in request. ",
        code: 50210,
        log_level: "ERROR",
        last_updated: "2018-10-10T11:27:41.000+0000",
        message: "Programmable Chat: Invalid notification level",
        secondary_message: "Request contains unknown notification level value",
        product: "Programmable Chat",
    },
    {
        date_created: "2018-10-10T11:21:17.000+0000",
        const_partition: "1",
        docs: "## Error - 50069\r\n\r\n### Programmable Chat: Service instance with provided unique name already exists\r\n\r\n#### Possible Causes \r\n*  Request contains already existing service instance unique name\r\n\r\n#### Possible Solutions\r\n*  Provide non-existent service instance unique name in the request",
        code: 50069,
        log_level: "ERROR",
        last_updated: "2018-10-10T11:21:17.000+0000",
        message: "Programmable Chat: Service instance with provided unique name already exists",
        secondary_message: "Request contains already existing service instance unique name",
        product: null,
    },
    {
        date_created: "2018-10-10T11:03:15.000+0000",
        const_partition: "1",
        docs: "## Error - 50068\r\n\r\n### Programmable Chat: Service instance unique name invalid\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted service instance unique name\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid service instance unique name is being passed in request. ",
        code: 50068,
        log_level: "ERROR",
        last_updated: "2018-10-10T11:03:15.000+0000",
        message: "Programmable Chat: Service instance unique name invalid",
        secondary_message: "Request does not contain correctly formatted service instance unique name",
        product: null,
    },
    {
        date_created: "2018-10-10T09:44:56.000+0000",
        const_partition: "1",
        docs: "## Request Entity Too Large\r\n\r\n### Request entity is larger than limits defined\r\n\r\nRequest entity is larger than limits defined by the server. ",
        code: 20413,
        log_level: "ERROR",
        last_updated: "2018-10-10T09:44:56.000+0000",
        message: "Request Entity Too Large",
        secondary_message: "Request entity is larger than limits defined",
        product: null,
    },
    {
        date_created: "2018-10-05T04:05:45.000+0000",
        const_partition: "1",
        docs: "## Error - 10004\r\n\r\n### Call concurrency limit exceeded\r\n\r\nThe call was rejected because you reached the maximum limit of concurrent calls available for your account.",
        code: 10004,
        log_level: "ERROR",
        last_updated: "2018-10-05T04:05:45.000+0000",
        message: "Call concurrency limit exceeded",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2018-10-05T03:12:52.000+0000",
        const_partition: "1",
        docs: "## Error\r\n\r\n### Internal Server Error from Downstream\r\n\r\nA downstream server failed or refused to process a request.",
        code: 80502,
        log_level: "ERROR",
        last_updated: "2018-10-05T03:12:52.000+0000",
        message: "Internal Server Error from Downstream",
        secondary_message: "A downstream server failed or refused to process a request.",
        product: "Proxy",
    },
    {
        date_created: "2018-10-03T23:24:30.000+0000",
        const_partition: "1",
        docs: "## Error\r\n\r\n### Storage Operation Failed\r\n\r\nAn internal server error has occurred during a storage operation",
        code: 80501,
        log_level: "ERROR",
        last_updated: "2018-10-03T23:24:30.000+0000",
        message: "Storage Operation Failed",
        secondary_message: "An internal server error has occurred during a storage operation",
        product: "Proxy",
    },
    {
        date_created: "2018-10-03T17:41:08.000+0000",
        solutions: "* Check the syntax used in your widget (See Liquid docs [here](https://www.twilio.com/docs/studio/user-guide/liquid-template-language))\r\n* Verify the runtime data of your flow execution by checking the Flow Data and inspecting any variables you may have referenced\r\n* Verify that your Liquid curly braces are matched\r\n* Verify that all tags and filters used in your template are correct (The list of available filters is [here](https://www.twilio.com/docs/studio/user-guide/liquid-template-language#standard-filters))",
        causes: "* The syntax used in your widget caused an error\r\n* An array index referenced in your widget didn't exist at execution time\r\n* Your Liquid curly braces are mismatched\r\n* You used a `+` character in your template\r\n* You have improperly assigned a variable\r\n* A tag or filter used in your template does not exist",
        description: "An error occurred when Studio tried to evaluate your template syntax.",
        const_partition: "1",
        docs: "## WARNING - 81018\r\n\r\n### Template evaluation error in Studio widget\r\n\r\n An error occurred when Studio tried to evaluate your template syntax.\r\n\r\n#### Possible Causes\r\n* The syntax used in your widget caused an error\r\n* An array index referenced in your widget didn't exist at execution time\r\n* Your Liquid curly braces are mismatched\r\n* You used a `+` character in your template\r\n* You have improperly assigned a variable\r\n* A tag or filter used in your template does not exist\r\n\r\n#### Possible Solutions\r\n* Check the syntax used in your widget (See Liquid docs [here](https://www.twilio.com/docs/studio/user-guide/liquid-template-language))\r\n* Verify the runtime data of your flow execution by checking the Flow Data and inspecting any variables you may have referenced\r\n* Verify that your Liquid curly braces are matched\r\n* Verify that all tags and filters used in your template are correct (The list of available filters is [here](https://www.twilio.com/docs/studio/user-guide/liquid-template-language#standard-filters))",
        code: 81018,
        log_level: "WARNING",
        last_updated: "2019-10-03T16:27:43.000+0000",
        message: "Template evaluation error in Studio widget",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-10-01T08:56:00.000+0000",
        solutions: "Update the configuration: set the workspace.",
        causes: "Workspace is not defined in the configuration.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45103\r\n\r\n### Workspace Not Configured\r\n\r\n \r\n\r\n#### Possible Causes\r\nWorkspace is not defined in the configuration.\r\n\r\n#### Possible Solutions\r\nUpdate the configuration: set the workspace.",
        code: 45103,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:23:28.000+0000",
        message: "Workspace Not Configured",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2018-10-01T08:55:12.000+0000",
        solutions: "Try to update the configuration again.",
        causes: "Configuration for the same account was changed by other request mostly at the same time.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45102\r\n\r\n### Collision On Configuration Change\r\n\r\n \r\n\r\n#### Possible Causes\r\nConfiguration for the same account was changed by other request mostly at the same time.\r\n\r\n#### Possible Solutions\r\nTry to update the configuration again.",
        code: 45102,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:23:21.000+0000",
        message: "Collision On Configuration Change",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2018-10-01T08:54:26.000+0000",
        solutions: "Ensure, that configuration for specific account is created, create one if not.",
        causes: "Queried configuration is not yet created for specified account.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45101\r\n\r\n### Configuration Not Found\r\n\r\n \r\n\r\n#### Possible Causes\r\nQueried configuration is not yet created for specified account.\r\n\r\n#### Possible Solutions\r\nEnsure, that configuration for specific account is created, create one if not.",
        code: 45101,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:23:12.000+0000",
        message: "Configuration Not Found",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2018-10-01T08:53:15.000+0000",
        solutions: "Try the request again.",
        causes: "Service or one of it dependent services does not respond, timeout, etc.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45005\r\n\r\n### Service Unavailable\r\n\r\n \r\n\r\n#### Possible Causes\r\nService or one of it dependent services does not respond, timeout, etc.\r\n\r\n#### Possible Solutions\r\nTry the request again.",
        code: 45005,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:21:10.000+0000",
        message: "Service Unavailable",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2018-10-01T08:52:05.000+0000",
        solutions: "Review the input and fix (if possible) the problem mentioned in the error message.",
        causes: "Request body validation fails.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45004\r\n\r\n### Validation Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nRequest body validation fails.\r\n\r\n#### Possible Solutions\r\nReview the input and fix (if possible) the problem mentioned in the error message.",
        code: 45004,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:20:39.000+0000",
        message: "Validation Error",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2018-10-01T08:51:10.000+0000",
        solutions: "Check that accessed resource is set correctly or apply for permissions.",
        causes: "Attempt to access resource where access is not allowed for given credentials.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45003\r\n\r\n### Authorization Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nAttempt to access resource where access is not allowed for given credentials.\r\n\r\n#### Possible Solutions\r\nCheck that accessed resource is set correctly or apply for permissions.",
        code: 45003,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:20:32.000+0000",
        message: "Authorization Error",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2018-10-01T08:49:49.000+0000",
        solutions: "Check the credentials and try again.",
        causes: "Attempt to access resource with invalid credentials or without credentials.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45002\r\n\r\n### Authentication Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nAttempt to access resource with invalid credentials or without credentials.\r\n\r\n#### Possible Solutions\r\nCheck the credentials and try again.",
        code: 45002,
        log_level: "ERROR",
        last_updated: "2019-07-09T15:20:20.000+0000",
        message: "Authentication Error",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2018-10-01T08:48:39.000+0000",
        solutions: "No further information available.",
        causes: "Flex encountered a general service error.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 45001\r\n\r\n### General Service Error\r\n\r\n \r\n\r\n#### Possible Causes\r\nFlex encountered a general service error.\r\n\r\n#### Possible Solutions\r\nNo further information available.",
        code: 45001,
        log_level: "ERROR",
        last_updated: "2019-07-08T11:21:31.000+0000",
        message: "General Service Error",
        log_type: "TWILIO",
        secondary_message: null,
        product: "Flex",
    },
    {
        date_created: "2018-09-28T16:25:58.000+0000",
        const_partition: "1",
        docs: '## Warning -  53632\r\n\r\n### Failed to enqueue a room composition\r\n\r\nThere was a failure enqueuing a composition for processing.\r\n\r\n#### Causes\r\n\r\n * There was an internal error when enqueuing the composition.\r\n\r\n#### Solutions\r\n\r\n* The composition can be launched again using the <a href="/docs/video/api/compositions-resource">REST API</a>.\r\n\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!',
        code: 53632,
        log_level: "WARNING",
        last_updated: "2018-09-28T16:25:58.000+0000",
        message: "Failed to enqueue a room composition",
        secondary_message: "The job will not be executed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-09-28T16:22:30.000+0000",
        const_partition: "1",
        docs: '## Warning -  53631\r\n\r\n### Failed to enqueue a room composition from a configured composition hook\r\n\r\nThere was a failure creating or enqueuing a composition for a completed Group Room, using the configuration from a composition hook.\r\n\r\n#### Causes\r\n\r\n * We failed to create the composition or the configuration was not suitable for a specific Group Room.\r\n\r\n#### Solutions\r\n\r\n* Verify the composition hook configured in your account\'s console.\r\n\r\n* The composition can also be launched manually using the <a href="/docs/video/api/compositions-resource">REST API</a>.\r\n\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!',
        code: 53631,
        log_level: "WARNING",
        last_updated: "2018-09-28T16:22:30.000+0000",
        message: "Failed to enqueue a room composition from a configured composition hook",
        secondary_message: "The group room will not be composed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-09-28T16:09:33.000+0000",
        const_partition: "1",
        docs: "## Error -  53630\r\n\r\n### Empty track list for composition\r\n\r\nThe combination of sources and exclusions passed to the composition resulted in an empty track list. The composition job did not start.\r\n\r\n#### Causes\r\n\r\n * You specified an incorrect list of sources and exclusions, audio and video, which have resulted in an empty track list.\r\n\r\n#### Solutions\r\n\r\n * Recreate the composition using an updated list of sources and exclusions.",
        code: 53630,
        log_level: "ERROR",
        last_updated: "2018-09-28T16:09:33.000+0000",
        message: "Empty track list for composition",
        secondary_message: "The composition job did not start",
        product: "Programmable Video",
    },
    {
        date_created: "2018-09-28T16:02:46.000+0000",
        const_partition: "1",
        docs: "## Warning - 53616\r\n\r\n### Deleted a recording with custom configuration as time for retries was depleted\r\n\r\nTwilio gave up on uploading your recording with custom configuration, as time for retries was depleted. The recording has been removed and will not be available.\r\n\r\n#### Causes\r\n\r\n * There was an error with your account's recording settings, either due to the access credentials for your own bucket or to the encryption key.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, review the credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).\r\n\r\n* In the recording settings section of your account's console, set a valid public key or disable the encryption (media will be uploaded in raw).",
        code: 53616,
        log_level: "WARNING",
        last_updated: "2018-09-28T16:02:46.000+0000",
        message: "Deleted a recording with custom configuration as time for retries was depleted",
        secondary_message: "The recording has been removed and will not be available",
        product: "Programmable Video",
    },
    {
        date_created: "2018-09-25T20:45:28.000+0000",
        const_partition: "1",
        docs: "## Warning\r\n\r\n### Not Found Chat Service\r\n\r\nFound no chat instance associated with service {ProxyServiceSid}",
        code: 80306,
        log_level: "ERROR",
        last_updated: "2018-09-25T20:45:28.000+0000",
        message: "Not Found Chat Service",
        secondary_message: "Found no chat instance associated with service {ProxyServiceSid}",
        product: "Proxy",
    },
    {
        date_created: "2018-09-21T17:11:37.000+0000",
        const_partition: "1",
        docs: "## Error - 82003\r\n\r\n### Deployment Installation Failure\r\nYour latest Functions and Private Assets failed to be deployed\r\n\r\n#### Possible Causes\r\n* NPM registry is degraded\r\n* Your Service instance is trying to install a package that requires a gcc compiler \r\n* Your Service instance resulted in out of space error due to large packages\r\n\r\n#### Possible Solutions",
        code: 82003,
        log_level: "ERROR",
        last_updated: "2018-09-21T17:17:58.000+0000",
        message: "Deployment Installation Failure",
        secondary_message: null,
        product: "Functions",
    },
    {
        date_created: "2018-09-19T18:48:09.000+0000",
        const_partition: "1",
        docs: "## Error - 81017\r\n\r\n### Error on Twilio Function response\r\nThere was an error in the response back from a Twilio Function attached to the Studio flow.\r\n\r\n#### Possible Causes\r\n* Your Function timed out before responding\r\n* Your Function returned an error response\r\n\r\n#### Possible Solutions\r\n* Your Function must contain a callback.\r\n* Make sure you place the Function callback `callback(err, response)` is placed correctly in your Function code.\r\n * If you are using a JavaScript promise, make sure the callback is called in both success and catch blocks.\r\n* Your Function responded with an error.",
        code: 81017,
        log_level: "ERROR",
        last_updated: "2018-09-19T18:48:25.000+0000",
        message: "Error in Twilio Function Response",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-09-19T18:47:42.000+0000",
        const_partition: "1",
        docs: "## Error - 81016\r\n\r\n### Outgoing HTTP request failed\r\nThe outgoing HTTP request from a Studio widget failed.\r\n\r\n#### Possible Causes\r\n* The URL you are requesting is incorrect\r\n* The response is badly formed\r\n* The URL returned a 4xx or 5xx error code\r\n\r\n#### Possible Solutions\r\n* Make sure the request results in a response code 2xx or 3xx\r\n",
        code: 81016,
        log_level: "ERROR",
        last_updated: "2018-11-26T16:30:07.000+0000",
        message: "Outbound HTTP Request Failed",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-09-18T20:08:16.000+0000",
        const_partition: "1",
        docs: "## Error\r\n\r\n### Not Found Unmanaged Identifier Sid\r\n\r\nExample Message: Unmanaged Proxy Identifier not found.  Unmanaged identifiers include non-phone number identifiers (e.g., a facebook messenger page id). If you want to include channels such as Facebook Messenger, WhatsApp, etc. as Proxy participants, you must configure the channel integration callback url to point to your proxy service: https://webhooks.twilio.com/v1/Accounts/{AccountSid}/Proxy/{ServiceSid}/Webhooks/Message",
        code: 80305,
        log_level: "ERROR",
        last_updated: "2018-09-18T20:08:16.000+0000",
        message: "Not Found Unmanaged Identifier Sid",
        secondary_message: "Unmanaged Proxy Identifier not found.  Unmanaged identifiers include non-phone number identifiers (e.g., a facebook messenger page id). If you want to include channels such as Facebook Messenger, WhatsApp, etc. as Proxy participants, you must configure the channel integration callback url to point to your proxy service: https://webhooks.twilio.com/v1/Accounts/<AccountSid>/Proxy/<ServiceSid>/Webhooks/Message",
        product: "Proxy",
    },
    {
        date_created: "2018-09-18T19:55:29.000+0000",
        const_partition: "1",
        docs: "## Warning\r\n\r\n### Not Found Unmanaged Identifier\r\n\r\nUnmanaged Proxy Identifier not found.  Unmanaged identifiers include non-phone number identifiers (e.g., a facebook messenger page id). Possibly you tried to add a participant with a proxy identifier for a channel that is not managed by Twilio or by your Proxy Service.",
        code: 80304,
        log_level: "WARNING",
        last_updated: "2018-09-18T19:55:29.000+0000",
        message: "Not Found Unmanaged Identifier",
        secondary_message: "Unmanaged Proxy Identifier not found.  Unmanaged identifiers include non-phone number identifiers (e.g., a facebook messenger page id). Possibly you tried to add a participant with a proxy identifier for a channel that is not managed by Twilio or by your Proxy Service.",
        product: "Proxy",
    },
    {
        date_created: "2018-09-12T03:00:55.000+0000",
        const_partition: "1",
        docs: "## Warning - 82001\r\n\r\n### Function invocation resulted in StatusCode 4xx\r\nYour Function invocation returned a 4xx StatusCode. \r\n\r\n#### Possible Causes\r\n* Function route does not exist\r\n* Function is set to Private and invocation request is not signed\r\n\r\n#### Possible Solutions\r\n* Check the Function route you are invoking exists\r\n* Check whether the Function's *Access Control* is set to Private and whether you intended to have it set as so. If it is Private, then your request must be properly signed.",
        code: 82001,
        log_level: "WARNING",
        last_updated: "2019-06-07T04:39:54.000+0000",
        message: "Function invocation resulted in StatusCode 4xx",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Functions",
    },
    {
        date_created: "2018-09-12T03:00:29.000+0000",
        const_partition: "1",
        docs: "## Error - 82002\r\n\r\n### Error on Twilio Function response\r\nYour Function invocation resulted in StatusCode 5xx.\r\n\r\n#### Possible Causes\r\n* Your Function timed out before responding\r\n* Your Function returned an error response\r\n\r\n#### Possible Solutions\r\n* Your Function must contain a callback.\r\n* Make sure you place the Function callback `callback(err, response)` is placed correctly in your Function code.\r\n * If you are using a JavaScript promise, make sure the callback is called in both success and catch blocks.\r\n* Your Function responded with an error.",
        code: 82002,
        log_level: "ERROR",
        last_updated: "2018-09-12T03:00:29.000+0000",
        message: "Error on Twilio Function response",
        secondary_message: null,
        product: "Functions",
    },
    {
        date_created: "2018-08-30T17:32:59.000+0000",
        const_partition: "1",
        docs: "## Error - 21652\r\n\r\n### Maximum subject text length is 40 characters\r\n\r\nThe subject text of your message should be 40 characters or less.\r\n",
        code: 21652,
        log_level: "ERROR",
        last_updated: "2018-08-30T17:35:25.000+0000",
        message: "Maximum subject length is 40 characters",
        secondary_message: "Keep the subject text of your message to 40 characters or less.",
        product: "Programmable SMS",
    },
    {
        date_created: "2018-08-28T02:36:57.000+0000",
        const_partition: "1",
        docs: "## Error\r\n\r\n### Account Sid on Legal Hold\r\n\r\nAccount <AccountSid> is on legal hold.  Cannot delete record <Sid>.",
        code: 80615,
        log_level: "ERROR",
        last_updated: "2018-08-28T02:36:57.000+0000",
        message: "Account Sid on Legal Hold",
        secondary_message: "Account <AccountSid> is on legal hold.  Cannot delete record <Sid>.",
        product: "Proxy",
    },
    {
        date_created: "2018-08-28T02:35:15.000+0000",
        const_partition: "1",
        docs: "## Error\r\n\r\n### Unsupported Identifier Type For Session Mode\r\n\r\nCannot add <Identifier> to session <SessionSid>. The identifier is not compatible with the session mode.",
        code: 80616,
        log_level: "ERROR",
        last_updated: "2018-08-28T02:35:15.000+0000",
        message: "Unsupported Identifier Type For Session Mode",
        secondary_message: "Cannot add <Identifier> to session <SessionSid>. The identifier is not compatible with the session mode.",
        product: "Proxy",
    },
    {
        date_created: "2018-08-27T20:31:01.000+0000",
        const_partition: "1",
        docs: "## Error - 31007\r\n\r\n### Twilio Client: This JS client version has been deprecated\r\n\r\n#### Possible Solutions\r\n\r\n- Migrate to newer version of Twilio JS client by following the direction provided here: https://www.twilio.com/docs/voice/client/javascript/sdk-11-12-migration-guide",
        code: 31007,
        log_level: "ERROR",
        last_updated: "2018-08-27T20:31:01.000+0000",
        message: "Twilio Client: Client version not supported",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2018-08-20T23:43:15.000+0000",
        const_partition: "1",
        docs: "## Error - 81015\r\n\r\n### Task was not successfully created\r\nAn error occurred when Studio attempted to create task.\r\n\r\n#### Possible Causes\r\n* Required values are missing from the widget.\r\n* Values are not correctly formatted (e.g. Attributes)\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?\r\n",
        code: 81015,
        log_level: "ERROR",
        last_updated: "2018-08-20T23:43:18.000+0000",
        message: "Failed to Create Task",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-07-26T21:31:58.000+0000",
        const_partition: "1",
        docs: "## Error - 70253\r\n\r\n### Invalid User Grants\r\nThe Request tries to authenticate through SSO. The request is well-formed, but the user grants stored is not a valid grants form.\r\n\r\n#### Possible Causes \r\n* Invalid User Grants.\r\n\r\n#### Possible Solution\r\n* Reconfigure the user grants and retry.",
        code: 70253,
        log_level: "ERROR",
        last_updated: "2018-07-26T21:33:06.000+0000",
        message: "Invalid User Grants",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2018-07-26T21:27:33.000+0000",
        const_partition: "1",
        docs: "## Error - 70252\r\n\r\n### Bad Saml Response\r\nThe Request tries to authenticate through SSO. The request is well-formed, but the response from the Identity Provider is missing necessary attributes. \r\n\r\n#### Possible Causes \r\n* Misconfigured Identity Provider settings\r\n\r\n#### Possible Solution\r\n* Reconfigure the Identity Provider settings and retry.",
        code: 70252,
        log_level: "ERROR",
        last_updated: "2018-07-26T21:27:33.000+0000",
        message: "Bad Saml Response",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2018-07-26T21:18:48.000+0000",
        const_partition: "1",
        docs: "## Error - 70251\r\n\r\n### Bad SSO Settings\r\nThe Request tries to authenticate through SSO. The request is well-formed, but the configured settings for the SSO is not valid.\r\n\r\n#### Possible Causes \r\n* Malformed urls\r\n* Missing certificates\r\n\r\n#### Possible Solution\r\n* Reconfigure the SSO settings and retry.",
        code: 70251,
        log_level: "ERROR",
        last_updated: "2018-07-26T22:15:45.000+0000",
        message: "Bad SSO Settings",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2018-07-26T20:08:56.000+0000",
        const_partition: "1",
        docs: "## Error - 11202\r\n### TCP connection refused\r\nTwilio cannot establish a TCP connection to your web server. Your web server rejected our two connection attempts.\r\n\r\n#### Possible Causes\r\n* invalid port number in the HTTP URL\r\n* your web server process is down so no process is listening on the port\r\n* your web server is in a degraded state and is not accepting new connections (e.g., overloaded)\r\n\r\n#### Possible Solutions\r\n* verify the HTTP URL provided has the correct host and port number of your web server\r\n* verify your web server is running and listening on the correct port\r\n* verify your web server is properly provisioned to handle all requests",
        code: 11202,
        log_level: "ERROR",
        last_updated: "2018-07-26T20:08:56.000+0000",
        message: "TCP connection refused",
        secondary_message: "Twilio cannot establish a TCP connection to your web server. Your web server rejected our two connection attempts.",
        product: null,
    },
    {
        date_created: "2018-07-26T20:08:21.000+0000",
        const_partition: "1",
        docs: "## Error - 11201\r\n### TCP connection timed out\r\nTwilio cannot establish a TCP connection to your web server. The two attempts to connect to your web server were timed out. Each connection attempt has a 5 second timeout.\r\n\r\n#### Possible Causes\r\n* firewall in your network blocking incoming TCP traffic\r\n* network outage between Twilio and your web server\r\n* invalid host part in the HTTP URL pointing to non-existing host or private IP address\r\n\r\n#### Possible Solutions\r\n* verify firewall configuration in your network or on the web server\r\n* verify network connectivity to your web server\r\n* verify the HTTP URL provided is accessible to the public Internet",
        code: 11201,
        log_level: "ERROR",
        last_updated: "2018-07-26T20:08:21.000+0000",
        message: "TCP connection timed out",
        secondary_message: "Twilio cannot establish a TCP connection to your web server. The two attempts to connect to your web server were timed out. Each connection attempt has a 5 second timeout.",
        product: null,
    },
    {
        date_created: "2018-07-05T18:04:49.000+0000",
        const_partition: "1",
        docs: "## Error - 21619\r\n\r\n### Unable to create record\r\n\r\nA text message body or media urls must be specified.",
        code: 21619,
        log_level: "ERROR",
        last_updated: "2018-07-05T18:04:49.000+0000",
        message: "Unable to create record",
        secondary_message: "A text message body or media urls must be specified",
        product: "Programmable SMS",
    },
    {
        date_created: "2018-07-02T13:45:27.000+0000",
        const_partition: "1",
        docs: "## Error -  53628\r\n\r\n### Room recordings deleted\r\n\r\nThe recordings for the room specified in your composition job have been deleted. Although the metadata for the recordings is present, the media has been removed from the Twilio Cloud and can't be recovered.\r\n\r\n#### Causes\r\n\r\n * You have deleted your Room Recordings, either from the console or the API.\r\n\r\n#### Solutions\r\n\r\n * There's no solution for this. Once the recorded media files are deleted from the system, they are gone forever.",
        code: 53628,
        log_level: "ERROR",
        last_updated: "2018-09-28T16:12:17.000+0000",
        message: "Room recordings deleted",
        secondary_message: "The recordings for the room have been deleted from the system",
        product: "Programmable Video",
    },
    {
        date_created: "2018-06-29T13:07:16.000+0000",
        const_partition: "1",
        docs: "## Warning - 53607\r\n\r\n### Internal failure when updating the recording resource\r\n\r\nRaised when an error prevented us from updating an internal resource tracking the media recording.\r\n\r\nThe recording's media will not be accessible directly from Twilio until we remediate the situation but the media file has probably been stored safely to S3.\r\n\r\n#### Causes\r\n\r\n* An internal error prevented us from updating a resource. We'll attempt again shortly.\r\n\r\n#### Solutions\r\n\r\n* If the error persists, please <a href=\"/help/contact\">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and what you were trying to do when it occurred!",
        code: 53607,
        log_level: "WARNING",
        last_updated: "2018-06-29T13:07:16.000+0000",
        message: "Internal failure when updating the recording resource",
        secondary_message: "A new attempt will be made after a delay",
        product: "Programmable Video",
    },
    {
        date_created: "2018-06-29T13:06:14.000+0000",
        const_partition: "1",
        docs: '## Warning - 53606\r\n\r\n### Internal failure when creating the recording resource\r\n\r\nRaised when an error prevented us from creating an internal resource tracking the media recording.\r\n\r\nThe recording will not be accessible directly from Twilio until we remediate the situation but the media file has probably been stored safely to S3.\r\n\r\n#### Causes\r\n\r\n* An internal error prevented us from creating a resource. We\'ll attempt again shortly.\r\n\r\n#### Solutions\r\n\r\n* If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and what you were trying to do when it occurred!',
        code: 53606,
        log_level: "WARNING",
        last_updated: "2018-06-29T13:06:14.000+0000",
        message: "Internal failure when creating the recording resource",
        secondary_message: "A new attempt will be made after a delay",
        product: "Programmable Video",
    },
    {
        date_created: "2018-06-26T23:17:30.000+0000",
        const_partition: "1",
        docs: "## Error - 81014\r\n\r\n### There was an error while processing an HTTP request\r\nAn error occurred when Studio was executing an HTTP request as part of the Webhook widget. \r\n\r\n#### Possible Causes\r\n* The URL is invalid.\r\n* Required values are missing from the widget.\r\n* The URL took too longer than 5 seconds to respond\r\n\r\n#### Possible Solutions\r\n* Verify all widget fields are filled out correctly\r\n* Check the HTTP request URL is valid and accessible\r\n* Ensure the URL responds within 5 seconds",
        code: 81014,
        log_level: "ERROR",
        last_updated: "2018-12-07T00:44:14.000+0000",
        message: "There was an error while processing an HTTP request",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:17:15.000+0000",
        const_partition: "1",
        docs: "## Error - 81013\r\n\r\n### Failed to invoke Understand API\r\nStudio was unable to invoke the Understand API while executing the Flow\r\n\r\n#### Possible Causes\r\n* The request to the Understand API failed.\r\n* Invalid values were passed to the Understand API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?",
        code: 81013,
        log_level: "ERROR",
        last_updated: "2018-06-26T23:17:15.000+0000",
        message: "Failed to invoke Understand API",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:17:01.000+0000",
        const_partition: "1",
        docs: "## Error - 81012\r\n\r\n### Failed to update Sync service\r\nStudio was unable to update the Sync Service while executing the Flow\r\n\r\n#### Possible Causes\r\n* The request to the Sync API failed.\r\n* Invalid values were passed to the Sync API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?",
        code: 81012,
        log_level: "ERROR",
        last_updated: "2018-06-26T23:17:01.000+0000",
        message: "Failed to update Sync service",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:16:46.000+0000",
        const_partition: "1",
        docs: "## Error - 81011\r\n\r\n### Failed to send Message\r\nStudio was unable to send a Message. This is usually due to incorrect setup of a Message Widget.\r\n\r\n#### Possible Causes\r\n* You have an invalid number.\r\n* You are missing a message body.\r\n* You are missing a Media URL\r\n\r\n#### Possible Solutions\r\n* Ensure the message number is valid.\r\n* Ensure you have set a correct message body in the Widget.\r\n* Ensure you have setup a Media URL.",
        code: 81011,
        log_level: "ERROR",
        last_updated: "2018-06-26T23:16:46.000+0000",
        message: "Failed to send Message",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:16:30.000+0000",
        const_partition: "1",
        docs: "## Error - 81010\r\n\r\n### There was an internal error while processing a Function\r\nStudio could not invoke the Function service.\r\n\r\n#### Possible Causes\r\n* The Function returned a 4xx or 5xx status code\r\n* The Function timed out or did not include `callback()`\r\n* There may be an issue with Twilio Function Service\r\n\r\n#### Possible Solutions\r\n* Verify your Function calls `callback()` to avoid timeouts\r\n* Check your Function logs for runtime errors\r\n* Ensure you're returning the correct status code",
        code: 81010,
        log_level: "ERROR",
        last_updated: "2018-07-24T20:49:33.000+0000",
        message: "There was an internal error while processing a Function",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:16:03.000+0000",
        const_partition: "1",
        docs: "## Error - 81009\r\n\r\n### Timed out enqueueing Call\r\nStudio timed out while executing the Enqueue Call widget in the Flow.\r\n\r\n#### Possible Causes\r\n* The request to the Taskrouter API failed.\r\n* Invalid values were passed to the Taskrouter API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?",
        code: 81009,
        log_level: "ERROR",
        last_updated: "2018-06-26T23:16:03.000+0000",
        message: "Timed out enqueueing Call",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:15:49.000+0000",
        const_partition: "1",
        docs: "## Error - 81008\r\n\r\n### Failed to connect to outgoing Call\r\nStudio was unable to connect a call while processing the Outgoing Call widget.\r\n\r\n#### Possible Causes\r\n* The request to the Voice API failed.\r\n* Invalid values were passed to the Voice API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?",
        code: 81008,
        log_level: "ERROR",
        last_updated: "2018-06-26T23:15:49.000+0000",
        message: "Failed to connect to outgoing Call",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:15:34.000+0000",
        const_partition: "1",
        docs: "## Error - 81007\r\n\r\n### Connecting to a Call timed out\r\nStudio timed out while executing the Connect Caller widget in the Flow.\r\n\r\n#### Possible Causes\r\n* The call could not be completed before the end of the timeout period.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?",
        code: 81007,
        log_level: "ERROR",
        last_updated: "2018-06-26T23:15:34.000+0000",
        message: "Connecting to a Call timed out",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:15:14.000+0000",
        const_partition: "1",
        docs: "## Error - 81006\r\n\r\n### Failed to create Chat Channel\r\nStudio was unable to create the Chat Channel while executing the Flow\r\n\r\n#### Possible Causes\r\n* The request to the Chat API failed.\r\n* Invalid values were passed to the Chat API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?",
        code: 81006,
        log_level: "ERROR",
        last_updated: "2018-06-26T23:15:14.000+0000",
        message: "Failed to create Chat Channel",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:14:59.000+0000",
        const_partition: "1",
        docs: "## Warning - 81005\r\n\r\n### Failed to transition because no match was found\r\nStudio was unable to transition to the next widget because no matching transition was found in the Split widget.\r\n\r\n#### Possible Causes\r\n* Missing values in the match field.\r\n* Match field is in the wrong format.\r\n* Regular expression is too restrictive.\r\n\r\n#### Possible Solutions\r\n* Check the values that you\u2019re matching against in the Split widget.",
        code: 81005,
        log_level: "WARNING",
        last_updated: "2018-06-26T23:14:59.000+0000",
        message: "Failed to transition because no match was found",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:14:37.000+0000",
        const_partition: "1",
        docs: "## Error - 81004\r\n\r\n### Failed to add member to Chat Channel\r\nStudio was unable to add a member to the Chat Channel while executing the Flow\r\n\r\n#### Possible Causes\r\n* The request to the Chat API failed.\r\n* Invalid values were passed to the Chat API.\r\n\r\n#### Possible Solutions\r\n* Check the Widget configuration. Are all fields filled out correctly?",
        code: 81004,
        log_level: "ERROR",
        last_updated: "2018-06-26T23:14:37.000+0000",
        message: "Failed to add member to Chat Channel",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:14:17.000+0000",
        solutions: "* Incoming Calls only: Enable [Concurrent Calls](https://www.twilio.com/docs/studio/user-guide#handling-concurrent-calls-from-the-same-number-in-studio) in the Flow's Trigger widget.\r\n* Ensure widgets and transitions are connected in a logical sequence for the communication method being used.\r\n* Return results for Function calls and HTTP requests quickly.\r\n* End any [stuck Executions](https://support.twilio.com/hc/en-us/articles/360019383714-Understanding-and-Avoiding-Stuck-Executions-in-Twilio-Studio) via Twilio Console.",
        causes: '* A hangup for a phone call was detected while processing a widget that does not have a "Hangup" transition (e.g. HTTP Request or Send Message).\r\n* A new call or message was initiated for a contact address (e.g. phone number) that already has an active Execution.\r\n* An event came in while processing a widget that cannot handle that event (e.g. incoming message received during Run Function widget).\r\n* There was no transition that matched the received event.',
        description: "An unexpected event was received while processing a widget. Studio ignored this event and did not transition to another widget because there was no matching transition available to handle the event. \r\n\r\n*Note:* If the Execution ended correctly, this warning can be ignored.",
        const_partition: "1",
        docs: '## WARNING - 81002\r\n\r\n### Unexpected event while processing Widget\r\n\r\n An unexpected event was received while processing a widget. Studio ignored this event and did not transition to another widget because there was no matching transition available to handle the event. \r\n\r\n*Note:* If the Execution ended correctly, this warning can be ignored.\r\n\r\n#### Possible Causes\r\n* A hangup for a phone call was detected while processing a widget that does not have a "Hangup" transition (e.g. HTTP Request or Send Message).\r\n* A new call or message was initiated for a contact address (e.g. phone number) that already has an active Execution.\r\n* An event came in while processing a widget that cannot handle that event (e.g. incoming message received during Run Function widget).\r\n* There was no transition that matched the received event.\r\n\r\n#### Possible Solutions\r\n* Incoming Calls only: Enable [Concurrent Calls](https://www.twilio.com/docs/studio/user-guide#handling-concurrent-calls-from-the-same-number-in-studio) in the Flow\'s Trigger widget.\r\n* Ensure widgets and transitions are connected in a logical sequence for the communication method being used.\r\n* Return results for Function calls and HTTP requests quickly.\r\n* End any [stuck Executions](https://support.twilio.com/hc/en-us/articles/360019383714-Understanding-and-Avoiding-Stuck-Executions-in-Twilio-Studio) via Twilio Console.',
        code: 81002,
        log_level: "WARNING",
        last_updated: "2019-11-06T18:49:32.000+0000",
        message: "Unexpected event while processing Widget",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:14:02.000+0000",
        const_partition: "1",
        docs: "## Warning - 81001\r\n\r\n### Widget has exceeded max steps in a loop\r\nThis limitation is enforced to prevent infinite loops. Please try to design your flows such that they terminate.\r\n\r\n#### Possible Causes\r\n* You have a single widget looping back on itself too many times.\r\n\r\n#### Possible Solutions\r\n* Remove the single widget loop.",
        code: 81001,
        log_level: "WARNING",
        last_updated: "2018-06-26T23:14:02.000+0000",
        message: "The Widget has exceeded max steps in a loop",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-26T23:13:46.000+0000",
        solutions: "* Reduce the number of steps in your flow.",
        causes: "* You have too many steps in your flow.",
        description: "This limitation is enforced to prevent infinite loops. Please try to design your flows such that they terminate.",
        const_partition: "1",
        docs: "## WARNING - 81000\r\n\r\n### The Execution has exceeded max steps allowed for a flow\r\n\r\n This limitation is enforced to prevent infinite loops. Please try to design your flows such that they terminate.\r\n\r\n#### Possible Causes\r\n* You have too many steps in your flow.\r\n\r\n#### Possible Solutions\r\n* Reduce the number of steps in your flow.",
        code: 81000,
        log_level: "WARNING",
        last_updated: "2019-06-19T00:28:51.000+0000",
        message: "The Execution has exceeded max steps allowed for a flow",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Studio",
    },
    {
        date_created: "2018-06-25T18:44:31.000+0000",
        solutions: "Instruct the recipient to join your Sandbox by sending the join phrase or keyword shown on the Sandbox page in your Twilio Console.",
        causes: "This message failed to be delivered to the user because it was sent from a Sandbox to a phone number that has not joined your Sandbox",
        description: "Channel Sandbox can only send messages to phone numbers that have joined the Sandbox",
        const_partition: "1",
        docs: "## ERROR - 63015\r\n\r\n### Channel Sandbox can only send messages to phone numbers that have joined the Sandbox\r\n\r\n Channel Sandbox can only send messages to phone numbers that have joined the Sandbox\r\n\r\n#### Possible Causes\r\nThis message failed to be delivered to the user because it was sent from a Sandbox to a phone number that has not joined your Sandbox\r\n\r\n#### Possible Solutions\r\nInstruct the recipient to join your Sandbox by sending the join phrase or keyword shown on the Sandbox page in your Twilio Console.",
        code: 63015,
        log_level: "ERROR",
        last_updated: "2019-06-25T21:07:58.000+0000",
        message: "Channel Sandbox can only send messages to phone numbers that have joined the Sandbox",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-06-25T10:21:51.000+0000",
        const_partition: "1",
        docs: '## Error - 53627\r\n\r\n### Internal failure when updating the composition resource\r\n\r\nRaised when an error prevented us from updating the resource tracking the media composition.\r\n\r\nThe media will not be accessible directly from Twilio until we remediate the situation but the composition media file has probably been stored safely to S3.\r\n\r\n#### Causes\r\n\r\n * An internal error prevented us from updating a resource. Sorry!\r\n\r\n#### Solutions\r\n\r\n*   Please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n*   Note the time of the error and what you were trying to do when it occurred!',
        code: 53627,
        log_level: "ERROR",
        last_updated: "2018-06-25T10:21:51.000+0000",
        message: "Internal failure when updating the composition resource",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2018-06-25T10:20:16.000+0000",
        const_partition: "1",
        docs: '## Error - 53626\r\n\r\n### Internal failure while processing media composition\r\n\r\nRaised when an internal error prevents us from processing the media composition.\r\n\r\n#### Causes\r\n\r\n * We screwed up. Sorry!\r\n\r\n#### Solutions\r\n\r\n*   If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n*   Note the time of the error and what you were trying to do when it occurred!',
        code: 53626,
        log_level: "ERROR",
        last_updated: "2018-06-25T10:20:16.000+0000",
        message: "Internal failure while processing media composition",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2018-06-11T21:19:09.000+0000",
        const_partition: "1",
        docs: "## Error - 32216\r\n\r\n### SIP: Address blacklisted\r\n\r\n#### Possible Causes \r\n*    This address is blacklisted",
        code: 32216,
        log_level: "ERROR",
        last_updated: "2018-06-11T21:19:09.000+0000",
        message: "SIP: Address blacklisted",
        secondary_message: "This address is blacklisted.",
        product: null,
    },
    {
        date_created: "2018-06-11T14:40:15.000+0000",
        const_partition: "1",
        docs: "## Warning - 53625\r\n\r\n### Access denied to external S3 bucket configured in composition settings\r\n\r\nFailed to upload media to the external S3 bucket configured in your account's composition settings.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket and access credentials, this is most likely due to the fact that the configuration is out of date.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, review the credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
        code: 53625,
        log_level: "WARNING",
        last_updated: "2018-06-25T10:24:25.000+0000",
        message: "Access denied to external S3 bucket configured in composition settings",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-06-11T14:39:24.000+0000",
        const_partition: "1",
        docs: "## Warning - 53624\r\n\r\n### Public key credentials for media tracks encryption could not be loaded\r\n\r\nThe public key credentials configured in your account's composition settings could not be loaded.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified a public key to cryptographically protect media tracks, this is most likely due to the fact that the credentials resource has been removed from Twilio.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, create and assign a new valid public key or disable the encryption (media will be uploaded in raw).",
        code: 53624,
        log_level: "WARNING",
        last_updated: "2018-06-25T10:24:16.000+0000",
        message: "Public key credentials for media tracks encryption could not be loaded",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-06-11T14:38:26.000+0000",
        const_partition: "1",
        docs: "## Warning - 53623\r\n\r\n### AWS credentials to access external S3 bucket could not be loaded\r\n\r\nThe AWS credentials configured in your account's composition settings could not be loaded.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket and access credentials, this is most likely due to the fact that the credentials resource has been removed from Twilio.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, create and assign a new credentials entry for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
        code: 53623,
        log_level: "WARNING",
        last_updated: "2018-06-25T10:24:07.000+0000",
        message: "AWS credentials to access external S3 bucket could not be loaded",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-06-11T14:37:32.000+0000",
        const_partition: "1",
        docs: "## Warning - 53622\r\n\r\n### Invalid public key for media tracks encryption in composition settings\r\n\r\nThe public key configured in your account's composition settings is not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified a public key to cryptographically protect media tracks, this is most likely due to the fact that the key value is not correct.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, set a valid public key or disable the encryption (media will be uploaded in raw).",
        code: 53622,
        log_level: "WARNING",
        last_updated: "2018-06-25T10:23:33.000+0000",
        message: "Invalid public key for media tracks encryption in composition settings",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-06-11T14:36:28.000+0000",
        const_partition: "1",
        docs: "## Warning - 53621\r\n\r\n### Invalid AWS credentials to access external S3 bucket in composition settings\r\n\r\nThe AWS credentials configured in your account's composition settings are not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket and access credentials, this is most likely due to the fact that the AWS Access Key ID and Secret Access Key are not correct.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, set some valid credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
        code: 53621,
        log_level: "WARNING",
        last_updated: "2018-06-25T10:23:26.000+0000",
        message: "Invalid AWS credentials to access external S3 bucket in composition settings",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-06-11T14:35:17.000+0000",
        const_partition: "1",
        docs: "## Warning - 53620\r\n\r\n### Invalid URL for external S3 bucket in composition settings\r\n\r\nThe S3 bucket URL configured in your account's composition settings is not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket, this is most likely due to the fact that the URL does not conform to an S3 URL.\r\n\r\n#### Solutions\r\n\r\n * In the composition settings section of your account's console, set a valid S3 URL for uploading media or disable the external storage (media will be uploaded to the default bucket).",
        code: 53620,
        log_level: "WARNING",
        last_updated: "2018-06-25T10:23:16.000+0000",
        message: "Invalid URL for external S3 bucket in composition settings",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-05-31T17:42:51.000+0000",
        const_partition: "1",
        docs: "## Error - 32218\r\n\r\n### SIP: Transfer not allowed\r\n\r\n#### Possible Causes \r\n*    Transfer enable mode is in DISABLE_ALL\r\n*    Transferring to PSTN when transfer enable mode is in `SIP_ONLY`\r\n*    Transferring to SIP when transfer enable mode is in `PSTN_ONLY`\r\n\r\n#### Possible Solutions\r\n*   There is a configurable transfer enable mode on your trunk. Change this mode to suit your needs",
        code: 32218,
        log_level: "ERROR",
        last_updated: "2018-06-11T21:07:15.000+0000",
        message: "SIP: Transfer not allowed",
        secondary_message: "Transfer is disabled or transferring to disallowed destination (SIP/PSTN)",
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2018-05-28T21:31:27.000+0000",
        solutions: "do not use app Hash with channel other than SMS",
        causes: "App hash can only be used with SMS channel",
        description: "App hash can only be used with SMS channel",
        const_partition: "1",
        docs: "## ERROR - 60601\r\n\r\n### App hash can only be used with SMS channel\r\n\r\nApp hash can only be used with SMS channel App hash can only be used with SMS channel\r\n\r\n#### Possible Causes\r\nApp hash can only be used with SMS channel\r\n\r\n#### Possible Solutions\r\ndo not use app Hash with channel other than SMS",
        code: 60601,
        log_level: "ERROR",
        last_updated: "2019-12-24T17:19:26.000+0000",
        message: "App hash can only be used with SMS channel",
        log_type: "APPLICATION",
        secondary_message: "App hash can only be used with SMS channel",
        product: "Verify",
    },
    {
        date_created: "2018-05-24T14:07:13.000+0000",
        const_partition: "1",
        docs: "## Warning - 53615\r\n\r\n### Access denied to external S3 bucket configured in recording settings\r\n\r\nWe failed to upload media to the external S3 bucket configured in your account's recording settings.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\nThis is a configuration error that can have different root causes\r\n   * The IAM user referenced in the credentials provided does not have enough permissions to upload to the bucket.\r\n   * The bucket configured in your settings has SSE-S3 enabled. The only default encryption mechanism supported is SSE-KMS. Please review the guides for more informtion\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, review the credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).\r\n* If SSE-S3 is enabled, please consider switching to SSE-KMS.",
        code: 53615,
        log_level: "WARNING",
        last_updated: "2018-06-29T13:04:40.000+0000",
        message: "Access denied to external S3 bucket configured in recording settings",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-05-24T13:36:47.000+0000",
        const_partition: "1",
        docs: "## Warning - 53614\r\n\r\n### Public key credentials for media tracks encryption could not be loaded\r\n\r\nThe public key credentials configured in your account's recording settings could not be loaded.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified a public key to cryptographically protect raw media tracks, this is most likely due to the fact that the credentials resource has been removed from Twilio.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, create and assign a new valid public key or disable the encryption (media will be uploaded in raw).",
        code: 53614,
        log_level: "WARNING",
        last_updated: "2018-06-29T13:04:18.000+0000",
        message: "Public key credentials for media tracks encryption could not be loaded",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-05-24T13:33:22.000+0000",
        const_partition: "1",
        docs: "## Warning - 53613\r\n\r\n### AWS credentials to access external S3 bucket could not be loaded\r\n\r\nThe AWS credentials configured in your account's recording settings could not be loaded.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\nThis is most likely due to the fact that the AWS Credentials resource has been removed from Twilio.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, create and assign a new credentials entry for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
        code: 53613,
        log_level: "WARNING",
        last_updated: "2018-06-29T13:04:11.000+0000",
        message: "AWS credentials to access external S3 bucket could not be loaded",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-05-24T13:22:15.000+0000",
        const_partition: "1",
        docs: "## Warning - 53612\r\n\r\n### Invalid public key for media tracks encryption in recording settings\r\n\r\nThe public key configured in your account's recording settings is not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified a public key to cryptographically protect raw media tracks, this is most likely due to the fact that the key value is not correct.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, set a valid public key or disable the encryption (media will be uploaded in raw).",
        code: 53612,
        log_level: "WARNING",
        last_updated: "2018-06-29T13:04:04.000+0000",
        message: "Invalid public key for media tracks encryption in recording settings",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-05-24T13:15:25.000+0000",
        const_partition: "1",
        docs: "## Warning - 53611\r\n\r\n### Invalid AWS credentials to access external S3 bucket in recording settings\r\n\r\nThe AWS credentials configured in your account's recording settings are not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket and access credentials, this is most likely due to the fact that the AWS Access Key ID and Secret Access Key are not correct.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, set some valid credentials for accessing your S3 bucket or disable the external storage (media will be uploaded to the default bucket).",
        code: 53611,
        log_level: "WARNING",
        last_updated: "2018-06-29T13:03:57.000+0000",
        message: "Invalid AWS credentials to access external S3 bucket in recording settings",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-05-24T12:45:45.000+0000",
        const_partition: "1",
        docs: "## Warning - 53610\r\n\r\n### Invalid URL for external S3 bucket in recording settings\r\n\r\nThe S3 bucket URL configured in your account's recording settings is not valid.\r\n\r\nThe media will not be uploaded until the configuration has been fixed.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket, this is most likely due to the fact that the URL does not conform to an S3 URL.\r\n\r\n#### Solutions\r\n\r\n * In the recording settings section of your account's console, set a valid S3 URL for uploading media or disable the external storage (media will be uploaded to the default bucket).",
        code: 53610,
        log_level: "WARNING",
        last_updated: "2018-06-29T13:03:25.000+0000",
        message: "Invalid URL for external S3 bucket in recording settings",
        secondary_message: "The media will not be uploaded until the configuration has been fixed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-05-23T22:17:34.000+0000",
        const_partition: "1",
        docs: "## Error - 60101\r\n\r\n### Unavailable information\r\n\r\nCanadian number. Further authorization required. Contact support@twilio.com\r\n\r\n#### Causes\r\n\r\nIn May of 2018, Twilio was informed by the Canadian Local Number Portability Consortium (CLNPC - http://www.clnpc.ca/) that due to contractual reasons, Twilio cannot provide carrier or portability details about Canadian numbers via the Lookup API without a contract existing between the Twilio customer and the CLNPC.\r\n\r\nMore info: https://support.twilio.com/hc/en-us/articles/360004563433",
        code: 60101,
        log_level: "ERROR",
        last_updated: "2018-05-23T22:17:34.000+0000",
        message: "Canadian number. Further authorization required.",
        secondary_message: null,
        product: "Lookup",
    },
    {
        date_created: "2018-04-18T21:11:05.000+0000",
        const_partition: "1",
        docs: "## Warning\r\n\r\n### No Partner Participant Found\r\n\r\nExample Message: Incoming message or call found no target participant in session <SessionSid> for participant <ParticipantSid>",
        code: 80614,
        log_level: "WARNING",
        last_updated: "2018-08-28T02:34:08.000+0000",
        message: " No Partner Participant Found",
        secondary_message: "Example Message: Incoming message or call found no target participant in session KCac74da33088913e84bfafb5b821ab0b0 for participant KP2ece38f658cdabc372ef3f149ed5977a",
        product: "Proxy",
    },
    {
        date_created: "2018-04-10T03:35:58.000+0000",
        const_partition: "1",
        docs: "## Error - 31201\r\n\r\n### Twilio Client: Error occurred while accessing microphone\r\n\r\n#### Possible Solutions\r\n\r\n- Check for conflicting applications that might be accessing or attempting to access the microphone\r\n- Try unplugging and reconnecting the microphone, if applicable, to reacquire the microphone",
        code: 31201,
        log_level: "ERROR",
        last_updated: "2018-04-10T03:45:04.000+0000",
        message: "Twilio Client: Error occurred while accessing microphone",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2018-04-10T03:31:44.000+0000",
        solutions: "You may not add a participant with the same identifier as a previously removed participant.",
        causes: "You tried to add a participant with an identifier that already exists, or existed for a participant that was deleted.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 80612\r\n\r\n### Duplicate Entry\r\n\r\n \r\n\r\n#### Possible Causes\r\nYou tried to add a participant with an identifier that already exists, or existed for a participant that was deleted.\r\n\r\n#### Possible Solutions\r\nYou may not add a participant with the same identifier as a previously removed participant.",
        code: 80612,
        log_level: "ERROR",
        last_updated: "2019-11-17T00:06:42.000+0000",
        message: "Duplicate Entry",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Proxy",
    },
    {
        date_created: "2018-04-10T03:31:04.000+0000",
        const_partition: "1",
        docs: "## Warning\r\n\r\n### Downstream Request Rejected\r\n\r\nExample Message: Your request was rejected: rejected reason",
        code: 80613,
        log_level: "WARNING",
        last_updated: "2018-04-10T03:31:04.000+0000",
        message: "Downstream Request Rejected",
        secondary_message: "Example Message: Your request was rejected: rejected reason",
        product: "Proxy",
    },
    {
        date_created: "2018-04-04T10:02:19.000+0000",
        const_partition: "1",
        docs: "## Error - 52149\r\n\r\n### Invalid APNs provider token used\r\n\r\n#### Possible Causes \r\n* The APNs provider token is malformed or otherwise incorrect\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52149,
        log_level: "ERROR",
        last_updated: "2018-04-04T10:02:19.000+0000",
        message: "Invalid APNs provider token used",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-04-04T10:01:11.000+0000",
        const_partition: "1",
        docs: "## Error - 52148\r\n\r\n### Expired APNs provider token used\r\n\r\n#### Possible Causes \r\n* The APNs provider token has been in the cache for too long\r\n* The APNs provider token is generated incorrectly\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52148,
        log_level: "ERROR",
        last_updated: "2018-04-04T10:01:11.000+0000",
        message: "Expired APNs provider token used",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-04-04T09:59:45.000+0000",
        const_partition: "1",
        docs: '## Error - 52147\r\n\r\n### Too many APNs provider token updates"\r\n\r\n#### Possible Causes \r\n* A new APNs provider token is being generated too often\r\n* The APNs provider token is not cached by Twilio\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).',
        code: 52147,
        log_level: "WARNING",
        last_updated: "2018-04-04T09:59:45.000+0000",
        message: "Too many APNs provider token updates",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-04-04T09:57:36.000+0000",
        const_partition: "1",
        docs: "## Error - 52174\r\n\r\n### Unexpected error response received for Webhook Credentials request\r\n\r\n#### Possible Causes \r\n* Your token endpoint responded with an unexpected error\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52174,
        log_level: "WARNING",
        last_updated: "2018-04-04T09:57:36.000+0000",
        message: "Unexpected error response received for Webhook Credentials request",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-04-04T09:56:23.000+0000",
        const_partition: "1",
        docs: "## Error - 52173\r\n\r\n### Unexpected Binding Type used for Webhook Credentials request\r\n\r\n#### Possible Causes \r\n* Your token endpoint responded with an error indicating that the Identifier used was not correct\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52173,
        log_level: "WARNING",
        last_updated: "2018-04-04T09:56:23.000+0000",
        message: "Unexpected Identifier used for Webhook Credentials request",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-04-04T09:55:20.000+0000",
        const_partition: "1",
        docs: "## Error - 52172\r\n\r\n### Unexpected Binding Type used for Webhook Credentials request\r\n\r\n#### Possible Causes \r\n* Your token endpoint responded with an error indicating that the Binding Type used was not correct\r\n\r\n#### Possible Solutions\r\n* Verify that your Webhook Credential is configured correctly\r\n* Verify that your token endpoint is configured correctly\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52172,
        log_level: "WARNING",
        last_updated: "2018-04-04T09:55:20.000+0000",
        message: "Unexpected Binding Type used for Webhook Credentials request",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-03-28T22:05:11.000+0000",
        const_partition: "1",
        docs: "## Error - 16108\r\n\r\n### Voice Recording: Request failed due to concurrent recordings\r\n\r\nThe request failed because there is more than one active recording for the provided Call SID",
        code: 16108,
        log_level: "ERROR",
        last_updated: "2018-03-28T22:05:11.000+0000",
        message: "Voice Recording: Request failed due to concurrent recordings",
        secondary_message: "The request failed because there is more than one active recording for the provided CallSID",
        product: "Programmable Voice",
    },
    {
        date_created: "2018-03-28T12:07:22.000+0000",
        const_partition: "1",
        docs: "## Error - 52171\r\n\r\n### Webhook Credentials request signature was not verified\r\n\r\n#### Possible Causes \r\n*  Your token endpoint was not able to verify the request signature\r\n\r\n#### Possible Solutions\r\n*  Verify that your Webhook Credentials are configured with the correct values\r\n*  Verify that your signature verification logic is working as expected",
        code: 52171,
        log_level: "ERROR",
        last_updated: "2018-03-28T12:07:22.000+0000",
        message: "Webhook Credentials request signature was not verified",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-03-28T12:04:59.000+0000",
        const_partition: "1",
        docs: "## Error - 52170\r\n\r\n### Too many Webhook Credential requests\r\n\r\n#### Possible Causes \r\n*  You are sending Notifications too quickly\r\n*  Your Webhook Credentials are not being cached correctly\r\n\r\n#### Possible Solutions\r\n*  Rate limit your requests accordingly\r\n*  Verify the contents of your token endpoint response",
        code: 52170,
        log_level: "ERROR",
        last_updated: "2018-03-28T12:04:59.000+0000",
        message: "Too many Webhook Credential requests",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-03-28T12:02:40.000+0000",
        const_partition: "1",
        docs: "## Error - 52168\r\n\r\n### Webhook Credentials request timed out\r\n\r\n#### Possible Causes \r\n*  The request attempt to the URL specified in your Webhook Credential timed out\r\n\r\n#### Possible Solutions\r\n*  Poor network conditions between Twilio and your endpoint\r\n*  Large delay during request processing by your endpoint",
        code: 52168,
        log_level: "ERROR",
        last_updated: "2018-03-28T12:02:40.000+0000",
        message: "Webhook Credentials request timed out",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-03-28T12:01:11.000+0000",
        const_partition: "1",
        docs: "## Error - 52167\r\n\r\n### Invalid Webhook Credentials response\r\n\r\n#### Possible Causes \r\n*  Your Webhook Credentials response did not adhere to the required schema\r\n\r\n#### Possible Solutions\r\n*  Verify that your Webhook Credentials response is correct",
        code: 52167,
        log_level: "ERROR",
        last_updated: "2018-03-28T12:01:11.000+0000",
        message: "Invalid Webhook Credentials response",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-03-28T11:57:55.000+0000",
        const_partition: "1",
        docs: "## Error - 52166\r\n\r\n### Webhook Credentials endpoint responded with Internal Error\r\n\r\n#### Possible Causes \r\n*  Your Webhook Credentials endpoint is misconfigured\r\n\r\n#### Possible Solutions\r\n*  Verify that your token endpoint is configured correctly",
        code: 52166,
        log_level: "ERROR",
        last_updated: "2018-03-28T11:59:43.000+0000",
        message: "Webhook Credentials endpoint responded with Internal Error",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-03-28T11:54:53.000+0000",
        const_partition: "1",
        docs: "## Error - 52165\r\n\r\n### No Credentials found for the supplied Identifier\r\n\r\n#### Possible Causes \r\n*  Your Webhook Credential has a misconfigured Identifier value\r\n*  Your token endpoint responded with the respective error code by mistake\r\n*  An internal Twilio error occurred\r\n\r\n#### Possible Solutions\r\n*  Verify that your Webhook Credential is configured correctly\r\n*  Verify that your token endpoint is set up correctly",
        code: 52165,
        log_level: "ERROR",
        last_updated: "2018-03-28T11:54:53.000+0000",
        message: "No Credentials found for the supplied Identifier",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-03-28T11:52:27.000+0000",
        const_partition: "1",
        docs: "## Error - 52131\r\n\r\n### Invalid APNs credentials\r\n\r\n#### Possible Causes \r\n*  The Webhook Credential was configured for the wrong Binding Type\r\n*  Your token endpoint responded with the respective error code by mistake\r\n*  An internal Twilio error occurred\r\n\r\n#### Possible Solutions\r\n*  Verify that your Webhook Credential is set up for the correct Binding Type\r\n*  Verify that your token endpoint is set up correctly",
        code: 52164,
        log_level: "ERROR",
        last_updated: "2018-03-28T11:52:27.000+0000",
        message: "No Credentials found for the supplied Binding Type",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-03-28T11:49:19.000+0000",
        const_partition: "1",
        docs: "## Error - 52163\r\n\r\n### Incorrect URL used to retrieve Webhook Credentials\r\n\r\n#### Possible Causes \r\n*  An incorrect URL was specified in your Webhook Credentials URL field\r\n*  The URL was correct, but returned a 404 response\r\n\r\n#### Possible Solutions\r\n*  Verify your Webhook Credential URL and response",
        code: 52163,
        log_level: "ERROR",
        last_updated: "2018-03-28T11:52:43.000+0000",
        message: "Incorrect URL used to retrieve Webhook Credentials",
        secondary_message: null,
        product: "Notifications",
    },
    {
        date_created: "2018-03-19T23:27:15.000+0000",
        const_partition: "1",
        docs: "### Twilio Channels Internal error\r\n\r\n#### Possible Causes \r\n*   Twilio's platform encountered an internal error processing this message",
        code: 63010,
        log_level: "ERROR",
        last_updated: "2018-04-02T22:30:46.000+0000",
        message: "Twilio's platform encountered an internal error processing this message",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-17T01:22:43.000+0000",
        const_partition: "1",
        docs: "### Twilio could not find a Channel with the From address\r\n\r\n#### Possible Causes \r\n* Sending a message using a From address that is not associated with any Channel or WhatsApp installation. \r\n* Sending a message using a From address for a Channel that is pending approval.\r\n\r\n#### Resolution\r\n* See [here](https://www.twilio.com/docs/api/channels#channel-addresses) for supported formats of Channel endpoint addresses. \r\n* To send messages using WhatsApp, the `From` address should be `whatsapp:<sandbox phone number>` or `whatsapp:<your twilio number>`. This can be found on the [WhatsApp sandbox page](https://www.twilio.com/console/messaging/whatsapp/sandbox) or [WhatsApp numbers page](https://www.twilio.com/console/messaging/whatsapp/numbers)\r\n* If you are using the WhatsApp sandbox, ensure that you have activated the Twilio Sandbox for WhatsApp. This can be found on the [WhatsApp sandbox page](https://www.twilio.com/console/messaging/whatsapp/sandbox).\r\n   ",
        code: 63007,
        log_level: "ERROR",
        last_updated: "2018-09-06T13:34:22.000+0000",
        message: "Twilio could not find a Channel with the specified From address",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-17T00:28:57.000+0000",
        const_partition: "1",
        docs: "### Channel message blocked by user action\r\n\r\n#### Possible Causes \r\n*   This message failed to be delivered to the user because it was blocked by some action on their part.  Please see Channel specific error message for more information.",
        code: 63014,
        log_level: "ERROR",
        last_updated: "2018-03-17T00:28:57.000+0000",
        message: "Channel message blocked by user action",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-17T00:28:00.000+0000",
        const_partition: "1",
        docs: "### Channel Policy violation\r\n\r\n#### Possible Causes \r\n*   This message send failed because it violates Channel provider's policy. Please see Channel specific error message for more information. ",
        code: 63013,
        log_level: "ERROR",
        last_updated: "2018-03-17T00:28:00.000+0000",
        message: "Channel policy violation",
        secondary_message: "This message send failed because it violates Channel provider's policy.",
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-17T00:26:57.000+0000",
        const_partition: "1",
        docs: "### Channel returned an internal service error\r\n\r\n#### Possible Causes \r\n*   Channel provider returned an internal service error (HTTP 5xx). ",
        code: 63012,
        log_level: "ERROR",
        last_updated: "2018-04-02T22:32:55.000+0000",
        message: "Channel provider returned an internal service error",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-17T00:23:54.000+0000",
        const_partition: "1",
        docs: "### Channel returned an error when executing the request\r\n\r\n#### Possible Causes \r\n*  Please see Channel specific error message for more information.",
        code: 63009,
        log_level: "ERROR",
        last_updated: "2018-04-02T22:28:42.000+0000",
        message: "Channel provider returned an internal service error (HTTP 5xx). Please see Channel specific error message for more information",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-17T00:22:45.000+0000",
        const_partition: "1",
        docs: "### Channel misconfigured\r\n\r\n#### Possible Causes \r\n*   Could not execute the request or send a message because the Channel has been misconfigured. Please check the Channel instance configuration in Twilio.",
        code: 63008,
        log_level: "ERROR",
        last_updated: "2018-04-02T22:28:04.000+0000",
        message: "Could not execute the request because the channel module has been misconfigured. Please check the Channel configuration in Twilio",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-17T00:20:54.000+0000",
        const_partition: "1",
        docs: "### Could not format given content for the Channel\r\n\r\n#### Possible Causes \r\n*   Incorrect format.",
        code: 63006,
        log_level: "ERROR",
        last_updated: "2018-04-02T22:26:15.000+0000",
        message: "Could not format given content for the channel. Please see Channel specific error message for more information",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-17T00:19:12.000+0000",
        const_partition: "1",
        docs: "### Channel did not accept given content\r\n\r\n#### Possible Causes \r\n*   The content you are trying to send was rejected by the Channel. Please see Channel specific error message for more information. ",
        code: 63005,
        log_level: "ERROR",
        last_updated: "2018-04-02T22:25:26.000+0000",
        message: "Channel did not accept given content. Please see Channel specific error message for more information",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-17T00:17:17.000+0000",
        const_partition: "1",
        docs: "### Channel could not find To address\r\n\r\n#### Possible Causes \r\n*   Incorrect To address or trying to use a To address that is not supported by this Channel when trying to send a message. See [here](https://www.twilio.com/docs/api/channels#channel-addresses) for supported formats of Channel user addresses. ",
        code: 63003,
        log_level: "ERROR",
        last_updated: "2018-03-17T00:17:17.000+0000",
        message: "Channel could not find To address",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-17T00:16:07.000+0000",
        const_partition: "1",
        docs: "### Channel could not find the From address\r\n\r\n#### Possible Causes \r\n*   Incorrect From address or trying to use a From address that is not supported by this Channel when trying to send a message. See [here](https://www.twilio.com/docs/api/channels#channel-addresses) for supported formats of Channel endpoint addresses. ",
        code: 63002,
        log_level: "ERROR",
        last_updated: "2018-03-17T00:16:07.000+0000",
        message: "Channel could not find the From address",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2018-03-12T15:29:05.000+0000",
        const_partition: "1",
        docs: "## Warning\r\n\r\n### Call To Message Only Session Rejected\r\n\r\nExample Message: Inbound call to message-only session rejected.",
        code: 80911,
        log_level: "WARNING",
        last_updated: "2018-03-12T15:29:05.000+0000",
        message: "Call To Message Only Session Rejected",
        secondary_message: "Example Message: Inbound call to message-only session rejected.",
        product: "Proxy",
    },
    {
        date_created: "2018-03-12T15:28:21.000+0000",
        const_partition: "1",
        docs: "## Warning\r\n\r\n### Message To Voice Only Session Rejected\r\n\r\nExample Message: Inbound message to voice-only session rejected.",
        code: 80910,
        log_level: "WARNING",
        last_updated: "2018-03-12T15:28:21.000+0000",
        message: "Message To Voice Only Session Rejected",
        secondary_message: "Example Message: Inbound message to voice-only session rejected.",
        product: "Proxy",
    },
    {
        date_created: "2018-03-12T12:26:26.000+0000",
        const_partition: "1",
        docs: "## Error - 21651\r\n\r\n### Document does not satisfy regulatory requirement\r\n\r\nThe document being mapped to the number does not satisfy the regulatory requirements. \r\n\r\n#### Possible Causes\r\n- The document is the incorrect type for the number you are trying to purchase or update.\r\n- The document does not have the correct metadata fields required for the number you are trying to purchase or update.\r\n- The document sid is not valid. \r\n\r\n#### Possible Solutions\r\n- Ensure that the document you are using satisfies the regulatory requirement.\r\n- Ensure the document sid refers to a document on your account or subaccount. \r\n- Contact support for assistance.",
        code: 21651,
        log_level: "ERROR",
        last_updated: "2018-03-12T12:26:26.000+0000",
        message: "Document does not satisfy regulatory requirement",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-03-08T23:50:04.000+0000",
        const_partition: "1",
        docs: "You must verify your caller ID on the Console or via the REST API. You must use a verified callerID for both the from and to number while in Trial status. Once you upgrade you can use any caller ID for the from and to number.\r\nYou can verify you caller ID in the Console (https://www.twilio.com/console/phone-numbers/verified)",
        code: 32100,
        log_level: "WARNING",
        last_updated: "2018-03-08T23:50:04.000+0000",
        message: "SIP: Trial accounts can only call verified caller IDs",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2018-02-27T21:58:54.000+0000",
        const_partition: "1",
        docs: "## Error - 22123\r\n\r\n#### Unable to Initiate Verification Call\r\n\r\n#### Possible Causes\r\n\r\n* The number you are trying to verify cannot be reached.\r\n\r\n* Your account is not allowed to call the number you are trying to verify.\r\n\r\n* The number you are attempting to verify has been blocked.\r\n\r\n* You are attempting to verify a number that is not a valid phone number.\r\n\r\n#### Possible Solutions\r\n\r\nPlease reach out to HostedSMS@twilio.com.",
        code: 22123,
        log_level: "ERROR",
        last_updated: "2018-02-27T21:58:54.000+0000",
        message: "Unable to Initiate Verification Call",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-19T10:43:12.000+0000",
        const_partition: "1",
        docs: "## Warning - 53662\r\n\r\n### StatusCallback is invalid\r\n\r\nThe recording will be processed, but status notifications will not be sent.\r\n\r\nRaised when StatusCallback is not a valid URL.\r\n\r\n#### Causes\r\n\r\n * Recording created with StatusCallback set to an invalid URL.\r\n\r\n#### Solutions\r\n\r\n * Set StatusCallback to a valid URL or leave blank (status notifications will not be sent).",
        code: 53662,
        log_level: "WARNING",
        last_updated: "2018-02-19T10:43:12.000+0000",
        message: "StatusCallback is invalid",
        secondary_message: "The recording will be processed, but status notifications will not be sent",
        product: "Programmable Video",
    },
    {
        date_created: "2018-02-19T10:41:57.000+0000",
        const_partition: "1",
        docs: "## Warning - 53661\r\n\r\n### StatusCallbackMethod is invalid\r\n\r\nThe recording will be processed, but status notifications will not be sent.\r\n\r\nRaised when StatusCallbackMethod is set to an invalid value.\r\n\r\n#### Causes\r\n\r\n * Recording created with StatusCallbackMethod set to an invalid value.\r\n\r\n#### Solutions\r\n\r\n * Set StatusCallbackMethod to either GET or POST or leave blank for the default (POST).",
        code: 53661,
        log_level: "WARNING",
        last_updated: "2018-02-19T10:41:57.000+0000",
        message: "StatusCallbackMethod is invalid",
        secondary_message: "The recording will be processed, but status notifications will not be sent",
        product: "Programmable Video",
    },
    {
        date_created: "2018-02-19T10:40:02.000+0000",
        const_partition: "1",
        docs: "## Warning - 53605\r\n\r\n### Internal failure when retrieving your account's recording settings\r\n\r\nRaised when an error prevented us from retrieving your account's recording settings.\r\n\r\nThe recording will not be uploaded until we manage to read your recording settings.\r\n\r\n#### Causes\r\n\r\n* An internal error stopped us from uploading the recording. We'll attempt again shortly.\r\n\r\n#### Solutions\r\n\r\n* If the error persists, please <a href=\"/help/contact\">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and what you were trying to do when it occurred!",
        code: 53605,
        log_level: "WARNING",
        last_updated: "2018-06-29T13:05:26.000+0000",
        message: "Internal failure when retrieving your account's recording settings",
        secondary_message: "A new attempt will be made after a delay",
        product: "Programmable Video",
    },
    {
        date_created: "2018-02-19T10:38:50.000+0000",
        const_partition: "1",
        docs: "## Warning - 53604\r\n\r\n### Failed to upload the recording to S3\r\n\r\nRaised when an error prevented us from uploading the media to S3.\r\n\r\n#### Causes\r\n\r\n* Despite our best efforts to upload your media to S3, we couldn't do it this time. We'll attempt again shortly.\r\n\r\n#### Solutions\r\n\r\n* Please verify that any S3 configuration you've provided us is correct, such as AWS access credentials or AWS encryption key.\r\n* If the error persists, please <a href=\"/help/contact\">contact us</a> to figure out what has happened and how to fix it!\r\n* Note the time of the error and what you were trying to do when it occurred!",
        code: 53604,
        log_level: "WARNING",
        last_updated: "2018-06-29T12:52:28.000+0000",
        message: "Failed to upload the recording to S3",
        secondary_message: "A new attempt will be made after a delay",
        product: "Programmable Video",
    },
    {
        date_created: "2018-02-19T10:37:53.000+0000",
        const_partition: "1",
        docs: '## Error - 53603\r\n\r\n### Internal failure while processing a recording\r\n\r\nRaised when an internal error prevents us from processing the recording.\r\n\r\n#### Causes\r\n\r\n * We screwed up. Sorry!\r\n\r\n#### Solutions\r\n\r\n*   If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\r\n*   Note the time of the error and what you were trying to do when it occurred!',
        code: 53603,
        log_level: "ERROR",
        last_updated: "2018-06-29T12:51:43.000+0000",
        message: "Internal failure while processing a recording",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2018-02-19T10:36:59.000+0000",
        const_partition: "1",
        docs: "## Error - 53602\r\n\r\n### AWS encryption key for recording upload is invalid\r\n\r\nThe recording will not be processed.\r\n\r\nRaised when the AWS encryption key provided in the recording's metadata for uploading the media to S3 is not valid.\r\n\r\n#### Causes\r\n\r\n * Providing an invalid AWS encryption key for uploading to S3.\r\n\r\n#### Solutions\r\n\r\n * Set AWS encryption key to a correct value.",
        code: 53602,
        log_level: "ERROR",
        last_updated: "2018-06-29T12:51:01.000+0000",
        message: "AWS encryption key for recording upload is invalid",
        secondary_message: "The recording will not be processed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-02-19T10:36:18.000+0000",
        const_partition: "1",
        docs: "## Error - 53601\r\n\r\n### AWS credentials for recording upload are invalid\r\n\r\nThe recording will not be processed.\r\n\r\nRaised when the AWS credentials provided in the recording's metadata for uploading the media to S3 are not valid.\r\n\r\n#### Causes\r\n\r\n * Providing invalid AWS credentials for S3 access.\r\n\r\n#### Solutions\r\n\r\n * Set AWS credentials to a correct value.",
        code: 53601,
        log_level: "ERROR",
        last_updated: "2018-06-29T12:50:18.000+0000",
        message: "AWS credentials for recording upload are invalid",
        secondary_message: "The recording will not be processed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-02-19T10:33:23.000+0000",
        const_partition: "1",
        docs: "## Error - 53600\r\n\r\n### S3 URL for recording upload is invalid\r\n\r\nThe recording will not be processed.\r\n\r\nRaised when the S3 URL specified in the recording's metadata is not valid.\r\n\r\n#### Causes\r\n\r\n * If you have specified your own bucket, this is most likely due to the fact that the URL does not conform to an S3 URL.\r\n\r\n#### Solutions\r\n\r\n * Set a valid S3 URL for uploading media or leave blank (media will be uploaded to the default bucket).",
        code: 53600,
        log_level: "ERROR",
        last_updated: "2018-06-29T12:49:31.000+0000",
        message: "S3 URL for recording upload is invalid",
        secondary_message: "The recording will not be processed",
        product: "Programmable Video",
    },
    {
        date_created: "2018-02-16T00:42:10.000+0000",
        const_partition: "1",
        docs: '## Error - 22122\r\n\r\n#### Invalid Authorization Document Status\r\n\r\nStatus must be one of "opened" or "signing."',
        code: 22122,
        log_level: "ERROR",
        last_updated: "2018-02-16T00:42:10.000+0000",
        message: "Invalid Authorization Document Status",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-16T00:41:27.000+0000",
        const_partition: "1",
        docs: '## Error - 22121\r\n\r\n#### Unable to Transfer Hosted Number \r\n\r\n\r\n#### Possible Causes\r\n\r\n\r\n* The Hosted Number you are trying to transfer is not in status "in-use."\r\n\r\n#### Possible Solutions\r\n\r\nSee [Exchanging Numbers Between Subaccounts](https://www.twilio.com/docs/api/rest/subaccounts#exchanging-numbers) for more details about transferring numbers.',
        code: 22121,
        log_level: "ERROR",
        last_updated: "2018-02-16T00:41:27.000+0000",
        message: "Unable to Transfer Hosted Number",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-16T00:40:19.000+0000",
        const_partition: "1",
        docs: '## Error - 22107\r\n\r\n#### Unable to Update Authorization Document\r\n\r\nYou attempted to make a change that cannot be applied to the Authorization Document resource.\r\n\r\n#### Possible Causes\r\n\r\n* Trying to update or delete an Authorization Document resource that is in status "signed."\r\n\r\n\r\n* Trying to update an Authorization Document that is in status "signing."\r\n\r\n#### Possible Solutions\r\n\r\n\r\nUpdate the Authorization Document to status "opened" if it is not already in a terminal state.',
        code: 22107,
        log_level: "ERROR",
        last_updated: "2018-02-16T00:40:19.000+0000",
        message: "Unable to Update Authorization Document",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-16T00:38:03.000+0000",
        const_partition: "1",
        docs: '## Error - 22101\r\n\r\n### Invalid Hosted Number Order SIDs\r\n\r\nYou attempted to create or update an Authorization Document with one or more invalid Hosted Number Order SIDs. \r\n\r\n#### Possible Causes\r\n\r\n* No Hosted Number Order SIDs were provided when creating the Authorization Document.\r\n\r\n* One or more of the SIDs provided is not a 34-character string that is prefixed with "HR".\r\n\r\n\r\n\r\n#### Possible Solutions\r\nPlease specify Hosted Number Order SIDs you\'ve created in your [Account Dashboard](https://www.twilio.com/console/phone-numbers/hosted).',
        code: 22101,
        log_level: "ERROR",
        last_updated: "2018-02-16T00:38:03.000+0000",
        message: "Invalid Hosted Number Order SIDs",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-13T01:37:23.000+0000",
        const_partition: "1",
        docs: "## Error - 22100\r\n\r\n### Reached Maximum Verification Attempts\r\n\r\nYou have reached maximum verification attempts on this Hosted Number Order. Please reach out to hostedsms@twilio.com to reset the verification attempts.",
        code: 22100,
        log_level: "ERROR",
        last_updated: "2018-02-13T01:37:23.000+0000",
        message: "Reached Maximum Verification Attempts",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-07T21:57:33.000+0000",
        const_partition: "1",
        docs: '## Error - 22120\r\n\r\n#### Invalid Verification Type\r\n\r\nVerification Type must be either "phone-call" or "phone-bill".',
        code: 22120,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:57:41.000+0000",
        message: "Invalid Verification Type",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-07T21:41:49.000+0000",
        const_partition: "1",
        docs: "## Error - 22119\r\n\r\n#### Invalid Capabilities\r\n\r\nThe SMS Capability you specified for your Hosted Number Order was not valid.\r\n\r\n#### Possible Solutions\r\n\r\nPlease explicitly specify SMS as the capability to host on Twilio's platform by setting SMS Capability to true.",
        code: 22119,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:57:11.000+0000",
        message: "Invalid Capabilities",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-07T19:45:13.000+0000",
        const_partition: "1",
        docs: '## Error - 22118\r\n\r\n#### Invalid Verification Document SID\r\n\r\nThe Verification Document SID specified is not a valid identity document identifier. \r\n\r\n#### Possible Causes\r\n\r\n* The Verification Document SID is not a 34-character string that is prefixed with "RI".\r\n\r\n* The identity document represented by the Verification DocumentSID is not of type "phone-bill".\r\n\r\n* The identity document represented by the Verification Document SID does not exist anymore or does not belong to your account.\r\n\r\n#### Possible Solutions\r\n\r\nPlease specify a Verification Document SID you\u2019ve created in your [Account Dashboard](https://www.twilio.com/console/phone-numbers/identities).',
        code: 22118,
        log_level: "ERROR",
        last_updated: "2018-02-16T00:43:10.000+0000",
        message: "Invalid Verification Document SID",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-07T05:11:10.000+0000",
        const_partition: "1",
        docs: '## Error - 22117\r\n\r\n#### Invalid Extension\r\n\r\nThe extension provided for the verification call contains characters that aren\'t allowed. \r\n\r\n#### Possible Solutions\r\n\r\n* Confirm that your Extension is a non-empty string. Extension may contain numbers, the # and * characters, as well as the "w" character to "wait" for half a second. ',
        code: 22117,
        log_level: "ERROR",
        last_updated: "2018-03-19T21:21:04.000+0000",
        message: "Invalid Extension",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-07T05:10:02.000+0000",
        const_partition: "1",
        docs: "## Error - 22116\r\n\r\n#### Invalid Friendly Name\r\n\r\nFriendly name is a descriptive name to help you remember your resource. The friendly name cannot exceed a length of 128 characters. \r\n\r\n#### Possible Solutions\r\n\r\n* Confirm that your friendly name is a string that does not exceed 128 characters.",
        code: 22116,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:56:08.000+0000",
        message: "Invalid Friendly Name",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-07T05:09:08.000+0000",
        const_partition: "1",
        docs: "## Error - 22115\r\n\r\n#### Invalid Unique Name\r\n\r\nThe unique name must be a string that does not exceed a length of 128 characters.\r\n\r\n#### Possible Solutions\r\n\r\n* Confirm that your unique name is a string that does not exceed 128 characters.",
        code: 22115,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:55:46.000+0000",
        message: "Invalid Unique Name",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-02-02T22:23:50.000+0000",
        const_partition: "1",
        docs: "## PSTN Post-Dial Delay timeout\r\n\r\n### Possible Causes \r\nPSTN Post-Dial Delay timer (60s) expired due to lack of response from multiple Carriers in route.\r\n\r\n\r\n### Possible Solutions \r\n* Check the dialed Number to ensure it is currently reachable.\r\n* If you believe the Number is currently reachable, please contact [Support](mailto:support@twilio.com) and be sure to mention this Error code.",
        code: 32016,
        log_level: "ERROR",
        last_updated: "2018-02-06T20:30:38.000+0000",
        message: "PSTN PDD timeout",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2018-01-30T03:59:54.000+0000",
        const_partition: "1",
        docs: '## Error - 22114\r\n\r\n#### Unable to Verify Code\r\n\r\nA verification code was provided but the Hosted Number Order instance is not in a valid state for handling caller ID verification.\r\n\r\n#### Possible Solutions\r\n\r\n* Update the status of the Hosted Number Order instance to "pending-verification".\r\n\r\n* Remove VerificationCode from the request body if verification call has already been completed.',
        code: 22114,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:55:23.000+0000",
        message: "Unable to Verify Code",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:59:12.000+0000",
        const_partition: "1",
        docs: "## Error - 22113\r\n\r\n#### Phone Verification Incorrect\r\n\r\nYou attempted to complete caller verification but the code you provided was incorrect. \r\n\r\n#### Possible Causes\r\n\r\n* You entered the code incorrectly in the request\r\n\r\n* The code you entered has expired\r\n\r\n#### Possible Solutions\r\n\r\n* Make another request to update Hosted Number Order instance to Status pending-verification to receive another verification code.",
        code: 22113,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:55:03.000+0000",
        message: "Phone Verification Incorrect",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:58:25.000+0000",
        const_partition: "1",
        docs: '## Error - 22112\r\n\r\n#### Unable to Update Hosted Number Order Status\r\n\r\nThe status provided in a request to update Hosted Number Order instance cannot be applied to the current Hosted Number Order state.\r\n\r\n#### Possible Causes\r\n\r\n* Trying to update a Hosted Number Order that has been completed or failed.\r\n\r\n* Trying to update the status of a Hosted Number Order to a status that cannot be user-initiated.\r\n\r\n#### Possible Solutions\r\n\r\n* If a Hosted Number Order is in a terminal state (failed or completed), create a new instance.\r\n\r\n* If a Hosted Number Order is in "action-required" state, reach out to support to remediate.',
        code: 22112,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:54:40.000+0000",
        message: "Unable to Update Hosted Number Order Status",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:55:51.000+0000",
        const_partition: "1",
        docs: "## Error - 22111\r\n\r\n#### Invalid Hosted Number Order Status\r\n\r\nThe status you specified is not a valid Hosted Number Order status.\r\n\r\n#### Possible Causes\r\n\r\n* Attempting to filter a list of Hosted Number Orders on a status that does not exist.\r\n\r\n* Attempting to update a Hosted Number Order instance with a status that cannot be applied to the current Hosted Number Order state.",
        code: 22111,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:54:14.000+0000",
        message: "Invalid Hosted Number Order Status",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:55:10.000+0000",
        const_partition: "1",
        docs: "## Error - 22110\r\n\r\n#### Phone Number Not Hostable\r\n\r\nYou attempted to host a number that is not hostable on Twilio.\r\n\r\n#### Possible Causes\r\n\r\n* The number is already hosted. \r\n\r\n* The number is owned by Twilio.\r\n\r\n* The number cannot be enabled by carrier for requested capabilities.\r\n\r\n* The number is type mobile or voip.",
        code: 22110,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:53:39.000+0000",
        message: "Phone Number Not Hostable",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:54:35.000+0000",
        const_partition: "1",
        docs: '## Error - 22109\r\n\r\n#### Invalid Address SID\r\n\r\nYou attempted to host a phone number with an invalid Address SID. \r\n\r\n#### Possible Causes\r\n\r\n* The SID is not a 34-character string that is prefixed with "AD". \r\n\r\n* The Address resource identified by the SID does not exist anymore or does not belong to your account.\r\n\r\n#### Possible Solutions\r\n\r\n* Please specify an Address SID you\u2019ve created in your [Account Dashboard](https://www.twilio.com/console/phone-numbers/addresses).',
        code: 22109,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:53:21.000+0000",
        message: "Invalid Address SID",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:54:09.000+0000",
        const_partition: "1",
        docs: '## Error - 22108\r\n\r\n#### Invalid Application SID\r\n\r\nYou attempted to configure a phone number with an invalid Application SID. \r\n\r\n#### Possible Causes\r\n\r\n* The SID is not a 34-character string that is prefixed with "AP".\r\n\r\n* Invalid SMS Application SID provided in request\r\n\r\n* Invalid Voice Application SID provided in request\r\n\r\n* The Application resource identified by the SID does not exist anymore or does not belong to your account.\r\n\r\n#### Possible Solutions\r\n\r\nPlease specify an Application SID you\u2019ve created in your [Account Dashboard](https://www.twilio.com/user/account/apps).',
        code: 22108,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:52:57.000+0000",
        message: "Invalid Application SID",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:53:18.000+0000",
        const_partition: "1",
        docs: "## Error - 22106\r\n\r\n#### Invalid Method\r\n\r\nThe method you provided for configuring your hosted number was invalid.\r\n\r\nValid values are GET and POST..\r\n\r\n#### Possible Causes\r\n\r\n* Invalid method passed for number configuration (SmsMethod, SmsFallbackMethod, VoiceMethod, VoiceFallbackMethod).\r\n\r\n* Invalid method passed for status callback configuration (StatusCallbackMethod).",
        code: 22106,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:51:30.000+0000",
        message: "Invalid Method",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:52:45.000+0000",
        const_partition: "1",
        docs: "## Error - 22105\r\n\r\n#### Invalid URL Format\r\n\r\nYou attempted to configure your hosted number, but the URL you specified was not valid.\r\n\r\n#### Possible Causes\r\n\r\n* Invalid URL provided for phone number configuration (SmsUrl, SmsFallbackUrl, VoiceUrl, VoiceFallbackUrl). \r\n\r\n* Invalid URL provided for status callback configuration (StatusCallbackUrl).\r\n\r\n#### Possible Solutions\r\n\r\nMake sure you submit a fully qualified URL including:\r\n\r\n*   protocol (http:// or https://)\r\n\r\n*   hostname\r\n\r\n*   file path\r\n\r\n*   properly url-encoded query parameters\r\n\r\nTwilio must be able to reach this URL over the public Internet.",
        code: 22105,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:50:45.000+0000",
        message: "Invalid URL format",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:51:10.000+0000",
        const_partition: "1",
        docs: "## Error - 22104\r\n\r\n#### Invalid Email Format\r\n\r\nThe format of a provided email was invalid.\r\n\r\n#### Possible Causes\r\n\r\n* Invalid email provided in request for email or cc emails.\r\n\r\n#### Possible Solutions\r\n\r\nMake sure you submit emails in the format local-part@domain",
        code: 22104,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:49:53.000+0000",
        message: "Invalid Email Format",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:50:24.000+0000",
        const_partition: "1",
        docs: "## Error - 22103\r\n\r\n### Unsupported Iso Country\r\n\r\nYou attempted to host a number, but Twilio does not currently support hosting numbers in the Iso Country provided.\r\n\r\n",
        code: 22103,
        log_level: "ERROR",
        last_updated: "2018-02-09T19:49:16.000+0000",
        message: "Unsupported Iso Country",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-30T03:49:28.000+0000",
        const_partition: "1",
        docs: '## Error - 22102\r\n\r\n### Invalid Phone Number\r\n\r\nThe phone number provided is not a valid number.\r\n\r\n#### Possible Causes\r\n\r\n* The phone number provided is formatted correctly.\r\n\r\n* The phone number provided includes a non-existent country code, area code or exchange.\r\n\r\n#### Possible Solutions\r\n\r\nPlease specify a valid phone number in [E164 format](http://en.wikipedia.org/wiki/E.164) (i.e. "+1 format").',
        code: 22102,
        log_level: "ERROR",
        last_updated: "2018-02-09T20:35:14.000+0000",
        message: "Invalid Phone Number",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-19T11:42:55.000+0000",
        const_partition: "1",
        docs: "## Error - 21102\r\n\r\n### Reached maximum number of Services\r\n\r\n#### Possible Causes\r\nYou have attempted to create a Service, but your parent account already has the maximum amount for this product.\r\n\r\n#### Possible Solutions\r\n* Contact support to increase your Service limit\r\n* Delete some of your Services",
        code: 21102,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:48:39.000+0000",
        message: "Reached maximum number of Services",
        secondary_message: "Reached maximum number of Services per parent account and product",
        product: "Platform",
    },
    {
        date_created: "2018-01-16T12:08:00.000+0000",
        const_partition: "1",
        docs: "## Error - 21449\r\n\r\n### Number already can be used for outgoing calls and messages\r\n\r\nThe number you attempted to add as an Outgoing Caller ID to your account already can be used for outgoing calls and messages.\r\n",
        code: 21449,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:53:12.000+0000",
        message: "Number already can be used for outgoing calls and messages",
        secondary_message: "The number you attempted to add as an Outgoing Caller ID to your account already can be used for outgoing calls and messages.",
        product: "Phone Numbers",
    },
    {
        date_created: "2018-01-12T17:09:14.000+0000",
        solutions: "The number can be removed from the Service once it's not in use.",
        causes: "It is in use by one or more Sessions.",
        description: "The Proxy Number cannot be removed from Service. ",
        const_partition: "1",
        docs: "## ERROR - 80611\r\n\r\n### Proxy Number In Active Sessions\r\n\r\n The Proxy Number cannot be removed from Service. \r\n\r\n#### Possible Causes\r\nIt is in use by one or more Sessions.\r\n\r\n#### Possible Solutions\r\nThe number can be removed from the Service once it's not in use.",
        code: 80611,
        log_level: "ERROR",
        last_updated: "2019-12-27T17:32:11.000+0000",
        message: "Proxy Number In Active Sessions",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Proxy",
    },
    {
        date_created: "2018-01-04T11:29:20.000+0000",
        const_partition: "1",
        docs: "## Error - 52145\r\n\r\n### Failed to authenticate with APNs\r\n\r\n#### Possible Causes \r\n*  Unable to complete the TLS handshake with APNs.\r\n\r\n#### Possible Solutions\r\n* Verify that your certificate and private key are correct and can be used together.\r\n* Verify that your certificate has not been revoked.\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52145,
        log_level: "ERROR",
        last_updated: "2018-02-02T07:31:40.000+0000",
        message: "Failed to authenticate with APNs",
        secondary_message: "Could not authenticate with APNs using the provided credentials",
        product: "Notifications",
    },
    {
        date_created: "2018-01-04T11:23:15.000+0000",
        const_partition: "1",
        docs: "## Error - 52144\r\n\r\n### APNs experienced an internal error\r\n\r\n#### Possible Causes \r\n* APNs had an unexpected error\r\n* APNS is unavailable\r\n* Request to APNs timed out\r\n\r\n#### Possible Solutions\r\n* Retry the request at a later time\r\n*  If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52144,
        log_level: "ERROR",
        last_updated: "2018-01-04T11:23:15.000+0000",
        message: "APNs experienced an internal error",
        secondary_message: "APNs was unable to handle your request",
        product: "Notifications",
    },
    {
        date_created: "2018-01-04T11:20:33.000+0000",
        const_partition: "1",
        docs: "## Error - 52143\r\n\r\n### The push notification was rejected by APNs\r\n\r\n#### Possible Causes \r\n* The push notification topic in the certificate is incorrect\r\n* The device token cannot be used with the specified topic\r\n* Pushing to the specified topic is not allowed\r\n* An internal Twilio error has occurred\r\n\r\n#### Possible Solutions\r\n* Verify that your certificate is correct\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52143,
        log_level: "ERROR",
        last_updated: "2018-01-04T12:01:21.000+0000",
        message: "The push notification was rejected by APNs",
        secondary_message: "Request was malformed",
        product: "Notifications",
    },
    {
        date_created: "2018-01-04T11:17:03.000+0000",
        const_partition: "1",
        docs: "## Error - 52142\r\n\r\n### The provided APNs device token is not correct\r\n\r\n#### Possible Causes \r\n*  The APNs device token is either malformed or missing.\r\n\r\n#### Possible Solutions\r\n*  Please verify that you're capturing the device token correctly.\r\n*  If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52142,
        log_level: "ERROR",
        last_updated: "2018-01-04T11:25:53.000+0000",
        message: "The provided APNs device token is not correct",
        secondary_message: "APNs Device Token is missing or malformed",
        product: "Notifications",
    },
    {
        date_created: "2018-01-04T11:14:58.000+0000",
        const_partition: "1",
        docs: "## Error - 52141\r\n\r\n### The provided APNs device token has been unregistered\r\n\r\n#### Possible Causes \r\n*  APNs notification delivery rejected because the app has either been uninstalled or notifications have been disabled.\r\n#### Possible Solutions\r\n* If the offending Binding still exists, remove it manually or avoid sending Notifications to it.\r\n* If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52141,
        log_level: "ERROR",
        last_updated: "2018-01-04T11:24:46.000+0000",
        message: "The provided APNs device token has been unregistered",
        secondary_message: "The device token specified is inactive for the specified topic.",
        product: "Notifications",
    },
    {
        date_created: "2017-12-28T11:43:25.000+0000",
        const_partition: "1",
        docs: "## Warning - 53660\r\n\r\n### Status callback response timed out\r\n\r\nRaised by a Twilio Service when the StatusCallback request takes too long or does not respond to callbacks sent \r\n\r\n### Causes\r\n\r\n * The server receiving status callbacks sent by Twilio takes too long too respond.\r\n\r\n### Solutions\r\n\r\n * Make sure service receiving callbacks does not block incoming requests.",
        code: 53660,
        log_level: "WARNING",
        last_updated: "2017-12-28T11:54:42.000+0000",
        message: "Status Callback response timed out",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-12-27T12:35:48.000+0000",
        const_partition: "1",
        docs: "## Error 52001\r\n\r\n### Invalid destination binding\r\n\r\nThe message has been rejected by channel due to an invalid destination information. This specific message has not been sent.\r\n\r\n### Possible causes\r\n- Address or identity or notification protocol version in a Notify Binding (or ToBinding) were invalid\r\n\r\n### Possible solutions\r\n- Make sure that you do not modify the address before creating the Binding or sending ToBinding property of Notification Request. \r\n",
        code: 52001,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:36:45.000+0000",
        message: "Invalid destination binding",
        secondary_message: "Provided destination binding information is invalid",
        product: "Notifications",
    },
    {
        date_created: "2017-12-21T12:07:11.000+0000",
        const_partition: "1",
        docs: "## Error - 52309\r\n\r\n### RtdNotification: Channel provider replied with an error\r\n\r\n#### Possible Causes \r\n*  Some errors in channel configuration: destination address, credentials, permissions, etc.\r\n\r\n#### Possible Solutions\r\n*  Check channel configuration or re-install the channel and destination binding. Check response message from the provider in a debugger alert.",
        code: 52309,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:45:18.000+0000",
        message: "Channel provider replied with an error",
        secondary_message: "Channel provider (Amazon Alexa, Facebook, etc) replied with an error",
        product: "Notifications",
    },
    {
        date_created: "2017-12-15T21:31:29.000+0000",
        const_partition: "1",
        docs: "## Error - 14222\r\n\r\n### Enqueue: Could not create Task\r\n\r\nCould not match the task to a target given the defined attributes.\r\n",
        code: 14222,
        log_level: "ERROR",
        last_updated: "2017-12-15T21:31:29.000+0000",
        message: "Enqueue: Could not create Task",
        secondary_message: "The Task attributes could not be matched a Workflow.",
        product: "TaskRouter",
    },
    {
        date_created: "2017-12-06T16:10:48.000+0000",
        const_partition: "1",
        docs: "## Error\r\n\r\n### No Records Updated\r\n\r\nExample Message: Record to be updated was not found. It may have been deleted.",
        code: 80503,
        log_level: "WARNING",
        last_updated: "2017-12-06T16:10:48.000+0000",
        message: "No Records Updated",
        secondary_message: "Record to be updated was not found. It may have been deleted.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        solutions: "If this was unintended, the logic in the InterceptCallbackUrl could be revised. See behavior in the webhooks [documentation](https://www.twilio.com/docs/proxy/api/webhooks).",
        causes: "A request to InterceptCallbackUrl received 403 and the interaction was aborted/blocked.",
        description: "Interaction not completed due to InterceptCallbackUrl.",
        const_partition: "1",
        docs: "## WARNING - 80909\r\n\r\n### Inbound Contact Rejected\r\n\r\n Interaction not completed due to InterceptCallbackUrl.\r\n\r\n#### Possible Causes\r\nA request to InterceptCallbackUrl received 403 and the interaction was aborted/blocked.\r\n\r\n#### Possible Solutions\r\nIf this was unintended, the logic in the InterceptCallbackUrl could be revised. See behavior in the webhooks [documentation](https://www.twilio.com/docs/proxy/api/webhooks).",
        code: 80909,
        log_level: "WARNING",
        last_updated: "2019-09-26T16:56:42.000+0000",
        message: "Inbound Contact Rejected",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Proxy",
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Callback Error\n\nExample Message: Error on Callback for http://www.yourdomain.com/callback",
        code: 80908,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Callback Error",
        secondary_message: "Error on Callback for http://www.yourdomain.com/callback",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Open Interaction Not Found\n\nExample Message: Received a call with no open interaction",
        code: 80907,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Open Interaction Not Found",
        secondary_message: "Received a call with no open interaction",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Interaction Not Open\n\nExample Message: Received interaction completion event for an Interaction that is already complete",
        code: 80906,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Interaction Not Open",
        secondary_message: "Received interaction completion event for an Interaction that is already complete",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Unknown Scenario\n\nExample Message: No valid proxy scenario for handling inbound call or message",
        code: 80905,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Unknown Scenario",
        secondary_message: "No valid proxy scenario for handling inbound call or message",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Expired Session\n\nExample Message: Expired Session",
        code: 80904,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Expired Session",
        secondary_message: "Expired Session",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Unknown Participant\n\nExample Message: Unknown Participant",
        code: 80903,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Unknown Participant",
        secondary_message: "Unknown Participant",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\r\n\r\n### No Active Session\r\n\r\nYou received a call to your Proxy Number from a caller who is not a participant in an active session. ",
        code: 80902,
        log_level: "ERROR",
        last_updated: "2018-05-17T18:12:33.000+0000",
        message: "No Active Session",
        secondary_message: "You received a call to your Proxy Number from a caller who is not a participant in an active session. ",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Message Matched Stop Word\n\nExample Message: Message matched a STOP or START word, not proxying",
        code: 80901,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Message Matched Stop Word",
        secondary_message: "Message matched a STOP or START word, not proxying",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Parameter Validation Failed\n\nExample Message: '<parameter name>' is invalid. <parameter is invalid>",
        code: 80701,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Parameter Validation Failed",
        secondary_message: "'<parameter name>' is invalid. <parameter is invalid>",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Unauthorized Operation\n\nExample Message: Unauthorized. You may be trying to use an invalid combination of sids.",
        code: 80610,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Unauthorized Operation",
        secondary_message: "Unauthorized. You may be trying to use an invalid combination of sids.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Too Many Added Participants\n\nExample Message: A Session may have at most 2 participants",
        code: 80609,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Too Many Added Participants",
        secondary_message: "A Session may have at most 2 participants",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        solutions: "To re-open a session the valid status update is from `closed` to `in-progress`. To close a session, update from `open` to `closed` or from `in-progress` to `closed`. \r\n",
        causes: "Session status change not supported. ",
        description: "Session Status Invalid\r\n\r\n",
        const_partition: "1",
        docs: "## ERROR - 80608\r\n\r\n### Session Status Invalid\r\n\r\nSession status change not supported Session Status Invalid\r\n\r\n\r\n\r\n#### Possible Causes\r\nSession status change not supported. \r\n\r\n#### Possible Solutions\r\nTo re-open a session the valid status update is from `closed` to `in-progress`. To close a session, update from `open` to `closed` or from `in-progress` to `closed`. \r\n",
        code: 80608,
        log_level: "ERROR",
        last_updated: "2020-01-01T16:39:13.000+0000",
        message: "Session Status Invalid",
        log_type: "APPLICATION",
        secondary_message: "Session status change not supported",
        product: "Proxy",
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Session Closed\n\nExample Message: Session is closed and cannot be updated",
        code: 80607,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Session Closed",
        secondary_message: "Session is closed and cannot be updated",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Proxy Identifier Not Owned By Account\n\nExample Message: Proxy identifier not owned by account.",
        code: 80606,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Proxy Identifier Not Owned By Account",
        secondary_message: "Proxy identifier not owned by account.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Proxy Identifier Not In Service\n\nExample Message: Proxy identifier not associated with service.",
        code: 80605,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Proxy Identifier Not In Service",
        secondary_message: "Proxy identifier not associated with service.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Proxy Identifier In Use\n\nExample Message: Proxy identifier already in use with requested identifier.",
        code: 80604,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Proxy Identifier In Use",
        secondary_message: "Proxy identifier already in use with requested identifier.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        solutions: "Retry with a UniqueName that is not currently in use by any other Sessions for this Service.",
        causes: "A Session exists with the proposed UniqueName.",
        description: "Session UniqueName must be unique.",
        const_partition: "1",
        docs: "## ERROR - 80603\r\n\r\n### Non Unique Session Name\r\n\r\n Session UniqueName must be unique.\r\n\r\n#### Possible Causes\r\nA Session exists with the proposed UniqueName.\r\n\r\n#### Possible Solutions\r\nRetry with a UniqueName that is not currently in use by any other Sessions for this Service.",
        code: 80603,
        log_level: "ERROR",
        last_updated: "2019-08-30T15:28:59.000+0000",
        message: "Non Unique Session Name",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Non Unique Service Name\n\nExample Message: Service UniqueName must be unique.",
        code: 80602,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Non Unique Service Name",
        secondary_message: "Service UniqueName must be unique.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Phone Number Not Available\n\nExample Message: PhoneNumber is not available.  It may be bound to a number pool.",
        code: 80601,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Phone Number Not Available",
        secondary_message: "PhoneNumber is not available.  It may be bound to a number pool.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Session Sid Invalid\n\nExample Message: Invalid Session Sid",
        code: 80409,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Session Sid Invalid",
        secondary_message: "Invalid Session Sid",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Service Sid Invalid\n\nExample Message: Invalid Service Sid",
        code: 80408,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Service Sid Invalid",
        secondary_message: "Invalid Service Sid",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:04.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Phone Number Sid Invalid\n\nExample Message: Invalid Phone Number Sid",
        code: 80407,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:04.000+0000",
        message: "Phone Number Sid Invalid",
        secondary_message: "Invalid Phone Number Sid",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Phone Number Did Invalid\n\nExample Message: Invalid Phone Number Did",
        code: 80406,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "Phone Number Did Invalid",
        secondary_message: "Invalid Phone Number Did",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Participant Sid Invalid\n\nExample Message: Invalid Participant Sid",
        code: 80405,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "Participant Sid Invalid",
        secondary_message: "Invalid Participant Sid",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        solutions: "Pass a valid participant's number in [E.164 format](https://www.twilio.com/docs/glossary/what-e164).",
        causes: "The participant's number passed in the participant creation is incorrect.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 80404\r\n\r\n### Participant Identifier Invalid\r\n\r\nParticipant identifier provided does not appear to be a valid, reachable phone number. \r\n\r\n#### Possible Causes\r\nThe participant's number passed in the participant creation is incorrect.\r\n\r\n#### Possible Solutions\r\nPass a valid participant's number in [E.164 format](https://www.twilio.com/docs/glossary/what-e164).",
        code: 80404,
        log_level: "ERROR",
        last_updated: "2019-09-20T17:00:49.000+0000",
        message: "Participant Identifier Invalid",
        log_type: "APPLICATION",
        secondary_message: "Participant identifier provided does not appear to be a valid, reachable phone number.",
        product: "Proxy",
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Interaction Sid Invalid\n\nExample Message: Invalid Interaction Sid",
        code: 80403,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "Interaction Sid Invalid",
        secondary_message: "Invalid Interaction Sid",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Identifier Proxy Pair Invalid\n\nExample Message: Invalid Identifier and Proxy Identifier pair",
        code: 80402,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "Identifier Proxy Pair Invalid",
        secondary_message: "Invalid Identifier and Proxy Identifier pair",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Account Sid Invalid\n\nExample Message: Invalid Account Sid",
        code: 80401,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "Account Sid Invalid",
        secondary_message: "Invalid Account Sid",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Not Found Short Code Sid\n\nExample Message: Short Code Sid is not associated with your Account.",
        code: 80303,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "Not Found Short Code Sid",
        secondary_message: "Short Code Sid is not associated with your Account.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        solutions: "The Phone Number SID should be owned by the Account SID.",
        causes: "The Account SID doesn't own the Phone Number SID.",
        description: "Phone Number SID is not associated with the Account SID.",
        const_partition: "1",
        docs: "## ERROR - 80301\r\n\r\n### Not Found Phone Number SID\r\n\r\n Phone Number SID is not associated with the Account SID.\r\n\r\n#### Possible Causes\r\nThe Account SID doesn't own the Phone Number SID.\r\n\r\n#### Possible Solutions\r\nThe Phone Number SID should be owned by the Account SID.",
        code: 80301,
        log_level: "ERROR",
        last_updated: "2019-11-14T15:35:59.000+0000",
        message: "Not Found Phone Number SID",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Proxy",
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### No Available Proxy\n\nExample Message: This Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for +1415555XXXX. Either you have no numbers meeting your service's GeoMatchLevel for the target number, or the numbers you do have are already in use by the participant in other Sessions.",
        code: 80206,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "No Available Proxy",
        secondary_message: "This Service has no compatible Proxy numbers for this Participant. Failed to find a proxy number for +1415555XXXX. Either you have no numbers meeting your service's GeoMatchLevel for the target number, or the numbers you do have are already in use by the participant in other Sessions.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### No Proxies For Service\n\nExample Message: This Service has no compatible Proxy numbers for this Participant. This Service has no Proxy numbers configured.",
        code: 80205,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "No Proxies For Service",
        secondary_message: "This Service has no compatible Proxy numbers for this Participant. This Service has no Proxy numbers configured.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        solutions: "Add a Twilio number from your account to the Service that matches the participant\u2019s country code. Alternatively, pass the proxyIdentifier's optional property when creating the participant. Please note that international tolls may apply.",
        causes: "There are no numbers in the Service that can be assigned to this participant's identifier.",
        description: "## ERROR - 80203\r\n\r\nThis Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers for the participant's number country code <country>.",
        const_partition: "1",
        docs: "## ERROR - 80203\r\n\r\n### No Available Proxy For Country\r\n\r\n ## ERROR - 80203\r\n\r\nThis Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers for the participant's number country code <country>.\r\n\r\n#### Possible Causes\r\nThere are no numbers in the Service that can be assigned to this participant's identifier.\r\n\r\n#### Possible Solutions\r\nAdd a Twilio number from your account to the Service that matches the participant\u2019s country code. Alternatively, pass the proxyIdentifier's optional property when creating the participant. Please note that international tolls may apply.",
        code: 80203,
        log_level: "ERROR",
        last_updated: "2019-11-11T22:29:28.000+0000",
        message: "No Available Proxy For Country",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Proxy",
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### No Available Message Proxy\n\nExample Message: This Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers having sms capabilities. This can happen if you attempted to create a participant in a session for which you did not specify a Mode in a country that does not support combined voice and sms capabilities, or if your only available proxy numbers do not have messaging capabilities.",
        code: 80202,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "No Available Message Proxy",
        secondary_message: "This Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers having sms capabilities. This can happen if you attempted to create a participant in a session for which you did not specify a Mode in a country that does not support combined voice and sms capabilities, or if your only available proxy numbers do not have messaging capabilities.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### No Available Voice Proxy\n\nExample Message: This Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers having voice capabilities. This can happen if you attempted to create a participant in a session for which you did not specify a Mode in a country that does not support combined voice and sms capabilities.",
        code: 80201,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "No Available Voice Proxy",
        secondary_message: "This Service has no compatible Proxy numbers for this Participant. This Service has no available Proxy numbers having voice capabilities. This can happen if you attempted to create a participant in a session for which you did not specify a Mode in a country that does not support combined voice and sms capabilities.",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Short Code Already In Service\n\nExample Message: ShortCode has already been added to Service",
        code: 80105,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "Short Code Already In Service",
        secondary_message: "ShortCode has already been added to Service",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Phone Number Already In Service\n\nExample Message: PhoneNumber has already been added to Service",
        code: 80104,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "Phone Number Already In Service",
        secondary_message: "PhoneNumber has already been added to Service",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Participant Already In Session\n\nExample Message: Participant has already been added to Session",
        code: 80103,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "Participant Already In Session",
        secondary_message: "Participant has already been added to Session",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        const_partition: "1",
        docs: "## Warning\n\n### Participant Already In Interaction\n\nExample Message: Participant has already been added to Interaction",
        code: 80102,
        log_level: "warning",
        last_updated: "2017-12-05T22:32:03.000+0000",
        message: "Participant Already In Interaction",
        secondary_message: "Participant has already been added to Interaction",
        product: null,
    },
    {
        date_created: "2017-12-05T22:32:03.000+0000",
        solutions: "Add a different phone number or remove the number from the relevant Proxy Service. ",
        causes: "Phone Number has already been added to another Service.",
        description: "A phone number can be added in one service at a time.",
        const_partition: "1",
        docs: "## ERROR - 80101\r\n\r\n### Number Already Added to Another Service\r\n\r\n A phone number can be added in one service at a time.\r\n\r\n#### Possible Causes\r\nPhone Number has already been added to another Service.\r\n\r\n#### Possible Solutions\r\nAdd a different phone number or remove the number from the relevant Proxy Service. ",
        code: 80101,
        log_level: "ERROR",
        last_updated: "2019-09-26T16:47:47.000+0000",
        message: "Number Already Added to Another Service",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Proxy",
    },
    {
        date_created: "2017-11-27T20:24:04.000+0000",
        const_partition: "1",
        docs: "## Error - 60600\r\n\r\n### Unprovisioned or Out of Coverage\r\n\r\nRaised in the Lookup service when an error prevented us from getting the carrier info for the phone number.\r\n\r\n#### Causes\r\n\r\nYou have provided a phone number that appears as either not provisioned with any carrier or belonging to a carrier outside the scope of our data coverage.",
        code: 60600,
        log_level: "ERROR",
        last_updated: "2017-11-28T21:57:55.000+0000",
        message: "Unprovisioned or Out of Coverage",
        secondary_message: null,
        product: "Lookup",
    },
    {
        date_created: "2017-11-06T21:16:58.000+0000",
        const_partition: "1",
        docs: "### Dial->Queue: Could not find or accept provided reservationSid\r\n\r\nProvided ReservationSid could not be found or has been canceled / rescinded.",
        code: 14217,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:33:21.000+0000",
        message: "Dial->Queue: Could not find or accept provided reservationSid",
        secondary_message: "Provided ReservationSid could not be found or has been canceled / rescinded.",
        product: "TaskRouter",
    },
    {
        date_created: "2017-11-06T12:43:01.000+0000",
        const_partition: "1",
        docs: "## Error - 50509\r\n\r\n### Programmable Chat: Media message body update not allowed\r\n\r\n#### Possible Causes \r\n*  Media message body cannot be updated. \r\n",
        code: 50509,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:54:28.000+0000",
        message: "Programmable Chat: Media message body cannot be updated",
        secondary_message: "Media message body cannot be updated",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T12:39:09.000+0000",
        const_partition: "1",
        docs: "## Error - 50508\r\n\r\n### Programmable Chat: Media already sent with another message\r\n\r\n#### Possible Causes \r\n*  Media with specified SID is already sent with another Chat message. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Media SID is being passed in request. ",
        code: 50508,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:54:35.000+0000",
        message: "Programmable Chat: Media already sent with another message",
        secondary_message: "Media with specified SID is already sent with another Chat message",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T12:37:07.000+0000",
        const_partition: "1",
        docs: "## Error - 50507\r\n\r\n### Programmable Chat: Media not found\t\r\n\r\n#### Possible Causes \r\n*  Media with specified SID does not exist. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Media SID is being passed in request. ",
        code: 50507,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:54:47.000+0000",
        message: "Programmable Chat: Media not found",
        secondary_message: "Media with specified SID does not exist. ",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T12:27:32.000+0000",
        const_partition: "1",
        docs: "## Error - 50506\r\n\r\n### Programmable Chat: Media SID not provided\t\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Media SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Media SID is being passed in request. ",
        code: 50506,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:54:54.000+0000",
        message: "Programmable Chat: Media SID not provided",
        secondary_message: "Request does not contain required Media SID parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T12:25:24.000+0000",
        const_partition: "1",
        docs: "## Error - 50505\r\n\r\n### Programmable Chat: Last Updated By parameter is too long\r\n\r\n#### Possible Causes \r\n*  Last Updated By parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length Last Updated By is being passed in request. ",
        code: 50505,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:55:02.000+0000",
        message: "Programmable Chat: Last Updated By parameter is too long",
        secondary_message: "Last Updated By parameter is too long",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T12:23:50.000+0000",
        const_partition: "1",
        docs: "## Error - 50504\r\n\r\n### Programmable Chat: Message body parameter is too long\r\n\r\n#### Possible Causes \r\n*  Message body parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length Message body is being passed in request. ",
        code: 50504,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:55:11.000+0000",
        message: "Programmable Chat: Message body parameter is too long",
        secondary_message: "Message body parameter is too long",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T12:18:46.000+0000",
        const_partition: "1",
        docs: "## Error - 50406\r\n\r\n### Programmable Chat: Invalid last consumed message index format\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for last consumed message index\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50406,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:55:59.000+0000",
        message: "Programmable Chat: Invalid last consumed message index format",
        secondary_message: "Request does not contain correctly formatted parameter for last consumed message index",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T12:17:03.000+0000",
        const_partition: "1",
        docs: "## Error - 50405\r\n\r\n### Programmable Chat: Invalid last consumption timestamp format\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for last consumption timestamp\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid parameter is passed in request. ",
        code: 50405,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:56:06.000+0000",
        message: "Programmable Chat: Invalid last consumption timestamp format",
        secondary_message: "Request does not contain correctly formatted parameter for last consumption timestamp",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T11:58:29.000+0000",
        const_partition: "1",
        docs: "## Error - 50309\r\n\r\n### Programmable Chat: Invalid Date Updated parameter\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for Date Updated.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Date Updated parameter is passed in request. ",
        code: 50309,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:57:02.000+0000",
        message: "Programmable Chat: Invalid Date Uodated parameter",
        secondary_message: "Request does not contain correctly formatted parameter for Date Updated",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T11:57:14.000+0000",
        const_partition: "1",
        docs: "## Error - 50308\r\n\r\n### Programmable Chat: Invalid Date Created parameter\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for Date Created.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Date Created parameter is passed in request. ",
        code: 50308,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:57:08.000+0000",
        message: "Programmable Chat: Invalid Date Created parameter",
        secondary_message: "Request does not contain correctly formatted parameter for Date Created",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T11:53:50.000+0000",
        const_partition: "1",
        docs: "## Error - 50310\r\n\r\n### Programmable Chat: Author parameter is too long\r\n\r\n#### Possible Causes \r\n*  Author parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length Author is being passed in request. ",
        code: 50310,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:56:52.000+0000",
        message: "Programmable Chat: Author parameter is too long",
        secondary_message: "Author parameter is too long.",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T11:43:58.000+0000",
        const_partition: "1",
        docs: "## Error - 50209\r\n\r\n### Programmable Chat: Invalid binding type\r\n\r\n#### Possible Causes \r\n*  Specified binding type does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid binding type is being passed in request. ",
        code: 50209,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:58:10.000+0000",
        message: "Programmable Chat: Invalid binding type",
        secondary_message: "Specified binding type does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T09:41:53.000+0000",
        const_partition: "1",
        docs: "## Error - 50065\r\n\r\n### Programmable Chat: Invalid webhook retry count\r\n\r\n#### Possible Causes \r\n* Request does not contain correctly formatted parameter for webhook retry count.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid webhook parameters are being passed in request. ",
        code: 50065,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:03:06.000+0000",
        message: "Programmable Chat: Invalid webhook retry count",
        secondary_message: "Request does not contain correctly formatted parameter for webhook retry count.",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T07:57:43.000+0000",
        const_partition: "1",
        docs: "## Error - 50061\r\n\r\n### Programmable Chat: Invalid channel members limit format\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for channel members limit.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid channel members limit parameter is passed in request. ",
        code: 50061,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:03:17.000+0000",
        message: "Programmable Chat: Invalid channel members limit format",
        secondary_message: "Request does not contain correctly formatted parameter for channel members limit",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T07:56:20.000+0000",
        const_partition: "1",
        docs: "## Error - 50060\r\n\r\n### Programmable Chat: Invalid user channels limit format\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameter for user channels limit.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid user channels limit parameter is passed in request. ",
        code: 50060,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:03:25.000+0000",
        message: "Programmable Chat: Invalid user channels limit format",
        secondary_message: "Request does not contain correctly formatted parameter for user channels limit",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-11-06T07:50:30.000+0000",
        const_partition: "1",
        docs: "## Error - 50059\r\n\r\n### Programmable Chat: Notification sound name too long\r\n\r\n#### Possible Causes \r\n*  Specified notification sound parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length notification sound parameter is being passed in request. ",
        code: 50059,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:03:31.000+0000",
        message: "Programmable Chat: Notification sound name too long",
        secondary_message: "Specified notification sound parameter is too long",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-10-30T13:04:16.000+0000",
        const_partition: "1",
        docs: "## Error - 50058\r\n\r\n### Programmable Chat: Notification template too long\r\n\r\n#### Possible Causes \r\n*  Specified notification template parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length notification template is being passed in request. ",
        code: 50058,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:03:46.000+0000",
        message: "Programmable Chat: Notification template too long",
        secondary_message: "Specified notification template parameter is too long",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-10-30T10:27:05.000+0000",
        solutions: "*  Notify: Set the Credential SID either in the Notify Service or in the Create Binding request\r\n*  Chat, Voice, Account Security: Set the Credential SiD in the Access Token",
        causes: "Configuration is slightly different depending on which Twilio API and product you are using.\r\n\r\n*  Notify: Credential SID can be specified in the Notify Service or in the Binding. This error indicates neither of those were specified.\r\n\r\n*  Chat, Voice, Account Security: Credential SID can be specified in the Twilio Access Token used to register for push notifications. This error indicates that the token missed that information.\r\n",
        description: "Credential SIDs are used to determine which Credential resource to use to send a given push notification (APNS, FCM or GCM). For each delivery attempt the system tries to select a Credential SID depending on the API request and configuration. This error indicates that the system did not find any available Credential SID to use and hence failed to send the delivery attempt.",
        const_partition: "1",
        docs: "## ERROR - 52004\r\n\r\n### Credential SID not specified\r\n\r\nCredential SID not specified in binding, token or service Credential SIDs are used to determine which Credential resource to use to send a given push notification (APNS, FCM or GCM). For each delivery attempt the system tries to select a Credential SID depending on the API request and configuration. This error indicates that the system did not find any available Credential SID to use and hence failed to send the delivery attempt.\r\n\r\n#### Possible Causes\r\nConfiguration is slightly different depending on which Twilio API and product you are using.\r\n\r\n*  Notify: Credential SID can be specified in the Notify Service or in the Binding. This error indicates neither of those were specified.\r\n\r\n*  Chat, Voice, Account Security: Credential SID can be specified in the Twilio Access Token used to register for push notifications. This error indicates that the token missed that information.\r\n\r\n\r\n#### Possible Solutions\r\n*  Notify: Set the Credential SID either in the Notify Service or in the Create Binding request\r\n*  Chat, Voice, Account Security: Set the Credential SiD in the Access Token",
        code: 52004,
        log_level: "ERROR",
        last_updated: "2019-11-14T13:48:13.000+0000",
        message: "Credential SID not specified",
        log_type: "APPLICATION",
        secondary_message: "Credential SID not specified in binding, token or service",
        product: null,
    },
    {
        date_created: "2017-10-14T07:36:47.000+0000",
        const_partition: "1",
        docs: "## Warning - 52401\r\n\r\n### Too many notification log events \r\n\r\n#### Possible Causes \r\n*  Notification requests resulted in too many delivery attempts. As a result, some of the notification events were rate limited and might not be visible in the notification log in console. The message delivery itself is not affected.\r\n\r\n#### Possible Solutions\r\n* When sending large broadcasts, slow down the rate of Send Notification requests, e.g. to 1 / s",
        code: 52401,
        log_level: "WARNING",
        last_updated: "2017-10-16T08:04:34.000+0000",
        message: "Too many notification log events ",
        secondary_message: "Too many notification log events, some may be discarded.",
        product: "Notifications",
    },
    {
        date_created: "2017-10-12T20:01:19.000+0000",
        const_partition: "1",
        docs: "### 53304: Track name is duplicated\r\n\r\nRaised whenever a Participant is currently publishing a Track with the same name.\r\n\r\n#### Causes\r\n\r\n * A Track with the same name already exists.\r\n\r\n#### Solutions\r\n\r\n * Choose a Track name that is unique per Participant.\r\n",
        code: 53304,
        log_level: "ERROR",
        last_updated: "2017-10-12T20:01:19.000+0000",
        message: "Track name is duplicated",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-10-12T20:00:45.000+0000",
        const_partition: "1",
        docs: "### 53303: Track name contains invalid characters\r\n\r\nRaised whenever a Track name contains invalid characters.\r\n\r\n#### Causes\r\n\r\n * The Track name contains an invalid UTF-8 byte sequence.\r\n\r\n#### Solutions\r\n\r\n * Choose a Track name that is a valid UTF-8 string.\r\n",
        code: 53303,
        log_level: "ERROR",
        last_updated: "2017-10-12T20:00:45.000+0000",
        message: "Track name contains invalid characters",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-10-12T19:59:42.000+0000",
        const_partition: "1",
        docs: "### 53302: Track name is too long\r\n\r\nRaised whenever a Track name is too long.\r\n\r\n#### Causes\r\n\r\n * The Track name is too long.\r\n\r\n#### Solutions\r\n\r\n * Choose a shorter Track name.\r\n",
        code: 53302,
        log_level: "ERROR",
        last_updated: "2017-10-12T19:59:42.000+0000",
        message: "Track name is too long",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-10-12T19:59:08.000+0000",
        const_partition: "1",
        docs: "### 53301: Track name is invalid\r\n\r\nRaised whenever a Track name is invalid, and the scenario is not covered by a more specific error code.\r\n\r\n#### Causes\r\n\r\n * The Track name does not adhere to the Track name requirements.\r\n\r\n#### Solutions\r\n\r\n * Choose a Track name adheres to the Track name requirements.\r\n",
        code: 53301,
        log_level: "ERROR",
        last_updated: "2017-10-12T19:59:08.000+0000",
        message: "Track name is invalid",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-10-12T19:58:28.000+0000",
        const_partition: "1",
        docs: "### 53300: Track is invalid\r\n\r\nRaised whenever a Track is invalid, and the scenario is not covered by a more specific error code.",
        code: 53300,
        log_level: "ERROR",
        last_updated: "2017-10-12T19:58:28.000+0000",
        message: "Track is invalid",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-10-05T22:56:56.000+0000",
        const_partition: "1",
        docs: "## Error - 31000\r\n\r\n### Generic error\r\n\r\n#### Possible Solutions\r\n\r\n- No further information available. Check the debugger for more information on the actual cause. ",
        code: 31000,
        log_level: "ERROR",
        last_updated: "2017-10-06T17:54:54.000+0000",
        message: "Generic error",
        secondary_message: "No further information available. Check the debugger for more information on the actual cause.",
        product: "Programmable Voice",
    },
    {
        date_created: "2017-10-04T22:02:37.000+0000",
        const_partition: "1",
        docs: "## Error - 60201 \r\n\r\n### Invalid verification code\r\n\r\nAn invalid code has been passed.\r\n\r\n#### Possible Causes \r\n*  Code is not a number.\r\n*  Code has not a valid length, it should be between 4 to 10 characters.\r\n*  Code has expired.",
        code: 60201,
        log_level: "ERROR",
        last_updated: "2018-11-20T19:37:42.000+0000",
        message: "Invalid verification code",
        secondary_message: "An invalid code has been passed.",
        product: "Verify",
    },
    {
        date_created: "2017-10-04T22:00:46.000+0000",
        solutions: "* Use strict [E.164 formatting](https://www.twilio.com/docs/glossary/what-e164), including the `+` sign, for phone numbers in the `To` parameter. Example: `+15017122661`.",
        causes: "* `To` parameter is incorrectly formatted or missing the leading `+`.\r\n* `Channel` parameter is not one of the [accepted options](https://www.twilio.com/docs/verify/api/verification#start-new-verification).\r\n* `FriendlyName` is too long (max 64 characters).",
        description: 'The response `message` contains the name of the invalid parameter. \r\n\r\nExample where `To` is the invalid parameter:\r\n```\r\n{\r\n    "code": 60200,\r\n    "message": "Invalid parameter: To",\r\n    "more_info": "https://www.twilio.com/docs/errors/60200",\r\n    "status": 400\r\n}\r\n```',
        const_partition: "1",
        docs: '## ERROR - 60200\r\n\r\n### Invalid parameter\r\n\r\nParameter value is incorrectly formatted or is not an accepted option. The response `message` contains the name of the invalid parameter. \r\n\r\nExample where `To` is the invalid parameter:\r\n```\r\n{\r\n    "code": 60200,\r\n    "message": "Invalid parameter: To",\r\n    "more_info": "https://www.twilio.com/docs/errors/60200",\r\n    "status": 400\r\n}\r\n```\r\n\r\n#### Possible Causes\r\n* `To` parameter is incorrectly formatted or missing the leading `+`.\r\n* `Channel` parameter is not one of the [accepted options](https://www.twilio.com/docs/verify/api/verification#start-new-verification).\r\n* `FriendlyName` is too long (max 64 characters).\r\n\r\n#### Possible Solutions\r\n* Use strict [E.164 formatting](https://www.twilio.com/docs/glossary/what-e164), including the `+` sign, for phone numbers in the `To` parameter. Example: `+15017122661`.',
        code: 60200,
        log_level: "ERROR",
        last_updated: "2019-10-09T22:28:19.000+0000",
        message: "Invalid parameter",
        log_type: "APPLICATION",
        secondary_message: "Parameter value is incorrectly formatted or is not an accepted option.",
        product: "Verify",
    },
    {
        date_created: "2017-09-15T19:47:56.000+0000",
        const_partition: "1",
        docs: "## Error - 34108\r\n### Fax: Other End Incompatible\r\n\r\nThe receiving fax machine answered, but then rejected your incoming media.\r\n\r\nTry reducing the size of your pdf or sending at a lower quality or resolution. Make sure your pdf is a standard size (US Letter, A4) and portrait-oriented.",
        code: 34108,
        log_level: "ERROR",
        last_updated: "2018-08-10T01:40:28.000+0000",
        message: "Other End Incompatible",
        secondary_message: null,
        product: "Programmable Fax",
    },
    {
        date_created: "2017-09-15T19:46:44.000+0000",
        const_partition: "1",
        docs: "## Error - 34004\r\n### Fax: Error during fax transmission\r\n\r\nEither poor connection quality to the recipient or the recipient terminated the fax early.",
        code: 34004,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:57:30.000+0000",
        message: "Error during fax transmission",
        secondary_message: null,
        product: "Programmable Fax",
    },
    {
        date_created: "2017-09-15T19:46:33.000+0000",
        const_partition: "1",
        docs: "## Error - 34003\r\n### Fax: Callee did not answer\r\n",
        code: 34003,
        log_level: "ERROR",
        last_updated: "2017-09-15T19:46:33.000+0000",
        message: "Callee did not answer",
        secondary_message: null,
        product: "Programmable Fax",
    },
    {
        date_created: "2017-09-15T19:46:00.000+0000",
        const_partition: "1",
        docs: "## Error - 34002\r\n### Fax: Callee Busy\r\n",
        code: 34002,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:58:10.000+0000",
        message: "Callee Busy",
        secondary_message: null,
        product: "Programmable Fax",
    },
    {
        date_created: "2017-09-11T22:30:36.000+0000",
        const_partition: "1",
        docs: "### 53113: Room creation failed\r\n\r\nRaised when the Server is unable to create a Room when the same name already exists.\r\n\r\n#### Causes\r\n\r\n * An existing Room exists with the same name\r\n\r\n#### Solutions\r\n\r\n * Create a Room with a unique name",
        code: 53113,
        log_level: "ERROR",
        last_updated: "2017-09-11T22:30:36.000+0000",
        message: "Room creation failed",
        secondary_message: "A Room exists with the same name",
        product: "Programmable Video",
    },
    {
        date_created: "2017-09-08T04:30:59.000+0000",
        const_partition: "1",
        docs: "## Error - 34106\r\n### Fax: No Fax TwiML action specified\r\n\r\nMissing [Receive](https://www.twilio.com/docs/api/fax/receive#receive) verb in received TwiML.\r\n\r\nSimplest implementation is `<Receive />`",
        code: 34106,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:57:19.000+0000",
        message: "No Fax TwiML action specified",
        secondary_message: "Missing Receive verb in TwiML",
        product: "Programmable Fax",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54458\n\n### Sync: Invalid List Item Index\nThe List Item index must be a non-negative integer.\n\n#### Possible Causes\n* The value supplied by the List Index parameter contains a non-integer or a negative integer.\n\n#### Possible Solutions\nConfirm that a valid List Index parameter is being passed in your request.\n",
        code: 54458,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid List Item index",
        secondary_message: "The List Item index must be a non-negative integer.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "## Error - 54454\r\n\r\n### Sync: Invalid 'PageSize' query parameter\r\nThe 'PageSize' value must be in the range [1-100].\r\n\r\n#### Possible Causes\r\n* The value supplied by the PageSize query string parameter is not an integer in the required range.\r\n\r\n#### Possible Solutions\r\nConfirm that a valid PageSize query parameter is being passed in request.\r\n",
        code: 54454,
        log_level: "ERROR",
        last_updated: "2019-04-09T06:34:01.000+0000",
        message: "Invalid 'PageSize' query parameter",
        secondary_message: "The requested page size must be in the range [1-100].",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "## Error - 54453\r\n\r\n### Sync: Invalid 'PageToken' query parameter\r\nThe specified 'PageToken' query parameter is invalid.\r\n\r\n#### Possible Causes\r\n* The value supplied by the PageToken query string parameter is invalid or malformed.\r\n\r\n#### Possible Solutions\r\nEnsure that a valid PageToken parameter is supplied, as originally included in the previous/next page links under the _meta_ block of pagination response.",
        code: 54453,
        log_level: "ERROR",
        last_updated: "2019-04-09T06:28:36.000+0000",
        message: "Invalid 'PageToken' query parameter",
        secondary_message: "Your query specifies an invalid paging token.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54452\n\n### Sync: Invalid 'Bounds' query parameter\nThe 'Bounds' query parameter must be one of {'inclusive', 'exclusive'}.\n\n#### Possible Causes\n* The value supplied by the Bounds query string parameter does not match _inclusive_ or _exclusive_ designators.\n\n#### Possible Solutions\nConfirm a valid Bounds query parameter is being passed in request.\n",
        code: 54452,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid 'Bounds' query parameter",
        secondary_message: "The 'Bounds' query parameter must be one of {'inclusive', 'exclusive'}.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54451\n\n### Sync: Invalid 'Order' query parameter\nThe 'Order' query parameter must be one of {'asc', 'desc'}.\n\n#### Possible Causes\n* The value supplied by the Order query string parameter does not match _asc_ or _desc_ designators.\n\n#### Possible Solutions\nConfirm a valid Order query parameter is being passed in request.\n",
        code: 54451,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid 'Order' query parameter",
        secondary_message: "The 'Order' query parameter must be one of {'asc', 'desc'}.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54450\n\n### Sync: Invalid 'Direction' query parameter\nThe 'Direction' query parameter must be one of {'forward', 'backward'}.\n\n#### Possible Causes\n* The value supplied by the Direction query string parameter does not match _forward_ or _backward_ designators.\n\n#### Possible Solutions\nConfirm that a valid Direction query parameter is being passed in request.\n",
        code: 54450,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid 'Direction' query parameter",
        secondary_message: "The 'Direction' query parameter must be one of {'forward', 'backward'}.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "## Error - 54354\r\n\r\n### Sync: Permission not found\r\nThe specified Permission does not exist.\r\n\r\n#### Possible Causes\r\n* Requested permission does not exist because the provided Identity parameter is incorrect.\r\n* Permission for the specified Identity has been deleted.\r\n\r\n#### Possible Solutions\r\nConfirm that the Identity parameter being passed in your request answers to the correct identity in your app, and that it has permissions to access the given object.",
        code: 54354,
        log_level: "ERROR",
        last_updated: "2019-04-09T06:16:03.000+0000",
        message: "Permission not found",
        secondary_message: "The specified Permission does not exist.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54351\n\n### Sync: Invalid identity\nIdentity must be a string with length 1-256.\n\n#### Possible Causes\n* The value supplied by the Identity parameter is an empty string.\n* The value supplied by the Identity parameter exceeds 256 characters.\n\n#### Possible Solutions\nConfirm than an Identity string parameter of 1-256 characters is being passed in request.\n",
        code: 54351,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid identity",
        secondary_message: "Identity must be a string with length 1-256.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54302\n\n### Sync: Invalid unique name\nThe unique name must be a string with length 1-256 and not match the SID pattern [A-Z]{2}[a-f0-9]{32}.\n\n#### Possible Causes\n* The value supplied by the UniqueName parameter is an empty string.\n* The value supplied by the UniqueName parameter exceeds 256 characters.\n\n#### Possible Solutions\nConfirm that your UniqueName is a string of 1-256 characters not matching the SID pattern.\n",
        code: 54302,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid unique name",
        secondary_message: "The unique name must be a string with length 1-256 and not match the SID pattern [A-Z]{2}[a-f0-9]{32}.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54301\n\n### Sync: Unique name already exists\nAn object with the specified unique name already exists.\n\n#### Possible Causes\n* Another object with the matching Unique Name already exists in this Sync Service Instance, causing a conflict.\n* The provided UniqueName parameter is not set correctly.\n* Your original Sync object creation request has been sent more than once due to a retrier error.\n\n#### Possible Solutions\n* Confirm a valid UniqueName parameter is being passed in request, matching your expectation.\n* Delete a previous object with the matching Unique Name if you no longer need it.\n* Pick a different Unique Name, or create an anonymous object addressed by a SID instead.\n",
        code: 54301,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Unique name already exists",
        secondary_message: "An object with the specified unique name already exists.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54300\n\n### Sync: Unique name not found\nNo object with the specified unique name exists.\n\n#### Possible Causes\n* The provided UniqueName parameter is incorrect.\n* The requested Sync object with given unique name has been deleted.\n\n#### Possible Solutions\nConfirm that a valid UniqueName parameter is being passed in your request.\n",
        code: 54300,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Unique name not found",
        secondary_message: "No object with the specified unique name exists.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54251\n\n### Sync: Invalid Stream Message data\nThe 'Data' parameter cannot be null.\n\n#### Possible Causes\n* Your request does not include a Data parameter which is required for this operation.\n\n#### Possible Solutions\nConfirm that a valid Data parameter containing a serialized, utf-8 JSON object is being passed in your request.\n",
        code: 54251,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid Message Stream Message data",
        secondary_message: "The 'Data' parameter cannot be null.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54250\n\n### Sync: Message Stream not found\nThe specified Message Stream does not exist.\n\n#### Possible Causes\n* The supplied Message Stream SID is erroneous.\n* The requested Message Stream has been deleted.\n\n#### Possible Solutions\nConfirm a valid Message Stream SID is being passed in your request.\n",
        code: 54250,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Message Stream not found",
        secondary_message: "The specified Message Stream does not exist.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54209\n\n### Sync: Invalid Map Item key\nThe Map Item key must be a string with length 1-256.\n\n#### Possible Causes\n* The value supplied by the Map Key parameter contains an empty string.\n* The string supplied by the Map Key parameter exceeds 256 characters.\n\n#### Possible Solutions\n* Confirm a valid Map Key parameter is being passed in your request.\n",
        code: 54209,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid Map Item key",
        secondary_message: "The Map Item key must be a string with length 1-256.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54208\n\n### Sync: Map Item already exists\nA Map Item with given key already exists in the Map.\n\n#### Possible Causes\n* Another Item with the matching Key already exists in this Sync Map, causing a conflict.\n* The provided Key parameter is not set correctly.\n* Your original Map Item creation request has been sent more than once due to a retrier error.\n\n#### Possible Solutions\n* Confirm a valid Key parameter is being passed in request, matching your expectation.\n* Delete a previous Map Item with the matching Key if you no longer need it.\n* Pick a different Key. If your items should be unique, consider using a UUID.\n",
        code: 54208,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Map Item already exists",
        secondary_message: "A Map Item with given key already exists in the Map.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54206\n\n### Sync: Invalid Map Item data\nThe 'Data' parameter cannot be null.\n\n#### Possible Causes\n* Your request does not include a Data parameter which is required for this operation.\n\n#### Possible Solutions\nConfirm that a valid Data parameter containing a serialized, utf-8 JSON object is being passed in your request.\n",
        code: 54206,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid Map Item data",
        secondary_message: "The 'Data' parameter cannot be null.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54205\n\n### Sync: Map Item revision mismatch\nThe actual revision of the Map Item does not match the expected revision.\n\n#### Possible Causes\n* Your update to this Sync Map Item has conflicted with a request submitted elsewhere.\n* The value specified in the If-Match header is erroneous.\n\n#### Possible Solutions\nIf your update conflicts with a concurrent update elsewhere, the correct solution is to read the latest data (on the client SDK: wait for an update) and then re-attempt your update until you succeed. Consider that, since the data has changed, you may not want to submit the exact same update a second time. On the JavaScript SDK, we suggest using the [mutate](https://www.twilio.com/docs/api/sync/mutation-and-conflict-resolution#javascript-sdk-conflict-walkthrough) convenience function.\n\nThe value you provide in the If-Match header should be a revision assigned by the Sync service when interacting with the object.\n\n* In SDKs, this is the `revision` field, part of the object descriptor.\n* When using REST (e.g. via the Twilio Helper libraries) this is the `ETag` header provided in responses.\n",
        code: 54205,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Map Item revision mismatch",
        secondary_message: "The actual revision of the Map Item does not match the expected revision.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54201\n\n### Sync: Map Item not found\nThe specified Map Item does not exist.\n\n#### Possible Causes\n* The specified Sync Map item key is incorrect.\n* The requested item of a Sync Map has been deleted.\n\n#### Possible Solutions\nConfirm a valid Sync Map key is being passed in your request.\n",
        code: 54201,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Map Item not found",
        secondary_message: "The specified Map Item does not exist.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54200\n\n### Sync: Map not found\nThe specified Map does not exist.\n\n#### Possible Causes\n* The supplied Sync Map SID is erroneous.\n* The requested Sync Map has been deleted.\n\n#### Possible Solutions\nConfirm that the map you're requesting exists, and that you are using the precise SID or unique name it is assigned.\n",
        code: 54200,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Map not found",
        secondary_message: "The specified Map does not exist.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54156\n\n### Sync: Invalid List Item Data\nThe 'Data' parameter cannot be null.\n\n#### Possible Causes\n* Your request does not include a Data parameter which is required for this operation.\n\n#### Possible Solutions\nConfirm that a valid Data parameter containing a serialized, utf-8 JSON object is being passed in your request.\n",
        code: 54156,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid List Item data",
        secondary_message: "The 'Data' parameter cannot be null.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54155\n\n### Sync: List Item revision mismatch\nThe actual revision of the List Item does not match the expected revision.\n\n#### Possible Causes\n* Your update to this Sync List Item has conflicted with a request submitted elsewhere.\n* The value specified in the If-Match header is erroneous.\n\n#### Possible Solutions\nIf your update conflicts with a concurrent update elsewhere, the correct solution is to read the latest data (on the client SDK: wait for an update) and then re-attempt your update until you succeed. Consider that, since the data has changed, you may not want to submit the exact same update a second time. On the JavaScript SDK, we suggest using the [mutate](https://www.twilio.com/docs/api/sync/mutation-and-conflict-resolution#javascript-sdk-conflict-walkthrough) convenience function.\n\nThe value you provide in the If-Match header should be a revision assigned by the Sync service when interacting with the object.\n\n* In SDKs, this is the `revision` field, part of the object descriptor.\n* When using REST (e.g. via the Twilio Helper libraries) this is the `ETag` header provided in responses.\n",
        code: 54155,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "List Item revision mismatch",
        secondary_message: "The actual revision of the List Item does not match the expected revision.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54151\n\n### Sync: List Item not found\nThe specified List Item does not exist.\n\n#### Possible Causes\n* The specified Sync List item index is incorrect.\n* The requested item of a Sync List has been deleted.\n\n#### Possible Solutions\nConfirm a valid Sync List index is being passed in your request.\n",
        code: 54151,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "List Item not found",
        secondary_message: "The specified List Item does not exist.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54150\n\n### Sync: List not found\nThe specified List does not exist.\n\n#### Possible Causes\n* The supplied Sync List SID is erroneous.\n* The requested Sync List has been deleted.\n\n#### Possible Solutions\nConfirm that the list you're requesting exists, and that you are using the precise SID or unique name it is assigned.\n",
        code: 54150,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "List not found",
        secondary_message: "The specified List does not exist.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54103\n\n### Sync: Document revision mismatch\nThe actual revision of the Document does not match the expected revision.\n\n#### Possible Causes\n* Your update to this Sync Document has conflicted with a request submitted elsewhere.\n* The value specified in the If-Match header is erroneous.\n\n#### Possible Solutions\nIf your update conflicts with a concurrent update elsewhere, the correct solution is to read the latest revision (on the client SDK: wait for an update) and then re-attempt your update until you succeed. Consider that, since the data has changed, you may not want to submit the exact same update a second time. On the JavaScript SDK, we suggest using the [mutate](https://www.twilio.com/docs/api/sync/mutation-and-conflict-resolution#javascript-sdk-conflict-walkthrough) convenience function.\n\nThe value you provide in the If-Match header should be a revision assigned by the Sync service when interacting with an object.\n\n* In SDKs, this is the `revision` field, part of the object descriptor.\n* When using REST (e.g. via the Twilio Helper libraries) this is the `ETag` header provided in responses.\n",
        code: 54103,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Document revision mismatch",
        secondary_message: "The actual revision of the Document does not match the expected revision.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54101\n\n### Sync: Invalid Document data\nThe 'Data' parameter cannot be null.\n\n#### Possible Causes\nYour request does not include a Data parameter which is required for this operation.\n\n#### Possible Solutions\nConfirm that a valid Data parameter containing a serialized, utf-8 JSON object is being passed in your request.\n",
        code: 54101,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid Document data",
        secondary_message: "The 'Data' parameter cannot be null.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54100\n\n### Sync: Document not found\nThe specified Document does not exist.\n\n#### Possible Causes\n* The supplied Sync Document SID or Unique Name is erroneous.\n* This Sync Document has been deleted.\n\n#### Possible Solutions\nConfirm that the document you're requesting exists, and that you are using the precise SID or unique name it is assigned.\n",
        code: 54100,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Document not found",
        secondary_message: "The specified Document does not exist.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54056\n\n### Sync: Account cannot access requested Service Instance\nAccount cannot access requested Service Instance.\n\n#### Possible Causes\n* The requested Sync Service does not belong to this account.\n* You have multiple accounts, and this Sync Service does not belong to the account whose credentials you used.\n\n#### Possible Solutions\nConfirm that you're using the correct credentials for this instance's account. This could mean:\n\n* Make sure the Access Token specifies the correct Account SID\n* Make sure that the Account SID + AuthToken pair you're using (for REST access) matches the correct account\n* Make sure the API Key + API secret you're using (for REST access) belongs to the correct account.\n",
        code: 54056,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Account cannot access requested Service Instance",
        secondary_message: "Account cannot access requested Service Instance.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54053\n\n### Sync: Invalid friendly name\nThe specified 'FriendlyName' parameter is not valid.\n\n#### Possible Causes\n* The value supplied by the FriendlyName parameter is an empty string.\n* The value supplied by the FriendlyName parameter exceeds 255 characters.\n\n#### Possible Solutions\nConfirm the FriendlyName string parameter is either unspecified (`null`) or a nonempty string of up to 1-255 Unicode characters.\n",
        code: 54053,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid friendly name",
        secondary_message: "The specified 'FriendlyName' parameter is not valid.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54051\n\n### Sync: Invalid webhook URL\nThe specified 'WebhookUrl' parameter is not a valid URL.\n\n#### Possible Causes\n* You did not pass a correctly-formatted URL.\n* You are crafting HTTP requests yourself and passed a URL, but did not percent-encoded it.\n\n#### Possible Solutions\nConfirm that you are providing a fully-qualified, percent-encoded HTTP URL.\n",
        code: 54051,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid webhook URL",
        secondary_message: "The specified 'WebhookUrl' parameter is not a valid URL.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54050\n\n### Sync: Instance not found\nThe specified Service Instance does not exist.\n\n#### Possible Causes\n* The supplied Sync Service Instance SID is erroneous.\n* The requested Sync Service Instance has been deleted.\n\n#### Possible Solutions\n* Use the [Twilio Console](https://twilio.com/console) or the [REST API](https://www.twilio.com/docs/api/sync/rest/services) to confirm your Sync service exists.\n* Make sure the Sync Service Instance SID passed in your request matches the SID of that service exactly.\n",
        code: 54050,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Service Instance not found",
        secondary_message: "The specified Service Instance does not exist.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54009\n\n### Sync: Rate limit exceeded\nThe rate of access to this resource exceeds the prescribed limits.\n\n#### Possible Causes\n* Your application is opening, reading or querying a single Sync object or its sub-items too often.\n* Your application is updating a single Sync object or its sub-items too often.\n* Your application is creating new Sync objects or their sub-items too often.\n\n#### Possible Solutions\n* Analyze your application to ensure that the _sustained_ rate of reads and writes against a single Sync object, and the sustained rate of of new object creations, is below 20 per second during normal application activity. Note that this limit only applies to explicit reads or writes; delivered state updates are not limited.\n* Analyze your application to ensure that bursts of activity are uncommon; Sync provides a ten-second burst window during which you can exceed the sustained request-rate limits.\n* Make sure your application (client or backend) uses a good exponential back-off algorithm like [the one advocated by Amazon](https://www.awsarchitectureblog.com/2015/03/backoff.html) to retry on HTTP 429 (rate limiting) responses.\n",
        code: 54009,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Rate limit exceeded",
        secondary_message: "The rate of access to this resource exceeds the prescribed limits.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54008\n\n### Sync: Invalid JSON\nThe specified 'Data' parameter is not valid JSON.\n\n#### Possible Causes\n* The data you submitted is not JSON, or\n* A missing or poorly-encoded character makes your JSON fail to parse.\n* You crafted the HTTP request yourself, and did not percent-encode the submitted JSON data in the form parameters.\n\n#### Possible Solutions\n* Use a tool like [JSONLint](https://jsonlint.com/) to check the data you're sending for syntax errors.\n* If you're crafting HTTP requests yourself, make sure all form data is percent-encoded.\n",
        code: 54008,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid JSON",
        secondary_message: "The specified 'Data' parameter is not valid JSON.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54007\n\n### Sync: Access forbidden for identity\nThe identity specified in the Access Token does not have permissions to perform this operation.\n\n#### Possible Causes\n* Sync's ACL control has been unintentionally enabled on your Sync service instance.\n* An SDK endpoint trying to read or write a Sync object does not have the correct permission configured.\n* The identity you specified in your SDK's token does not match the permissions that you intended for them.\n\n#### Possible Solutions\n* Disable the ACL feature on this Sync service. This will allow access from any SDK with a valid token.\nDo this by either unchecking the AclEnabled feature in the [Twilio Console](https://www.twilio.com/console/sync/services), or setting the `acl_enabled` flag to `false` via the [Sync REST API](https://www.twilio.com/docs/api/sync/rest/services).\n* Confirm a valid permission is configured via the [Sync Permissions REST API](https://www.twilio.com/docs/api/sync/rest/sync-rest-api-permissions), and that the configured identity matches the identity you provide in your FPA Access Tokens.\n",
        code: 54007,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Access forbidden for identity",
        secondary_message: "The identity specified in the Access Token does not have permissions to perform this operation.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54006\n\n### Sync: Request entity too large\nThe size of the specified 'Data' parameter exceeds the size limit.\n\n#### Possible Causes\n* The size of a serialized JSON payload stored in a Sync Document, List Item, or Map Item cannot exceed 16KB; attempting to submit a larger object will yield this error.\n\n#### Possible Solutions\n* Reduce the size of the submitted JSON object by removing or compressing data.\n* Split your data across multiple Map Items, List Items, or Documents.\n",
        code: 54006,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Request entity too large",
        secondary_message: "The size of the specified 'Data' parameter exceeds the size limit.",
        product: "Sync",
    },
    {
        date_created: "2017-09-04T00:00:00.000+0000",
        const_partition: "1",
        docs: "\n## Error - 54003\n\n### Sync: Invalid If-Match header\nThe specified If-Match header cannot be used for concurrency control.\n\n#### Possible Causes\n* The value specified in the If-Match header is not a valid Sync object revision.\n\n#### Possible Solutions\nThe value you provide should be a revision assigned by the Sync service when interacting with an object.\n\n* In SDKs, this is the `revision` field, part of the object descriptor.\n* When using REST (e.g. via the Twilio Helper libraries) this is the `ETag` header provided in responses.\n",
        code: 54003,
        log_level: "error",
        last_updated: "2017-09-22T19:06:19.065Z",
        message: "Invalid If-Match header",
        secondary_message: "The specified If-Match header is invalid.",
        product: "Sync",
    },
    {
        date_created: "2017-08-25T22:30:45.000+0000",
        const_partition: "1",
        docs: "## Error - 16107\r\n\r\n### Voice Recording: Encrypted with alternate public key\r\n\r\nRecording was encrypted with alternate public key because the one configured on the account is invalid or deleted. (only applicable if call recording encryption feature enabled)",
        code: 16107,
        log_level: "ERROR",
        last_updated: "2018-05-30T19:06:49.000+0000",
        message: "Voice Recording: Encrypted with alternate public key",
        secondary_message: "Recording was encrypted with alternate public key because the one configured on the account is invalid or deleted. (only applicable if call recording encryption feature enabled)",
        product: "Programmable Voice",
    },
    {
        date_created: "2017-08-25T22:29:47.000+0000",
        const_partition: "1",
        docs: "## Error - 16106\r\n\r\n### Voice Recording: Unavailable due to internal encryption error\r\n\r\nRecording was not stored due to a transient internal encryption error  (only applicable if call recording encryption feature enabled)",
        code: 16106,
        log_level: "ERROR",
        last_updated: "2018-05-30T19:05:59.000+0000",
        message: "Voice Recording: Unavailable due to internal encryption error",
        secondary_message: "Recording was not stored due to a transient internal encryption error  (only applicable if call recording encryption feature enabled)",
        product: "Programmable Voice",
    },
    {
        date_created: "2017-08-25T22:27:42.000+0000",
        const_partition: "1",
        docs: "## Error - 16105\r\n\r\n### Voice Recording: Unavailable due to no valid public keys\r\n\r\nRecording was not stored because there were no valid public keys on the account  (only applicable if call recording encryption feature enabled)",
        code: 16105,
        log_level: "ERROR",
        last_updated: "2018-05-30T19:04:53.000+0000",
        message: "Voice Recording: Unavailable due to no valid public keys",
        secondary_message: "Recording was not stored due to no valid public keys on the account  (only applicable if call recording encryption feature enabled)",
        product: "Programmable Voice",
    },
    {
        date_created: "2017-08-25T22:23:16.000+0000",
        const_partition: "1",
        docs: "## Error - 16104\r\n\r\n### Voice Recording: Unavailable due to encryption failure\r\n\r\nRecording was not stored due to a public key encryption failure.  (only applicable if call recording encryption feature enabled)",
        code: 16104,
        log_level: "ERROR",
        last_updated: "2018-05-30T19:04:09.000+0000",
        message: "Voice Recording: Unavailable due to encryption failure",
        secondary_message: "Recording was not stored due to a public key encryption failure.  (only applicable if call recording encryption feature enabled)",
        product: "Programmable Voice",
    },
    {
        date_created: "2017-08-24T16:40:34.000+0000",
        const_partition: "1",
        docs: "## Warning - 32015\r\n\r\n### Call is terminated due to exceeding max call duration of 4 hours.\r\n\r\n#### Possible Causes\r\n\r\n* You've exceeded the max call duration of 4 hours so call is terminated.",
        code: 32015,
        log_level: "WARNING",
        last_updated: "2017-08-24T16:40:45.000+0000",
        message: "Call is terminated due to exceeding max call duration of 4 hours.",
        secondary_message: "Session-Timeout",
        product: "Programmable Voice",
    },
    {
        date_created: "2017-08-24T16:39:49.000+0000",
        const_partition: "1",
        docs: "## Warning - 32014\r\n\r\n### Call is terminated because of no audio received\r\n\r\n#### Possible Causes\r\n\r\n* One party doesn't send audio for an extended period of time and call is terminated.\r\n\r\n#### Possible Solutions\r\n\r\n* It could be the case when one party is disconnected without hanging up due to network failure. Try to call again later.\r\n* If this keeps happening, please contact Twilio support to enable voice trace. With voice trace enabled, Twilio can know which side stops sending audio to track down the root cause.",
        code: 32014,
        log_level: "WARNING",
        last_updated: "2017-08-24T16:39:49.000+0000",
        message: "Call is terminated because of no audio received",
        secondary_message: "RTP-Timeout",
        product: "Programmable Voice",
    },
    {
        date_created: "2017-08-21T21:41:13.000+0000",
        const_partition: "1",
        docs: "## Warning - 13328 \r\n\r\n### Gather: Invalid maxSpeechTime value",
        code: 13328,
        log_level: "WARNING",
        last_updated: "2017-08-21T21:41:13.000+0000",
        message: "Gather: Invalid maxSpeechTime value",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2017-08-03T11:53:37.000+0000",
        const_partition: "1",
        docs: "## Error - 70106\r\n\r\n### Invalid AWS credentials specified in the request\r\nWhen uploading AWS credentials to Twilio make sure:\r\n* AWS key matches the regex: (?<![A-Z0-9])[A-Z0-9]{20}(?![A-Z0-9])\r\n* AWS secret matches the regex: (?<![A-Za-z0-9/+=])[A-Za-z0-9/+=]{40}(?![A-Za-z0-9/+=])\r\n\r\n#### Possible Solution:\r\n* Validate the credentials and upload them again.\r\n\r\n",
        code: 70106,
        log_level: "ERROR",
        last_updated: "2017-08-03T11:53:37.000+0000",
        message: "Invalid AWS credentials",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-07-26T21:02:28.000+0000",
        const_partition: "1",
        docs: "## Warning - 13621\r\n\r\n### Invalid 'recordingStatusCallbackEvent'\r\n\r\nOne or more of the recordingStatusCallbackEvents provided were invalid.",
        code: 13621,
        log_level: "ERROR",
        last_updated: "2017-09-28T18:06:48.000+0000",
        message: "Invalid 'recordingStatusCallbackEvent'",
        secondary_message: "One or more of the recordingStatusCallbackEvents provided were invalid.",
        product: "Programmable Voice",
    },
    {
        date_created: "2017-07-17T07:40:44.000+0000",
        const_partition: "1",
        docs: "## Error - 52203\r\n\r\n### Missing body for Facebook Messenger delivery attempt\r\n\r\nMessenger messages need to have some content. You can specify this either via the [generic Body parameter](https://www.twilio.com/docs/api/notify/rest/notifications#generic-payload-parameters) of the Notification request or the [FacebookMessenger channel specific parameter](https://www.twilio.com/docs/api/notify/rest/notifications#channel-specific-parameters).\r\n\r\n#### Possible causes\r\n- Notification has neither Body not FacebookMessenger parameter set\r\n\r\n#### Possible solutions\r\n- Specify either Body or FacebookMessenger parameter when sending a Notification",
        code: 52203,
        log_level: "ERROR",
        last_updated: "2017-07-17T08:40:25.000+0000",
        message: "Missing body for Facebook Messenger delivery attempt",
        secondary_message: "Either Body or FacebookMessenger parameter of Notification should be used to specify the message body",
        product: "Notifications",
    },
    {
        date_created: "2017-07-14T09:29:35.000+0000",
        const_partition: "1",
        docs: "## Error - 52182\r\n\r\n### Messaging Service not specified\r\n\r\nIn order to send SMS messages with Notify you need to configure a [Messaging Service](https://www.twilio.com/docs/api/rest/messaging-services-and-copilot-overview) and connect it with your Notify Service. Messaging Services make it easy to build SMS application by automatically selecting an optimal From phone number from pool you can define. \r\n\r\n#### Possible causes\r\n- MessagingServiceSid in Notify Service is not specified\r\n\r\n#### Possible solutions\r\n- Configure a Messaging Service in the [console](/console/notify/services) or via the [REST API](https://www.twilio.com/docs/api/notify/rest/services#update-a-service). You can create a new Messaging Service in the [console](https://www.twilio.com/console/sms/services) or via the [REST API](https://www.twilio.com/docs/api/rest/messaging-services).",
        code: 52182,
        log_level: "ERROR",
        last_updated: "2017-07-14T09:47:16.000+0000",
        message: "Messaging Service not specified",
        secondary_message: "MessagingServiceSid in Notify Service is not specified",
        product: "Notifications",
    },
    {
        date_created: "2017-07-06T13:43:21.000+0000",
        const_partition: "1",
        docs: "## Error 20503\r\n\r\n### Service unavailable\r\n\r\nThe requested Twilio Service is temporarily unavailable.\r\n\r\n### Possible Solutions\r\n- Try again a few times with exponential back-off\r\n- If the problem persists, please [contact support](https://www.twilio.com/help/contact).",
        code: 20503,
        log_level: "ERROR",
        last_updated: "2019-01-30T16:21:15.000+0000",
        message: "Service unavailable",
        secondary_message: "Service is unavailable",
        product: null,
    },
    {
        date_created: "2017-07-06T13:36:46.000+0000",
        const_partition: "1",
        docs: "## Error - 52307\r\n\r\n### No users with provided segments\r\n\r\nNo users were found belonging to the specified segment(s)\r\n\r\n#### Possible Causes \r\n* A notification was sent to one or more user segments, but no users belong to these segments\r\n\r\n#### Possible Solutions\r\n* Check if correct segments were specified\r\n* Check if users are assigned to correct segments",
        code: 52307,
        log_level: "WARNING",
        last_updated: "2017-12-27T12:45:26.000+0000",
        message: "No users with provided segments",
        secondary_message: "No users were found belonging to the specified segment(s)",
        product: "Notifications",
    },
    {
        date_created: "2017-07-06T13:14:05.000+0000",
        const_partition: "1",
        docs: "## Error - 52214\r\n\r\n### Alexa skill not connected to Twilio\r\n\r\n#### Possible Causes \r\n* Alexa skill ID configured for Notify Service is not connected to Twilio\r\n* After the Notify Service had been configured, the Alexa skill was disconnected from Twilio\r\n\r\n#### Possible Solutions\r\n* [Configure a new Alexa skill](https://www.twilio.com/console/notify/services) for your Notify Service\r\n* [Connect the Alexa skill](https://www.twilio.com/console/channels) to your Twilio Account",
        code: 52214,
        log_level: "ERROR",
        last_updated: "2017-07-06T14:16:46.000+0000",
        message: "Alexa skill is not connected to Twilio",
        secondary_message: "The Alexa skill configured for the Notify Service is not connected to Twilio",
        product: "Notifications",
    },
    {
        date_created: "2017-07-06T13:09:20.000+0000",
        const_partition: "1",
        docs: "## Error - 52202\r\n\r\n### Facebook page ID is not connected to Twilio\r\n\r\n#### Possible Causes \r\n* Facebook page configured in Notify Service instance is not connected to Twilio\r\n* The connection may have been removed after the Notify Service had been configured\r\n\r\n#### Possible Solutions\r\n* [Configure a new Facebook page](https://www.twilio.com/console/notify/services) for your Notify Service\r\n* [Connect the Facebook page](https://www.twilio.com/console/channels) to your Twilio account",
        code: 52202,
        log_level: "ERROR",
        last_updated: "2017-07-06T14:11:51.000+0000",
        message: "Facebook page is not connected to Twilio",
        secondary_message: "Facebook page configured in Service is not connected to Twilio",
        product: "Notifications",
    },
    {
        date_created: "2017-06-28T22:21:51.000+0000",
        const_partition: "1",
        docs: "## Error - 21650\r\n\r\n### Phone Number Requires a Verified Identity Document\r\n\r\nTo purchase this number you must have a verified identity document on your account. \r\n\r\n#### Possible Causes\r\n- There is no verified identity document on your account or subaccount. Due to local regulations, some phone numbers require a verified identity document associated with your Twilio account.\r\n\r\n#### Possible Solutions\r\n- In the Phone Numbers > Documents section in Console, provide the name of the individual or business registering the phone numbers and a scanned copy of supporting identification documents.\r\n- Ensure that the verification status of the identity document record is \u201cPassed\u201d. If \u201cPending\u201d, wait 48 business hours for Twilio to verify the document. If \u201cFailed\u201d, please refer to the failure reason to address the issue. \r\n",
        code: 21650,
        log_level: "ERROR",
        last_updated: "2017-06-29T20:46:13.000+0000",
        message: "Phone Number Requires a Verified Identity Document",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2017-06-22T15:30:09.000+0000",
        const_partition: "1",
        docs: "## Error 52215\r\n\r\n### Missing Title parameter for Alexa\r\n\r\nMessage has been rejected by Alexa channel due to missing Title parameter. Title is a required parameter for Alexa channel. This specific message has not been sent. \r\n\r\n### Possible causes\r\n- Have not provided the Title parameter neither in the generic payload nor in the Alexa specific parameter. \r\n\r\n### Possible solutions\r\n- Make sure that you provide the Title parameter for the Alexa channel either in the [generic payload](https://www.twilio.com/docs/api/notify/rest/notifications#generic-payload-parameters) or the [Alexa specific parameter](https://www.twilio.com/docs/api/notify/rest/notifications#sending-channel-specific-notifications).",
        code: 52215,
        log_level: "ERROR",
        last_updated: "2017-06-22T15:30:09.000+0000",
        message: "Missing Title parameter for Alexa",
        secondary_message: "Message has been rejected by Alexa channel due to missing Title parameter",
        product: "Notifications",
    },
    {
        date_created: "2017-06-22T15:23:19.000+0000",
        const_partition: "1",
        docs: "## Error 52213\r\n\r\n### Invalid Alexa user ID\r\n\r\nThe message has been rejected by Alexa channel due to an invalid User ID. This specific message has not been sent.\r\n\r\n### Possible causes\r\n- The user ID (Address) in a Notify Binding was invalid\r\n\r\n### Possible solutions\r\n- Make sure that you do not modify the user ID before creating the Binding. \r\n",
        code: 52213,
        log_level: "ERROR",
        last_updated: "2017-06-22T15:23:19.000+0000",
        message: "Invalid Alexa user ID",
        secondary_message: "The message has been rejected by Alexa channel due to an invalid User ID",
        product: "Notifications",
    },
    {
        date_created: "2017-06-22T15:15:53.000+0000",
        const_partition: "1",
        docs: "## Error 52212\r\n\r\n### Missing Alexa skill ID\r\n\r\nYour Alexa message was rejected because the Alexa Skill ID was missing. This specific message was not sent.\r\n\r\n### Possible causes\r\n- You have not specified the Alexa Skill ID in your Notify Service.\r\n\r\n### Possible solutions\r\n- Connect your Alexa Skill via the [Channels console](https://www.twilio.com/console/channels) then connect your skill to your [Notify Service](https://www.twilio.com/console/notify/services).",
        code: 52212,
        log_level: "ERROR",
        last_updated: "2017-06-22T15:15:53.000+0000",
        message: "Missing Alexa skill ID",
        secondary_message: "You have not specified the Alexa Skill ID in the Notify Service",
        product: "Notifications",
    },
    {
        date_created: "2017-06-22T15:10:46.000+0000",
        const_partition: "1",
        docs: "## Error 52211\r\n\r\n### Too many Alexa notifications\r\n\r\nYour message has been rejected by the Alexa channel due too many messages.\r\n\r\n### Possible causes\r\n- You are making Send Notification requests too fast.\r\n- You have made some bulk notification requests that created too many Alexa messages too fast.\r\n\r\n### Possible solutions\r\n- Slow down the rate of Send Notification requests.\r\n- Target less recipients per bulk notification request and send the bulk requests more slowly.",
        code: 52211,
        log_level: "ERROR",
        last_updated: "2017-06-22T15:10:46.000+0000",
        message: "Too many Alexa notifications",
        secondary_message: "You are sending Alexa notifications too fast",
        product: "Notifications",
    },
    {
        date_created: "2017-06-22T15:02:09.000+0000",
        const_partition: "1",
        docs: "## Error - 20500 \r\n\r\n### Internal Server Error\r\n\r\nThe Twilio API encountered an error when processing your request. This generally indicates an error in the server handling logic or a timeout in the API. We apologize for the inconvenience.\r\n\r\n#### I'm seeing a lot of these\r\n\r\nIf you are seeing a consistent pattern of 500 server errors coming from the Twilio API, check our [status page](http://status.twilio.com/) for more details. If our status page has no information, [contact support](https://www.twilio.com/help/contact) with details about the requests that are failing, and we will investigate.\r\n\r\n#### Is the request safe to retry?\r\n\r\nGET and DELETE requests are always safe for you to retry as they are idempotent. Some POST requests are idempotent by nature - purchasing a specific phone number, or hanging up a call - and while these may return different HTTP status codes on each attempt, the end state of the system will be the same whether you make the request one time or ten.\r\n\r\nOther POST requests - sending an SMS or triggering an outbound call - are not idempotent. If you get a 500 Server Error on these requests, and you retry the request, it is possible for a customer to receive multiple messages or calls from your application.",
        code: 20500,
        log_level: "ERROR",
        last_updated: "2019-01-30T16:19:16.000+0000",
        message: "Internal Server Error",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-06-13T21:24:51.000+0000",
        const_partition: "1",
        docs: "## Warning - 13327 \r\n\r\n### Gather: Invalid speechTimeout value",
        code: 13327,
        log_level: "WARNING",
        last_updated: "2017-06-13T21:24:51.000+0000",
        message: "Gather: Invalid speechTimeout value",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2017-06-05T22:47:22.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*  The subaccount is not authorized to access this connection.\r\n \r\n \r\n#### Possible Solutions\r\n*  Please verify your Interconnect Connection permission settings, visit [Interconnect Connections](https://www.twilio.com/console/sip-trunking/interconnect/connections).\r\n \r\n",
        code: 62053,
        log_level: "ERROR",
        last_updated: "2017-06-05T22:47:22.000+0000",
        message: "Interconnect: The subaccount is not authorized to access this connection.  ",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2017-06-05T22:46:23.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*  This account is not a subaccount of the Interconnect Connection owner's account.\r\n \r\n \r\n#### Possible Solutions\r\n*  Please verify your Connection SID. Visit [Interconnect Connections](https://www.twilio.com/console/sip-trunking/interconnect/connections).\r\n \r\n",
        code: 62052,
        log_level: "ERROR",
        last_updated: "2017-06-05T22:46:23.000+0000",
        message: "Interconnect: This account is not a subaccount of the Interconnect Connection owner's account.",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2017-06-05T17:36:49.000+0000",
        const_partition: "1",
        docs: "### 53501: Unable to acquire TURN credentials\r\n\r\nRaised whenever the Server is unable to return TURN credentials to the Client\r\n\r\n#### Causes\r\n\r\n* A server-side error has occurred.\r\n\r\n#### Solutions\r\n\r\n * If the problem persists, try connecting to another region.",
        code: 53501,
        log_level: "ERROR",
        last_updated: "2017-06-05T17:36:49.000+0000",
        message: "Unable to acquire TURN credentials",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-06-05T17:34:15.000+0000",
        const_partition: "1",
        docs: "### 53500: Unable to acquire configuration\r\n\r\nRaised whenever the Client is unable to acquire configuration information from the Server.\r\n\r\n#### Causes\r\n\r\n * The device running your application lost its Internet connection.\r\n * A server-side error has occurred.\r\n\r\n#### Solutions\r\n\r\n * Ensure the device running your application has access to a stable internet connection. If the problem persists, try connecting to another region.",
        code: 53500,
        log_level: "ERROR",
        last_updated: "2017-06-05T17:34:15.000+0000",
        message: "Unable to acquire configuration",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-05-31T22:21:51.000+0000",
        const_partition: "1",
        docs: "### Channel authentication error\r\n\r\n#### Possible Causes \r\n*   The Channel could not authenticate the request. Please see Channel specific error message for more information.",
        code: 63001,
        log_level: "ERROR",
        last_updated: "2018-04-02T22:23:22.000+0000",
        message: "Channel could not authenticate the request. Please see Channel specific error message for more information",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2017-05-24T08:49:50.000+0000",
        const_partition: "1",
        docs: "## Error - 52306\r\n\r\n### Cannot delete User resource with Bindings\r\n\r\n#### Possible Causes \r\n*  User has at least one Binding.\r\n\r\n#### Possible Solutions\r\n*  Make sure you delete all Bindings of a User before you try to delete the User.",
        code: 52306,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:45:34.000+0000",
        message: "Cannot delete User resource with Bindings",
        secondary_message: "User cannot be deleted if it has at least one Binding",
        product: "Notifications",
    },
    {
        date_created: "2017-05-24T08:45:48.000+0000",
        const_partition: "1",
        docs: "## Warning - 52305\r\n\r\n### User is already a member of this segment.\r\n\r\n#### Possible Causes \r\n*  User has already been added to this segment.\r\n\r\n#### Possible Solutions\r\n*  As user is already a member of the required segment, no actions are needed.",
        code: 52305,
        log_level: "WARNING",
        last_updated: "2017-12-27T12:45:46.000+0000",
        message: "User already belongs to the segment",
        secondary_message: "User is already a member of this segment",
        product: "Notifications",
    },
    {
        date_created: "2017-05-24T08:42:20.000+0000",
        const_partition: "1",
        docs: "## Warning - 52304\r\n\r\n### User already exists.\r\n\r\n#### Possible Causes \r\n*  User with this identity has already been created, possibly during create binding operation.\r\n\r\n#### Possible Solutions\r\n*  As user already exists, no extra actions are required. However one might want to make sure that the existing user has all the necessary attributes, e.g. segments.",
        code: 52304,
        log_level: "WARNING",
        last_updated: "2017-12-27T12:45:59.000+0000",
        message: "User already exists",
        secondary_message: "User with this identity already exists",
        product: "Notifications",
    },
    {
        date_created: "2017-05-24T08:37:50.000+0000",
        const_partition: "1",
        docs: "## Error - 52303\r\n\r\n### Concurrent User update\r\n\r\nUpdating the same User resource in multiple concurrent requests may cause data inconsistency. This may result in that searches using multiple Segments will not find your User resource even if it should belong to all the specified Segments.\r\n\r\n#### Possible Causes \r\n* Updating the same User resource (e.g. adding or removing it to/from Segments) in multiple requests concurrently.\r\n\r\n#### Possible Solutions\r\n* Change implementation so that if you need to add a User to multiple Segments at once you wait for each request to complete before trying the next one.\r\n* For past errors, just read the affected User resource by using the [Read User API](https://www.twilio.com/docs/notify/api/users#retrieve-a-user) this will fix the data inconsistency.",
        code: 52303,
        log_level: "WARNING",
        last_updated: "2018-04-06T13:24:03.000+0000",
        message: "Concurrent User update",
        secondary_message: "Concurrent User update may have caused User data inconsistency",
        product: "Notifications",
    },
    {
        date_created: "2017-05-24T08:28:51.000+0000",
        const_partition: "1",
        docs: "## Error - 52302\r\n\r\n### Request has exceed the maximum recipients limit. No deliveries were attempted.\r\n\r\n#### Possible Causes \r\n*  An attempt was made to send a broadcast notification that targeted too many recipients.\r\n\r\n#### Possible Solutions\r\n*  Send several notifications that target fewer recipients (e.g. by partitioning your audience using more Segments and Tags).\r\n*  If there is no good way to partition your audience, contact support at help@twilio.com.",
        code: 52302,
        log_level: "ERROR",
        last_updated: "2018-02-26T08:16:19.000+0000",
        message: "Too many recipients",
        secondary_message: "Request has exceed the maximum recipients limit. No deliveries were attempted.",
        product: "Notifications",
    },
    {
        date_created: "2017-05-23T20:56:57.000+0000",
        const_partition: "1",
        docs: "\r\n#### Possible Causes \r\n*  Calls Per Second placed on a SIP domain exceeded the Master Account limits. \r\n\r\n#### Possible Solutions\r\n*  You've exceeded the number of calls per second you are authorized to make on your Master Account for SIP Interface. ",
        code: 32013,
        log_level: "ERROR",
        last_updated: "2017-05-23T20:56:57.000+0000",
        message: "SIP: Master account SIP Interface CPS limit exceeded",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2017-05-23T20:53:16.000+0000",
        const_partition: "1",
        docs: "\r\n#### Possible Causes \r\n*  Calls Per Second placed on a SIP trunk exceeded the Master Account pool limit. \r\n\r\n#### Possible Solutions\r\n*  You've exceeded the number of calls per second you are authorized to make on your Master Account. ",
        code: 32012,
        log_level: "ERROR",
        last_updated: "2017-05-23T20:53:16.000+0000",
        message: "SIP: Master account pooled Trunking CPS limit exceeded",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2017-05-18T21:39:00.000+0000",
        const_partition: "1",
        docs: "## Error - 21624\r\n\r\n### Invalid validity period value\r\n\r\nValidity period can only be set to integers between 1 and 14,400 seconds (4 hours max).",
        code: 21624,
        log_level: "ERROR",
        last_updated: "2017-05-18T21:39:00.000+0000",
        message: "Invalid validity period value",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2017-05-17T11:33:25.000+0000",
        solutions: "- Add an address that satisfies the locality requirement\r\n- Contact Twilio Support",
        causes: "- No address on your account or subaccount that satisfies the locality requirement. Depending on the country, this can be either same country or same geographic area as the number being purchased.",
        description: "To purchase this number you must have an Address on your account which satisfies the local address requirements. ",
        const_partition: "1",
        docs: "## ERROR - 21615\r\n\r\n### Phone Number Requires a Local Address\r\n\r\n To purchase this number you must have an Address on your account which satisfies the local address requirements. \r\n\r\n#### Possible Causes\r\n- No address on your account or subaccount that satisfies the locality requirement. Depending on the country, this can be either same country or same geographic area as the number being purchased.\r\n\r\n#### Possible Solutions\r\n- Add an address that satisfies the locality requirement\r\n- Contact Twilio Support",
        code: 21615,
        log_level: "ERROR",
        last_updated: "2019-07-17T00:55:37.000+0000",
        message: "Phone Number Requires a Local Address",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2017-05-15T17:44:46.000+0000",
        const_partition: "1",
        docs: "## Error - 21629\r\n\r\n### Address Validation Error - Check Suggested Address\r\n\r\nThe address you have provided cannot be validated. A similar address has been found to be valid. The suggested address is included in the error message body. \r\n\r\n#### Possible Causes\r\n- Address misspelling\r\n- Alternate format or spelling in third-party data source\r\n\r\n#### Possible Solutions\r\n- Ensure the address is spelled correctly\r\n- If a correct suggestion, submit the suggested address for validation\r\n- Contact Twilio Support",
        code: 21629,
        log_level: "ERROR",
        last_updated: "2017-05-15T17:44:46.000+0000",
        message: "Address Validation Error - Check Suggested Address",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2017-05-11T18:55:36.000+0000",
        const_partition: "1",
        docs: "## Warning - 32011\r\n\r\n### Error communicating with your SIP communications infrastructure\r\nThere was a problem communicating with a specific endpoint of your SIP communications infrastructure. This means there was either a lack of timely response, an error response or an invalid response from your SIP endpoint. This may result in increased call setup times or even failed call depending on the failover configuration for your Elastic SIP Trunk or SIP application. Twilio will make multiple attempts to deliver calls to your endpoint and each failed attempt will have it's own notification.\r\nThe notification will have details about the specific error response and the SIP URI that causes the failure.\r\n\r\n#### Possible Causes \r\n* Your SIP endpoint is not reachable due to network connectivity issue between Twilio and your system\r\n* Your SIP endpoint is not responding (service down or maintenance) \r\n* There is a firewall in your network that is blocking SIP traffic from Twilio\r\n* Your SIP endpoint is sending an error response, such as SIP 500 response.\r\n* The SIP URI specified in your Trunking Origination URI, <Dial> <SIP> TwiML or REST API call is invalid\r\n\r\n#### Possible Solutions\r\n* Ensure the SIP URI used in the request is correctly configured.\r\n * For details on how to configure your Origination URIs for SIP trunking, please see [Origination settings](/docs/api/sip-trunking/getting-started#origination).\r\n * For SIP interfaces verify that your SIP URI in your <Dial> <SIP> TwiML or REST API call, see [Receiving SIP from Twilio](/docs/api/twilio-sip/receiving-sip-how-it-works).\r\n* Ensure you've whitelisted Twilio's IP address ranges and ports on your firewall for SIP signalling and RTP media traffic, see [IP address whitelist - Trunking](/docs/api/sip-trunking/getting-started#whitelist) or [IP address whitelist - SIP Interface](/docs/api/twilio-sip#ip-whitelist)\r\n* Ensure that your SIP servers are running properly and is properly processing calls from Twilio.",
        code: 32011,
        log_level: "WARNING",
        last_updated: "2018-06-08T17:57:39.000+0000",
        message: "Error communicating with your SIP communications infrastructure",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2017-05-09T23:59:56.000+0000",
        const_partition: "1",
        docs: "### 53205: Participant disconnected because of duplicate identity\r\n\r\nRaised by the server to the existing Participant when a new Participant joins a Room with the same identity as the existing Participant.\r\n\r\n#### Causes\r\n\r\n * Using the same identity for more than one Room Participant.\r\n\r\n#### Solutions\r\n\r\n * Make sure that each Participant joins a Room with a unique identity.\r\n\r\n",
        code: 53205,
        log_level: "ERROR",
        last_updated: "2017-05-09T23:59:56.000+0000",
        message: "Participant disconnected because of duplicate identity",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-05-05T16:40:23.000+0000",
        const_partition: "1",
        docs: "## Error - 70155\r\n\r\n### Request Is Missing Required HTTP Headers\r\nThe JWT received by Twilio along with the request has defined a set of HTTP headers that must be validated. The actual request is missing at least one of those headers. This is a Public Key Client Validation Error.\r\n\r\n#### Possible Solution:\r\n* Make sure you are using the latest Twilio helper library.\r\n* Make sure the JWT does not declare unnecessary headers.\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)",
        code: 70155,
        log_level: "ERROR",
        last_updated: "2017-05-05T16:45:35.000+0000",
        message: "Request Is Missing Required HTTP Headers",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-05-05T16:39:55.000+0000",
        const_partition: "1",
        docs: "## Error - 70156\r\n\r\n### Request Hash Is Invalid\r\nThe request hash that is declared in the JWT does not match the given request\u2019s hash calculated by Twilio. This is a Public Key Client Validation Error.\r\n\r\n#### Possible Solution:\r\n* Make sure you are using the latest Twilio helper library. If not using the library, make sure the request hash is calculated on the canonicalized HTTP request and the same canonicalization is used.\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)",
        code: 70156,
        log_level: "ERROR",
        last_updated: "2017-05-05T16:45:14.000+0000",
        message: "Request Hash Is Invalid",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-05-05T16:39:08.000+0000",
        const_partition: "1",
        docs: "## Error - 70154\r\n\r\n### Public Key Is Invalid\r\nThe Public Key provided to Twilio is invalid. This is a Public Key Client Validation Error.\r\n\r\n#### Possible Solution:\r\n* Upload a new, valid Public Key.\r\n* For details on the Credentials Endpoint, see [the documentation](/docs/api/credentials/rest)",
        code: 70154,
        log_level: "ERROR",
        last_updated: "2017-05-05T16:39:08.000+0000",
        message: "Public Key Is Invalid",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-05-05T16:33:26.000+0000",
        const_partition: "1",
        docs: "## Error - 70153 \r\n\r\n### Public Key Specified Does Not Exist\r\nThe Public Key with the SID provided in the JWT header does exist. This is a Public Key Client Validation Error.\r\n\r\n#### Possible Solution:\r\n* Update the kid value provided in the JWT header.\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)",
        code: 70153,
        log_level: "ERROR",
        last_updated: "2017-05-05T16:37:18.000+0000",
        message: "Public Key Specified Does Not Exist",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-05-05T16:31:59.000+0000",
        const_partition: "1",
        docs: "## Error - 70152\r\n\r\n### Request Contains Invalid Flags\r\nOne or more of the provided flags in the API key request are invalid in the given context.\r\n\r\n#### Possible Causes \r\n* An API key is attempting to create a new key with greater permissions than what it is assigned.\r\n\r\n#### Possible Solution:\r\n* Remove the invalid flag(s) that would expand permissions.",
        code: 70152,
        log_level: "ERROR",
        last_updated: "2017-05-05T16:31:59.000+0000",
        message: "Request Contains Invalid Flags",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-05-05T16:25:00.000+0000",
        const_partition: "1",
        docs: "## Error - 70151\r\n\r\n### Maximum Number Of API Keys Exceeded\r\nThe account reached the maximum limit of API Keys allowed. \r\n\r\n#### Possible Solution:\r\n* Delete unused API Keys before creating additional ones.",
        code: 70151,
        log_level: "ERROR",
        last_updated: "2017-05-05T16:44:00.000+0000",
        message: "Maximum Number Of API Keys Exceeded",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-05-05T16:20:36.000+0000",
        const_partition: "1",
        docs: "\r\n## Error - 70053\r\n\r\n### Public Key Client Validation Not Enabled For Account\r\nThe request attempted to use the Public Key Client Validation but the functionality is not enabled for this account.\r\n\r\n#### Possible Solution:\r\n* Ensure your Account is enabled for this feature.\r\n* Remove the Twilio-Client-Validation header from your request",
        code: 70053,
        log_level: "ERROR",
        last_updated: "2017-05-05T16:20:36.000+0000",
        message: "Public Key Client Validation Not Enabled For Account",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-05-05T16:19:33.000+0000",
        const_partition: "1",
        docs: "## Error - 70052 \r\n\r\n### Public Key Client Validation Required For Account\r\nThe account is only allowed to perform Public Key Client Validation requests at Twilio. All other types of authentication are disabled for the account.\r\n\r\n#### Possible Causes \r\n* The Twilio-Client-Validation is not present in the request.\r\n\r\n#### Possible Solution:\r\n* Ensure the Twilio-Client-Validation header is present in the request and valid.\r\n* Disable forcing Client Validation feature at the Console if not needed.\r\n",
        code: 70052,
        log_level: "ERROR",
        last_updated: "2017-05-05T16:19:33.000+0000",
        message: "Public Key Client Validation Required For Account",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-05-05T16:17:31.000+0000",
        const_partition: "1",
        docs: "## Error - 70051 \r\n\r\n### Authorization Failed\r\nTwilio could not authorize the given request.\r\n\r\n#### Possible Causes \r\n* The Account is not found or is suspended\r\n* The API key is not found or is suspended\r\n* The Credentials used for authorization do not belong to the given account\r\n\r\n\r\n#### Possible Solution:\r\n* Make sure the account or the API key are valid and active",
        code: 70051,
        log_level: "ERROR",
        last_updated: "2017-05-05T16:17:31.000+0000",
        message: "Authorization Failed",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-05-05T16:16:52.000+0000",
        const_partition: "1",
        docs: "## Error - 70005 \r\n\r\n### Failure Threshold Exceeded\r\nToo many unsuccessful requests against Twilio API.\r\n\r\n#### Possible Causes \r\n* The requests try to repeatedly access a deleted resource\r\n* The requests try to repeatedly access an invalid resource\r\n\r\n#### Possible Solution:\r\n* Slow down the requests\r\n* Validate whether the given resource exists",
        code: 70005,
        log_level: "ERROR",
        last_updated: "2017-05-05T16:16:52.000+0000",
        message: "Failure Threshold Exceeded",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-05-05T16:14:48.000+0000",
        const_partition: "1",
        docs: "## Error - 20160 \r\n\r\n### Invalid Token\r\nThe JWT provided to the Twilio API is not a valid JWT.\r\n\r\n#### Possible Solution:\r\n* Make sure you are using the latest version of Twilio Helper libraries\r\n* To check whether the JWT is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).",
        code: 20160,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:49:41.000+0000",
        message: "Invalid Token",
        secondary_message: null,
        product: "Platform",
    },
    {
        date_created: "2017-05-05T16:14:06.000+0000",
        const_partition: "1",
        docs: "## Error - 20159 \r\n\r\n### Invalid Signature\r\nThe JWT provided to the Twilio API has an invalid or mismatching signature.\r\n\r\n#### Possible Causes \r\n* Public key in the JWT does not match the actual private key used for signing the request.\r\n\r\n#### Possible Solution:\r\n* Make sure the private key used for signing the JWT matches the public key identifier in JWT.\r\n* To check whether the JWT is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).",
        code: 20159,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:49:49.000+0000",
        message: "Invalid Signature",
        secondary_message: null,
        product: "Platform",
    },
    {
        date_created: "2017-05-05T16:12:57.000+0000",
        const_partition: "1",
        docs: "## Error - 20157 \r\n\r\n### Expiration Time Exceeds Maximum Time Allowed\r\nThe expiration time provided when creating the JWT exceeds 24 hours, which is the maximum duration allowed.\r\n\r\n#### Possible Solution:\r\n* Provide a shorter expiration time, which does not exceed the maximum.\r\n\r\nSee [the capability token docs](https://www.twilio.com/docs/voice/client/capability-tokens) to learn more.",
        code: 20157,
        log_level: "ERROR",
        last_updated: "2018-08-21T00:07:08.000+0000",
        message: "Expiration Time Exceeds Maximum Time Allowed",
        secondary_message: null,
        product: "Platform",
    },
    {
        date_created: "2017-05-05T16:12:14.000+0000",
        const_partition: "1",
        docs: "## Error - 20156\r\n\r\n### Expired or Invalid Expiration in Token\r\nThe JWT provided to the Twilio API has expired, or the expiration time specified in the JWT was invalid.\r\n\r\n\r\n#### Possible Causes \r\n* The client system that generates the JWT might have issues with system time.\r\n* To check whether the JWT is structurally correct, you can use the tools available at jwt.io.",
        code: 20156,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:50:09.000+0000",
        message: "Expired or Invalid Expiration in Token",
        secondary_message: null,
        product: "Platform",
    },
    {
        date_created: "2017-05-05T16:11:20.000+0000",
        const_partition: "1",
        docs: "## Error - 20155 \r\n\r\n### Expiration Time In The Future\r\nThe JWT provided to the Twilio API is not yet valid.\r\n\r\n#### Possible Causes \r\n* The client system that generates the JWT might have issues with system time.",
        code: 20155,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:50:21.000+0000",
        message: "Expiration Time In The Future",
        secondary_message: null,
        product: "Platform",
    },
    {
        date_created: "2017-05-05T16:08:16.000+0000",
        const_partition: "1",
        docs: "## Error - 20154 \r\n\r\n### Invalid Claim Set\r\nThe JWT could be parsed, but the claims in the payload section are invalid.\r\n\r\n#### Possible Causes \r\n* One of the required claims is missing.\r\n* For JWTs used as part of Public Key Client Validation, we require two custom claims:\r\n  * \u201chrh\u201d - HTTP headers that were included when calculating the request hash\r\n  * \u201crqh\u201d - The hash of the HTTP request\r\n\r\n#### Possible Solution:\r\n* Make sure you are using the latest Twilio Helper Library\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)\r\n* To check whether the JWT is structurally correct, you can use the tools available at jwt.io.\r\n",
        code: 20154,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:50:29.000+0000",
        message: "Invalid Claim Set",
        secondary_message: null,
        product: "Platform",
    },
    {
        date_created: "2017-05-05T16:05:37.000+0000",
        const_partition: "1",
        docs: "## Error - 20153 \r\n\r\n### Invalid Issuer Or Subject\r\nThe issuer or subject of the JWT provided to the Twilio API was invalid.\r\n\r\n#### Possible Causes \r\n* The issuer is missing from JWT\r\n* The issuer entity is suspended in Twilio.\r\n* The subject is missing from JWT\r\n* The subject entity is suspended in Twilio.\r\n* The issuer and subject are not related.\r\n\r\n#### Possible Solution:\r\n* In case of Public Key Client Validation, make sure the account and the API key are valid and not suspended.\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)\r\n* To check whether the JWT is structurally correct, you can use the tools available at jwt.io.",
        code: 20153,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:50:37.000+0000",
        message: "Invalid Issuer Or Subject",
        secondary_message: null,
        product: "Platform",
    },
    {
        date_created: "2017-05-05T16:04:34.000+0000",
        const_partition: "1",
        docs: "## Error - 20152\r\n\r\n### Invalid Header\r\nThe header of the JWT provided to the Twilio API was invalid.\r\n\r\n#### Possible Causes \r\n* The structure of the header was invalid.\r\n* Required header values not provided\r\n* Provided header values invalid.\r\n\r\n#### Possible Solution:\r\n* For the details on JWTs used as part of Public Key Client Validation, see [the documentation](/docs/api/credentials/public-key-client-validation-getting-started)\r\n* To check whether the JWT is structurally correct, you can use the tools available at jwt.io.",
        code: 20152,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:50:46.000+0000",
        message: "Invalid Header",
        secondary_message: null,
        product: "Platform",
    },
    {
        date_created: "2017-05-05T15:59:36.000+0000",
        const_partition: "1",
        docs: "## Error - 20151\r\n\r\n### Authentication Failed\r\nThe Authentication with the provided JWT failed.\r\n\r\n\r\n#### Possible Causes \r\n* The system could not perform the authorization for the given request.\r\n\r\n#### Possible Solution:\r\n* Retry, if this keeps happening, please contact the Twilio Support\r\n* To check whether the JWT is structurally correct, you can use the tools available at jwt.io.",
        code: 20151,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:50:55.000+0000",
        message: "Authentication Failed",
        secondary_message: null,
        product: "Platform",
    },
    {
        date_created: "2017-05-03T21:24:06.000+0000",
        const_partition: "1",
        docs: "### Invalid PageToken\r\n\r\nThe `PageToken` in the requested URL was not valid. If you are paging through\r\na result set, be sure you are requesting the provided paging urls in the\r\nTwilio API response.",
        code: 21481,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:53:30.000+0000",
        message: "Invalid PageToken",
        secondary_message: "The PageToken in the requested URL was not valid.",
        product: "Platform",
    },
    {
        date_created: "2017-05-03T21:16:28.000+0000",
        const_partition: "1",
        docs: '## Not Found\r\n\r\nThe resource was not found. Here are some examples of cases that may trigger\r\na 404 error.\r\n\r\n- Requesting a resource for a sid that does not exist, for example\r\n\r\n        GET /2010-04-01/Accounts/AC123/Calls/CA123\r\n\r\n    where CA123 is not a call sid that exists for your account\r\n\r\n- Trying to retrieve a resource that doesn\'t exist, for example\r\n\r\n        GET /2010-04-01/Accounts/AC123/TwilioCalls/CA123\r\n\r\n    where the resource name is Calls, not TwilioCalls. Note that the API is\r\n    case sensitive, so requesting "calls" instead of "Calls" will also return a\r\n    404.\r\n\r\n- Missing a sid in the request path. For example, let\'s say I accidentally\r\ndon\'t set a value for a call sid, using the PHP helper library:\r\n\r\n        $callSid = null;\r\n        $client->account->calls->get($callSid);\r\n\r\n    This may turn into\r\n\r\n        GET /2010-04-01/Accounts/AC123/Calls/.json\r\n\r\n    because of the nonexistent sid, which may 404 your request or give you back\r\n    a result you were not expecting. Or, you may initialize the client with an\r\n    empty string for an account sid, which means the URL will get truncated in\r\n    the middle (note the consecutive slashes):\r\n\r\n        GET /2010-04-01/Accounts//Calls/CA123.json\r\n\r\n- Using a base URL that is not `https://api.twilio.com`. For example, making\r\n  requests to `https://twilio.com` or `https://www.twilio.com` will not work.',
        code: 20404,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:49:18.000+0000",
        message: "Not Found",
        secondary_message: "The resource was not found.",
        product: "Platform",
    },
    {
        date_created: "2017-05-01T22:48:24.000+0000",
        const_partition: "1",
        docs: "## Warning - 13332\r\n\r\n### Gather: Invalid bargeIn value",
        code: 13332,
        log_level: "WARNING",
        last_updated: "2017-05-01T22:48:35.000+0000",
        message: "Gather: Invalid bargeIn value",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2017-05-01T22:47:43.000+0000",
        const_partition: "1",
        docs: "## Warning - 13331\r\n\r\n### Gather: Invalid language value",
        code: 13331,
        log_level: "WARNING",
        last_updated: "2017-05-01T22:47:43.000+0000",
        message: "Gather: Invalid language value",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2017-05-01T22:46:50.000+0000",
        const_partition: "1",
        docs: "## Warning - 13330\r\n\r\n### Gather: Invalid hints value",
        code: 13330,
        log_level: "WARNING",
        last_updated: "2017-05-01T22:46:50.000+0000",
        message: "Gather: Invalid hints value",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2017-05-01T22:46:05.000+0000",
        const_partition: "1",
        docs: "## Warning - 13329\r\n\r\n### Gather: Invalid partialResultCallbackMethod value",
        code: 13329,
        log_level: "WARNING",
        last_updated: "2017-05-01T22:46:05.000+0000",
        message: "Gather: Invalid partialResultCallbackMethod value",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2017-05-01T22:44:32.000+0000",
        const_partition: "1",
        docs: "## Warning - 13326 \r\n\r\n### Gather: Invalid input value",
        code: 13326,
        log_level: "WARNING",
        last_updated: "2017-05-01T22:44:32.000+0000",
        message: "Gather: Invalid input value",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2017-04-24T22:00:26.000+0000",
        const_partition: "1",
        docs: "### 53402: Client is unable to apply a remote media description\r\n\r\nRaised whenever the Client receives a remote media description but is unable to apply it.\r\n\r\n#### Causes\r\n\r\n * The Client may not be using a supported WebRTC implementation.\r\n * The Client may be connecting peer-to-peer with another Participant that is not using a supported WebRTC implementation.\r\n * The Client may not have the necessary resources to apply a new media description.\r\n\r\n#### Solutions\r\n\r\n * If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation.\r\n",
        code: 53402,
        log_level: "ERROR",
        last_updated: "2017-04-24T22:00:26.000+0000",
        message: "Client is unable to apply a remote media description",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T21:58:38.000+0000",
        const_partition: "1",
        docs: "### 53400: Client is unable to create or apply a local media description\r\n\r\nRaised whenever a Client is unable to create or apply a local media description.\r\n\r\n#### Causes\r\n\r\n * The Client may not be using a supported WebRTC implementation.\r\n * The Client may not have the necessary resources to create or apply a new media description.\r\n\r\n#### Solutions\r\n\r\n * If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation.",
        code: 53400,
        log_level: "ERROR",
        last_updated: "2017-04-24T21:58:38.000+0000",
        message: "Client is unable to create or apply a local media description",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:59:42.000+0000",
        const_partition: "1",
        docs: "### 53112: Status is invalid\r\n\r\nRaised in the REST API when Status is not valid or the Room is not in-progress.\r\n\r\n#### Causes\r\n\r\n * REST API call to Update Room instance with Status that is invalid or cannot be applied to the current Room state.\r\n\r\n#### Solutions\r\n\r\n * Set Status to completed and only apply to a Room that is in-progress.\r\n",
        code: 53112,
        log_level: "ERROR",
        last_updated: "2017-04-24T16:01:05.000+0000",
        message: "Status is invalid",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:57:53.000+0000",
        const_partition: "1",
        docs: "### 53104: Unable to connect to Room\r\n\r\nRaised whenever a Client is unable to connect to a Room, and the scenario is not covered by a more specific error code.\r\n\r\n#### Causes\r\n\r\n * A server-side error has occurred.\r\n\r\n#### Solutions\r\n\r\n * If the problem persists, try connecting to another region.",
        code: 53104,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:57:53.000+0000",
        message: "Unable to connect to Room",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:56:17.000+0000",
        const_partition: "1",
        docs: "### 53102: Room name contains invalid characters\r\n\r\nRaised whenever a Room name contains invalid characters.\r\n\r\n#### Causes\r\n\r\n * The Room name contains an invalid UTF-8 byte sequence.\r\n\r\n#### Solutions\r\n\r\n * Choose a Room name that is a valid UTF-8 string.",
        code: 53102,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:56:17.000+0000",
        message: "Room name contains invalid characters",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:49:31.000+0000",
        const_partition: "1",
        docs: "### 53204: Participant not found\r\n\r\nRaised whenever attempting operation on a non-existent Participant.\r\n\r\n#### Causes\r\n\r\n * Attempting operation on an non-existent Participant.\r\n\r\n#### Solutions\r\n\r\n * Make sure participant exists before re-attempting operation.",
        code: 53204,
        log_level: "ERROR",
        last_updated: "2017-04-24T16:03:31.000+0000",
        message: "Participant not found",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:48:42.000+0000",
        const_partition: "1",
        docs: "### 53203: Participant has too many Tracks\r\n\r\nRaised whenever a Participant has too many Tracks.\r\n\r\n#### Causes\r\n\r\n * A Client added more than the maximum number of Tracks allowed per Participant.\r\n\r\n#### Solutions\r\n\r\n * Have the Client remove one or more Tracks.",
        code: 53203,
        log_level: "ERROR",
        last_updated: "2017-04-24T16:03:19.000+0000",
        message: "Participant has too many Tracks",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:47:52.000+0000",
        const_partition: "1",
        docs: "### 53202: Participant identity contains invalid characters\r\n\r\nRaised whenever a Participant identity contains invalid characters.\r\n\r\n#### Causes\r\n\r\n * The Participant identity contains an invalid UTF-8 byte sequence.\r\n\r\n#### Solutions\r\n\r\n * Choose a Participant identity that is a valid UTF-8 string.",
        code: 53202,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:47:52.000+0000",
        message: "Participant identity contains invalid characters",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:47:27.000+0000",
        const_partition: "1",
        docs: "### 53201: Participant identity is too long\r\n\r\nRaised whenever a Participant identity is too long.\r\n\r\n#### Causes\r\n\r\n * The Participant identity is too long.\r\n\r\n#### Solutions\r\n\r\n * Choose a shorter Participant identity.",
        code: 53201,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:47:27.000+0000",
        message: "Participant identity is too long",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:47:04.000+0000",
        const_partition: "1",
        docs: "### 53200: Participant identity is invalid\r\n\r\nRaised whenever a Participant identity is invalid, and the scenario is not covered by a more specific error code.\r\n\r\n#### Causes\r\n\r\nThe Participant identity does not adhere to the Participant identity requirements. \r\n\r\nPossible causes:\r\n\r\n* The identity is null or an empty string.\r\n* Another Participant with the same identity already exists in the Room.\r\n* The identity has more than 128 characters (NOTE: Double-byte characters are counted as 2 characters).\r\n\r\n\r\n#### Solutions\r\n\r\n * Choose a Participant identity adheres to the Participant identity requirements.",
        code: 53200,
        log_level: "ERROR",
        last_updated: "2017-12-11T18:40:41.000+0000",
        message: "Participant identity is invalid",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:46:02.000+0000",
        const_partition: "1",
        docs: "### 53111: StatusCallback is invalid\r\n\r\nRaised in the REST API when StatusCallback is not a valid URL or the url is too long.\r\n\r\n#### Causes\r\n\r\n * REST API call to Create or Update Room instance with StatusCallback set to an invalid URL.\r\n\r\n#### Solutions\r\n\r\n * Set StatusCallback to a valid URL less than 1024 characters or leave blank to disable callbacks.\r\n",
        code: 53111,
        log_level: "ERROR",
        last_updated: "2017-04-24T16:01:47.000+0000",
        message: "StatusCallback is invalid",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:45:33.000+0000",
        const_partition: "1",
        docs: "### 53110: StatusCallbackMethod is invalid\r\n\r\nRaised in the REST API when StatusCallbackMethod is set to an invalid value.\r\n\r\n#### Causes\r\n\r\n * REST API call to Create or Update Room instance with StatusCallbackMethod set to an invalid value.\r\n\r\n#### Solutions\r\n\r\n * Set StatusCallbackMethod to either GET or POST or leave blank for the default.",
        code: 53110,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:45:33.000+0000",
        message: "StatusCallbackMethod is invalid",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:45:09.000+0000",
        const_partition: "1",
        docs: "### 53109: Timeout is out of range\r\n\r\nRaised in the REST API when Timeout is set out of range.\r\n\r\n#### Causes\r\n\r\n * REST API call to Create or Update Room instance with Timeout out of range.\r\n\r\n#### Solutions\r\n\r\n * Set the Timeout value (in seconds) from 1 second up to a maximum of 1 hour.",
        code: 53109,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:45:09.000+0000",
        message: "Timeout is out of range",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:44:21.000+0000",
        const_partition: "1",
        docs: "### 53108: RoomType is not valid\r\n\r\nRaised in the REST API when the user attempts to create a Room with an invalid RoomType\r\n\r\n#### Causes\r\n\r\n * REST API call to Create Room instance with an invalid RoomType.\r\n\r\n#### Solutions\r\n\r\n * Set the RoomType value to a valid type or leave this field blank for the default.",
        code: 53108,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:44:21.000+0000",
        message: "RoomType is not valid",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:43:56.000+0000",
        const_partition: "1",
        docs: "### 53107: MaxParticipants is out of range\r\n\r\nRaised in the REST API when MaxParticipants is set out of range.\r\n\r\n#### Causes\r\n\r\n * REST API call to Create or Update Room instance with MaxParticipants out of range.\r\n\r\n#### Solutions\r\n\r\n * Set the MaximumParticipants value from 1 up to the maximum allowed for the Room Type.",
        code: 53107,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:43:56.000+0000",
        message: "MaxParticipants is out of range",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:43:26.000+0000",
        const_partition: "1",
        docs: "### 53106: Room not found\r\n\r\nRaised whenever attempting operation on a non-existent Room.\r\n\r\n#### Causes\r\n\r\n * Attempted to perform operation on non-existent Room.\r\n\r\n#### Solutions\r\n\r\n * Make sure Room exists before re-attempting operation.",
        code: 53106,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:43:26.000+0000",
        message: "Room not found",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:43:03.000+0000",
        const_partition: "1",
        docs: "### 53105: Room contains too many Participants\r\n\r\nRaised whenever a Client is unable to connect to a Room because the Room contains too many Participants.\r\n\r\n#### Causes\r\n\r\n * A Client attempted to connect to a Room that already contained the maximum number of Participants.\r\n\r\n#### Solutions\r\n\r\n * Have one or more Participants disconnect from the Room in order to make room for the Client to connect.",
        code: 53105,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:43:03.000+0000",
        message: "Room contains too many Participants",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:42:05.000+0000",
        const_partition: "1",
        docs: "### 53103: Unable to create Room\r\n\r\nRaised whenever the Server is unable to create a Room.\r\n\r\n#### Causes\r\n\r\n * You may have chosen to enable Room features that are unsupported or not available to your account.\r\n * A server-side error has occurred.\r\n * An existing Room exists with the same name\r\n\r\n#### Solutions\r\n\r\n * Choose a Room configuration supported by your account.\r\n * If the problem persists, try connecting to another region.\r\n * Create a Room with a unique name",
        code: 53103,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:57:27.000+0000",
        message: " Unable to create Room",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:40:26.000+0000",
        const_partition: "1",
        docs: "### 53101: Room name is too long\r\n\r\nRaised whenever a Room name is too long.\r\n\r\n#### Causes\r\n\r\n * The Room name is too long.\r\n\r\n#### Solutions\r\n\r\n * Choose a shorter Room name.",
        code: 53101,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:55:32.000+0000",
        message: "Room name is too long",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:39:38.000+0000",
        const_partition: "1",
        docs: "### 53100: Room name is invalid\r\n\r\nRaised whenever a Room name is invalid, and the scenario is not covered by a more specific error code.\r\n\r\n#### Causes\r\n\r\n * The Room name does not adhere to the Room name requirements.\r\n\r\n#### Solutions\r\n\r\n * Choose a Room name adheres to the Room name requirements.",
        code: 53100,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:40:00.000+0000",
        message: "Room name is invalid",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:39:17.000+0000",
        const_partition: "1",
        docs: "### 53004: Client sent an invalid signaling message\r\n\r\nRaised whenever the Client sends a message to the Server that the Server cannot handle.",
        code: 53004,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:39:17.000+0000",
        message: "Client sent an invalid signaling message",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:38:53.000+0000",
        const_partition: "1",
        docs: "### 53003: Client received an invalid signaling message\r\n\r\nRaised whenever the Client receives a message from the Server that the Client cannot handle.",
        code: 53003,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:38:53.000+0000",
        message: "Client received an invalid signaling message",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:38:29.000+0000",
        const_partition: "1",
        docs: "### 53002: Signaling connection timed out\r\n\r\nRaised whenever the signaling connection times out.\r\n",
        code: 53002,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:38:29.000+0000",
        message: "Signaling connection timed out",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-24T15:37:59.000+0000",
        const_partition: "1",
        docs: "### 53001: Signaling connection disconnected\r\n\r\nRaised whenever the signaling connection is unexpectedly disconnected.\r\n\r\n#### Causes\r\n\r\n * The device running your application lost its internet connection.\r\n\r\n#### Solutions\r\n\r\n * Ensure the device running your application has access to a stable internet connection.\r\n",
        code: 53001,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:37:59.000+0000",
        message: "Signaling connection disconnected",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-21T22:58:09.000+0000",
        const_partition: "1",
        docs: "### 53000: Signaling connection error\r\n\r\nRaised whenever a signaling connection error occurs that is not covered by a more specific error code.",
        code: 53000,
        log_level: "ERROR",
        last_updated: "2017-04-24T15:37:21.000+0000",
        message: "Signaling connection error",
        secondary_message: null,
        product: "Programmable Video",
    },
    {
        date_created: "2017-04-14T20:59:28.000+0000",
        const_partition: "1",
        docs: "## Error - 70105\r\n\r\n### Invalid Type Specified in the Request\r\nWhen using a Twilio Resource that supports working with different types of Twilio Credentials (Public Key Credentials, Push Credentials) the request must contain type(s) that is recognized by the resource.\r\n\r\n#### Possible Solution:\r\n* Check the API documents to verify the correct credential type(s) were used in the request.\r\n\r\n",
        code: 70105,
        log_level: "ERROR",
        last_updated: "2017-04-24T21:53:20.000+0000",
        message: "Invalid Type Specified in the Request",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-04-14T20:57:56.000+0000",
        const_partition: "1",
        docs: "## Error - 70104\r\n\r\n### Invalid Public Key\r\nThe Request tries to store a Public Key in Twilio. This public key cannot be parsed. Only supported key format is X.509 PEM. The prefix and suffix (-----BEGIN PUBLIC KEY-----) of the key can be present (but not mandatory).\r\n\r\n#### Possible Solution:\r\nMake sure the public key is correct in the request:\r\n* The key is in X.509 PEM format\r\n* There are no copy paste errors\r\n* All the parts of the key are present in the request.",
        code: 70104,
        log_level: "ERROR",
        last_updated: "2017-04-24T21:53:10.000+0000",
        message: "Invalid Public Key",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-04-14T20:53:22.000+0000",
        const_partition: "1",
        docs: "## Error - 70103\r\n\r\n### Unsupported Public Key Exponent\r\nThe Request tries to store a Public Key in Twilio. This public key can be parsed, has a correct encryption algorithm, but the request fails because the key exponent has an invalid length.\r\n\r\n#### Possible Causes \r\n* Public key key exponent different than 65537.\r\n\r\n#### Possible Solution\r\n* Regenerate a new keypair with exponent 65537 and retry.",
        code: 70103,
        log_level: "ERROR",
        last_updated: "2017-04-24T21:53:00.000+0000",
        message: "Unsupported Public Key Exponent",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-04-14T20:50:40.000+0000",
        const_partition: "1",
        docs: "## Error - 70102\r\n\r\n### Unsupported Public Key Length\r\nThe Request tries to store a Public Key in Twilio. This public key can be parsed, has a correct encryption algorithm, but the request fails because the key has an invalid length.\r\n\r\n#### Possible Causes \r\n* Public key lenght different than 2048.\r\n\r\n#### Possible Solution\r\n* Regenerate a new keypair with length 2048 and retry.",
        code: 70102,
        log_level: "ERROR",
        last_updated: "2017-04-26T21:00:35.000+0000",
        message: "Unsupported Public Key Length",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-04-14T20:43:57.000+0000",
        const_partition: "1",
        docs: "## Error - 70101\r\n\r\n### Unsupported Public Key Algorithm\r\nThe Request tries to store a Public Key in Twilio. This public key can be parsed, but the request fails, because the key uses an unsupported algorithm.\r\n\r\n#### Possible Causes \r\n* Wrong public key algorithm. Only supported algorithm is RSA.\r\n\r\n#### Possible Solution\r\n* Regenerate a new keypair with RSA encryption and retry.",
        code: 70101,
        log_level: "ERROR",
        last_updated: "2017-04-24T21:52:40.000+0000",
        message: "Unsupported Public Key Algorithm",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-04-14T20:39:48.000+0000",
        const_partition: "1",
        docs: "## Error - 70004\r\n\r\n### Unauthorized\r\nThe Request does not contain any authorization information (most cases: credentials) or the credentials and the resource have no relation.\r\n\r\n#### Possible Causes \r\n* When omitting the Auth header from HTTP request\r\n* Passing an Auth header to access a resource that belongs to some other account.\r\n",
        code: 70004,
        log_level: "ERROR",
        last_updated: "2017-04-24T21:52:31.000+0000",
        message: "Unauthorized",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-04-14T20:37:58.000+0000",
        const_partition: "1",
        docs: "## Error - 70003\r\n\r\n### Outdated Entity\r\nThe request tries to update a resource that has been already updated (by someone else). Only applies if the resource uses a version field.\r\n\r\n#### Possible Causes \r\n* When sending an update request that contains field: \u201cversion: 1\u201d and the server recognizes that the actual version of the resource is already 2.\r\n\r\n#### Possible Solution:\r\n* Reload the resource with a GET request to get the latest version.",
        code: 70003,
        log_level: "ERROR",
        last_updated: "2017-04-24T21:52:23.000+0000",
        message: "Outdated Entity",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-04-14T20:35:35.000+0000",
        const_partition: "1",
        docs: "## Error - 70002\r\n\r\n### Bad request\r\nThe data in the request is unparsable.\r\n\r\n#### Possible Causes \r\n* When sending a string field \u201cabc\u201d when an intValue is expected\r\n* When sending invalid JSON in the request body",
        code: 70002,
        log_level: "ERROR",
        last_updated: "2017-04-24T21:52:14.000+0000",
        message: "Bad request",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-04-14T20:28:31.000+0000",
        const_partition: "1",
        docs: "## Error - 70001\r\n\r\n### Validation Failed\r\nThe Request body is syntactically correct, the body was successfully parsed, but the data in the body violates the constraints.\r\n\r\n#### Possible Causes \r\n* Performing an update to the \u201cFriendlyName\u201d with a string longer than the allowed 64 characters.\r\n* Updating a field that cannot have a null value to a null.",
        code: 70001,
        log_level: "ERROR",
        last_updated: "2017-04-26T20:45:11.000+0000",
        message: "Validation Failed",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-04-05T13:02:02.000+0000",
        const_partition: "1",
        docs: "### Programmable Chat: Member already exists\r\n\r\n#### Possible Causes \r\n\r\n*  Member with specified Identity already exists in this Channel.\r\n\r\n#### Possible Solutions\r\n\r\n*  Confirm that the Member Identity passed in the request is not already a member of the intended channel.",
        code: 50404,
        log_level: "ERROR",
        last_updated: "2018-09-17T21:58:32.000+0000",
        message: "Programmable Chat: Member already exists",
        secondary_message: "Member with specified Identity already exists in this Channel",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-03-30T21:11:14.000+0000",
        const_partition: "1",
        docs: "## Error - 30011 \r\n\r\n### Incoming MMS not supported by the receiving phone number in this region\r\n\r\nThere was a failure attempting to receive an incoming MMS\r\n\r\nA 30011 error is an indicator of a delivery failure between a telecom carrier and Twilio. \r\nYour Twilio phone number was sent an MMS in a region where Twilio does not support incoming MMS.\r\n\r\nIt is recommended that you respond to the user sending the MMS to let them know that you cannot receive MMS in this region.",
        code: 30011,
        log_level: "ERROR",
        last_updated: "2017-03-30T21:11:14.000+0000",
        message: "Incoming MMS not supported by the receiving phone number in this region",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2017-03-30T11:33:50.000+0000",
        const_partition: "1",
        docs: "## Error - 50403\r\n\r\n### Programmable Chat: Channel member limit exceeded\r\n\r\n#### Possible Causes \r\n* Channel has too many members\r\n\r\n#### Possible Solutions\r\n*  Increase channel member limit for service instance\r\n*  Remove members from channel",
        code: 50403,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:56:24.000+0000",
        message: "Programmable Chat: Channel member limit exceeded",
        secondary_message: "Channel has too many members",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-03-30T11:28:06.000+0000",
        const_partition: "1",
        docs: "## Error - 50208\r\n\r\n### Programmable Chat: User channel limit exceeded\r\n\r\n#### Possible Causes \r\n*  User has joined too many channels\r\n\r\n#### Possible Solutions\r\n*  Increase user channel limit for service instance\r\n*  Remove user from channels",
        code: 50208,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:58:17.000+0000",
        message: "Programmable Chat: User channel limit exceeded",
        secondary_message: null,
        product: "Programmable Chat",
    },
    {
        date_created: "2017-03-30T11:05:13.000+0000",
        const_partition: "1",
        docs: "## Error - 50063\r\n\r\n### Programmable Chat: Actions per second limit exceeded\r\n\r\n#### Possible Causes \r\n*  Your application is generating too many actions per second (APS) for Chat service instance\r\n*  Note that the APS limit is enforced for commands such as sending a Message or creating a Channel - not Read actions\r\n\r\n#### Possible Solutions\r\n*  Make sure your application (client or backend) uses a good exponential back-off algorithm like the [one advocated by Amazon](https://www.awsarchitectureblog.com/2015/03/backoff.html) to retry on HTTP 429 (rate limiting) responses\r\n*  Reduce the rate of requests and introduce basic rate control, e.g. for user or channel provisioning use-cases\r\n*  Reduce number of concurrent requests\r\n",
        code: 50063,
        log_level: "ERROR",
        last_updated: "2019-02-25T09:56:21.000+0000",
        message: "Programmable Chat: Actions per second limit exceeded",
        secondary_message: "Service instance actions per second limit exceeded",
        product: "Programmable Chat",
    },
    {
        date_created: "2017-03-11T21:13:06.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*   The Region requested is not valid.\r\n\r\n#### Possible Solutions\r\n*  Please see [Localized Termination URIs](/docs/api/sip-trunking/getting-started#localized-termination-uris) for more information on the valid Elastic SIP Trunking Regions.\r\n",
        code: 21252,
        log_level: "ERROR",
        last_updated: "2017-03-11T21:13:06.000+0000",
        message: "Invalid Region",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2017-03-11T21:11:59.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*   This CPS change is not allowed.\r\n\r\n#### Possible Solutions\r\n*  This CPS change is not allowed, kindly contact [Twilio Support](mailto:support@twilio.com).\r\n",
        code: 21251,
        log_level: "ERROR",
        last_updated: "2017-03-11T21:11:59.000+0000",
        message: "Trunking CPS change not allowed",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2017-03-11T21:09:20.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*   You've configured the maximum number of Origination URIs allowed for your Trunk.\r\n\r\n#### Possible Solutions\r\n* Please see [Multiple Origination URIs](/docs/api/sip-trunking/getting-started#multiple-orig-uris) for more information.\r\n",
        code: 21249,
        log_level: "ERROR",
        last_updated: "2017-03-11T21:09:20.000+0000",
        message: "Maximum Origination URIs reached  ",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2017-03-11T21:08:25.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*   This Termination URI (Domain) is not available.\r\n\r\n#### Possible Solutions\r\n*  Please review your Termination URI (Domain name) and select a different one.\r\n",
        code: 21248,
        log_level: "ERROR",
        last_updated: "2017-03-11T21:08:25.000+0000",
        message: "Trunk Domain already taken",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2017-03-11T21:07:34.000+0000",
        const_partition: "1",
        docs: '#### Possible Causes \r\n*  Cannot create subdomain because parent domain does not exist/account does not own it\r\n* Cannot delete trunk while it has subdomains\r\n* Cannot rename subdomain because parent domain does not exist/account doesn\'t own it\r\n* Cannot rename domain while it has subdomains\r\n\r\n#### Possible Solutions\r\n*  One of these constraints in the "Possible Causes" has been be violated, please review your Termination URI (Domain name).\r\n',
        code: 21247,
        log_level: "ERROR",
        last_updated: "2017-03-11T21:07:34.000+0000",
        message: "Trunk Dependencies",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2017-03-11T21:06:22.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n* Cannot use another account's SID as the Termination URI for this Trunk\r\n* Cannot create more than one Trunk with the same Termination URI\r\n* Credential List or IP-ACL already associated with Trunk\r\n\r\n#### Possible Solutions\r\n*  Please update your Trunk settings to avoid the conditions stated above. Learn more: [Configure Trunks](/docs/api/sip-trunking/getting-started#configure-trunks).\r\n",
        code: 21245,
        log_level: "ERROR",
        last_updated: "2017-03-11T21:06:22.000+0000",
        message: "Trunk Validation Error",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2017-03-11T21:05:16.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*   Maximum Number of Trunks reached.\r\n\r\n#### Possible Solutions\r\n*  Please see limits allowed, visit [Trunking Key Concepts](/docs/api/sip-trunking/key-concepts).\r\n",
        code: 21244,
        log_level: "ERROR",
        last_updated: "2017-03-11T21:05:16.000+0000",
        message: "Maximum Number of Trunks reached",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2017-03-03T21:15:29.000+0000",
        const_partition: "1",
        docs: "## Error - 20010\r\n\r\n#### Action disabled for account\r\n\r\n The action you attempted to perform has been disabled for your account. Please contact Customer Support for assistance.",
        code: 20010,
        log_level: "ERROR",
        last_updated: "2017-03-03T21:15:29.000+0000",
        message: "Action disabled for account",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-03-03T21:14:43.000+0000",
        const_partition: "1",
        docs: "## Error - 20009\r\n\r\n#### Cannot delete this resource before it is complete\r\n\r\nYou attempted to delete a call or message resource before it was completed. Wait until the call or message is completed and try your request again.",
        code: 20009,
        log_level: "ERROR",
        last_updated: "2017-03-03T21:14:43.000+0000",
        message: "Cannot delete this resource before it is complete",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2017-02-24T00:20:34.000+0000",
        const_partition: "1",
        docs: "## Error - 16000\r\n\r\n### Whisper Not Available on Twilio Conference\r\n\r\nWhisper is only available on Agent Conference, to create an Agent Conference configure your account to use Agent Conference in the [conference settings page](https://www.twilio.com/console/voice/settings/conferences)",
        code: 16000,
        log_level: "ERROR",
        last_updated: "2017-05-16T17:56:46.000+0000",
        message: "Whisper Not Available on Twilio Conference",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2017-02-14T23:38:57.000+0000",
        const_partition: "1",
        docs: "## Error - 13240\r\n\r\n### Dial->Conference: Invalid Whisper SID\r\n\r\nThe call SID specified by the whisper parameter is invalid. This may because the specified call is no longer connected to the conference. Validate that this call is connecting to the correct conference and the call SID specified is also in the conference.",
        code: 13240,
        log_level: "ERROR",
        last_updated: "2017-02-24T00:25:53.000+0000",
        message: "Dial->Conference: Invalid Whisper SID",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2017-02-14T23:37:04.000+0000",
        const_partition: "1",
        docs: "## Error - 13239\r\n\r\n### Dial->Conference: Invalid Trim Value\r\n\r\nThe trim parameter you entered is invalid. Acceptable values are trim-silence, do-not-trim, true and false.",
        code: 13239,
        log_level: "ERROR",
        last_updated: "2017-02-14T23:37:04.000+0000",
        message: "Dial->Conference: Invalid Trim Value",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-12-07T05:05:24.000+0000",
        const_partition: "1",
        docs: "## Error - 21628\r\n\r\n### Address Validation Error\r\n\r\nThe address you have provided cannot be validated. \r\n\r\n#### Possible Causes\r\n- Address misspelling\r\n- Address cannot be found in third-party data source \r\n\r\n#### Possible Solutions\r\n- Ensure the address is spelled correctly \r\n- Contact Twilio Support",
        code: 21628,
        log_level: "ERROR",
        last_updated: "2017-05-17T11:28:48.000+0000",
        message: "Address Validation Error",
        secondary_message: null,
        product: "Phone Numbers",
    },
    {
        date_created: "2016-11-16T21:56:25.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*  Your Elastic SIP Trunk does not have any valid active origination URLs\r\n\r\n\r\n#### Possible Solutions\r\n*  Please verify your [Origination settings](/docs/api/sip-trunking/getting-started#origination) of your Elastic SIP Trunk.",
        code: 32010,
        log_level: "ERROR",
        last_updated: "2016-11-16T22:12:01.000+0000",
        message: "SIP: No valid Origination URIs configured on your Elastic SIP Trunk",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2016-11-16T21:55:38.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*  The Interconnect Connection (TNX) SID is not Active.\r\n\r\n\r\n#### Possible Solutions\r\n*  Please verify the status of your Interconnect Connection SID, visit [Interconnect Connections](https://www.twilio.com/console/sip-trunking/interconnect/connections).\r\n\r\n\r\n",
        code: 32304,
        log_level: "WARNING",
        last_updated: "2018-06-11T21:13:39.000+0000",
        message: "Interconnect: Connection (TNX) SID is not Active",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2016-11-16T21:54:51.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*   Multiple SIP outbound dials with TNX parameter\r\n\r\n\r\n#### Possible Solutions\r\n*  We don't support multiple SIP outbound dials with TNX parameter, please ensure you Response only includes one.\r\n",
        code: 32303,
        log_level: "WARNING",
        last_updated: "2018-06-11T21:13:26.000+0000",
        message: "Interconnect: Multiple SIP Dials with Interconnect Connection (TNX) SID",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2016-11-16T21:53:40.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*  The Interconnect Connection (TNX) SID was not found.\r\n\r\n\r\n#### Possible Solutions\r\n*  Please verify your Interconnect Connection SID, visit [Interconnect Connections](https://www.twilio.com/console/sip-trunking/interconnect/connections).\r\n",
        code: 32302,
        log_level: "WARNING",
        last_updated: "2018-06-11T21:11:27.000+0000",
        message: "Interconnect: Connection (TNX) SID not found",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2016-11-16T21:52:51.000+0000",
        const_partition: "1",
        docs: "#### Possible Causes \r\n*  The Interconnect Connection (TNX) SID is invalid.\r\n\r\n#### Possible Solutions\r\n*  Please verify your Interconnect Connection SID, visit [Interconnect Connections](https://www.twilio.com/console/sip-trunking/interconnect/connections).",
        code: 32301,
        log_level: "WARNING",
        last_updated: "2018-06-11T21:11:05.000+0000",
        message: "Interconnect: Invalid Connection (TNX) SID",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2016-11-15T21:50:24.000+0000",
        const_partition: "1",
        docs: "## Error - 32212\r\n\r\n### Registration Authentication problem\r\n\r\n#### Possible Causes \r\n\r\nA SIP Endpoint tried to register with this SIP Domain and there isn't a Credential List mapped.\r\n#### Possible Solutions\r\n\r\nPlease map a Credential List to the Registration Authentication part of the SIP Domain",
        code: 32212,
        log_level: "WARNING",
        last_updated: "2016-11-15T21:50:24.000+0000",
        message: "SIP: Registration Authentication problem",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-11-15T20:22:33.000+0000",
        const_partition: "1",
        docs: "## Warning 32214\r\n\r\n###  Invalid &lt;Dial&gt;&lt;Sip&gt;\r\n\r\n#### Possible Causes\r\nYour TwiML can only &lt;Dial&gt;&lt;Sip&gt;username@yoursipdomain.sip.us1.twilio.com&lt;/Dial&gt;&lt;/Sip&gt;\r\n  to Twilio SIP Domains either in the same subaccount or within the master account.\r\n\r\n<b>Possible Solutions</b>\r\n\r\nRegister the SIP endpoint to a SIP Domain on the same subaccount.",
        code: 32214,
        log_level: "WARNING",
        last_updated: "2016-11-15T20:26:25.000+0000",
        message: "SIP: Invalid <Dial><Sip> ",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-11-15T19:54:16.000+0000",
        const_partition: "1",
        docs: "The AOR refers to: username@yoursipdomain.com\r\n\r\nThere is a limit on the number of SIP Endpoints/bindings per AOR\r\n\r\n<b>Possible Causes</b>\r\n\r\nThere is a limit of 10 bindings (SIP Endpoints) per AOR.\r\n\r\n<b>Possible Solutions</b>\r\nReduce the number of SIP Endpoints",
        code: 32007,
        log_level: "WARNING",
        last_updated: "2016-11-15T19:54:33.000+0000",
        message: "SIP: Too many endpoints/bindings for the Address-of-record (AOR)",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-11-09T23:00:49.000+0000",
        const_partition: "1",
        docs: "Registration per second limit reached\r\n\r\n<b>Cause</b>\r\n\r\nYou are allowed:\r\n5 REGISTER requests / second / AOR\r\n\r\n<b>Solution</b>\r\n\r\nReduce the frequency (Increase interval) of REGISTRATIONS by your SIP Endpoints.",
        code: 32008,
        log_level: "WARNING",
        last_updated: "2016-11-09T23:05:46.000+0000",
        message: "SIP: Registration per second limit reached",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-11-09T22:37:37.000+0000",
        const_partition: "1",
        docs: "Authentication error.\r\n\r\n<b>Possible Causes</b>\r\n\r\nAuthorization name and username do not match.\r\n\r\n<b>Possible Solutions</b>\r\n\r\nConfigure your SIP endpoint so the username and Authorization name match",
        code: 32106,
        log_level: "ERROR",
        last_updated: "2018-06-11T22:28:37.000+0000",
        message: "SIP: Authentication Error",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-11-09T00:55:10.000+0000",
        const_partition: "1",
        docs: "Possible loop in Contact header\r\n\r\n<b>Possible Causes</b>\r\n\r\nYou\u2019re sending `127.0.0.1` or `localhost` in the Contact header which will create a loop at Twilio.\r\n\r\n<b>Possible Solutions</b>\r\n\r\n Configure your SIP stack so it populates the Contact header properly.",
        code: 32105,
        log_level: "WARNING",
        last_updated: "2016-11-09T00:55:10.000+0000",
        message: "SIP: Invalid contact header",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-10-28T21:16:58.000+0000",
        const_partition: "1",
        docs: "## Error - 32002\r\n\r\n### Dial failure - Twilio SIP Domain not found\r\n\r\n#### Possible Causes\r\n\r\n* There is a typo in the name of the SIP Domain.\r\n* When a SIP Domain is created you must press SAVE on Console. \r\n\r\n#### Possible Solutions\r\n\r\n* Verify the existence and name of the SIP Domain that you created.",
        code: 32002,
        log_level: "WARNING",
        last_updated: "2016-11-15T20:18:30.000+0000",
        message: "SIP: Dial failure - Twilio SIP Domain not found",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-10-28T21:02:03.000+0000",
        const_partition: "1",
        docs: "## Error - 32215\r\n\r\n### Dial failure - Must specify a region in the SIP Domain\r\n\r\n#### Possible Causes\r\n\r\n* If you do a &lt;Dial&gt;&lt;Sip&gt; without specifying a region\r\n\r\n#### Possible Solutions\r\n\r\n* Dial the regional SIP domain.\r\nFor instance:\r\n&lt;Dial&gt;&lt;Sip&gt;username@yoursipdomain.sip.`us1`.twilio.com&lt;/Dial&gt;&lt;/Sip&gt;.\r\n\r\nNote the `us1` above that is specifying that you are calling a SIP endpoint registered to the US1 (North Virginia) data center.",
        code: 32215,
        log_level: "WARNING",
        last_updated: "2016-10-28T21:02:03.000+0000",
        message: "Dial failure calling a SIP Domain without specifying a region",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-10-28T19:54:55.000+0000",
        const_partition: "1",
        docs: "## Error - 32009\r\n\r\n### Dialing SIP Endpoint failure - User not registered\r\nThere was a failure attempting to Dial the specified SIP Endpoint.\r\nThe User specified is not registered.\r\n\r\n#### Possible Causes \r\n\r\nYou tried to Dial a SIP Endpoint that is not currently registered with the corresponding SIP Domain. Please check your TwiML or REST API.\r\n\r\n#### Possible Solutions\r\n\r\n* If you are using TwiML\r\nPlease check that there isn't a typo in  &lt;Dial&gt;&lt;Sip&gt;<b>username</b>@yoursipdomain.sip.us1.twilio.com&lt;/Sip&gt;&lt;/Dial&gt; and compare against your SIP Endpoint configuration. \r\nMake sure the <b>username</b> matches a username in the Credential List used to authenticate the SIP Endpoint with the SIP Domain. \r\n\r\n* If you are using the REST API\r\nPlease check the <b>To</b> field and verify there isn't a typo. Make sure the <b>username</b> matches a username in the Credential List used to authenticate the SIP Endpoint with the SIP Domain.\r\n\r\n#### Troubleshooting\r\n* Prior to dialing, you can verify that your SIP Endpoint has successfully registered in the Console \"Registered SIP Endpoints\" tab found on the SIP Domains page.",
        code: 32009,
        log_level: "WARNING",
        last_updated: "2018-05-14T15:10:31.000+0000",
        message: "The user you tried to dial is not registered with the corresponding SIP Domain",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-10-11T17:58:00.000+0000",
        const_partition: "1",
        docs: "#### Warning - 13620   \r\n\r\nRecord: Transcription feature not available for this recording.  \r\n\r\n#### Possible Causes \r\nTranscription feature not supported for recordings when your account has client side Recording Encryption enabled.\r\n\r\n#### Possible Solutions: \r\nContact support to disable client side Recording Encryption feature on your account.",
        code: 13620,
        log_level: "WARNING",
        last_updated: "2016-10-11T17:58:00.000+0000",
        message: "Record: Transcription not available for this recording",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-10-05T23:53:23.000+0000",
        const_partition: "1",
        docs: "## Error - 62035\r\n\r\n#### Possible Causes \r\n*  No bandwidth was specified in the request\r\n\r\n#### Possible Solutions\r\n* The request did not specify bandwidth. Please include an approved bandwidth option--those are 10.0Mb, 100.0mb, and 1000.0Mb",
        code: 62035,
        log_level: "ERROR",
        last_updated: "2017-07-14T22:20:04.000+0000",
        message: "Interconnect: No bandwidth was specified in the request",
        secondary_message: "The request did not specify bandwidth. Approved quantities are 10.0, 100.0, and 1000.0Mb.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:52:34.000+0000",
        const_partition: "1",
        docs: "## Error - 62034 \r\n\r\n#### Possible Causes \r\n*  No useful parameters provided\r\n\r\n#### Possible Solutions\r\n*  The request you made expected at least 1 optional parameter, but none was provided. Please add a parameter and/or confirm that is was not misspelled.",
        code: 62034,
        log_level: "ERROR",
        last_updated: "2017-07-14T22:44:18.000+0000",
        message: "Interconnect: No useful parameters provided.",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:51:26.000+0000",
        const_partition: "1",
        docs: "## Error - 62028\r\n\r\n#### Possible Causes \r\n* Connection expired.\r\n\r\n#### Possible Solutions\r\n*  The connection SID in the request has expired, and may no longer be used. Please create a new connection. ",
        code: 62028,
        log_level: "ERROR",
        last_updated: "2017-07-14T22:48:44.000+0000",
        message: "Interconnect: Connection expired.",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:50:56.000+0000",
        const_partition: "1",
        docs: "## Error - 62027\r\n\r\n#### Possible Causes \r\n* Extra MPLS parameter\r\n\r\n#### Possible Solutions\r\n*  An MPLS carrier does not relate to a connection of the specified type, please update the parameter and try again.",
        code: 62027,
        log_level: "ERROR",
        last_updated: "2017-07-14T22:50:28.000+0000",
        message: "Interconnect: Extra MPLS parameter",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:50:17.000+0000",
        const_partition: "1",
        docs: "## Error - 62026\r\n\r\n#### Possible Causes \r\n* Missing MPLS carrier SID\r\n\r\n#### Possible Solutions\r\n*  Please add a valid MPLS carrier SID.",
        code: 62026,
        log_level: "ERROR",
        last_updated: "2017-07-14T23:01:24.000+0000",
        message: "Interconnect: Missing MPLS carrier SID",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:49:50.000+0000",
        const_partition: "1",
        docs: "## Error - 62025\r\n\r\n#### Possible Causes \r\n* Invalid connection type\r\n\r\n#### Possible Solutions\r\n*  The request specified an invalid connection type. Please add a valid type-cloudconnect, crossconnect, mpls or vpn.",
        code: 62025,
        log_level: "ERROR",
        last_updated: "2017-07-14T23:03:20.000+0000",
        message: "Interconnect: Invalid connection type",
        secondary_message: null,
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:49:15.000+0000",
        const_partition: "1",
        docs: "## Error - 62024\r\n\r\n### Missing connection type\r\n\r\nThe request did not specify a connection type. Valid connection types are vpn, crossconnect, mpls.",
        code: 62024,
        log_level: "ERROR",
        last_updated: "2016-10-06T00:10:45.000+0000",
        message: "Missing connection type",
        secondary_message: "The request did not specify a connection type. Valid connection types are vpn, crossconnect, mpls.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:48:43.000+0000",
        const_partition: "1",
        docs: "## Error - 62023\r\n\r\n### Missing exchange\r\n\r\nThe request did not specify an exchange SID. ",
        code: 62023,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:48:43.000+0000",
        message: "Missing exchange",
        secondary_message: "The request did not specify an exchange SID.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:48:09.000+0000",
        const_partition: "1",
        docs: "## Error - 62022\r\n\r\n### Missing account SID\r\n\r\nThe request did not specify an account SID.",
        code: 62022,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:48:09.000+0000",
        message: "Missing account SID",
        secondary_message: "The request did not specify an account SID. ",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:47:11.000+0000",
        const_partition: "1",
        docs: "## Error - 62021\r\n\r\n### IP Gateway Invalid\r\n\r\nThe request provided an invalid gateway IP address. Request must provide a valid IP address not in the RFC 1918 range.",
        code: 62021,
        log_level: "ERROR",
        last_updated: "2016-10-06T00:09:59.000+0000",
        message: "IP Gateway Invalid",
        secondary_message: "The request provided an invalid gateway IP address. Request must provide a valid IP address not in the RFC 1918 range.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:46:37.000+0000",
        const_partition: "1",
        docs: "## Error - 62020\r\n\r\n### Connection pending deletion.\r\n\r\nThe connection SID in the request is pending deletion. No changes can be made to it. ",
        code: 62020,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:46:37.000+0000",
        message: "Connection pending deletion.",
        secondary_message: "The connection SID in the request is pending deletion. No changes can be made to it.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:44:37.000+0000",
        const_partition: "1",
        docs: "## Error - 62019\r\n\r\n### IP route exceeds permitted IP range\r\n\r\nThe request provided an IP route that would exceed permitted IP range. IP addresses are limited to the 256 address range.",
        code: 62019,
        log_level: "ERROR",
        last_updated: "2016-10-06T00:09:36.000+0000",
        message: "IP route exceeds permitted IP range",
        secondary_message: "The request provided an IP route that would exceed permitted IP range. IP addresses are limited to the 256 address range.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:43:42.000+0000",
        const_partition: "1",
        docs: "## Error - 62018\r\n\r\n### Invalid IP route\r\n\r\nThe request provided an invalid IP route. The IP route must be a valid formed CIDR address that does not exist within the RFC 1918 address space.",
        code: 62018,
        log_level: "ERROR",
        last_updated: "2016-10-06T00:08:52.000+0000",
        message: "Invalid IP route",
        secondary_message: "The request provided an invalid IP route. The IP route must be a valid formed CIDR address that does not exist within the RFC 1918 address space.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:43:10.000+0000",
        const_partition: "1",
        docs: "## Error - 62017\r\n\r\n### No IP route specified\r\n\r\nThe request did not identify an IP route. This may indicate that the IP Route parameter was misspelled.",
        code: 62017,
        log_level: "ERROR",
        last_updated: "2016-10-06T00:15:38.000+0000",
        message: "No IP route specified",
        secondary_message: "The request did not identify an IP route. This may indicate that the IP Route parameter was misspelled.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:42:34.000+0000",
        const_partition: "1",
        docs: "## Error - 62016\r\n\r\n### Connection not active\r\n\r\nThe connection SID in the request is not currently active. To transition a connection from active to inactive, the connection must be in an active state.",
        code: 62016,
        log_level: "ERROR",
        last_updated: "2016-10-06T00:13:21.000+0000",
        message: "Connection not active",
        secondary_message: "The connection SID in the request is not currently active. To transition a connection from active to inactive, the connection must be in an active state.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:42:03.000+0000",
        const_partition: "1",
        docs: "## Error - 62015\r\n\r\n### Connection in transition\r\n\r\nThe connection SID in the request is currently in a state of transition. A connection cannot be transitioned from inactive to active unless if the connection is currently in an inactive state. To transition the connection to an active state, please wait for the connection to be inactive again. ",
        code: 62015,
        log_level: "ERROR",
        last_updated: "2016-10-06T00:13:11.000+0000",
        message: "Connection in transition",
        secondary_message: "The connection SID in the request is currently in a state of transition. A connection cannot be transitioned from inactive to active unless if the connection is currently in an inactive state. To transition the connection to an active state, please wait for the connection to be inactive again. ",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:41:28.000+0000",
        const_partition: "1",
        docs: "## Error - 62014\r\n\r\n### Connection not ready\r\n\r\nThe connection SID in the request is not fully configured.  Please provide additional configuration info.  For a VPN connection, please provide IP Gateway and at least one IP route. ",
        code: 62014,
        log_level: "ERROR",
        last_updated: "2016-10-06T00:13:00.000+0000",
        message: "Connection not ready",
        secondary_message: "The connection SID in the request is not fully configured. Please provide additional configuration info.  For a VPN connection, please provide IP Gateway and at least one IP route. ",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:40:59.000+0000",
        const_partition: "1",
        docs: "## Error - 62013\r\n\r\n### Unable to identify account owner of connection\r\n\r\nThe connection SID in the request is orphaned, and the owner cannot be\r\nidentified.",
        code: 62013,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:40:59.000+0000",
        message: "Unable to identify account owner of connection.",
        secondary_message: "The connection SID in the request is orphaned, and the owner cannot be identified.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:40:17.000+0000",
        const_partition: "1",
        docs: "## Error - 62012\r\n\r\n### Connection not found\r\n\r\nThe connection SID in the request could not be found.",
        code: 62012,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:40:17.000+0000",
        message: "Connection not found.",
        secondary_message: "The connection SID in the request could not be found.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:39:45.000+0000",
        const_partition: "1",
        docs: "## Error - 62011\r\n\r\n### Unauthorized\r\n\r\nThe access credentials provided are not authorized to access this resource.",
        code: 62011,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:39:45.000+0000",
        message: "Unauthorized",
        secondary_message: "The access credentials provided are not authorized to access this resource.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:39:06.000+0000",
        const_partition: "1",
        docs: "## Error - 62010\r\n\r\n### No authentication was provided.\r\n\r\nAn attempt was made to access a restricted resource without proper\r\nauthorization. Provide authentication details and try again.",
        code: 62010,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:39:06.000+0000",
        message: "No authentication was provided.",
        secondary_message: "An attempt was made to access a restricted resource without proper authorization. Provide authentication details and try again.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:38:28.000+0000",
        const_partition: "1",
        docs: "## Error - 62009\r\n\r\n### Account SID was not found\r\n\r\nThe account SID in the request could not be found in the Twilio Interconnect\r\ndirectory. This does not mean that the account is not valid, only that it\r\nis not associated with any Twilio Interconnect entries.",
        code: 62009,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:38:28.000+0000",
        message: "Account SID was not found.",
        secondary_message: "The account SID in the request could not be found in the Twilio Interconnect directory. This does not mean that the account is not valid, only that it is not associated with any Twilio Interconnect entries.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:37:48.000+0000",
        const_partition: "1",
        docs: "## Error - 62008\r\n\r\n### Bandwidth reserve is not associated with the exchange\r\n\r\nThe bandwidth reserve SID in the request is not associated with the\r\nexchange SID in the request. Choose a bandwidth reserve that is associated\r\nwith the exchange SID, or choose an exchange SID that is associated with\r\nthe bandwidth reserve SID.",
        code: 62008,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:37:48.000+0000",
        message: "Bandwidth reserve is not associated with the exchange.",
        secondary_message: "The bandwidth reserve SID in the request is not associated with the exchange SID in the request. Choose a bandwidth reserve that is associated with the exchange SID, or choose an exchange SID that is associated with the bandwidth reserve SID.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:37:08.000+0000",
        const_partition: "1",
        docs: "## Error - 62007\r\n\r\n### Direct connect is not associated with the exchange\r\n\r\nThe direct connect SID in the request is not associated with the exchange\r\nSID in the request. Choose a direct connect SID that is associated with the\r\nexchange SID, or choose an exchange SID associated with the direct connect\r\nSID.",
        code: 62007,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:37:08.000+0000",
        message: "Direct connect is not associated with the exchange.",
        secondary_message: "The direct connect SID in the request is not associated with the exchange SID in the request. Choose a direct connect SID that is associated with the exchange SID, or choose an exchange SID associated with the direct connect SID.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:36:20.000+0000",
        const_partition: "1",
        docs: "## Error - 62006\r\n\r\n### MPLS carrier is not associated with the exchange\r\n\r\nThe MPLS carrier SID in the request is not associated with the exchange SID\r\nin the request. Choose an MPLS carrier SID that is associated with the\r\nexchange SID, or choose an exchange SID that is associated with the MPLS\r\ncarrier SID.",
        code: 62006,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:36:20.000+0000",
        message: " MPLS carrier is not associated with the exchange.",
        secondary_message: "The MPLS carrier SID in the request is not associated with the exchange SID in the request. Choose an MPLS carrier SID that is associated with the exchange SID, or choose an exchange SID that is associated with the MPLS carrier SID.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:35:36.000+0000",
        const_partition: "1",
        docs: "## Error - 62005\r\n\r\n### Bandwidth reserve not found\r\n\r\nThe bandwidth reserve SID in the request could not be found.\r\n\r\n",
        code: 62005,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:35:36.000+0000",
        message: " Bandwidth reserve not found.",
        secondary_message: "The bandwidth reserve SID in the request could not be found.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:35:06.000+0000",
        const_partition: "1",
        docs: "## Error - 62004\r\n\r\n### Direct connect not found\r\n\r\nThe direct connect SID in the request could not be found.\r\n\r\n",
        code: 62004,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:35:06.000+0000",
        message: "Direct connect not found.",
        secondary_message: "The direct connect SID in the request could not be found.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:34:32.000+0000",
        const_partition: "1",
        docs: "## Error - 62003\r\n\r\n### MPLS carrier not found\r\n\r\nThe MPLS carrier SID in the request could not be found.",
        code: 62003,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:34:32.000+0000",
        message: "MPLS carrier not found.",
        secondary_message: "The MPLS carrier SID in the request could not be found.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T23:33:35.000+0000",
        const_partition: "1",
        docs: "## Error - 62002\r\n\r\n### Exchange not found\r\n\r\nThe exchange SID in the request could not be found.",
        code: 62002,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:33:35.000+0000",
        message: "Exchange not found",
        secondary_message: "The exchange SID in the request could not be found.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T20:26:23.000+0000",
        const_partition: "1",
        docs: "## Error - 62001\r\n\r\n### Invalid SID\r\n\r\nA SID that was provided in the request was not valid. Ensure that any SIDs\r\nare complete and valid.",
        code: 62001,
        log_level: "ERROR",
        last_updated: "2016-10-06T00:11:35.000+0000",
        message: "Invalid SID",
        secondary_message: "A SID that was provided in the request was not valid. Ensure that any SIDs are complete and valid.",
        product: "Interconnect",
    },
    {
        date_created: "2016-10-05T20:25:16.000+0000",
        const_partition: "1",
        docs: "## Error - 62000\r\n\r\n### Failed to write to the database.\r\n\r\nAn internal error occurred, and the service was unable to write data relevant\r\nto your request.",
        code: 62000,
        log_level: "ERROR",
        last_updated: "2016-10-05T23:31:30.000+0000",
        message: "Failed to write to the database.",
        secondary_message: "An internal error occurred, and the service was unable to write data relevant to your request.",
        product: "Interconnect",
    },
    {
        date_created: "2016-08-22T23:02:11.000+0000",
        const_partition: "1",
        docs: '## Error - 40135\r\n\r\n### The Reservation must currently be Pending - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  The Reservation has been moved to a non-Pending state.\r\n\r\n#### Possible Solutions\r\n*  Make certain that the Reservation is currently Pending. \r\n\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
        code: 40135,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:00:58.000+0000",
        message: "TaskRouter->Dequeue",
        secondary_message: "Dequeue Instruction can only be issued on a currently pending reservation.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-08-22T23:00:20.000+0000",
        const_partition: "1",
        docs: '## Error - 40123\r\n\r\n### The Reservation must currently be Pending - Redirect Instruction\r\n\r\n#### Possible Causes \r\n*  The Reservation has been moved to a non-Pending state.\r\n\r\n#### Possible Solutions\r\n*  Make certain that the Reservation is currently Pending. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "redirect",\r\n\t"call_sid": "CA0123456789abcdef0123456789abcdef",\r\n\t"url": "https://example.com/twiml?querystring=1234"\r\n}\r\n```',
        code: 40123,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:01:34.000+0000",
        message: "TaskRouter->Redirect",
        secondary_message: "Redirect Instruction can only be issued on a currently pending reservation.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-08-22T22:59:40.000+0000",
        const_partition: "1",
        docs: '## Error - 40114\r\n\r\n### The Reservation must currently be Pending - Call Instruction\r\n\r\n#### Possible Causes \r\n*  The Reservation has been moved to a non-Pending state.\r\n\r\n#### Possible Solutions\r\n*  Make certain that the Reservation is currently Pending. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "call",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"url": "https://example.com/twiml"\r\n}\r\n```',
        code: 40114,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:02:03.000+0000",
        message: "TaskRouter->Call",
        secondary_message: "Call Instruction can only be issued on a currently pending reservation.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-07-28T22:11:03.000+0000",
        const_partition: "1",
        docs: '## Error - 40134\r\n\r\n### Invalid \'status_callback_events\' parameter - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  You provided an invalid format in your "status_callback_events" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "status_callback_events" contains a valid comma separated string of events to subscribe to if responding to an assignment callback\r\n*  Make certain each "DequeueStatusCallbackEvent" contains an acceptable event to subscribe to if making a POST /v1/Workspaces/{WorkspaceSid}/Tasks/{TaskSid}/Reservations/{ReservationSid}\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef",\r\n    "status_callback_events": "initiated,ringing,answered,completed"\r\n}\r\n```',
        code: 40134,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:05:59.000+0000",
        message: "Dequeue Instruction does not have a valid 'status_callback_events' parameter",
        secondary_message: null,
        product: "TaskRouter",
    },
    {
        date_created: "2016-06-07T15:57:03.000+0000",
        const_partition: "1",
        docs: "## Error - 52201\r\n\r\n### RtdNotification: Too many Facebook notifications from same page ID\r\n\r\n#### Possible Causes \r\n* Customer is trying to broadcast Facebook messenger notifications \r\n\r\n#### Possible Solutions\r\n* Please notify RTD Notifications team if this error starts occurring.",
        code: 52201,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:46:45.000+0000",
        message: "Too many Facebook messenger notification requests",
        secondary_message: "Too many Facebook messenger notifications are sent from the same Facebook page ID",
        product: "Notifications",
    },
    {
        date_created: "2016-06-07T15:56:12.000+0000",
        const_partition: "1",
        docs: "## Error - 52181\r\n\r\n### RtdNotification: Global SMS notification per second limit exceeded\r\n\r\n#### Possible Causes \r\n* Somebody is using SMS broadcast\r\n* General high load\r\n\r\n#### Possible Solutions\r\n* At the moment there is a global SMS rate limit. This should be increased or eliminated entirely in the near future, but that requires some development. Please notify RTD Notifications team if this error starts occurring.",
        code: 52181,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:39:12.000+0000",
        message: "Too many SMS notification requests",
        secondary_message: "Global SMS notification per second limit exceeded",
        product: "Notifications",
    },
    {
        date_created: "2016-06-01T00:39:05.000+0000",
        const_partition: "1",
        docs: "## Error - 61009\r\n\r\n### Add-ons: Could not fulfill request with available data\r\n\r\n#### Possible Causes \r\n*   One of the request fields in the Add-ons specification could not be interpolated with the provided data. The result is an invalid URL, Header value or other parameter that makes the request impossible to execute.",
        code: 61009,
        log_level: "ERROR",
        last_updated: "2016-06-01T00:39:05.000+0000",
        message: "Add-ons: Could not fulfill request with available data",
        secondary_message: " One of the request fields in the Add-ons specification could not be interpolated with the provided data. The result is an invalid URL, Header value or other parameter that makes the request impossible to execute.",
        product: null,
    },
    {
        date_created: "2016-06-01T00:38:44.000+0000",
        const_partition: "1",
        docs: "## Error - 61008\r\n\r\n### Add-ons:  HTTP too many redirects\r\n\r\n#### Possible Causes \r\n*  Add-on Provider returned too many HTTP redirects. To prevent getting stuck in a redirect loop only 5 redirects will be followed. After that the request will be terminated and this error code will be returned.",
        code: 61008,
        log_level: "ERROR",
        last_updated: "2016-06-01T00:38:44.000+0000",
        message: "Add-ons:  HTTP too many redirects",
        secondary_message: "Add-on Provider returned too many HTTP redirects. To prevent getting stuck in a redirect loop only 5 redirects will be followed. After that the request will be terminated and this error code will be returned.",
        product: null,
    },
    {
        date_created: "2016-06-01T00:38:26.000+0000",
        const_partition: "1",
        docs: "## Error - 61007\r\n\r\n### Add-ons: Response body too large\r\n\r\n#### Possible Causes \r\n*   The Add-on Provider returned a response payload that exceeded 64 kilobytes. As a result the payload was removed and this error was returned instead.",
        code: 61007,
        log_level: "ERROR",
        last_updated: "2016-06-01T00:38:26.000+0000",
        message: "Add-ons: Response body too large",
        secondary_message: " The Add-on Provider returned a response payload that exceeded 64 kilobytes. As a result the payload was removed and this error was returned instead.",
        product: null,
    },
    {
        date_created: "2016-06-01T00:38:04.000+0000",
        const_partition: "1",
        docs: "## Error - 61006\r\n\r\n### Add-ons: Add-ons unavailable for GET callbacks\r\n\r\n#### Possible Causes \r\n*  Due to the size limitations of GET callbacks we do not include Add-on results in GET callbacks",
        code: 61006,
        log_level: "WARNING",
        last_updated: "2018-08-24T14:18:51.000+0000",
        message: "Add-ons: Add-ons unavailable for GET callbacks",
        secondary_message: "Due to the size limitations of GET callbacks we do not include Add-on results in GET callbacks",
        product: null,
    },
    {
        date_created: "2016-06-01T00:37:37.000+0000",
        const_partition: "1",
        docs: "## Error - 61005\r\n\r\n### Add-ons: Bad request\r\n\r\n#### Possible Causes \r\n*   The Add-on Provider provided an HTTP Status Code in the 400 range. This indicates that they received the request but were unable to processes it due to validation or authorization issue.\r\n",
        code: 61005,
        log_level: "ERROR",
        last_updated: "2018-08-24T14:20:15.000+0000",
        message: "Add-ons: Bad request",
        secondary_message: " The Vendor provided an HTTP Status Code in the 400 range. This indicates that the Add-on Provider received the request but was unable to processes it due to validation or authorization issue.",
        product: null,
    },
    {
        date_created: "2016-06-01T00:37:17.000+0000",
        const_partition: "1",
        docs: "## Error - 61004\r\n\r\n### Add-ons: No results\r\n\r\n#### Possible Causes \r\n*   The Add-on Provider returned a successful response but the Response Validation Schema indicated there was no usable data.\r\n",
        code: 61004,
        log_level: "WARNING",
        last_updated: "2018-08-24T14:20:07.000+0000",
        message: "Add-ons: No results",
        secondary_message: " The Add-on Provider returned a successful response but the Response Validation Schema indicated there was no usable data.",
        product: null,
    },
    {
        date_created: "2016-06-01T00:36:55.000+0000",
        const_partition: "1",
        docs: "## Error - 61003\r\n\r\n### Add-ons: Requirements to invoke AddOns have not been met\r\n\r\n#### Possible Causes \r\n*  A parameter required to complete the request was not provided at run time. As a result the Add-on Request can not be completed.\r\n*  The Add-on does not support the data that was provided. For example the Add-on may not support looking up phone numbers in specific countries. \r\n\r\n#### Possible Solutions\r\n*  Refer to Add-on documentation in Console to determine if the Add-on supports the country or format of the data you are providing\r\n* Check Add-on documentation to see if you may be missing some data for Lookup Add-ons",
        code: 61003,
        log_level: "ERROR",
        last_updated: "2018-03-30T23:07:59.000+0000",
        message: "Add-ons: Requirements to invoke AddOns have not been met",
        secondary_message: " A parameter required to complete the request was missing or is not supported. As a result the Add-on Request can not be completed.",
        product: null,
    },
    {
        date_created: "2016-06-01T00:36:32.000+0000",
        const_partition: "1",
        docs: "## Error - 61002\r\n\r\n### Add-ons: Provider could not complete request\r\n\r\n#### Possible Causes \r\n*  The Add-on Provider  provided a HTTP Status Code in the 500 range. This indicates an error processing the Add-on Request on the Vendors side. ",
        code: 61002,
        log_level: "ERROR",
        last_updated: "2018-08-24T14:19:47.000+0000",
        message: "Add-ons: Provider could not complete request",
        secondary_message: "The Add-on Provider  provided a HTTP Status Code in the 500 range. This indicates an error processing the Add-on Request on the Vendors side.",
        product: null,
    },
    {
        date_created: "2016-06-01T00:36:03.000+0000",
        const_partition: "1",
        docs: "## Error - 61001\r\n\r\n### Add-ons: Request timed out\r\n\r\n#### Possible Causes \r\n*   The Add-on Provider failed to respond in the allotted time. The request was terminated and no further processing was attempted.\r\n\r\n#### Possible Solutions\r\n*  Contact Add-on Provider if this error persists",
        code: 61001,
        log_level: "ERROR",
        last_updated: "2016-06-01T00:36:03.000+0000",
        message: "Add-ons: Request timed out",
        secondary_message: " The Add-on Provider failed to respond in the allotted time. The request was terminated and no further processing was attempted.",
        product: null,
    },
    {
        date_created: "2016-06-01T00:35:33.000+0000",
        const_partition: "1",
        docs: "## Error - 61000\r\n\r\n### Add-ons Internal server error\r\n\r\n#### Possible Causes \r\n*  This is generic catch all error for Add-on related conditions that were not caught by a more specific error.\r\n",
        code: 61000,
        log_level: "ERROR",
        last_updated: "2018-08-24T14:19:57.000+0000",
        message: "Add-ons: Internal server error",
        secondary_message: "This is generic catch all error for Add-on related conditions that were not caught by a more specific error.",
        product: null,
    },
    {
        date_created: "2016-05-20T03:22:25.000+0000",
        const_partition: "1",
        docs: "Warning - 13619 Record: Transcription feature not available for this type of recording. Possible Causes The transcription attribute was specified for a type of recording that does not currently support transcription. Possible Solutions: Check in the TwiML or API docs whether the recording type you specified allows transcription.",
        code: 13619,
        log_level: "WARNING",
        last_updated: "2016-05-20T03:22:25.000+0000",
        message: "Record: Transcription feature not available for this type of recording.",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-05-19T19:42:01.000+0000",
        const_partition: "1",
        docs: "### Content-Type of 'application/json' not set\r\n\r\n#### Possible Causes \r\n*  You responded with a 200 HTTP response but did not provide a Content-Type header of 'application/json'\r\n\r\n#### Possible Solutions\r\n*  Add Content-Type header of 'application/json'\r\n\r\n#### Example\r\n\r\n~~~.json\r\n{\r\n\t\"instruction\": \"accept\"\r\n}\r\n~~~\r\n\r\nwith no Content-Type header provided.\r\n",
        code: 40000,
        log_level: "ERROR",
        last_updated: "2016-05-19T19:42:01.000+0000",
        message: "Content-Type of 'application/json' not set",
        secondary_message: null,
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-28T12:08:18.000+0000",
        const_partition: "1",
        docs: '## Error - 51007\r\n\r\n### Client Connection: Token authentication is rejected by authentication service\r\n\r\n#### Possible Causes \r\n\r\nAuthentication service has rejected provided Access Token.\r\n\r\nTo check whether the Access Token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio\'s specific Access Token implementation including the grant format, see [the documentation](/docs/api/rest/access-tokens).\r\n\r\nFor further assistance, please contact <a href="mailto:help@twilio.com">help@twilio.com</a>.',
        code: 51007,
        log_level: "ERROR",
        last_updated: "2016-04-28T12:08:25.000+0000",
        message: "Client Connection: Token authentication is rejected",
        secondary_message: "error",
        product: null,
    },
    {
        date_created: "2016-04-27T19:48:45.000+0000",
        const_partition: "1",
        docs: "## Error - 14239\r\n\r\n### Conference: Unable to update Worker's activity\r\n\r\nUnable to update the Worker to the provided ActivitySid. ",
        code: 14239,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:41:39.000+0000",
        message: "Dial->Conference: Unable to update Worker",
        secondary_message: "Unable to update Worker to provided PostWorkActivitySid",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:48:23.000+0000",
        const_partition: "1",
        docs: "## Error - 14238\r\n\r\n### Conference: Unable to accept or find the Reservation\r\n\r\nUnable to accept or find the provided Reservation.\r\n",
        code: 14238,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:39:22.000+0000",
        message: "Dial->Conference: Unable to accept Reservation",
        secondary_message: "Unable to accept the Reservation",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:48:00.000+0000",
        const_partition: "1",
        docs: "## Error - 14237\r\n\r\n### Conference: Invalid PostWorkActivitySid\r\n\r\nThe provided PostWorkActivitySid on the Conference TwiML was an invalid ActivitySid.\r\n",
        code: 14237,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:39:36.000+0000",
        message: "Dial->Conference: Invalid PostWorkActivitySid",
        secondary_message: "Provided PostWorkActivitySid on Conference is invalid",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:47:38.000+0000",
        const_partition: "1",
        docs: "## Error - 14236\r\n\r\n### Conference: Invalid ReservationSid\r\n\r\nThe provided ReservationSid on the Conference TwiML was invalid.\r\n",
        code: 14236,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:39:46.000+0000",
        message: "Dial->Conference: Invalid ReservationSid",
        secondary_message: "Provided ReservationSid on Conference is invalid",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:47:14.000+0000",
        const_partition: "1",
        docs: "## Error - 14235\r\n\r\n### Conference: Unable to cleanup Task\r\n\r\nUnable to cancel the Task created by Conference upon a TwiML error or task hangup.\r\n",
        code: 14235,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:39:55.000+0000",
        message: "Dial->Conference: Unable to cleanup task",
        secondary_message: "Unable to cancel the task created by Conference upon a TwiML error or task hangup.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:46:44.000+0000",
        const_partition: "1",
        docs: "## Error - 14234\r\n\r\n### Conference: Unable to create Task\r\n\r\nUnable to create the Task specified under Conference upon a TwiML error.\r\n",
        code: 14234,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:40:07.000+0000",
        message: "Dial->Conference: Unable to create task",
        secondary_message: "Unable to create the task created by Conference",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:46:24.000+0000",
        const_partition: "1",
        docs: "## Error - 14233\r\n\r\n### Conference: Provided Timeout was not a valid integer\r\n\r\nProvided Timeout is invalid.\r\n",
        code: 14233,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:40:17.000+0000",
        message: "Dial->Conference: Invalid Timeout",
        secondary_message: "Provided timeout is not a valid integer",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:46:04.000+0000",
        const_partition: "1",
        docs: "## Error - 14232\r\n\r\n### Conference: Provided Priority was not a valid integer\r\n\r\nProvided Priority is invalid.\r\n",
        code: 14232,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:40:41.000+0000",
        message: "Dial->Conference: Invalid Priority",
        secondary_message: "Provided priority is not a valid integer",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:45:43.000+0000",
        const_partition: "1",
        docs: "## Error - 14231\r\n\r\n### Conference: Provided Attributes JSON was not valid\r\n\r\nProvided Attributes is not valid JSON.\r\n",
        code: 14231,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:41:09.000+0000",
        message: "Dial->Conference: Provided Attributes was not valid JSON ",
        secondary_message: "Provided attributes is not valid JSON",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:44:58.000+0000",
        const_partition: "1",
        docs: "## Error - 14230\r\n\r\n### Conference: Provided WorkflowSid was not valid\r\n\r\nProvided Workflow is invalid.\r\n",
        code: 14230,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:41:19.000+0000",
        message: "Dial->Conference: Invalid WorkflowSid",
        secondary_message: "Provided workflow sid was not valid.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:43:34.000+0000",
        const_partition: "1",
        docs: '## Error - 40145\r\n\r\n### Call API Error - Conference Instruction\r\n\r\n#### Possible Causes \r\n*  Un-routable address provided for \'to\' field. \r\n*  Invalid caller-id passed to \'from\' field. \r\n*  Missing \'room_name\' field.\r\n*  Internal Twilio API error. \r\n\r\n#### Possible Solutions\r\n*  Make certain \'to\' contains a routable phone number, client URI or SIP URI. \r\n*  Make certain \'to\' is to a country you have permissions set to call.\r\n*  Make certain \'from\' contains an acceptable caller ID for the chosen \'to\' address.\r\n*  Make certain \'room_name\' is a valid Conference Room Name.\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"room_name": "abc",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
        code: 40145,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:00:14.000+0000",
        message: "TaskRouter->Conference",
        secondary_message: "Conference Instruction encountered an error when requesting an outgoing call be made from the API.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:43:10.000+0000",
        const_partition: "1",
        docs: '## Error - 40144\r\n\r\n### Reservation is no longer Pending - Conference Instruction\r\n\r\n#### Possible Causes \r\n* The original caller has hungup\r\n* The Task has been moved into a \'canceled\' state\r\n\r\n#### Possible Solutions\r\n*  Make sure the Task created has not been canceled prior to issuing \'conference\' instruction\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"room_name": "abc",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
        code: 40144,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:00:21.000+0000",
        message: "TaskRouter->Conference",
        secondary_message: "Conference Instruction does not have a pending Reservation for the Task",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:42:29.000+0000",
        const_partition: "1",
        docs: '## Error - 40143\r\n\r\n### Invalid Activity Sid - Conference Instruction\r\n\r\n#### Possible Causes \r\n*  You provided a \'post_work_activity_sid\' that was invalid or no longer exists.  \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid ActivitySid is being passed in the \'post_work_activity_sid\' parameter and it exists in your workspace. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"room_name": "abc",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
        code: 40143,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:00:34.000+0000",
        message: "TaskRouter->Conference",
        secondary_message: "Conference Instruction does not have a valid 'post_work_activity_sid' provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:40:40.000+0000",
        const_partition: "1",
        docs: '## Error - 40142\r\n\r\n### Missing or Invalid \'room_name\' parameter - Conference Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a \'room_name\' parameter on your \'conference\' instruction.\r\n*  You provided an invalid format in your \'room_name\' field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain \'room_name\' contains a valid conference room name.\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"room_name": "abc",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
        code: 40142,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:59:58.000+0000",
        message: "TaskRouter->Conference",
        secondary_message: "Conference Instruction does not have a valid 'room_name' parameter provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:40:13.000+0000",
        const_partition: "1",
        docs: '## Error - 40141\r\n\r\n### Missing or Invalid \'from\' parameter - Conference Instruction\r\n\r\n#### Possible Causes\r\n*  You did not provide a \'from\' parameter on your \'conference\' instruction.\r\n*  You provided an invalid format in your "from" field.\r\n\r\n#### Possible Solutions\r\n*  Make certain \'from\' contains a validated caller ID if you\'re dialing the PSTN.\r\n*  Make certain \'from\' contains an acceptable caller field.\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"room_name": "abc",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```\r\n',
        code: 40141,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:00:42.000+0000",
        message: "TaskRouter->Conference",
        secondary_message: "Conference Instruction does not have a valid 'from' parameter provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-27T19:38:39.000+0000",
        const_partition: "1",
        docs: '## Error - 40140\r\n\r\n### Missing or Invalid \'to\' parameter - Conference Instruction\r\n\r\n#### Possible Causes\r\n*  You did not provide a \'to\' parameter on your \'conference\' instruction.\r\n*  You provided an invalid format in your \'to\' field.\r\n\r\n#### Possible Solutions\r\n*  Make certain \'to\' contains a valid phone number, client URI, or SIP URI.\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "conference",\r\n\t"room_name": "abc",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```\r\n',
        code: 40140,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:00:50.000+0000",
        message: "TaskRouter->Conference",
        secondary_message: "Conference Instruction does not have a valid 'to' parameter provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-04-19T15:41:17.000+0000",
        const_partition: "1",
        docs: "## Warning - 52301\r\n\r\n### Destination list for requested parameters is empty\r\n\r\n#### Possible Causes \r\n*  No bindings were selected by the provided combination of parameters.\r\n\r\n#### Possible Solutions\r\n*  This may have been your intention, in that case no action is needed.\r\n*  In case you expected to notify some of your bindings then review your parameters and bindings/registrations.",
        code: 52301,
        log_level: "WARNING",
        last_updated: "2017-12-27T12:46:31.000+0000",
        message: "Resulted destination list for requested parameters is empty",
        secondary_message: "Search of target destinations by provided parameters returned empty list",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:40:33.000+0000",
        const_partition: "1",
        docs: "## Error - 52162\r\n\r\n### Credentials do not belong to used account\r\n\r\n#### Possible Causes \r\n*  The credential you have tried to use does not belong to the account.\r\n\r\n#### Possible Solutions\r\n*  Use a credential that belongs to the account.",
        code: 52162,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:39:25.000+0000",
        message: "Credentials do not belong to used account",
        secondary_message: "Account sid from credentials is not equal account sid which is used for sending notification",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:39:55.000+0000",
        const_partition: "1",
        docs: "## Error - 52161\r\n\r\n### Empty Credentials\r\n\r\n#### Possible Causes \r\n*  Credentials are invalid or do not exist for provided credential sid.\r\n\r\n#### Possible Solutions\r\n*  Make sure you have credential is valid.",
        code: 52161,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:39:39.000+0000",
        message: "Empty Credentials",
        secondary_message: "Credentials are misconfigured or not exist yet",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:39:17.000+0000",
        const_partition: "1",
        docs: "## Error - 52140\r\n\r\n### Unknown APNs error\r\n\r\n#### Possible Causes \r\n*  Unknown APNs error.\r\n\r\n#### Possible Solutions\r\n*  If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52140,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:39:52.000+0000",
        message: "Unknown APNs error",
        secondary_message: "Unexpected error has happened in Apn binding adaptor",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:38:39.000+0000",
        const_partition: "1",
        docs: "## Error - 52139\r\n\r\n### APNs service shutdown\r\n\r\n#### Possible Causes \r\n*  APNs delivery rejected because APNs service is shutting down (e.g. for maintenance).\r\n\r\n#### Possible Solutions\r\n*  If the problem persists, please contact [customer support](https://www.twilio.com/help/contact).",
        code: 52139,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:40:05.000+0000",
        message: "APN service shutdown",
        secondary_message: "APNs is shutdown",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:38:00.000+0000",
        const_partition: "1",
        docs: "## Error - 52138\r\n\r\n### APNs payload too large\r\n\r\n#### Possible Causes \r\n*  Generated APNs payload exceeded limit.\r\n\r\n#### Possible Solutions\r\n*  The maximum payload size allowed for iOS 8+ devices is 2KB for earlier devices it is 256 B. Revise your payload so that it does not exceed this limit.",
        code: 52138,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:40:18.000+0000",
        message: "APNs payload too large",
        secondary_message: "Provided payload is too large for APNs",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:37:14.000+0000",
        const_partition: "1",
        docs: "## Error - 52137\r\n\r\n### Invalid size of subject in APNs certificate\r\n\r\n#### Possible Causes \r\n*  The subject of APNs certificate is of invalid size.\r\n\r\n#### Possible Solutions\r\n*  The subject of the APNs certificate is the bundle ID of your application. Make sure you have a valid bundle ID defined when generating the certificate signing request.",
        code: 52137,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:40:32.000+0000",
        message: "Invalid size of subject in APNs certificate",
        secondary_message: "APNs certificate is invalid",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:36:38.000+0000",
        const_partition: "1",
        docs: "## Error - 52136\r\n\r\n### Missing payload for APNs delivery\r\n\r\n#### Possible Causes \r\n*  APNs delivery had no payload.\r\n\r\n#### Possible Solutions\r\n*  Make sure to provide a payload using at least one of Body, Sound, Action, Data or Aps parameters.",
        code: 52136,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:40:45.000+0000",
        message: "Missing payload for APNs delivery",
        secondary_message: "Payload must be provided to send notification over APNs",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:36:04.000+0000",
        const_partition: "1",
        docs: "## Error - 52135\r\n\r\n### Missing subject in APNs certificate\r\n\r\n#### Possible Causes \r\n*  The subject of APNs certificate is missing.\r\n\r\n#### Possible Solutions\r\n*  The subject of the APNs certificate is the bundle ID of your application. Make sure you have a bundle ID defined when generating the certificate signing request.",
        code: 52135,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:40:59.000+0000",
        message: "Missing subject in APNs certificate",
        secondary_message: "APNs certificate is invalid",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:35:27.000+0000",
        const_partition: "1",
        docs: "## Error - 52134\r\n\r\n### Invalid APNs device token\r\n\r\n#### Possible Causes \r\n*  APNs device token format is invalid.\r\n*  Trying to use a development certificate for a production application or vice-versa.\r\n\r\n#### Possible Solutions\r\n*  Make sure you do not modify the device token before providing it to Twilio. If using a command line tool make sure to url-encode the token.\r\n*  Make sure that you are using a development certificate for a development application and a production certificate for a production application.\r\n\t* If you are using a traditional certificate, you can tell its environment by looking at the common name field\r\n\t\t* For a development certificate, it will start with: Apple Development IOS Push Services\r\n\t\t* For a production certificate, it will start with: Apple Push Services\r\n\t* If you are using a universal certificate, you can use it for both development and production applications. However you have to make sure that you have properly indicated the type of application by setting the sandbox parameter when you create the credential. You can check the sandbox flag of your credential via the [REST API](/docs/api/ip-messaging/rest/credentials#action-get).",
        code: 52134,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:41:09.000+0000",
        message: "Invalid APNs device token",
        secondary_message: "APNs rejected notification with InvalidToken reason",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:34:46.000+0000",
        const_partition: "1",
        docs: "## Error - 52133\r\n\r\n### Invalid APNs device token size\r\n\r\n#### Possible Causes \r\n*  Invalid APNs token was provided.\r\n\r\n#### Possible Solutions\r\n*  Make sure you do not modify the APNs device token before providing it to Twilio.",
        code: 52133,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:41:21.000+0000",
        message: "Invalid APNs device token size",
        secondary_message: "APN token size is invalid",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:34:09.000+0000",
        const_partition: "1",
        docs: "## Error - 52131\r\n\r\n### Invalid APNs credentials\r\n\r\n#### Possible Causes \r\n*  Credential (certificate and private key) is invalid.\r\n*  Certificate expired.\r\n\r\n#### Possible Solutions\r\n*  Make sure you have valid certificate and private key provided in your Credential.",
        code: 52131,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:41:32.000+0000",
        message: "Invalid APNs credentials",
        secondary_message: "APN certificate or Private Key are invalid",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:33:19.000+0000",
        const_partition: "1",
        docs: "## Error - 52111\r\n\r\n### GCM/FCM unknown error\r\n\r\n#### Possible Causes \r\n*  Unknown GCM/FCM error.\r\n\r\n#### Possible Solutions\r\n*  If the problem persists, contact [customer support](https://www.twilio.com/help/contact) and provide the time of the error and details about the requests that are failing.",
        code: 52111,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:41:47.000+0000",
        message: "GCM/FCM unknown error",
        secondary_message: "Unexpected error has happened in GCM/FCM binding adaptor",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:32:38.000+0000",
        const_partition: "1",
        docs: "## Error - 52110\r\n\r\n### GCM/FCM service unavailable\r\n\r\n#### Possible Causes \r\n*  GCM/FCM service is temporarily unavailable or Twilio cannot connect to it.\r\n\r\n#### Possible Solutions\r\n*  Check our [status page](http://status.twilio.com) to see if we are having an outage. \r\n*  If the problem persists, [contact support](https://www.twilio.com/help/contact) and we will investigate.",
        code: 52110,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:42:00.000+0000",
        message: "GCM/FCM service unavailable",
        secondary_message: "GCM/FCM service is temporary unavailable",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:31:42.000+0000",
        const_partition: "1",
        docs: "## Error - 52109\r\n\r\n### GCM/FCM unauthorized error\r\n\r\n#### Possible Causes \r\n*  ApiKey/Secret is revoked or invalid.\r\n\r\n#### Possible Solutions\r\nProvide a new API Key/Secret and make sure your application is configured to use it.\r\n\r\n* If using IP-Messaging, update your Credential with the new API Key/Secret.\r\n* If using User Notifications, you can either update your Credential or create a new Credential and update your Service's GcmCredentialSid/FcmCredentialSid.",
        code: 52109,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:42:12.000+0000",
        message: "GCM/FCM unauthorized error",
        secondary_message: "GCM/FCM could not authorise request",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:31:02.000+0000",
        const_partition: "1",
        docs: "## Error - 52108\r\n\r\n### GCM/FCM device message rate exceeded\r\n\r\n#### Possible Causes \r\n*  The rate of messages to a particular device via GCM/FCM is too high.\r\n\r\n#### Possible Solutions\r\n*  Reduce the number of messages sent to this device and do not immediately retry sending to this device.",
        code: 52108,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:42:25.000+0000",
        message: "GCM/FCM device message rate exceeded",
        secondary_message: "Too many requests were sent to GCM/FCM service",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:30:22.000+0000",
        const_partition: "1",
        docs: "## Error - 52107\r\n\r\n### Invalid custom key for GCM/FCM\r\n\r\n#### Possible Causes \r\n*  You have specified an invalid key in the custom key-value pair section of the payload.\r\n\r\n#### Possible Solutions\r\n*  GCM/FCM rejects some keys including from, gcm and anything prefixed by google. Make sure you are not using any of these keys.",
        code: 52107,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:42:37.000+0000",
        message: "Invalid custom key for GCM/FCM",
        secondary_message: "Using one of custom keys is rejected by GCM/FCM service",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:29:41.000+0000",
        const_partition: "1",
        docs: "## Error - 52106\r\n\r\n### Notification too large for GCM/FCM\r\n\r\n#### Possible Causes \r\n*  Payload generated for GCM/FCM exceeded the 4 KB limit.\r\n\r\n#### Possible Solutions\r\n*  Reduce the size of the payload.",
        code: 52106,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:42:50.000+0000",
        message: "Notification too large for GCM/FCM",
        secondary_message: "Try to send notification through GCM/FCM binding channel with too big payload",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:28:59.000+0000",
        const_partition: "1",
        docs: "## Error - 52105\r\n\r\n### RtdNotification: Invalid GCM/FCM package name\r\n\r\n#### Possible Causes \r\n*  Application configuration problem.\r\n\r\n#### Possible Solutions\r\n*  Make sure the message was addressed to a registration token whose package name matches the value passed in the request. ",
        code: 52105,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:43:01.000+0000",
        message: "Invalid GCM/FCM package name",
        secondary_message: "Mismatch package name in request and from GCM/FCM registration id",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:26:02.000+0000",
        const_partition: "1",
        docs: "## Error - 52104\r\n\r\n### Mismatched GCM/FCM sender ID\r\n\r\n#### Possible Causes \r\n*  GCM/FCM API Key provided is not allowed to send notifications to the registration token.\r\n\r\n#### Possible Solutions\r\nMake sure that you are using an API Key/Secret that is allowed to send notifications to your application.\r\n\r\n*\tAdd the Project number of the Google Developers Console/Firebase Console project that the API Key/Secret belongs to to the allowed sender IDs of your application\r\n*\tAlternatively use an API Key/Secret from a project that is already allowed to send notifications to your application",
        code: 52104,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:43:40.000+0000",
        message: "Mismatched GCM/FCM sender ID",
        secondary_message: "GCM/FCM application used different sender id with provided application credentials (ApiKey/Secret)",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:25:08.000+0000",
        const_partition: "1",
        docs: "## Error - 52103\r\n\r\n### GCM/FCM client uninstalled or turned off notifications\r\n\r\n#### Possible Causes \r\n*  GCM/FCM client application was uninstalled or the user turned off push notifications.\r\n\r\n#### Possible Solutions\r\n*  No action needed. We have disabled the registration token and we will not send new notifications to it.",
        code: 52103,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:46:58.000+0000",
        message: "GCM/FCM client uninstalled or turned off notifications",
        secondary_message: "GCM/FCM service marked used registration id as unusable anymore",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:06:11.000+0000",
        const_partition: "1",
        docs: "## Error - 52102\r\n\r\n### Invalid GCM/FCM registration token\r\n\r\n#### Possible Causes \r\n*  Invalid GCM/FCM registration token provided via the Android SDK or the REST API.\r\n\r\n#### Possible Solutions\r\n*  Make sure you do not modify the registration token before providing it to Twilio via the SDK or the REST API.\r\n*  If you are using a command line tool to provide the registration token, make sure that it is URL-encoded.",
        code: 52102,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:43:56.000+0000",
        message: "Invalid GCM/FCM registration token",
        secondary_message: "GCM/FCM service responded with InvalidRegistration error",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:05:29.000+0000",
        const_partition: "1",
        docs: "## Error - 52101\r\n\r\n### Invalid GCM Api Key or FCM Secret\r\n\r\n#### Possible Causes \r\n*  The GCM API Key or FCM Secret provided is invalid.\r\n\r\n#### Possible Solutions\r\n* Provide a valid GCM API Key or FCM Secret",
        code: 52101,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:44:09.000+0000",
        message: "Invalid GCM Api Key or FCM Secret",
        secondary_message: "GCM/FCM credential contains invalid or empty ApiKey/Secret",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:04:40.000+0000",
        const_partition: "1",
        docs: "## Warning - 52072\r\n\r\n### RtdNotification: Mqtt client connection not created or closed\r\n\r\n#### Possible Causes \r\n*  Most probably mqtt client had disconnected but registration didn't removed yet.\r\n\r\n#### Possible Solutions\r\n*  Check this warning happens only once for certain registration id. ",
        code: 52072,
        log_level: "WARNING",
        last_updated: "2017-12-27T12:44:22.000+0000",
        message: "Client mqtt connection not created or closed",
        secondary_message: "Mqtt gateway could not find connection to user for sending notification",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:03:56.000+0000",
        const_partition: "1",
        docs: "## Error - 52071\r\n\r\n### RtdNotification: Internal error when sending notification via mqtt client connection\r\n\r\n#### Possible Causes \r\n*  Temporary outage of client connection mqtt gateway.\r\n\r\n#### Possible Solutions\r\n*  Ask customer support for investigation. ",
        code: 52071,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:44:34.000+0000",
        message: "Internal error when sending notification via mqtt client connection",
        secondary_message: "An unexpected error has happened in notification flow via mqtt client connection",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:02:55.000+0000",
        const_partition: "1",
        docs: "## Warning - 52052\r\n\r\n### Client connection not found\r\n\r\n#### Possible Causes \r\n*  Client connection not found.\r\n\r\n#### Possible Solutions\r\n*  No action needed. The client will automatically reconnect when possible.",
        code: 52052,
        log_level: "WARNING",
        last_updated: "2017-12-27T12:38:18.000+0000",
        message: "Client connection not created or closed",
        secondary_message: "Websocket gateway could not find connection to user for sending notification",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:02:09.000+0000",
        const_partition: "1",
        docs: "## Error - 52051\r\n\r\n### Internal error when sending notification via client connection\r\n\r\n#### Possible Causes \r\n*  Our client connection gateway is potentially unavailable. We apologize.\r\n\r\n#### Possible Solutions\r\n* Check our [status page](http://status.twilio.com) to see if we are having an outage. \r\n* If our status page has no information, [contact support](https://www.twilio.com/help/contact) with details about the requests that are failing, and we will investigate.",
        code: 52051,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:38:00.000+0000",
        message: "Internal error when sending notification via client connection",
        secondary_message: "An unexpected error has happened in notification flow via realtime client connection",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:01:14.000+0000",
        const_partition: "1",
        docs: "## Error - 52003\r\n\r\n### Invalid Credential Type\r\n\r\n#### Possible Causes \r\n*  Type of credential provided in access token does not match that of the registration. For example you included the SID of a APS type Credential in the access token for an Android application using GCM.\r\n\r\n#### Possible Solutions\r\n*  Make sure you provide the right Credential SID in the access token.",
        code: 52003,
        log_level: "ERROR",
        last_updated: "2017-10-30T10:19:55.000+0000",
        message: "Invalid Credential Type",
        secondary_message: "Credential type and binding type does not match",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T15:00:27.000+0000",
        const_partition: "1",
        docs: "## Error - 52002\r\n\r\n### Invalid Credential Sid\r\nIn order to send push notifications to iOS and Android devices you need to configure a Credential that allows Twilio to send notifications to your app. \r\n\r\nYou can configure these at different places depending on which Twilio product you use:\r\n\r\n* Chat: Configure in access token\r\n* Notify: Configure default Credential in Notify Service or Binding specific one in Binding\r\n* Voice SDK: Configure in access token\r\n\r\n#### Possible Causes \r\n*   Credential SID is not configured correctly\r\n\r\n#### Possible Solutions\r\n* If using Chat include Credential SID in access token. Check out this [guide](https://www.twilio.com/docs/api/ip-messaging/guides/push-notifications-ios)\r\n*  If using Notify, either configure default Credential SID in your [Service](https://www.twilio.com/console/notify/services) or provide the Credential SID in the [Create Binding](https://www.twilio.com/docs/api/notify/rest/bindings#create-a-binding) request\r\n* If using Voice SDK, include Credential SID in access token. Check out our [documentation](https://www.twilio.com/docs/api/voice-sdk) for details",
        code: 52002,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:37:30.000+0000",
        message: "Invalid Credential Sid",
        secondary_message: "Provided credential sid is invalid or empty",
        product: "Notifications",
    },
    {
        date_created: "2016-04-19T14:59:35.000+0000",
        const_partition: "1",
        docs: "## Error - 52000\r\n\r\n### Internal error\r\n\r\n#### Possible Causes \r\n*  An internal error has occurred that prevented Twilio from processing of your request.\r\n\r\n#### Possible Solutions\r\n* Check our [status page](http://status.twilio.com) to see if we are having an outage. \r\n* If our status page has no information, [contact support](https://www.twilio.com/help/contact) with details about the requests that are failing, and we will investigate.",
        code: 52000,
        log_level: "ERROR",
        last_updated: "2017-12-27T12:37:11.000+0000",
        message: "Internal notification error",
        secondary_message: "Internal error is inside of notification services",
        product: "Notifications",
    },
    {
        date_created: "2016-04-15T11:23:18.000+0000",
        const_partition: "1",
        docs: "## Error - 50207\r\n\r\n### Programmable Chat: Identity too long\r\n\r\n#### Possible Causes \r\n*  Specified User's Identity parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length User's Identity is being passed in request. ",
        code: 50207,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:58:29.000+0000",
        message: "Programmable Chat: Identity too long",
        secondary_message: "Specified User's Identity parameter is too long",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-04-15T11:22:50.000+0000",
        const_partition: "1",
        docs: "## Error - 50206\r\n\r\n### Programmable Chat: Identity should not match user SID pattern\r\n\r\n#### Possible Causes \r\n*  Specified User's Identity matches User SID Pattern \"US[0-9a-f]{32}\".\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid User's Identity is being passed in request. ",
        code: 50206,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:58:36.000+0000",
        message: "Programmable Chat: Identity should not match user SID pattern",
        secondary_message: 'Specified User\'s Identity matches User SID Pattern "US[0-9a-f]{32}"',
        product: "Programmable Chat",
    },
    {
        date_created: "2016-04-15T11:19:12.000+0000",
        const_partition: "1",
        docs: '## Error - 50000\r\n\r\n### Programmable Chat: FriendlyName not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required "FriendlyName" parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid FriendlyName is being passed in request. ',
        code: 50000,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:05:18.000+0000",
        message: "Programmable Chat: FriendlyName not provided",
        secondary_message: 'Request does not contain required "FriendlyName" parameter.',
        product: "Programmable Chat",
    },
    {
        date_created: "2016-04-11T20:56:00.000+0000",
        const_partition: "1",
        docs: "## Error - 32210\r\n\r\n###  SIP: Registration not supported\r\n\r\n#### Possible Causes \r\n*    Registration is not enabled for the SIP domain\r\n\r\n#### Possible Solutions\r\n*   Enable registration for the SIP domain.",
        code: 32210,
        log_level: "ERROR",
        last_updated: "2016-04-11T20:56:00.000+0000",
        message: "SIP: Register not supported",
        secondary_message: "Registration is not enabled for the SIP domain",
        product: "Programmable Voice",
    },
    {
        date_created: "2016-04-01T20:24:55.000+0000",
        const_partition: "1",
        docs: "This account is currently not in an active state\r\n\r\n#### Possible causes\r\n\r\n* Account is suspended\r\n",
        code: 90010,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:28:33.000+0000",
        message: "Account is not active",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2016-04-01T14:31:42.000+0000",
        const_partition: "1",
        docs: "# Error - 20403\r\n\r\n## Forbidden\r\n\r\nThe account lacks permission to access the Twilio API. Typically this means\r\nthe account has been suspended or closed. For assistance, [please contact support](mailto:help@twilio.com).",
        code: 20403,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:49:32.000+0000",
        message: "403 Forbidden",
        secondary_message: "Forbidden",
        product: "Platform",
    },
    {
        date_created: "2016-04-01T11:43:41.000+0000",
        const_partition: "1",
        docs: "## Error - 50057\r\n\r\n### Programmable Chat: Webhook call failed to execute successfully\r\n\r\n#### Possible Causes \r\n*  The Webhook endpoint called returned an error code\r\n\r\n#### Possible Solutions\r\n* Check your Webhook execution logic to ensure it is processing the webhook calls correctly and passing back 200 OK",
        code: 50057,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:03:55.000+0000",
        message: "Programmable Chat: Webhook call failed to execute successfully",
        secondary_message: "The event triggered webhook call failed to execute successfully",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-04-01T07:02:07.000+0000",
        const_partition: "1",
        docs: "# Error - 20107\r\n\r\n## Invalid Access Token signature\r\n\r\nThe signature for the Access Token provided was invalid.\r\n\r\nCheck that your code is correctly generating signatures using the algorithm and format expected by the Twilio API.\r\n\r\nTo check whether the Access Token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nAccess Tokens are used by multiple Twilio SDKs, including Programmable Voice, Programmable Video, and Programmable Chat. For the details of Twilio's specific Access Token implementation, see [the documentation](/docs/api/rest/access-tokens).\r\n\r\n### Possible Causes\r\n\r\n* The supplied Account SID, API Key or API Secret is incorrect.\r\n\r\n### Possible Solutions\r\n\r\n* Ensure you're using the correct Account SID for your [Live API Credentials](/console/account/settings).\r\n* Verify the API Key was generated for the same account as the supplied Account SID. (The API Secret is not the same as the Account Auth Token.)\r\n* Verify the API Secret is correct for the API Key being used and that no extra characters are included.\r\n* Check if the API Secret passes signature validation when used at [jwt.io](https://jwt.io/).\r\n* Generate a new API Key and Secret for the Account SID and try again.",
        code: 20107,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:51:05.000+0000",
        message: "Invalid Access Token signature",
        secondary_message: "Invalid Access Token signature",
        product: "Platform",
    },
    {
        date_created: "2016-04-01T07:00:25.000+0000",
        const_partition: "1",
        docs: "# Error - 20106\r\n\r\n## Invalid Access Token grants\r\n\r\nThe Access Token signature and issuer were valid, but the grants specified\r\nin the token were invalid, unparseable, or did not authorize the action\r\nbeing requested.\r\n\r\nTo check whether the Access Token is structurally correct,\r\nyou can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio's specific Access Token implementation including the\r\ngrant format, see\r\n[the documentation](/docs/api/rest/access-tokens).",
        code: 20106,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:51:25.000+0000",
        message: "Invalid Access Token grants",
        secondary_message: "Invalid Access Token grants",
        product: "Platform",
    },
    {
        date_created: "2016-04-01T06:57:16.000+0000",
        const_partition: "1",
        docs: "# Error - 20105\r\n\r\n## Access Token not yet valid\r\n\r\nThe Access Token provided to the Twilio API is not yet valid.\r\n\r\nTwilio Access Tokens are generated with a `nbf` field that determines the\r\nstart of the token's lifetime. Normally this is set to the current time\r\nwhen the token is generated; check whether your computer's clock has drifted.\r\n\r\nTo check whether the Access Token is structurally correct,\r\nyou can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio's specific Access Token implementation and the\r\nrequirements of the issuer and subject fields, see [the\r\ndocumentation](/docs/api/rest/access-tokens).",
        code: 20105,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:51:36.000+0000",
        message: "Access Token not yet valid",
        secondary_message: "Access Token not yet valid",
        product: "Platform",
    },
    {
        date_created: "2016-04-01T06:53:53.000+0000",
        const_partition: "1",
        docs: "# Warning - 20104\r\n\r\n## Access Token has expired or expiration date is invalid\r\n\r\nThe Access Token provided to the Twilio API has expired, the expiration time\r\nspecified in the token was invalid, or the expiration time specified was too\r\nfar in the future.\r\n\r\nAccess Token expiration times can be set up to 24 hours in the future.\r\n\r\nTo check whether the Access Token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nAccess Tokens are used by multiple Twilio SDKs, including Programmable Voice, Programmable Video, and Programmable Chat. For the details of Twilio's specific Access Token implementation, see [the documentation](/docs/api/rest/access-tokens).",
        code: 20104,
        log_level: "WARNING",
        last_updated: "2018-06-18T22:51:45.000+0000",
        message: "Access Token expired or expiration date invalid",
        secondary_message: "Access Token has expired or expiration date is invalid",
        product: "Platform",
    },
    {
        date_created: "2016-04-01T06:51:44.000+0000",
        const_partition: "1",
        docs: "# Error - 20103\r\n\r\n## Invalid Access Token issuer or subject\r\n\r\nThe issuer or subject of the Access Token provided to the Twilio API was\r\ninvalid.\r\n\r\n**Issuer:** The [API Key](/docs/api/rest/keys) used to sign the the token.\r\n\r\n**Subject:** The Twilio Account SID from your [Live Credentials](/console/account/settings).\r\n\r\n### Possible Causes\r\n* Account is inactive or suspended.\r\n* Account SID is incorrect.\r\n* API Key is incorrect or has been deleted.\r\n\r\n### Possible Solutions\r\n\r\n* Ensure the account is active and there are enough funds available.\r\n* Ensure the Account SID is correct and is from your Live Credentials.\r\n* Make sure that the API Key used to sign the request is correct and associated with the supplied Account SID.\r\n\r\nTo check whether the Access Token is structurally correct, you can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nAccess Tokens are used by multiple Twilio SDKs, including Programmable Voice, Programmable Video, and Programmable Chat. For the details of Twilio's specific Access Token implementation and the requirements of the issuer and subject fields, see [the documentation](/docs/api/rest/access-tokens).",
        code: 20103,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:51:51.000+0000",
        message: "Invalid Access Token issuer/subject",
        secondary_message: "Invalid Access Token issuer or subject",
        product: "Platform",
    },
    {
        date_created: "2016-04-01T06:49:49.000+0000",
        const_partition: "1",
        docs: "# Error - 20102\r\n\r\n## Invalid Access Token header\r\n\r\nThe header of the Access Token provided to the Twilio API was\r\ninvalid.\r\n\r\nTo check whether the Access Token is structurally correct,\r\nyou can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio's specific Access Token implementation and the header\r\nrequirements, see [the documentation](/docs/api/rest/access-tokens).\r\n",
        code: 20102,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:52:00.000+0000",
        message: "Invalid Access Token header",
        secondary_message: "Invalid Access Token header",
        product: "Platform",
    },
    {
        date_created: "2016-04-01T06:43:22.000+0000",
        const_partition: "1",
        docs: "# Error - 20101\r\n\r\n## Twilio was unable to validate your Access Token\r\n\r\nThe Access Token provided to the Twilio API was invalid.\r\n\r\nTo check whether the Access Token is structurally correct,\r\nyou can use the tools available at [jwt.io](https://jwt.io/).\r\n\r\nFor the details of Twilio's specific Access Token implementation, see\r\n[the documentation](/docs/api/rest/access-tokens).\r\n",
        code: 20101,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:52:10.000+0000",
        message: "Invalid Access Token",
        secondary_message: "Twilio was unable to validate your Access Token",
        product: "Platform",
    },
    {
        date_created: "2016-03-31T17:14:56.000+0000",
        const_partition: "1",
        docs: "## Warning - 51006\n\n### Client Connection: Connection expired\n\n#### Possible Causes \n\nThe connection has expired. The connection expiration is set by the `exp` field of the Access Token.\n\n#### Possible Solutions\n\nMake sure clients refresh Access Tokens before they expire. Please, refer to the Twilio SDK documentation for further details.\n\n",
        code: 51006,
        log_level: "error",
        last_updated: "2016-03-31T17:14:56.000+0000",
        message: "Client Connection: Connection expired",
        secondary_message: "warning",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:55.000+0000",
        const_partition: "1",
        docs: "## Warning - 51005\n\n### Client Connection: Command or keepalive acknowledgement not received\n\n#### Possible Causes \n\nThe client did not acknowledge a message or a keep-alive request, which is required by the connection protocol therefore the connection has been dropped. This is most often caused by network connectivity issues.\n\n#### Possible Solutions\n\nTwilio SDKs automatically recover and reestablish the connection if possible. \nFor best user experience, ensure reliable network connectivity.\n",
        code: 51005,
        log_level: "error",
        last_updated: "2016-03-31T17:14:55.000+0000",
        message: "Client Connection: Command or keepalive acknowledgement not received",
        secondary_message: "warning",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:55.000+0000",
        const_partition: "1",
        docs: "## Error - 51004\n\n### Client Connection: `endpoint_id` string too long\n\n#### Possible Causes \n\n`endpoint_id` field in the Access Token is too long.\n\n#### Possible Solutions\n\nConsult the product documentation for maximum allowed length of `endpoint_id` field.\n",
        code: 51004,
        log_level: "error",
        last_updated: "2016-03-31T17:14:55.000+0000",
        message: "Client Connection: endpoint_id too long",
        secondary_message: "error",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:55.000+0000",
        const_partition: "1",
        docs: "## Error - 51003\n\n### Client Connection: `identity` too long\n\n#### Possible Causes \n\n`identity` field in the Access Token is too long.\n\n#### Possible Solutions\n\nConsult the product documentation for maximum allowed length of `identity` field.\n",
        code: 51003,
        log_level: "error",
        last_updated: "2016-03-31T17:14:55.000+0000",
        message: "Client Connection: identity too long",
        secondary_message: "error",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:54.000+0000",
        const_partition: "1",
        docs: "## Error - 51002\n\n### Client Connection: Request rate limit exceeded\n\n#### Possible Causes \n\nThe rate of client requests exceeded the limit.\n\n#### Possible Solutions\n\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your Account's client request limit.\n",
        code: 51002,
        log_level: "error",
        last_updated: "2016-03-31T17:14:54.000+0000",
        message: "Client Connection: Request rate limit exceeded",
        secondary_message: "error",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:54.000+0000",
        const_partition: "1",
        docs: "## Error - 51001\r\n\r\n### Client Connection: Connections resource limit exceeded\r\n\r\n#### Possible Causes \r\n\r\nThe rate of client connection requests or the number of concurrent connections exceeded the limit.\r\n\r\n#### Possible Solutions\r\n\r\nVerify that your application is not misbehaving and the load is expected. If everything is as expected then contact Customer Support to increase your Account's limits.\r\n\r\n",
        code: 51001,
        log_level: "ERROR",
        last_updated: "2019-03-21T12:14:09.000+0000",
        message: "Client Connection: Connections resource limit exceeded",
        secondary_message: "error",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:54.000+0000",
        const_partition: "1",
        docs: "## Error - 50601\r\n\r\n### Programmable Chat: Invite not found\r\n\r\n#### Possible Causes \r\n*  Specified Invite does not exist. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Invite is being passed in request. ",
        code: 50601,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:54:09.000+0000",
        message: "Programmable Chat: Invite not found",
        secondary_message: "Specified Invite does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:54.000+0000",
        const_partition: "1",
        docs: "## Error - 50600\r\n\r\n### Programmable Chat: Invite SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Invite SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Invite SID is being passed in request. ",
        code: 50600,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:54:19.000+0000",
        message: "Programmable Chat: Invite SID not provided",
        secondary_message: "Request does not contain required Invite SID parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:53.000+0000",
        const_partition: "1",
        docs: "## Error - 50503\r\n\r\n### Programmable Chat: Message body not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Message Body parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Message Body is being passed in request. ",
        code: 50503,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:55:29.000+0000",
        message: "Programmable Chat: Message body not provided",
        secondary_message: "Request does not contain required Message Body parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:53.000+0000",
        const_partition: "1",
        docs: "## Error - 50502\r\n\r\n### Programmable Chat: Message index not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Message Index parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Message Index is being passed in request. ",
        code: 50502,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:55:37.000+0000",
        message: "Programmable Chat: Message index not provided",
        secondary_message: "Request does not contain required Message Index parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:53.000+0000",
        const_partition: "1",
        docs: "## Error - 50501\r\n\r\n### Programmable Chat: Message SID not provided\t\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Message SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Message SID is being passed in request. ",
        code: 50501,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:55:43.000+0000",
        message: "Programmable Chat: Message SID not provided",
        secondary_message: "Request does not contain required Message SID parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:52.000+0000",
        const_partition: "1",
        docs: "## Error - 50500\r\n\r\n### Programmable Chat: Message not found\t\r\n\r\n#### Possible Causes \r\n*  Specified Message does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Message is being passed in request. ",
        code: 50500,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:55:50.000+0000",
        message: "Programmable Chat: Message not found",
        secondary_message: "Specified Message does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:52.000+0000",
        const_partition: "1",
        docs: "## Error - 500402\r\n\r\n### Programmable Chat: Member not found\r\n\r\n#### Possible Causes \r\n*  Specified Member does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Member is being passed in request. ",
        code: 50402,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:56:30.000+0000",
        message: "Programmable Chat: Member not found",
        secondary_message: "Specified Member does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:52.000+0000",
        const_partition: "1",
        docs: "## Error - 50401\r\n\r\n### Programmable Chat: Member SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Member SID parameter. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Member SID is being passed in request. ",
        code: 50401,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:13:20.000+0000",
        message: "Programmable Chat: Member SID not provided",
        secondary_message: "Request does not contain required Member SID parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:52.000+0000",
        const_partition: "1",
        docs: "## Error - 50400\r\n\r\n### Programmable Chat: User not member of channel\r\n\r\n#### Possible Causes \r\n*  Specified User is not member of this Channel.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid User who is Member of this Channel is being passed in request. ",
        code: 50400,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:13:12.000+0000",
        message: "Programmable Chat: User not member of channel",
        secondary_message: "Specified User is not member of this Channel.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:51.000+0000",
        const_partition: "1",
        docs: "## Error - 50307\r\n\r\n### Programmable Chat: Channel with provided unique name already exists\t\r\n\r\n#### Possible Causes \r\n*  Specified Channel's Unique Name already exists in this Service deployment.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid non-existing Channel's Unique Name is being passed in request. ",
        code: 50307,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:57:16.000+0000",
        message: "Programmable Chat: Channel with provided unique name already exists",
        secondary_message: "Specified Channel's Unique Name already exists in this Service deployment.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:51.000+0000",
        const_partition: "1",
        docs: "## Error - 50306\r\n\r\n### Programmable Chat: Unique name should not match channel SID pattern\r\n\r\n#### Possible Causes \r\n*  Specified Channel's Unique Name matches Channel SID Pattern \"CH[0-9a-f]{32}\".\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel's Unique Name is being passed in request. ",
        code: 50306,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:57:23.000+0000",
        message: "Programmable Chat: Unique name should not match channel SID pattern",
        secondary_message: 'Specified Channel\'s Unique Name matches Channel SID Pattern "CH[0-9a-f]{32}".',
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:51.000+0000",
        const_partition: "1",
        docs: "## Error - 50305\r\n\r\n### Programmable Chat: Channel SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Channel SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel SID is being passed in request. ",
        code: 50305,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:57:33.000+0000",
        message: "Programmable Chat: Channel SID not provided",
        secondary_message: "Request does not contain required Channel SID parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:50.000+0000",
        const_partition: "1",
        docs: "## Error - 50304\r\n\r\n### Programmable Chat: Attributes not valid JSON\t \r\n\r\n#### Possible Causes \r\n*  Specified Channel's Attributes are not valid JSON.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel's Attributes in JSON format are being passed in request. ",
        code: 50304,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:57:41.000+0000",
        message: "Programmable Chat: Attributes not valid JSON",
        secondary_message: "Specified Channel's Attributes are not valid JSON.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:50.000+0000",
        const_partition: "1",
        docs: "## Error - 50303\r\n\r\n### Programmable Chat: Attributes too long\r\n\r\n#### Possible Causes \r\n*  Specified Channel's Attributes parameter is too long.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid length Channel's Attributes is being passed in request. ",
        code: 50303,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:12:59.000+0000",
        message: "Programmable Chat: Attributes too long",
        secondary_message: "Specified Channel's Attributes parameter is too long.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:50.000+0000",
        const_partition: "1",
        docs: "## Error - 50302\r\n\r\n### Programmable Chat: Unknown channel command\r\n\r\n#### Possible Causes \r\n*  Specified Channel Command does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel Command is being passed in request. ",
        code: 50302,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:57:48.000+0000",
        message: "Programmable Chat: Unknown channel command",
        secondary_message: "Specified Channel Command does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:50.000+0000",
        const_partition: "1",
        docs: "## Error - 50301\r\n\r\n### Programmable Chat: Channel key not provided\t\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Channel SID or Channel's Unique Name parameters.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel SID or Channel's Unique Name is being passed in request. ",
        code: 50301,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:57:55.000+0000",
        message: "Programmable Chat: Channel key not provided",
        secondary_message: "Request does not contain required Channel SID or Channel's Unique Name parameters.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:49.000+0000",
        const_partition: "1",
        docs: "## Error - 50300\r\n\r\n### Programmable Chat: Channel not found\r\n\r\n#### Possible Causes \r\n*  Specified Channel does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel is being passed in request. ",
        code: 50300,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:58:02.000+0000",
        message: "Programmable Chat: Channel not found",
        secondary_message: "Specified Channel does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:49.000+0000",
        const_partition: "1",
        docs: "## Error - 50205\r\n\r\n### Programmable Chat: User unauthorized to set role\r\n\r\n#### Possible Causes \r\n*  Specified User does not have Role or Permissions to set the Role.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid User having valid Role and Permissions is being passed in request. ",
        code: 50205,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:59:45.000+0000",
        message: "Programmable Chat: User unauthorized to set role",
        secondary_message: "Specified User does not have Role or Permissions to set the Role.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:49.000+0000",
        const_partition: "1",
        docs: '## Error - 50204\r\n\r\n### Programmable Chat: Identity not provided\t\r\n\r\n#### Possible Causes \r\n*  Request does not contain required "Identity" parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid "Identity" parameter is being passed in request. ',
        code: 50204,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:59:53.000+0000",
        message: "Programmable Chat: Identity not provided",
        secondary_message: 'Request does not contain required "Identity" parameter.',
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:49.000+0000",
        const_partition: "1",
        docs: "## Error - 50203\r\n\r\n### Programmable Chat: Identity reserved\t \r\n\r\n#### Possible Causes \r\n*  Specified identity is reserved for internal use.\r\n\r\n#### Possible Solutions\r\n*  Choose different valid identity and provide it in request. ",
        code: 50203,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:12:46.000+0000",
        message: "Programmable Chat: Identity reserved",
        secondary_message: "Specified identity is reserved for internal use.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:48.000+0000",
        const_partition: "1",
        docs: "## Error - 50202\r\n\r\n### Programmable Chat: User SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required User SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid User SID is being passed in request. ",
        code: 50202,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:00:12.000+0000",
        message: "Programmable Chat: User SID not provided",
        secondary_message: "Request does not contain required User SID parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:48.000+0000",
        const_partition: "1",
        docs: "## Error - 50201\r\n\r\n### Programmable Chat: User already exists\r\n\r\n#### Possible Causes \r\n*  Specified User already exists for this Service.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid non-existing User is being passed in request. ",
        code: 50201,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:00:18.000+0000",
        message: "Programmable Chat: User already exists",
        secondary_message: "Specified User already exists for this Service.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:48.000+0000",
        const_partition: "1",
        docs: "## Error - 50200\r\n\r\n### Programmable Chat: User not found\r\n\r\n#### Possible Causes \r\n*  Specified User does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid User is being passed in request. ",
        code: 50200,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:00:26.000+0000",
        message: "Programmable Chat: User not found",
        secondary_message: "Specified User does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:48.000+0000",
        const_partition: "1",
        docs: "## Error - 50107\r\n\r\n### Programmable Chat: User not authorized for command\t\r\n\r\n#### Possible Causes \r\n*  Specified User is not authorized for this command due to his Role or Permissions set.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Role and Permissions exist for this User to execute request's provided command. ",
        code: 50107,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:00:34.000+0000",
        message: "Programmable Chat: User not authorized for command",
        secondary_message: "Specified User is not authorized for this command due to his Role or Permissions set.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:47.000+0000",
        const_partition: "1",
        docs: "## Error - 50106\r\n\r\n### Programmable Chat: Channel creator role not found\r\n\r\n#### Possible Causes \r\n*  Valid Channel Creator Role does not exist in this service deployment.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel Creator Role exists in this service deployment. ",
        code: 50106,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:10:13.000+0000",
        message: "Programmable Chat: Channel creator role not found",
        secondary_message: "Valid Channel Creator Role does not exist in this service deployment.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:47.000+0000",
        const_partition: "1",
        docs: "## Error - 50105\r\n\r\n### Programmable Chat: Invalid role type\t\r\n\r\n#### Possible Causes \r\n*  Specified Role Type does not exist. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Role Type is being passed in request. ",
        code: 50105,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:00:43.000+0000",
        message: "Programmable Chat: Invalid role type",
        secondary_message: "Specified Role Type does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:47.000+0000",
        const_partition: "1",
        docs: "## Error - 50104\r\n\r\n### Programmable Chat: Permission not found\t\r\n\r\n#### Possible Causes \r\n*  Specified Permission does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Permission is being passed in request. ",
        code: 50104,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:00:53.000+0000",
        message: "Programmable Chat: Permission not found",
        secondary_message: "Specified Permission does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:47.000+0000",
        const_partition: "1",
        docs: "## Error - 50103\r\n\r\n### Programmable Chat: Role SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Role SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Role SID is being passed in request. ",
        code: 50103,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:12:32.000+0000",
        message: "Programmable Chat: Role SID not provided",
        secondary_message: "Request does not contain required Role SID parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:46.000+0000",
        const_partition: "1",
        docs: "## Error - 50102\r\n\r\n### Programmable Chat: Deployment role not found\t\r\n\r\n#### Possible Causes \r\n*  Specified Deployment Role does not exist. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Deployment Role is being passed in request. ",
        code: 50102,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:01:09.000+0000",
        message: "Programmable Chat: Deployment role not found",
        secondary_message: "Specified Deployment Role does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:46.000+0000",
        const_partition: "1",
        docs: "## Error - 50101\r\n\r\n### Programmable Chat: Channel role not found\r\n\r\n#### Possible Causes \r\n*  Specified Channel Role does not exist. \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Channel Role is being passed in request. ",
        code: 50101,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:01:16.000+0000",
        message: "Programmable Chat: Channel role not found",
        secondary_message: "Specified Channel Role does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:46.000+0000",
        const_partition: "1",
        docs: "## Error - 50100\r\n\r\n### Programmable Chat: Role not found\r\n\r\n#### Possible Causes \r\n*  Specified Role does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Role is being passed in request. ",
        code: 50100,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:02:59.000+0000",
        message: "Programmable Chat: Role not found",
        secondary_message: "Specified Role does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:46.000+0000",
        const_partition: "1",
        docs: '## Error - 50056\r\n\r\n### Programmable Chat: Webhook disabled processing of command\r\n\r\n#### Possible Causes \r\n*  Defined webhook returned other than "200 OK" HTTP code and Programmable Chat Service disabled processing of command.\r\n\r\n#### Possible Solutions\r\n*  Confirm that defined webhooks are processing Programmable Chat Service\'s webhook calls correctly. ',
        code: 50056,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:12:17.000+0000",
        message: "Programmable Chat: Webhook disabled processing of command",
        secondary_message: 'Defined webhook returned other than "200 OK" HTTP code and Programmable Chat Service disabled processing of command.',
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:45.000+0000",
        const_partition: "1",
        docs: "## Error - 50055\r\n\r\n### Programmable Chat: Invalid webhook method\r\n\r\n#### Possible Causes \r\n*  Request does not contain valid HTTP method for webhook.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid HTTP method for webhook is being passed in request. ",
        code: 50055,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:12:05.000+0000",
        message: "Programmable Chat: Invalid webhook method",
        secondary_message: "Request does not contain valid HTTP method for webhook.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:45.000+0000",
        const_partition: "1",
        docs: "## Error - 50054\r\n\r\n### Programmable Chat: Invalid webhook format\r\n\r\n#### Possible Causes \r\n*  Request does not contain correctly formatted parameters for webhooks.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid webhook parameters are being passed in request. ",
        code: 50054,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:04:24.000+0000",
        message: "Programmable Chat: Invalid webhook format",
        secondary_message: "Request does not contain correctly formatted parameters for webhooks.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:45.000+0000",
        const_partition: "1",
        docs: "## Error - 50053\r\n\r\n### Programmable Chat: Invalid typing indicator format\r\n\r\n#### Possible Causes \r\n*  Request does not contain valid typing indicator timeout.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid typing indicator timeout is being passed in request. \r\n",
        code: 50053,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:04:31.000+0000",
        message: "Programmable Chat: Invalid typing indicator format",
        secondary_message: "Request does not contain valid typing indicator timeout.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:44.000+0000",
        const_partition: "1",
        docs: "## Error - 50052\r\n\r\n### Programmable Chat: Invalid consumption interval format\t\r\n\r\n#### Possible Causes \r\n*  Request does not contain valid consumption interval.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid consumption interval format is being passed in request. ",
        code: 50052,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:04:37.000+0000",
        message: "Programmable Chat: Invalid consumption interval format",
        secondary_message: "Request does not contain valid consumption interval.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:44.000+0000",
        const_partition: "1",
        docs: "## Error - 50051\r\n\r\n### Programmable Chat: Service SID not provided\r\n\r\n#### Possible Causes \r\n*  Request does not contain required Service SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Service SID is being passed in request. ",
        code: 50051,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:04:44.000+0000",
        message: "Programmable Chat: Service SID not provided",
        secondary_message: "Request does not contain required Service SID parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:44.000+0000",
        const_partition: "1",
        docs: "## Error - 50050\r\n\r\n### Programmable Chat: Service Instance not found\r\n\r\n#### Possible Causes \r\n*  Specified Service Instance does not exist.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Service Instance is being passed in request. ",
        code: 50050,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:04:54.000+0000",
        message: "Programmable Chat: Service Instance not found",
        secondary_message: "Specified Service Instance does not exist.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:43.000+0000",
        const_partition: "1",
        docs: "## Error - 50002\r\n\r\n### Programmable Chat: Resource is being deleted\r\n\r\n#### Possible Causes \r\n*  The resource your request relates to is currently being deleted.\r\n\r\n#### Possible Solutions\r\n*  Try the same request again later.",
        code: 50002,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:11:52.000+0000",
        message: "Programmable Chat: Resource is being deleted",
        secondary_message: "The resource your request relates to is currently being deleted.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:43.000+0000",
        const_partition: "1",
        docs: "## Error - 50001\r\n\r\n### Programmable Chat: Account SID not provided \r\n\r\n#### Possible Causes \r\n*  Request does not contain required Account SID parameter.\r\n\r\n#### Possible Solutions\r\n*  Confirm a valid Account SID is being passed in request.",
        code: 50001,
        log_level: "ERROR",
        last_updated: "2018-06-19T00:05:11.000+0000",
        message: "Programmable Chat: Account SID not provided",
        secondary_message: "Request does not contain required Account SID parameter.",
        product: "Programmable Chat",
    },
    {
        date_created: "2016-03-31T17:14:43.000+0000",
        const_partition: "1",
        docs: '## Error - 40133\r\n\r\n### Call API Error - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  Un-routable address provided for "to" field. \r\n*  Invalid caller-id passed to "from" field. \r\n*  Internal Twilio API error. \r\n\r\n#### Possible Solutions\r\n*  Make certain "to" contains a routable phone number, client URI or SIP URI. \r\n*  Make certain "to" is to a country you have permissions set to call.\r\n*  Make certain "from" contains an acceptable caller ID for the chosen "to" address.\r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "18001234567",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
        code: 40133,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:01:06.000+0000",
        message: "TaskRouter->Dequeue",
        secondary_message: "Dequeue Instruction encountered an error when requesting an outgoing call be made from the API.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:43.000+0000",
        const_partition: "1",
        docs: '## Error - 40132\r\n\r\n### Missing or Invalid \'from\' parameter - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "from" parameter on your \'dequeue\' instruction.\r\n*  You provided an invalid format in your "from" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "from" contains a validated caller ID if you\'re dialing the PSTN. \r\n*  Make certain "from" contains an acceptable caller field when connecting to client or SIP.  \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
        code: 40132,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:01:12.000+0000",
        message: "TaskRouter->Dequeue",
        secondary_message: "Dequeue Instruction does not have a valid 'from' parameter provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:42.000+0000",
        const_partition: "1",
        docs: '## Error - 40131\r\n\r\n### Missing or Invalid \'to\' parameter - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "to" parameter on your \'dequeue\' instruction.\r\n*  You provided an invalid format in your "to" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "to" contains a valid phone number, client URI, or SIP URI. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
        code: 40131,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:01:20.000+0000",
        message: "TaskRouter->Dequeue",
        secondary_message: "Dequeue Instruction does not have a valid 'to' parameter provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:42.000+0000",
        const_partition: "1",
        docs: '## Error - 40130\r\n\r\n### Invalid Activity Sid - Dequeue Instruction\r\n\r\n#### Possible Causes \r\n*  You provided a "post_work_activity_sid"" that was invalid or no longer exists.  \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid ActivitySid is being passed in the "post_work_activity_sid" parameter exists in your workspace. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "dequeue",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"post_work_activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
        code: 40130,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:01:27.000+0000",
        message: "TaskRouter->Dequeue",
        secondary_message: "Dequeue Instruction does not have a valid 'post_work_activity_sid' provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:42.000+0000",
        const_partition: "1",
        docs: '## Error - 40122\r\n\r\n### Call Redirection API Error - Redirect Instruction\r\n\r\n#### Possible Causes \r\n*  The call being redirected is no longer in progress.\r\n*  The call_sid passed doesn\'t reference an actual call\r\n\r\n#### Possible Solutions\r\n*  Make certain "call_sid" is provided an is a 34 char string starting with CA that represents a live call. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "redirect",\r\n\t"call_sid": "CA0123456789abcdef0123456789abcdef",\r\n\t"url": "https://example.com/twiml?querystring=1234"\r\n}\r\n```',
        code: 40122,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:01:41.000+0000",
        message: "TaskRouter->Direct",
        secondary_message: "Direct Instruction encountered an error when redirecting a call via the API.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:41.000+0000",
        const_partition: "1",
        docs: '## Error - 40121\r\n\r\n### Missing or Invalid \'call_sid\' parameter - Redirect Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "call_sid" parameter on your \'redirect\' instruction.\r\n*  You provided an invalid value for the "call_sid" parameter. \r\n\r\n#### Possible Solutions\r\n*  Make certain "call_sid" is provided an is a 34char string starting with CA that represents a live call. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "redirect",\r\n\t"call_sid": "CA0123456789abcdef0123456789abcdef",\r\n\t"url": "https://example.com/twiml?querystring=1234"\r\n}\r\n```',
        code: 40121,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:01:49.000+0000",
        message: "TaskRouter->Direct",
        secondary_message: "Redirect Instruction does not have a valid 'call_sid' parameter provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:41.000+0000",
        const_partition: "1",
        docs: '## Error - 40120\r\n\r\n### Missing or Invalid \'url\' parameter - Redirect Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "url" parameter on your \'redirect\' instruction.\r\n*  You provided an invalid format in your "url" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "url" is provided and contains a well formed HTTP or HTTPS URL. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "redirect",\r\n\t"call_sid": "CA0123456789abcdef0123456789abcdef",\r\n\t"url": "https://example.com/twiml?querystring=1234"\r\n}\r\n```',
        code: 40120,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:01:56.000+0000",
        message: "TaskRouter->Direct",
        secondary_message: "Redirect Instruction does not have a valid 'url' parameter provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:41.000+0000",
        const_partition: "1",
        docs: '## Error - 40113\r\n\r\n### Error Making Outgoing Call - Call Instruction\r\n\r\n#### Possible Causes \r\n*  Un-routable address provided for "to" field. \r\n*  Invalid caller-id passed to "from" field. \r\n*  Poorly formed URL passed to "url" field. \r\n*  Internal Twilio API error.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "to" contains a routable phone number, client URI or SIP URI. \r\n*  Make certain "to" is to a country you have permissions set to call.\r\n*  Make certain "from" contains an acceptable caller ID for the chosen "to" address.\r\n*  Make certain "url" is a valid HTTP/HTTPS URL. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "call",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"url": "https://example.com/twiml"\r\n}\r\n```',
        code: 40113,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:02:10.000+0000",
        message: "TaskRouter->Call",
        secondary_message: "Call Instruction encountered an error when requesting an outgoing call be made from the API.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:40.000+0000",
        const_partition: "1",
        docs: '## Error - 40112\r\n\r\n### Missing or Invalid \'url\' parameter - Call Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "url" parameter on your \'call\' instruction.\r\n*  You provided an invalid format in your "url" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "url" is provided and contains a well formed HTTP or HTTPS URL. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "call",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"url": "https://example.com/twiml?querystring=1234"\r\n}\r\n```',
        code: 40112,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:02:17.000+0000",
        message: "TaskRouter->Call",
        secondary_message: "Call Instruction does not have a valid 'url' parameter provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:40.000+0000",
        const_partition: "1",
        docs: '## Error - 40111\r\n\r\n### Missing or Invalid \'from\' parameter - Call Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "from" parameter on your \'call\' instruction.\r\n*  You provided an invalid format in your "from" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "from" contains a validated caller ID if you\'re dialing the PSTN. \r\n*  Make certain "from" contains an acceptable caller field when connecting to client or SIP.  \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "call",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"url": "https://example.com/twiml"\r\n}\r\n```',
        code: 40111,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:02:25.000+0000",
        message: "TaskRouter->Call",
        secondary_message: "Call Instruction does not have a valid 'from' parameter provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:40.000+0000",
        const_partition: "1",
        docs: '## Error - 40110\r\n\r\n### Missing or Invalid \'to\' parameter - Call Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide a "to" parameter on your \'call\' instruction.\r\n*  You provided an invalid format in your "to" field.  \r\n\r\n#### Possible Solutions\r\n*  Make certain "to" contains a valid phone number, client URI, or SIP URI. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "call",\r\n\t"to": "client:alice",\r\n\t"from": "bob",\r\n\t"url": "https://example.com/twiml"\r\n}\r\n```',
        code: 40110,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:02:33.000+0000",
        message: "TaskRouter->Call",
        secondary_message: "Call Instruction does not have a valid 'to' parameter provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:39.000+0000",
        const_partition: "1",
        docs: '## Error - 40100\r\n\r\n### Invalid Activity Sid - Reject Instruction\r\n\r\n#### Possible Causes \r\n*  You did not provide an "activity_sid" parameter on your \'reject\' instruction.\r\n*  You provided an activity_sid that was invalid or no longer exists.  \r\n\r\n#### Possible Solutions\r\n*  Confirm a valid ActivitySid is being passed in the "activity_sid" parameter. \r\n\r\n#### Example\r\n\r\n```\r\n{\r\n\t"instruction": "reject",\r\n\t"activity_sid": "WA0123456789abcdef0123456789abcdef"\r\n}\r\n```',
        code: 40100,
        log_level: "ERROR",
        last_updated: "2018-06-18T23:02:40.000+0000",
        message: "TaskRouter->Reject",
        secondary_message: "Reject Instruction does not have a valid 'activity_sid' provided.",
        product: "TaskRouter",
    },
    {
        date_created: "2016-03-31T17:14:39.000+0000",
        solutions: "* Please ensure your PBX or end device is configured to send SIP traffic over the TLS transport.\r\n* If you are using SIP registration, your device must be configured to *register* over the TLS protocol. Devices registered over insecure protocols will not be attempted for secure calls.",
        causes: "* Media security is enabled on your SIP domain or trunk, but Twilio received SIP traffic over an insecure protocol, such as UDP or TCP.\r\n* You are using SIP registration, and are attempting to place a secure call to an endpoint where all of the available bindings were registered with an insecure protocol, such as UDP or TCP.",
        description: null,
        const_partition: "1",
        docs: "## ERROR - 32209\r\n\r\n### SIP: Secure transport required\r\n\r\nWhen secure calling is enabled, Twilio cannot accept calls made using UDP or TCP. Please use TLS. \r\n\r\n#### Possible Causes\r\n* Media security is enabled on your SIP domain or trunk, but Twilio received SIP traffic over an insecure protocol, such as UDP or TCP.\r\n* You are using SIP registration, and are attempting to place a secure call to an endpoint where all of the available bindings were registered with an insecure protocol, such as UDP or TCP.\r\n\r\n#### Possible Solutions\r\n* Please ensure your PBX or end device is configured to send SIP traffic over the TLS transport.\r\n* If you are using SIP registration, your device must be configured to *register* over the TLS protocol. Devices registered over insecure protocols will not be attempted for secure calls.",
        code: 32209,
        log_level: "ERROR",
        last_updated: "2020-01-15T19:00:41.000+0000",
        message: "SIP: Secure transport required",
        log_type: "APPLICATION",
        secondary_message: "When secure calling is enabled, Twilio cannot accept calls made using UDP or TCP. Please use TLS.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:39.000+0000",
        const_partition: "1",
        docs: "## Error - 32208\r\n\r\n###  SIP: Secure media required\r\n\r\n#### Possible Causes \r\n*    This secure SIP trunk cannot accept insecure media (RTP). \r\n\r\n#### Possible Solutions\r\n*  Please use SRTP. See more on [Secure Trunking](/docs/api/sip-trunking/getting-started#securetrunking).",
        code: 32208,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:54:27.000+0000",
        message: "SIP: Secure media required",
        secondary_message: "This secure SIP trunk cannot accept insecure media (RTP). Please use SRTP. See more on [Secure Trunking](/docs/api/sip-trunking/getting-started#securetrunking).",
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2016-03-31T17:14:39.000+0000",
        const_partition: "1",
        docs: "## Error - 32207\r\n\r\n###  SIP: Secure media not accepted\r\n\r\n#### Possible Causes\r\n*    A SIP Call is made to a Twilio SIP Domain using SRTP, which it is not supported\r\n*    A termination Call is made to a Twilio SIP Trunk and the Twilio SIP Trunk is not configured to accept secure media (SRTP). \r\n\r\n#### Possible Solutions\r\n*  Please use RTP.\r\n*  For Twilio Elastic SIP Trunking, if you wish to use SRTP kindly enable [Secure Trunking](/docs/api/sip-trunking/getting-started#securetrunking).\r\n",
        code: 32207,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:54:34.000+0000",
        message: "SIP: Secure media not accepted",
        secondary_message: "Please use RTP. For SIP Trunking if you wish to use SRTP kindly enable [Secure Trunking](/docs/api/sip-trunking/getting-started#securetrunking).",
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2016-03-31T17:14:38.000+0000",
        const_partition: "1",
        docs: "## Error - 32205\r\n\r\n### SIP Trunking: Geo Permission configuration is not permitting call\r\n\r\nYou attempted to initiate an outbound phone call to a phone number that is not enabled on your account. Please check your [Geographic Permissions](https://www.twilio.com/console/voice/calls/geo-permissions), fix it, and try\r\nagain.\r\n",
        code: 32205,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:54:43.000+0000",
        message: "SIP Trunking: Geo Permission configuration is not permitting call",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2016-03-31T17:14:38.000+0000",
        solutions: "Change the callerID used in the From field of the SIP INVITE to a Twilio number on your account or verify your number by visiting the Console [Verified Caller IDs](/user/account/phone-numbers/verified) or REST API.",
        causes: "The `From` number used to make outbound call not a Twilio number or not a verified caller ID",
        description: "You attempted to initiate an outbound phone call, but the <span class='rest-attribute'>From</span> number you specified is not a verified Outgoing Caller ID for your account.  In order to use a phone number as the Caller ID on outgoing calls, you must first validate your ownership of that phone number.",
        const_partition: "1",
        docs: "## ERROR - 32204\r\n\r\n### SIP: 'From' phone number not verified\r\n\r\n You attempted to initiate an outbound phone call, but the <span class='rest-attribute'>From</span> number you specified is not a verified Outgoing Caller ID for your account.  In order to use a phone number as the Caller ID on outgoing calls, you must first validate your ownership of that phone number.\r\n\r\n#### Possible Causes\r\nThe `From` number used to make outbound call not a Twilio number or not a verified caller ID\r\n\r\n#### Possible Solutions\r\nChange the callerID used in the From field of the SIP INVITE to a Twilio number on your account or verify your number by visiting the Console [Verified Caller IDs](/user/account/phone-numbers/verified) or REST API.",
        code: 32204,
        log_level: "ERROR",
        last_updated: "2019-08-16T18:35:04.000+0000",
        message: "SIP: 'From' phone number not verified",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2016-03-31T17:14:38.000+0000",
        const_partition: "1",
        docs: "## Error - 32203\r\n\r\n### SIP Trunking: Call blocked by Twilio blacklist\r\nThe destination number is blocked by Twilio because this destination has a high-risk of fraud or due to regulatory reasons cannot be enabled by default. If you have a legitimate need to call this number, please email help@twilio.com with an explanation of your use case.",
        code: 32203,
        log_level: "ERROR",
        last_updated: "2019-05-08T18:15:24.000+0000",
        message: "SIP: Call blocked by Twilio blacklist",
        secondary_message: null,
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2016-03-31T17:14:38.000+0000",
        const_partition: "1",
        docs: "## Error - 32202\r\n\r\n###  SIP: Bad user credentials\r\n\r\n#### Possible Causes \r\n*  There is a Credentials List on your trunk, and your INVITE\u2019s Authentication Digest is incorrect due to wrong username/password\r\n\r\n#### Possible Solutions\r\n*  Confirm that your username/password matches one in your Credentials List. ",
        code: 32202,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:55:29.000+0000",
        message: "SIP: Bad user credentials",
        secondary_message: "Bad user credentials. Confirm that your username/password matches one in your [Credentials List](/user/account/sip-trunking/authentication/cls).",
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2016-03-31T17:14:37.000+0000",
        const_partition: "1",
        docs: "## Error - 32201\r\n\r\n###  SIP: Source IP address not in ACL\r\n\r\n#### Possible Causes \r\n*  Authorization failure - source IP Address not in ACL (Access Control List).\r\n\r\n#### Possible Solutions\r\n*  There is an ACL on your trunk and you are sending us INVITE requests from an IP address not on that ACL. Either fix local routing so that you are sending us SIP from an address already in your ACL or add this other address to your ACL. ",
        code: 32201,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:55:36.000+0000",
        message: "SIP: Source IP address not in ACL",
        secondary_message: "Authorization failure - source IP Address not in ACL. Either fix local routing so that you are sending us SIP from an address already in your ACL or add this other address to your [ACL](/user/account/sip-trunking/authentication/ip-acls).",
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2016-03-31T17:14:37.000+0000",
        const_partition: "1",
        docs: "## Error - 32200\r\n\r\n###  SIP: Insufficient permissions\r\n\r\n#### Possible Causes \r\n*  Request failed due to insufficient permissions.\r\n\r\n#### Possible Solutions\r\n*  Please check that your account is active. Ensure that you have [Authentication details](/docs/api/sip-trunking/getting-started#authentication) configured on your Trunk.",
        code: 32200,
        log_level: "ERROR",
        last_updated: "2018-06-18T22:55:44.000+0000",
        message: "SIP: Insufficient permissions",
        secondary_message: "Request failed due to insufficient permissions.",
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2016-03-31T17:14:37.000+0000",
        const_partition: "1",
        docs: "## Error - 32103\n\n###  SIP: Empty body\n\n#### Possible Causes \n*  The body of the request was empty, which is not allowed in this context.\n",
        code: 32103,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:37.000+0000",
        message: "SIP: Empty body",
        secondary_message: "The body of the request was empty, which is not allowed in this context.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:37.000+0000",
        const_partition: "1",
        docs: "## Error - 32102\n\n###  SIP: Bad SDP\n\n#### Possible Causes \n*  The SDP is not correctly formatted.\n\n#### Possible Solutions\n*  Please see [RFC 2327 - SDP: Session Description Protocol](https://www.ietf.org/rfc/rfc2327.txt).",
        code: 32102,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:37.000+0000",
        message: "SIP: Bad SDP",
        secondary_message: "The SDP is not correctly formatted.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:36.000+0000",
        const_partition: "1",
        docs: "## Error - 32101\n\n### SIP: Invalid phone number\n\n#### Possible Causes \n*   The called number is not a valid E.164 number.\n\n#### Possible Solutions\n*  Make sure that any phone number sent via SIP to Twilio is always E.164-formatted.",
        code: 32101,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:36.000+0000",
        message: "SIP: Invalid phone number",
        secondary_message: "The called number is not a valid E.164 number. Make sure that any phone number sent via SIP to Twilio is always E.164-formatted.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:36.000+0000",
        const_partition: "1",
        docs: "## Error - 32006\n\n### SIP: Too many hops\n\n#### Possible Causes \n*  The request was rejected because its `Max-Forward` header had reached zero.\n\n#### Possible Solutions\n*  Ensure your infrastructure will send a minimum value of 20 for `Max-Forward` to ensure your call is processed successfully.",
        code: 32006,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:36.000+0000",
        message: "SIP: Too many hops",
        secondary_message: "The request was rejected because its 'Max-Forward' header had reached zero. Ensure your infrastructure will send a minimum value of 20 for 'Max-Forward' to ensure your call is processed successfully.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:36.000+0000",
        const_partition: "1",
        docs: "## Error - 32001\r\n\r\n### SIP: Trunk CPS limit exceeded\r\n\r\n#### Possible Causes \r\n*  Calls Per Second placed against a SIP trunk exceeded its set limit. \r\n\r\n#### Possible Solutions\r\n*  You've exceeded the number of calls per second you are authorized to make on this SIP Trunk. Visit [Elastic SIP Trunks](/user/account/sip-trunking/trunks) and within a specific Trunk, under the `Termination` tab you may see your CPS limits.",
        code: 32001,
        log_level: "ERROR",
        last_updated: "2019-04-05T04:42:01.000+0000",
        message: "SIP: Trunk CPS limit exceeded",
        secondary_message: "Calls Per Second placed against a SIP trunk exceeded its set limit.",
        product: "Elastic SIP Trunking",
    },
    {
        date_created: "2016-03-31T17:14:36.000+0000",
        solutions: "* Increase the MaxPrice parameter value in your API requests.\r\n* Remove the MaxPrice parameter from your API requests.\r\n* Check your message body for any Unicode-only characters such as emojis, glyphs, or curly apostrophes or quotation marks which could cause the message to require additional segments.\r\n* Consider using the [Smart Encoding](https://www.twilio.com/docs/sms/services#smart-encoding) feature of [Messaging Services](https://www.twilio.com/docs/sms/services) to automatically replace [certain Unicode-only characters](https://www.twilio.com/docs/sms/services/copilot-smart-encoding-char-list) with standard GSM equivalents.",
        causes: "* The message price exceeded the MaxPrice you specified in your API request.",
        description: "## Error - 30010\r\n\r\n### Message price exceeds Max Price\r\n\r\nYou provided the [MaxPrice parameter](https://support.twilio.com/hc/en-us/articles/360014170533-Using-MaxPrice-with-Twilio-SMS) in your API request. MaxPrice will prevent a message from sending if it exceeds the price you specified.\r\n\r\nPlease note that SMS pricing is per-segment. SMS messages longer than 160 characters (or longer than 70 characters, if emojis or special characters are used) will require multiple segments. For a detailed explanation of message segmentation and encoding, see [What the Heck is a Segment?](https://www.twilio.com/blog/2017/03/what-the-heck-is-a-segment.html).",
        const_partition: "1",
        docs: "## ERROR - 30010\r\n\r\n### Message price exceeds max price\r\n\r\n ## Error - 30010\r\n\r\n### Message price exceeds Max Price\r\n\r\nYou provided the [MaxPrice parameter](https://support.twilio.com/hc/en-us/articles/360014170533-Using-MaxPrice-with-Twilio-SMS) in your API request. MaxPrice will prevent a message from sending if it exceeds the price you specified.\r\n\r\nPlease note that SMS pricing is per-segment. SMS messages longer than 160 characters (or longer than 70 characters, if emojis or special characters are used) will require multiple segments. For a detailed explanation of message segmentation and encoding, see [What the Heck is a Segment?](https://www.twilio.com/blog/2017/03/what-the-heck-is-a-segment.html).\r\n\r\n#### Possible Causes\r\n* The message price exceeded the MaxPrice you specified in your API request.\r\n\r\n#### Possible Solutions\r\n* Increase the MaxPrice parameter value in your API requests.\r\n* Remove the MaxPrice parameter from your API requests.\r\n* Check your message body for any Unicode-only characters such as emojis, glyphs, or curly apostrophes or quotation marks which could cause the message to require additional segments.\r\n* Consider using the [Smart Encoding](https://www.twilio.com/docs/sms/services#smart-encoding) feature of [Messaging Services](https://www.twilio.com/docs/sms/services) to automatically replace [certain Unicode-only characters](https://www.twilio.com/docs/sms/services/copilot-smart-encoding-char-list) with standard GSM equivalents.",
        code: 30010,
        log_level: "ERROR",
        last_updated: "2019-12-11T23:11:06.000+0000",
        message: "Message price exceeds max price",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:35.000+0000",
        const_partition: "1",
        docs: "## Error - 30009\n\n### Inbound Message - Missing Segment\n\nOne or more segments associated with your multi-part inbound message was not received.",
        code: 30009,
        log_level: "error",
        last_updated: "2016-03-31T17:14:35.000+0000",
        message: "Missing inbound segment",
        secondary_message: "One or more segments associated with your multi-part inbound message was not received.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:35.000+0000",
        const_partition: "1",
        docs: '## Error - 30008\r\n\r\n### Message Delivery - Unknown error\r\n\r\nIf a message you sent is not delivered to the end device and returns a 30008 error code, this means that delivery of your message failed for unknown reasons.\r\n\r\nWhen Twilio receives a very generic error from our carrier partner that we have no further details about, we associate the message with the error code 30008, letting you know that Twilio truly doesn\u2019t know what caused this error from the provider.\r\n\r\n#### Possible Solutions\r\n* Check that the phone you were sending to is turned on and can receive non-Twilio SMS\r\n* Ensure that the phone is not roaming off network. We cannot guarantee message delivery on roaming phones.\r\n* Try sending to other phones who have the same mobile carrier (you can use our Lookups API to determine the carrier if you\u2019re unsure). If messages to other phones go through, the issue is likely device related. Try rebooting the device or contact the mobile carrier for help.\r\n* If you are sending SMS from an alphanumeric sender ID, see if using a Twilio phone number works better. We\u2019ve observed that certain networks may block alpha sender IDs.\r\n* If the recipient number is another Twilio number, ensure that number has an action configured for its Messaging capabilities. Choose any available option like "Webhook" or "TwiML Bin."\r\n* Try sending a shorter message to the phone, with simple content that does not include any special characters. This would give our support team an idea as to whether the failure is related to concatenation or character encoding.\r\n* Twilio support can help investigate what went wrong with our carriers. Please open a support request and include a minimum of 3 or more message SIDs where a 30008 error was thrown. Per our carriers\' requirements, these SIDs can be no older than 48 hours at most.',
        code: 30008,
        log_level: "ERROR",
        last_updated: "2018-01-22T19:48:05.000+0000",
        message: "Unknown error",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:35.000+0000",
        const_partition: "1",
        docs: "## Error - 30007\r\n\r\n### Message Delivery - Carrier violation\r\n\r\nYour message was flagged as objectionable and blocked by the receiving wireless carrier. Some carriers do this to enforce rules or regulations about what types of messaging are allowed to that country or mobile network. Many carriers also have systems in place to protect mobile subscribers from spam or unwanted messages.\r\n\r\nLearn more about how carrier filtering works and how to avoid it: [How Does Carrier Filtering Work?](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work-)\r\n\r\nFor a detailed explanation of carrier filtering in the United States and Canada, please see [SMS Carrier Filtering in the United States and Canada](https://support.twilio.com/hc/en-us/articles/360022449893-SMS-Carrier-Filtering-in-the-United-States-and-Canada).",
        code: 30007,
        log_level: "ERROR",
        last_updated: "2019-05-13T21:49:06.000+0000",
        message: "Carrier violation",
        secondary_message: "Your message content was flagged as going against carrier guidelines.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:34.000+0000",
        const_partition: "1",
        docs: "## Error - 30006\n\n### Message Delivery - Landline or unreachable carrier\n\n#### Possible Causes\n\n*  The destination number is unable to receive this message. Potential reasons\ncould include trying to reach a landline or, in the case of short codes, an\nunreachable carrier.\n",
        code: 30006,
        log_level: "error",
        last_updated: "2016-03-31T17:14:34.000+0000",
        message: "Landline or unreachable carrier",
        secondary_message: "The destination number is unable to receive this message. Potential reasons could include trying to reach a landline or, in the case of short codes, an unreachable carrier.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:34.000+0000",
        const_partition: "1",
        docs: "## Error - 30005\r\n\r\n## Message Delivery - Unknown destination handset\r\n\r\n### Possible Causes \r\n*  The destination number you are trying to reach is unknown and may no longer exist.\r\n*  The device you are trying to reach is not on or does not have sufficient signal.\r\n*  The device cannot receive SMS (for example, the phone number belongs to a landline)\r\n*  There is an issue with the mobile carrier\r\n\r\n### Possible Solutions\r\nThe first step to troubleshooting this issue is to attempt to replicate the problems. Attempt to send another test message to this user via a REST API request, or through the API Explorer in the [Twilio Console](https://www.twilio.com/console/runtime/api-explorer/voice). \r\n\r\nPay close attention to your request and double check to verify you are attempting to send messages to the correct phone number in the correct [E.164](https://www.twilio.com/docs/glossary/what-e164) format: `[+] [country code] [subscriber number including area code]` \r\n\r\nIf you see similar results, continue troubleshooting with the following checklist:\r\n*  Is the destination device powered on?\r\n*  Does the device have sufficient signal? If not power the device off, wait 30 seconds, and then power it back up.\r\n*  Is the device connected to the home carrier's network? We cannot guarantee message delivery on devices roaming off-network.\r\n*  Can the device receive non-Twilio SMS?\r\n*  Can the device receive messages from another Twilio number (non-Alphanumeric Sender ID), or with a shorter one-segment (non-concatenated) body?\r\n*  Can other devices using the same mobile carrier receive your messages?\r\n\r\n#### Continued issues with Error 30005\r\nTwilio's Support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with `Error 30005`, and [open a support request](https://www.twilio.com/console/support/tickets/create).",
        code: 30005,
        log_level: "ERROR",
        last_updated: "2018-09-06T14:59:55.000+0000",
        message: "Unknown destination handset",
        secondary_message: "The destination number you are trying to reach is unknown and may no longer exist.",
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:34.000+0000",
        const_partition: "1",
        docs: '## Error - 30004\r\n\r\n## Message Delivery - Message blocked\r\n\r\n### Possible Causes \r\n*  The destination number you are trying to reach is blocked from receiving this message (e.g., due to blacklisting).\r\n*  The device you are trying to reach does not have sufficient signal.\r\n*  The device cannot receive SMS (for example, the phone number belongs to a landline).\r\n*  The destination number is on India\'s national Do Not Call registry.\r\n*  There is an issue with the mobile carrier.\r\n\r\n### Possible Solutions\r\nThe first step to troubleshooting this issue is to attempt to replicate the problem. Attempt to send another test message to this user via a REST API request or through the API Explorer in the [Twilio Console](https://www.twilio.com/console/runtime/api-explorer/voice). \r\n\r\nIf you see similar results, continue troubleshooting with the following checklist:\r\n*  Is the destination device powered on?\r\n*  Does the device have sufficient signal? If not, power the device off, then wait 30 seconds and then power it back up.\r\n*  Is the device connected to the home carrier\'s network? We cannot guarantee message delivery to devices roaming off-network.\r\n*  Can the device receive non-Twilio SMS?\r\n*  Can the device receive messages from another Twilio number (not using an [Alphanumeric Sender ID](https://www.twilio.com/docs/glossary/what-alphanumeric-sender-id)), or with a shorter one-segment (non-[concatenated](https://support.twilio.com/hc/en-us/articles/223181508-Does-Twilio-support-concatenated-SMS-messages-or-messages-over-160-characters)) body?\r\n*  Can other devices using the same mobile carrier receive your messages?\r\n\r\nIf you can rule out all of the above issues, continue troubleshooting below.\r\n\r\n#### "Undelivered" messages sent to India\r\nError 30004 results on undelivered messages sent to India could be due to the destination number being listed on the national Do Not Call (DNC) registry. \r\n\r\nFor more information on sending messages to India, including links for updating DNC settings, please see our help center article on [limitations for sending SMS to India](https://support.twilio.com/hc/en-us/articles/223134167-Limitations-sending-SMS-messages-to-Indian-mobile-devices).\r\n\r\n#### "Failed" messages\r\nRepeated messages with a `Failed` status and error 30004 results indicate Twilio may be filtering some of your messages internally. \r\n\r\nThis filtering is in place to help protect our customers, and the rules attempt to match what we have observed from the industry. For more details, including potential workarounds, please see our help center article ["How Does Carrier Filtering Work?"](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work)\r\n\r\n#### Continued issues with error 30004\r\nTwilio\'s support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30004, and [open a support request](https://www.twilio.com/console/support/tickets/create).',
        code: 30004,
        log_level: "ERROR",
        last_updated: "2018-09-06T15:00:21.000+0000",
        message: "Message blocked",
        secondary_message: "The destination number you are trying to reach is blocked from receiving this message (e.g. due to blacklisting).",
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:34.000+0000",
        const_partition: "1",
        docs: '## Error - 30003\r\n\r\n## Message Delivery - Unreachable destination handset\r\n\r\n### Possible Causes \r\n*  The destination handset you are trying to reach is switched off or otherwise unavailable.\r\n*  The device you are trying to reach does not have sufficient signal\r\n*  The device cannot receive SMS (for example, the phone number belongs to a landline)\r\n*  There is an issue with the mobile carrier\r\n\r\n### Possible Solutions\r\nThe first step to troubleshooting this issue is to attempt to replicate the problems. Attempt to send another test message to this user via a REST API request, or through the API Explorer in the [Twilio Console](https://www.twilio.com/console/runtime/api-explorer/voice). \r\n\r\nIf you see similar results, continue troubleshooting with the following checklist:\r\n*  Is the destination device powered on?\r\n*  Does the device have sufficient signal? If not power the device off, wait 30 seconds, and then power it back up.\r\n*  Is the device connected to the home carrier\'s network? We cannot guarantee message delivery on devices roaming off-network.\r\n*  Can the device receive non-Twilio SMS?\r\n*  Can the device receive messages from another Twilio number (non-Alphanumeric Sender ID), or with a shorter one-segment (non-concatenated) body?\r\n*  Can other devices using the same mobile carrier receive your messages?\r\n\r\nIf you can rule out all of the above issues, continue troubleshooting below.\r\n\r\n#### Messages sent from short codes\r\nRepeated Error 30003 results on undelivered messages sent from [short codes](https://support.twilio.com/hc/en-us/articles/223182068-What-is-a-Messaging-Short-Code) could occur if the destination user has a wireless plan that does not support short code or "Premium" messages.\r\n\r\nTo workaround these plan limitations, we suggest using the **Fallback to Long Code** feature of [Messaging CoPilot](https://www.twilio.com/copilot). By enabling this feature, CoPilot will attempt first to send your message out using your short code, and then make a second attempt over a [long code](https://www.twilio.com/docs/glossary/what-long-code-phone-number) if necessary. For more details, please see our blog post ["Improve SMS Deliverability with Fallback to Long Code"](https://www.twilio.com/blog/2017/06/improve-sms-deliverability-with-fallback-to-long-code.html).\r\n\r\n**Sprint** customers may be able to whitelist messages sent from your short code by texting the phrase `Allow XXXXX` to **9999**, replacing `XXXXX` with your short code. However, customers from other wireless carriers will likely need to reach out to their carrier\'s support group to enable "Premium" or short code messaging.\r\n\r\n#### Messages sent from long codes\r\nRepeated Error 30003 results on undelivered messages sent from long codes (regular phone numbers) could be due to carrier filtering. \r\n\r\nThe rules for carrier filtering vary throughout the industry, making it difficult at times to pin down exactly why a message is being filtered out. For more details including potential workarounds, please see this Help Center article ["How Does Carrier Filtering Work?"](https://support.twilio.com/hc/en-us/articles/223181848-How-Does-Carrier-Filtering-Work)\r\n\r\n#### Continued Error 30003 issues\r\nTwilio\'s Support team can help investigate what went wrong with delivering your message. Please collect 3 or more message SIDs in your [SMS logs](https://www.twilio.com/console/sms/logs) from the last 24 hours that were flagged with Error 30003, and [open a support request](https://www.twilio.com/console/support/tickets/create).\r\n',
        code: 30003,
        log_level: "ERROR",
        last_updated: "2018-09-06T15:00:45.000+0000",
        message: "Unreachable destination handset",
        secondary_message: "The destination handset you are trying to reach is switched off or otherwise unavailable.",
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:33.000+0000",
        solutions: "*  Please [contact Twilio support](https://www.twilio.com/console/support/tickets/create).\r\n",
        causes: "*  Account was suspended for lack of funds after your message was queued but before it was sent by Twilio.\r\n* Account was suspended because Twilio detected a violation of our Acceptable Use Policy. \r\n",
        description: "This message failed because your account was suspended after this message was queued but before it was sent by Twilio.\r\n",
        const_partition: "1",
        docs: "## ERROR - 30002\r\n\r\n### Account suspended\r\n\r\nYour account was suspended between the time of message send and delivery. Please contact Twilio. This message failed because your account was suspended after this message was queued but before it was sent by Twilio.\r\n\r\n\r\n#### Possible Causes\r\n*  Account was suspended for lack of funds after your message was queued but before it was sent by Twilio.\r\n* Account was suspended because Twilio detected a violation of our Acceptable Use Policy. \r\n\r\n\r\n#### Possible Solutions\r\n*  Please [contact Twilio support](https://www.twilio.com/console/support/tickets/create).\r\n",
        code: 30002,
        log_level: "ERROR",
        last_updated: "2019-10-25T20:52:59.000+0000",
        message: "Account suspended",
        log_type: "TWILIO",
        secondary_message: "Your account was suspended between the time of message send and delivery. Please contact Twilio.",
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:33.000+0000",
        solutions: "* Try sending your message again after waiting for some time.\r\n* Try using a [Messaging Service](https://www.twilio.com/docs/sms/services).\r\n* Talk to Twilio Sales about getting a [Short Code](https://support.twilio.com/hc/en-us/articles/223182068-What-is-a-Messaging-Short-Code-) number that allows you to send more messages per second.",
        causes: "* You tried to send too many messages too quickly and your message queue overflowed.\r\n",
        description: "Twilio queues messages based on the sending rate of a sender or an account. For example a US long code number can send one message [segment](https://www.twilio.com/blog/2017/03/what-the-heck-is-a-segment.html) per second. \r\n\r\nMessages can only be queued for 4 hours and then they automatically fail.\r\nYou can monitor the length on your queue via the [Queue Insights dashboard](https://www.twilio.com/console/sms/insights/queue).\r\n\r\nFor more information please view this [FAQ](https://support.twilio.com/hc/en-us/articles/115002943027-Understanding-Twilio-Rate-Limits-and-Message-Queues). \r\n",
        const_partition: "1",
        docs: "## ERROR - 30001\r\n\r\n### Queue overflow\r\n\r\n Twilio queues messages based on the sending rate of a sender or an account. For example a US long code number can send one message [segment](https://www.twilio.com/blog/2017/03/what-the-heck-is-a-segment.html) per second. \r\n\r\nMessages can only be queued for 4 hours and then they automatically fail.\r\nYou can monitor the length on your queue via the [Queue Insights dashboard](https://www.twilio.com/console/sms/insights/queue).\r\n\r\nFor more information please view this [FAQ](https://support.twilio.com/hc/en-us/articles/115002943027-Understanding-Twilio-Rate-Limits-and-Message-Queues). \r\n\r\n\r\n#### Possible Causes\r\n* You tried to send too many messages too quickly and your message queue overflowed.\r\n\r\n\r\n#### Possible Solutions\r\n* Try sending your message again after waiting for some time.\r\n* Try using a [Messaging Service](https://www.twilio.com/docs/sms/services).\r\n* Talk to Twilio Sales about getting a [Short Code](https://support.twilio.com/hc/en-us/articles/223182068-What-is-a-Messaging-Short-Code-) number that allows you to send more messages per second.",
        code: 30001,
        log_level: "ERROR",
        last_updated: "2019-10-25T21:21:14.000+0000",
        message: "Queue overflow",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:33.000+0000",
        const_partition: "1",
        docs: "## Error - 11751\r\n\r\n### MMS -> Media exceeds mobile operator size limit\r\n\r\nThe specified message media exceeds the maximum size limit for that number's mobile operator.\r\n\r\nFor more details, see [\r\nTwilio Programmable SMS Supported File Types and Size Limits for MMS Media Messages\r\n](https://support.twilio.com/hc/en-us/articles/360018832773-Twilio-Programmable-SMS-Supported-File-Types-and-Size-Limits-for-MMS-Media-Messages).\r\n\r\n#### Possible Solutions\r\n\r\n*   Verify that the specified media is less than 600 KB\r\n",
        code: 11751,
        log_level: "ERROR",
        last_updated: "2019-04-05T02:02:08.000+0000",
        message: "MMS -> Media exceeds mobile operator size limit",
        secondary_message: "The combined size of the media in the message exceeds the maximum size limit for that number's mobile operator. #### Possible Solutions  Verify that the specified media is less than 500 KB",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:32.000+0000",
        const_partition: "1",
        docs: "# Error - 21233\n\n### Domain still has subdomains  \n\nYou cannot delete a domain while subdomains of it exist.  \n",
        code: 21233,
        log_level: "error",
        last_updated: "2016-03-31T17:14:32.000+0000",
        message: "Domain still has subdomains",
        secondary_message: "You cannot delete a domain while subdomains of it exist.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:32.000+0000",
        const_partition: "1",
        docs: "# Error - 21232\n\n### Invalid Domain\n\nThe domain name requested is invalid, already in use or a subdomain of a domain you do not control.  This is likely because the parent domain does not exist or because neither the account sid or its parent account controls the parent domain.\n",
        code: 21232,
        log_level: "error",
        last_updated: "2016-03-31T17:14:32.000+0000",
        message: "Invalid Domain",
        secondary_message: "The domain name requested is invalid, already in use or a subdomain of a domain you do not control.  Please see the response body for more details.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:32.000+0000",
        const_partition: "1",
        docs: "# Warning - 13255\n\n### Dial->Sip: Dialing .sip.twilio.com addresses is not currently allowed\n\nAt this time internal routing of SIP calls within Twilio is not supported i.e. dialing .sip.twilio.com addresses from a Twilio number.",
        code: 13255,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:32.000+0000",
        message: "Dialing .sip.twilio.com addresses is not currently allowed",
        secondary_message: "At this time internal routing of SIP calls within Twilio is not supported i.e. dialing .sip.twilio.com addresses from a Twilio number.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:31.000+0000",
        const_partition: "1",
        docs: "# Error - 21231\n\n### Domain Validation Error\n\nOne of the parameters passed when creating or updating a SIP domain was incorrect.  This may be caused by the IP Access Control List SID already being associated with the Domain.  \n",
        code: 21231,
        log_level: "error",
        last_updated: "2016-03-31T17:14:31.000+0000",
        message: "Domain Validation Error",
        secondary_message: "One of the parameters passed when creating or updating a SIP domain was incorrect.  Please see the response body for more details.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:31.000+0000",
        const_partition: "1",
        docs: "# Error - 21230\n\n### Maximum Domains Reached\n\nAn account cannot have more than 100 domains.",
        code: 21230,
        log_level: "error",
        last_updated: "2016-03-31T17:14:31.000+0000",
        message: "Maximum Domains Reached",
        secondary_message: "An account cannot have more than 100 domains.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:31.000+0000",
        const_partition: "1",
        docs: "## Warning - 13254\n\n### Dial->Sip: SIP URI DNS does not resolve or resolves to an non-public IP address\n\nPlease check your DNS record to ensure it is properly configured. Alternatively, you can use a specific public IP address in your URI rather than specifying a domain.\n",
        code: 13254,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:31.000+0000",
        message: "Dial->Sip: SIP URI DNS does not resolve or resolves to an non-public IP address",
        secondary_message: "Please check your DNS record to ensure it is properly configured. Alternatively, you can use a specific public IP address in your URI rather than specifying a domain.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:30.000+0000",
        const_partition: "1",
        docs: "## Error - 21705\n\n### The Messaging Service is invalid\n\nThe Messaging Service Sid you are using is not valid. \n\n#### Possible Solutions\n*  Double check the Messaging Service Sid parameter that you are using\n\n\n\n\n",
        code: 21705,
        log_level: "error",
        last_updated: "2016-03-31T17:14:30.000+0000",
        message: "The Messaging Service is invalid",
        secondary_message: "The Messaging Service Sid you are using is not valid",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:30.000+0000",
        solutions: "* Add at least one phone number or short code to your Messaging Service, or enable Alphanumeric Sender ID.",
        causes: "* Your Messaging Service does not contain any senders",
        description: "## Error - 21704\r\n\r\n### The Messaging Service contains no senders.\r\n\r\nA Messaging Service requires at least one phone number, Alphanumeric Sender ID or short code to send messages.\r\n\r\n\r\n\r\n\r\n\r\n",
        const_partition: "1",
        docs: "## ERROR - 21704\r\n\r\n### The Messaging Service contains no phone numbers\r\n\r\n ## Error - 21704\r\n\r\n### The Messaging Service contains no senders.\r\n\r\nA Messaging Service requires at least one phone number, Alphanumeric Sender ID or short code to send messages.\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n#### Possible Causes\r\n* Your Messaging Service does not contain any senders\r\n\r\n#### Possible Solutions\r\n* Add at least one phone number or short code to your Messaging Service, or enable Alphanumeric Sender ID.",
        code: 21704,
        log_level: "ERROR",
        last_updated: "2019-12-10T23:40:16.000+0000",
        message: "The Messaging Service contains no phone numbers",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:30.000+0000",
        const_partition: "1",
        docs: "## Error - 20007\n\n### Page size too large\n\nYou've requested a page size that is too large. The maximum page size is 1000.\n\n#### Possible solutions\n\n* Decrease the page size in your request.\n",
        code: 20007,
        log_level: "error",
        last_updated: "2016-03-31T17:14:30.000+0000",
        message: "Page size too large",
        secondary_message: "You\u2019ve requested a page size that is too large. The maximum page size is 1000.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:30.000+0000",
        const_partition: "1",
        docs: '## Error - 11750\r\n\r\n## TwiML response body too large\r\n\r\nIn your response to Twilio\'s request, the response body is larger than 64 kB.\r\n\r\n### Possible Causes \r\n\r\n*   The TwiML that you are serving is larger than 64 kB\r\n*   You are serving non-TwiML content in your response\r\n\r\n### Possible Solutions\r\n\r\n*  Verify that you are serving TwiML in your response to Twilio\'s request. \r\n*  Verify that you are including this header in your TwiML response: `<?xml version="1.0" encoding="UTF-8"?>`  \r\n*  Limit your TwiML response to 64 kB or less.\r\n*  Does your TwiML include the [Play verb](https://www.twilio.com/docs/voice/twiml/play)? Double-check the size of the MP3 file you include and ensure it is 64kb or less.\r\n*  Check that your TwiML is formatted properly. To quickly verify your TwiML, you can copy and paste it into a new [TwiML bin in the Twilio Console](https://www.twilio.com/console/runtime/twiml-bins/create).\r\n*   Check to see if your application is throwing errors. This may cause your application to send a large debug output as HTML back to Twilio instead of the expected TwiML.\r\n*  If you are trying to send a `200` response in a status callback, use an empty TwiML response: `<Response/>`',
        code: 11750,
        log_level: "ERROR",
        last_updated: "2018-09-06T15:55:11.000+0000",
        message: "TwiML response body too large",
        secondary_message: "In your response to Twilio\u2019s request, the response body is larger than 64 kB.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:29.000+0000",
        solutions: "* Add a sender to your Messaging Service with the required capabilities, using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/sms/services/api/phonenumber-resource#create-a-phonenumber-resource).",
        causes: "* You attempted to send a message to a United States or Canada mobile number, but you do not have any US/Canada numbers or short codes in your Messaging Service. US/Canada mobile numbers are not reachable from Twilio numbers from outside the US/Canada, due to limitations imposed by carriers.\r\n* You only have a short code number in your Messaging Service, and the recipient is not reachable from your short code (for example, the To number is from a different country than your short code, or is on a [carrier that does not support short code messaging](https://support.twilio.com/hc/en-us/articles/223182088-What-carriers-are-supported-on-Twilio-short-codes-)).\r\n* You attempted to send an MMS message, but you do not have any US/Canada long code numbers or an [MMS-enabled short code](https://support.twilio.com/hc/en-us/articles/223134667-Sending-receiving-MMS-messages-with-short-codes) in your Messaging Service.\r\n* You only have an [Alphanumeric Sender ID](https://support.twilio.com/hc/en-us/articles/223181348-Getting-started-with-Alphanumeric-Sender-ID) in your Messaging Service, and the To number is in a [country where Alphanumeric Sender ID is unsupported](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).",
        description: "## Error - 21703\r\n\r\n### The Messaging Service does not have a phone number available to send a message.\r\n\r\nNone of the senders or numbers in your Messaging Service are capable of sending the requested message to this recipient.\r\n\r\nPossible causes vary depending on the type of message and the country of the destination number. Below are several common causes of this error.",
        const_partition: "1",
        docs: "## ERROR - 21703\r\n\r\n### The Messaging Service does not have a phone number available to send a message\r\n\r\n ## Error - 21703\r\n\r\n### The Messaging Service does not have a phone number available to send a message.\r\n\r\nNone of the senders or numbers in your Messaging Service are capable of sending the requested message to this recipient.\r\n\r\nPossible causes vary depending on the type of message and the country of the destination number. Below are several common causes of this error.\r\n\r\n#### Possible Causes\r\n* You attempted to send a message to a United States or Canada mobile number, but you do not have any US/Canada numbers or short codes in your Messaging Service. US/Canada mobile numbers are not reachable from Twilio numbers from outside the US/Canada, due to limitations imposed by carriers.\r\n* You only have a short code number in your Messaging Service, and the recipient is not reachable from your short code (for example, the To number is from a different country than your short code, or is on a [carrier that does not support short code messaging](https://support.twilio.com/hc/en-us/articles/223182088-What-carriers-are-supported-on-Twilio-short-codes-)).\r\n* You attempted to send an MMS message, but you do not have any US/Canada long code numbers or an [MMS-enabled short code](https://support.twilio.com/hc/en-us/articles/223134667-Sending-receiving-MMS-messages-with-short-codes) in your Messaging Service.\r\n* You only have an [Alphanumeric Sender ID](https://support.twilio.com/hc/en-us/articles/223181348-Getting-started-with-Alphanumeric-Sender-ID) in your Messaging Service, and the To number is in a [country where Alphanumeric Sender ID is unsupported](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n\r\n#### Possible Solutions\r\n* Add a sender to your Messaging Service with the required capabilities, using the [Twilio Console](https://www.twilio.com/console/sms/services) or the [REST API](https://www.twilio.com/docs/sms/services/api/phonenumber-resource#create-a-phonenumber-resource).",
        code: 21703,
        log_level: "ERROR",
        last_updated: "2019-12-10T23:35:27.000+0000",
        message: "The Messaging Service does not have a phone number available to send a message",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:29.000+0000",
        const_partition: "1",
        docs: "## Error - 21702\n\n### The Messaging Service is not available to send new messages.\n\nThe Messaging Service is not available to send new messages.\n\n#### Possible Solutions\n*  Retry your API call\n",
        code: 21702,
        log_level: "error",
        last_updated: "2016-03-31T17:14:29.000+0000",
        message: "The Messaging Service is not available to send new messages",
        secondary_message: "The Messaging Service is not available to send new messages",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:29.000+0000",
        const_partition: "1",
        docs: "## Error - 21701\n\n### The Messaging Service does not exist.\n\nThe Messaging Service resource you are referencing does not exist\n\n#### Possible Solutions\n*  Double check the Messaging Service Sid parameter that you are using\n\n\n\n",
        code: 21701,
        log_level: "error",
        last_updated: "2016-03-31T17:14:29.000+0000",
        message: "The Messaging Service does not exist",
        secondary_message: "The Messaging Service resource you are referencing does not exist",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:29.000+0000",
        const_partition: "1",
        docs: "## Error - 21623\n\n### Number of media files exceeds allowed limit\n\nThe number of media URLs exceeds the maximum allowed. You may send up to 10 media files in a single message. \n",
        code: 21623,
        log_level: "error",
        last_updated: "2016-03-31T17:14:29.000+0000",
        message: "Number of media files exceeds allowed limit",
        secondary_message: "The number of media URLs exceeds the maximum allowed. You may send up to 10 media files in a single message.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:28.000+0000",
        const_partition: "1",
        docs: "## Error - 21622\n\n### MMS has not been enabled for your account\n\nYour account has not been enabled for picture messaging.  Please [contact support](/help/contact) to send picture messages\n",
        code: 21622,
        log_level: "error",
        last_updated: "2016-03-31T17:14:28.000+0000",
        message: "MMS has not been enabled for your account",
        secondary_message: "Your account has not been enabled for picture messaging. Please contact support to send picture messages.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:28.000+0000",
        const_partition: "1",
        docs: "## Error - 21621\n\n### The \u2018From\u2019 number has not been enabled for MMS messaging\n\nThe \u2018From\u2019 phone number does not appear to be a phone number that you can send MMS messages from\n",
        code: 21621,
        log_level: "error",
        last_updated: "2016-03-31T17:14:28.000+0000",
        message: "The 'From' number has not been enabled for MMS",
        secondary_message: "The 'From' phone number does not appear to be a phone number that you can send MMS messages from.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:28.000+0000",
        const_partition: "1",
        docs: "## Error - 21620\n\n### Invalid media URL(s)\n\nOne or more media URL you provided is invalid.  Please use only valid http and https urls\n",
        code: 21620,
        log_level: "error",
        last_updated: "2016-03-31T17:14:28.000+0000",
        message: "Invalid media URL(s)",
        secondary_message: "One or more media URL you provided is invalid. Please use only valid HTTP and HTTPS URLs.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:27.000+0000",
        const_partition: "1",
        docs: "## Error - 21618\n\n### The message body cannot be sent\n\nYou have attempted to send a message with content that is being filtered by all\nof our carriers.\n\nWe have logged the carrier you are attempting to reach and will monitor these\nfailures when adding new carriers. If we add a new carrier in the future that\ndoes not filter the content you are trying to send, Twilio will automatically\nroute your message through the new carrier.\n",
        code: 21618,
        log_level: "error",
        last_updated: "2016-03-31T17:14:27.000+0000",
        message: "The message body cannot be sent",
        secondary_message: "You have attempted to send a message with content that is being filtered by all of our carriers.  We have logged the carrier you are attempting to reach and will monitor these failures when adding new carriers. If we add a new carrier in the future that does not filter the content you are trying to send, Twilio will automatically route your message through the new carrier.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:27.000+0000",
        const_partition: "1",
        docs: "## Error - 21617\n\n### The concatenated message body exceeds the 1600 character limit.\n\nThe maximum allowable body text length is generally 1600 characters,\nbut some glyphs such as Emoji, Emoticons or other special characters\nwill be counted as multiple.\n",
        code: 21617,
        log_level: "error",
        last_updated: "2016-03-31T17:14:27.000+0000",
        message: "The concatenated message body exceeds the 1600 character limit",
        secondary_message: "The maximum allowable body text length is generally 1600 characters, but some glyphs such as Emoji, Emoticons or other special characters will be counted as multiple characters.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:27.000+0000",
        const_partition: "1",
        docs: "## Error - 21616\n\n### The 'From' number matches multiple numbers for your account\n\nYou have attempted to send a SMS with a 'From' number that matches more\nthan one number belonging to your account. Please submit the 'From'\nnumber in E.164 format to resolve the ambiguity.\n",
        code: 21616,
        log_level: "error",
        last_updated: "2016-03-31T17:14:27.000+0000",
        message: "The 'From' number matches multiple numbers for your account",
        secondary_message: "You have attempted to send a SMS with a 'From' number that matches more than one number belonging to your account. Please submit the 'From' number in E.164 format to resolve the ambiguity.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:26.000+0000",
        solutions: "* Confirm that the number you are sending to is not a landline, using the [Lookup API](https://www.twilio.com/docs/lookup/api#lookup-a-phone-number).\r\n* Please verify you have provided a valid mobile number in proper [E.164 format](https://support.twilio.com/hc/en-us/articles/223183008-Formatting-International-Phone-Numbers).\r\n* If you are attempting to send SMS to an IoT or M2M number, check whether the number format is different from the standard mobile numbers in that country or locality. Often, these numbers have additional digits or unusual formats which do not pass Twilio's number validation. If you believe this is the issue, please [contact Twilio Support](https://www.twilio.com/help/contact) for assistance.",
        causes: "* The number you provided may be a landline number.\r\n* The number you provided may be invalid or formatted incorrectly.\r\n* If you are attempting to send SMS to Internet of Things (IoT) or machine-to-machine (M2M) numbers, the numbers may use a non-standard format that Twilio has not added to our number validation system yet.",
        description: "### 'To' number is not a valid mobile number\r\n\r\nYou have attempted to send a SMS with a 'To' number that is not \r\na valid mobile number. It is likely that the number that you \r\nhave specified is a landline number or is an invalid number. ",
        const_partition: "1",
        docs: "## ERROR - 21614\r\n\r\n### 'To' number is not a valid mobile number\r\n\r\n ### 'To' number is not a valid mobile number\r\n\r\nYou have attempted to send a SMS with a 'To' number that is not \r\na valid mobile number. It is likely that the number that you \r\nhave specified is a landline number or is an invalid number. \r\n\r\n#### Possible Causes\r\n* The number you provided may be a landline number.\r\n* The number you provided may be invalid or formatted incorrectly.\r\n* If you are attempting to send SMS to Internet of Things (IoT) or machine-to-machine (M2M) numbers, the numbers may use a non-standard format that Twilio has not added to our number validation system yet.\r\n\r\n#### Possible Solutions\r\n* Confirm that the number you are sending to is not a landline, using the [Lookup API](https://www.twilio.com/docs/lookup/api#lookup-a-phone-number).\r\n* Please verify you have provided a valid mobile number in proper [E.164 format](https://support.twilio.com/hc/en-us/articles/223183008-Formatting-International-Phone-Numbers).\r\n* If you are attempting to send SMS to an IoT or M2M number, check whether the number format is different from the standard mobile numbers in that country or locality. Often, these numbers have additional digits or unusual formats which do not pass Twilio's number validation. If you believe this is the issue, please [contact Twilio Support](https://www.twilio.com/help/contact) for assistance.",
        code: 21614,
        log_level: "ERROR",
        last_updated: "2019-12-10T22:06:40.000+0000",
        message: "'To' number is not a valid mobile number",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:26.000+0000",
        const_partition: "1",
        docs: "## Error - 21613\n\n### PhoneNumber Requires an Address\n\nLocal regulation requires Twilio to have an address on file for your account to\npurchase this phone number.  You must add an address that specifies the end\nuser\u2019s location using our [API][addresses-api] or [account\nportal][addresses-portal]. Alternatively, you can provision a phone number that\ndoes not require an address by using Basic List Filters on the\n[AvailablePhoneNumbers][phone-numbers] resource. If you received this error\nwhen trying to transfer a phone number to a subaccount or between subaccounts,\nplease ensure that the subaccount has the correct address on file.\n\n[addresses-api]: /docs/api/rest/addresses\n[addresses-portal]: /user/account\n[phone-numbers]: /docs/api/rest/available-phone-numbers\n",
        code: 21613,
        log_level: "error",
        last_updated: "2016-03-31T17:14:26.000+0000",
        message: "PhoneNumber Requires Certification",
        secondary_message: "To purchase this phone number, you must certify that you or your customer has a business or personal address within the local country. To certify that you have an address in this country for this account, please purchase this phone number via the [buy a phone number](/user/account/phone-numbers/search) page in the account portal.  You will only need to certify your address once for each country.  Alternatively, you can provision a phone number that does not require certification.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:26.000+0000",
        const_partition: "1",
        docs: "## Error - 21612\r\n\r\n### The 'To' phone number is not currently reachable via SMS or MMS\r\n\r\nYou have attempted to send to a number that is not currently reachable via\r\nTwilio SMS or MMS.\r\n\r\nIf the number provided is a properly formatted E.164, it is\r\npossible that Twilio does not yet have service with the carrier you are trying to reach.\r\n\r\nIf you are using an alphanumeric sender ID, the 'To' number is in a country where alphanumeric sender IDs are not supported. [A list of countries where alphanumeric sender ID is supported can be found here][alphanumeric-countries].\r\n\r\nWe have logged the carrier you are attempting to reach and will monitor these\r\nfailures when adding new carriers.\r\n\r\nOther possible causes include:\r\n\r\n- Sending international SMS messages from domestic only geographic phone numbers or short codes\r\n- Sending MMS messages to an unreachable carrier with [MMS Converter](/user/account/settings) disabled.\r\n- Sending from [Globally SMS-enabled](https://support.twilio.com/hc/en-us/articles/223183068-Twilio-international-phone-number-availability-and-their-capabilities) numbers is not supported when reaching +1 destinations (US and Canada). Use other +1 SMS-enabled Twilio numbers when communicating in these regions.\r\n\r\n[alphanumeric-countries]:https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID",
        code: 21612,
        log_level: "ERROR",
        last_updated: "2017-10-06T16:40:21.000+0000",
        message: "The 'To' phone number is not currently reachable via SMS",
        secondary_message: "You have attempted to send to a number that is not currently reachable via Twilio SMS. If the number provided is a properly formatted E.164, it is most likely that Twilio does not yet have service with the carrier you are trying to reach.  We have logged the carrier you are attempting to reach and will monitor these failures when adding new carriers.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:25.000+0000",
        const_partition: "1",
        docs: "## Error - 21611\r\n\r\n### This 'From' number has exceeded the maximum number of queued messages\r\n\r\nYou have attempted to enqueue too many messages for a given 'From' number.\r\nTwilio SMS and Fax send messages at 1 message per second from a phone number and 100  messages per second from a shortcode. Messages that exceed these rates will be queued and delivered at the defined rates. When a queue for a particular 'From'\r\nnumber exceeds 4 hours, this error will be thrown.",
        code: 21611,
        log_level: "ERROR",
        last_updated: "2019-06-03T16:48:34.000+0000",
        message: "This 'From' number has exceeded the maximum number of queued messages",
        secondary_message: "You have attempted to enqueue too many messages for a given 'From' number. Twilio SMS sends messages at 1 message per second from a phone number and 30 messages per second from a shortcode. Messages that exceed these rates will be queued and delivered at the defined rates. When a queue for a particular 'From' number exceeds 4 hours, this error will be thrown.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:25.000+0000",
        solutions: '* Consider removing this phone number from your list of recipients.\r\n* Request the recipient to resubscribe to your messages by texting in "START" or [another opt-in keyword](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) to your Twilio sender.\r\n* Before sending messages to a recipient, ensure they have consented to receive messages from you. Please read these guidelines to understand [messaging opt-in requirements and best practices](https://www.twilio.com/blog/ctia-messaging-principles-and-best-practices).',
        causes: '* The end user handset has responded with "STOP" or [another opt-out keyword](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-).\r\n',
        description: "The person you are trying to message has opted out of receiving messages from your Twilio phone number, Channels sender, or Messaging Service.\r\n\r\nYou have attempted to message a 'To' number that has replied with \"STOP\" to one of your previous messages. You will not be able to send to the phone number specified in the 'To' parameter until the subscriber identified by the phone number has responded with \"START\". \r\n\r\nPlease see [this FAQ](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) for more information about how Twilio handles opt-out and opt-in.",
        const_partition: "1",
        docs: '## ERROR - 21610\r\n\r\n### Attempt to send to unsubscribed recipient\r\n\r\n The person you are trying to message has opted out of receiving messages from your Twilio phone number, Channels sender, or Messaging Service.\r\n\r\nYou have attempted to message a \'To\' number that has replied with "STOP" to one of your previous messages. You will not be able to send to the phone number specified in the \'To\' parameter until the subscriber identified by the phone number has responded with "START". \r\n\r\nPlease see [this FAQ](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) for more information about how Twilio handles opt-out and opt-in.\r\n\r\n#### Possible Causes\r\n* The end user handset has responded with "STOP" or [another opt-out keyword](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-).\r\n\r\n\r\n#### Possible Solutions\r\n* Consider removing this phone number from your list of recipients.\r\n* Request the recipient to resubscribe to your messages by texting in "START" or [another opt-in keyword](https://support.twilio.com/hc/en-us/articles/223134027-Twilio-support-for-opt-out-keywords-SMS-STOP-filtering-) to your Twilio sender.\r\n* Before sending messages to a recipient, ensure they have consented to receive messages from you. Please read these guidelines to understand [messaging opt-in requirements and best practices](https://www.twilio.com/blog/ctia-messaging-principles-and-best-practices).',
        code: 21610,
        log_level: "ERROR",
        last_updated: "2019-12-10T22:08:22.000+0000",
        message: "Attempt to send to unsubscribed recipient",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:25.000+0000",
        const_partition: "1",
        docs: "## Error - 21601\n\n### Phone number is not a valid SMS-capable/MMS-capable inbound phone number \n\nThe phone number you provided as the FROM field to initiate an outbound message is not an incoming phone number assigned to your account. Only phone numbers that you buy from Twilio can be used for outgoing messages. In particular, 3rd party phone numbers such as validated CallerIDs cannot be used to send messages.",
        code: 21601,
        log_level: "error",
        last_updated: "2016-03-31T17:14:25.000+0000",
        message: "Phone number is not a valid SMS-capable inbound phone number",
        secondary_message: "The phone number you provided as the FROM field to initiate an outbound SMS is not an incoming phone number assigned to your account.  Only phone numbers that you buy from Twilio can be used for outgoing SMSes.  In particular, 3rd party phone numbers such as validated CallerIDs cannot be used to send SMSs.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:25.000+0000",
        const_partition: "1",
        docs: "## Error - 21480\n\n### Reached maximum number of subaccounts\n\nReached maximum number of subaccounts, please contact [Twilio](/help) if you want to create more subaccounts.\n",
        code: 21480,
        log_level: "error",
        last_updated: "2016-03-31T17:14:25.000+0000",
        message: "Reached maximum number of subaccounts",
        secondary_message: "Reached maximum number of subaccounts, please contact [Twilio](/help) if you want to create more subaccounts.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:24.000+0000",
        const_partition: "1",
        docs: "## Error - 21479\n\n### Unable to update Status for subaccount, subaccount has been closed.\n\nUnable to update Status for subaccount, subaccount is closed and can not be re-opened.\n",
        code: 21479,
        log_level: "error",
        last_updated: "2016-03-31T17:14:24.000+0000",
        message: "Unable to update Status for subaccount, subaccount has been closed.",
        secondary_message: "Unable to update Status for subaccount, subaccount is closed and can not be re-opened.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:24.000+0000",
        const_partition: "1",
        docs: "## Error - 21478\n\n### Unable to update Status for subaccount, subaccount has been suspended by Twilio\n\nUnable to update Status for subaccounts that have been suspended externally by Twilio.  Please contact customer support: http://www.twilio.com/help\n\n",
        code: 21478,
        log_level: "error",
        last_updated: "2016-03-31T17:14:24.000+0000",
        message: "Unable to update Status for subaccount, subaccount has been suspended by Twilio",
        secondary_message: "Unable to update Status for subaccounts that have been suspended externally by Twilio.  Please contact customer support: http://www.twilio.com/help",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:24.000+0000",
        const_partition: "1",
        docs: "## Error - 21477\n\n### Unable to update Status for parent accounts\n\nUnable to update Status for parent accounts, status updates restricted to subaccounts only\n\n",
        code: 21477,
        log_level: "error",
        last_updated: "2016-03-31T17:14:24.000+0000",
        message: "Unable to update Status for parent accounts",
        secondary_message: "Unable to update Status for parent accounts, status updates restricted to subaccounts only",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:24.000+0000",
        const_partition: "1",
        docs: "## Error - 21476\n\n### Unable to update Status for subaccount, parent account is suspended.\n\nUnable to update Status for subaccount, parent account is suspended.  The account needs to be in good standing to continue using the subaccount feature.\n\n\n\n",
        code: 21476,
        log_level: "error",
        last_updated: "2016-03-31T17:14:24.000+0000",
        message: "Unable to update Status for subaccount, parent account is suspended.",
        secondary_message: "Unable to update Status for subaccount, parent account is suspended.  The account needs to be in good standing to continue using the subaccount feature.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:23.000+0000",
        const_partition: "1",
        docs: "## Error - 21475\n\n### Unable to update Status, invalid Status.\n\nThe Status you specified must be one of the following strings: 'active', 'suspended', or 'closed'.\n\n\n\n\n",
        code: 21475,
        log_level: "error",
        last_updated: "2016-03-31T17:14:23.000+0000",
        message: "Unable to update Status, invalid Status.",
        secondary_message: "The Status you specified must be one of the following strings: 'active', 'suspended', or 'closed'.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:23.000+0000",
        const_partition: "1",
        docs: "## Error - 21474\n\n### API User must be the parent account to transfer phone numbers.\n\nThe API user can not be a subaccount, must be a parent account to transfer phone numbers between parent and child accounts.\n\n\n\n\n",
        code: 21474,
        log_level: "error",
        last_updated: "2016-03-31T17:14:23.000+0000",
        message: "API User must be the parent account to transfer phone numbers.",
        secondary_message: "The API user can not be a subaccount, must be a parent account to transfer phone numbers between parent and child accounts.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:23.000+0000",
        const_partition: "1",
        docs: "## Error - 21473\n\n### AccountSid you are transferring to is not related to the originating owner of the phone number\n\nThe AccountSid you specified is neither parent nor child of the originating Account owner.  Please make sure that the subaccount or parent account is related to the current owner you are transferring from or to.\n\n\n\n\n\n",
        code: 21473,
        log_level: "error",
        last_updated: "2016-03-31T17:14:23.000+0000",
        message: "AccountSid you are transferring to is not related to the originating owner of the phone number",
        secondary_message: "The AccountSid you specified is neither parent nor child of the originating Account owner.  Please make sure that the subaccount or parent account is related to the current owner you are transferring from or to.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:22.000+0000",
        const_partition: "1",
        docs: "## Error - 21472\n\n### Account is not active\n\nThe AccountSid you specified is not an active Twilio Account.  To transfer the account, you must supply an Active 34 character AccountSid .\n\n\n\n\n\n",
        code: 21472,
        log_level: "error",
        last_updated: "2016-03-31T17:14:22.000+0000",
        message: "Account is not active",
        secondary_message: "The AccountSid you specified is not an active Twilio Account.  To transfer the account, you must supply an Active 34 character AccountSid .",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:22.000+0000",
        const_partition: "1",
        docs: "## Error - 21471\r\n\r\n### Account does not exist\r\n\r\nThe AccountSid you specified does not exist.  AccountSids are 34 character strings that represent the Twilio Account.  For example, AC44CE4123947237834573457345347567.\r\n\r\n\r\n\r\n\r\n\r\n",
        code: 21471,
        log_level: "ERROR",
        last_updated: "2018-02-07T08:01:51.000+0000",
        message: "Account does not exist",
        secondary_message: "The AccountSid you specified does not exist. AccountSids are 34 character strings that represent the Twilio Account.  For example, AC44CE4123947237834573457345347567.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:22.000+0000",
        const_partition: "1",
        docs: "## Error - 21470\n\n### Invalid AccountSid\n\nThe AccountSid you specified was not a valid AccountSid identifier.  AccountSid's are 34 character strings that represent the Twilio Account .  For example, AC44CE4123947237834573457345347567.\n\n\n\n\n\n",
        code: 21470,
        log_level: "error",
        last_updated: "2016-03-31T17:14:22.000+0000",
        message: "Invalid AccountSid",
        secondary_message: "The AccountSid you specified was not a valid AccountSid identifier.  AccountSid's are 34 character strings that represent the Twilio Account .  For example, AC44CE4123947237834573457345347567.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:21.000+0000",
        const_partition: "1",
        docs: "## Error - 21458\n\n### PhoneNumber Provisioning Type Mismatch\n\nThe type of a PhoneNumber (toll-free or not) did not match the type of the IncomingPhoneNumbers sub-resource (Local or TollFree).\n\n#### Possible Causes \n*  Make sure to provision toll-free numbers from the IncomingPhoneNumbers/TollFree resource or directly from the IncomingPhoneNumbers/ resource.\n*  Make sure to provision non-toll-free numbers from the IncomingPhoneNumbers/Local resource or directly from the IncomingPhoneNumbers/ resource.\n",
        code: 21458,
        log_level: "error",
        last_updated: "2016-03-31T17:14:21.000+0000",
        message: "PhoneNumber Provisioning Type Mismatch",
        secondary_message: "The type of a PhoneNumber (toll-free or not) did not match the type of the IncomingPhoneNumbers sub-resource (Local or TollFree).  #### Possible Causes *  Make sure to provision toll-free numbers from the IncomingPhoneNumbers/TollFree resource or directly from the IncomingPhoneNumbers/ resource. *  Make sure to provision non-toll-free numbers from the IncomingPhoneNumbers/Local resource or directly from the IncomingPhoneNumbers/ resource.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:21.000+0000",
        const_partition: "1",
        docs: "## Error - 21457\n\n### AreaCode Parameter not Supported\n\nThe AreaCode parameter for provisioning numbers is not supported on the IncomingPhoneNumbers/Local & IncomingPhoneNumbers/TollFree sub-resources.\n\n\n\n\n\n",
        code: 21457,
        log_level: "error",
        last_updated: "2016-03-31T17:14:21.000+0000",
        message: "AreaCode Parameter not Supported",
        secondary_message: "The AreaCode parameter for provisioning numbers is not supported on the IncomingPhoneNumbers/Local & IncomingPhoneNumbers/TollFree sub-resources.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:21.000+0000",
        const_partition: "1",
        docs: "## Error - 21422\n\n### PhoneNumber is not available\n\nYou tried to purchase a phone number that is not available for purchase. \n\nThis error can be triggered in a few ways:\n\n- Twilio does not own the phone number in question.\n- Twilio owns the number, but it is reserved for another account.\n\n",
        code: 21422,
        log_level: "error",
        last_updated: "2016-03-31T17:14:21.000+0000",
        message: "PhoneNumber is not available",
        secondary_message: "You tried to purchase a phone number that is not available for purchase.  This error can be triggered in a few ways:  - Twilio does not own the phone number in question. - Twilio owns the number, but it is reserved for another account.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:21.000+0000",
        const_partition: "1",
        docs: "## Error - 21421\n\n### PhoneNumber is invalid\n\nYou tried to purchase or lookup a phone number that is invalid. Please specify a\nvalid phone number in E.164 format.\n",
        code: 21421,
        log_level: "error",
        last_updated: "2016-03-31T17:14:21.000+0000",
        message: "PhoneNumber is invalid",
        secondary_message: "You tried to purchase a phone number for your account that was an invalid number. Please specify a valid phone number in E.164 format.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:20.000+0000",
        const_partition: "1",
        docs: "## Error - 21420\n\n### ApplicationSid is not accessible\n\nYou specified a VoiceApplicationSid or SmsApplicationSid for a new phone number\nthat is not controlled by your account, or is invalid. Please specify an\nApplicationSid that you've created in your [Account\nDashboard](/user/account/apps).\n",
        code: 21420,
        log_level: "error",
        last_updated: "2016-03-31T17:14:20.000+0000",
        message: "ApplicationSid is not accessible",
        secondary_message: "You specified a VoiceApplicationSid or SmsApplicationSid for a new phone number that is not controlled by your account, or is invalid. Please specify an ApplicationSid that you've created in your [Account Dashboard](/user/account/apps).",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:20.000+0000",
        solutions: "If you wish to send messages to this region, please enable the relevant permissions on your account using the [Messaging Geographic Permissions](https://www.twilio.com/console/sms/settings/geo-permissions) page.",
        causes: "* You have attempted to send an SMS to a region that has not been enabled in your account's [Geo-Permissions](https://www.twilio.com/console/sms/settings/geo-permissions) settings. ",
        description: "## Error - 21408 \r\n\r\n### Permission to send an SMS has not been enabled for the region indicated by the 'To' number",
        const_partition: "1",
        docs: "## ERROR - 21408\r\n\r\n### Permission to send an SMS has not been enabled for the region indicated by the 'To' number\r\n\r\n ## Error - 21408 \r\n\r\n### Permission to send an SMS has not been enabled for the region indicated by the 'To' number\r\n\r\n#### Possible Causes\r\n* You have attempted to send an SMS to a region that has not been enabled in your account's [Geo-Permissions](https://www.twilio.com/console/sms/settings/geo-permissions) settings. \r\n\r\n#### Possible Solutions\r\nIf you wish to send messages to this region, please enable the relevant permissions on your account using the [Messaging Geographic Permissions](https://www.twilio.com/console/sms/settings/geo-permissions) page.",
        code: 21408,
        log_level: "ERROR",
        last_updated: "2019-12-10T23:58:00.000+0000",
        message: "Permission to send an SMS has not been enabled for the region indicated by the 'To' number",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:20.000+0000",
        const_partition: "1",
        docs: "## Error - 21407 \n\n### This Phone Number type does not support SMS\n\nThis phone number type does not support SMS.  You cannot set SmsUrl, SmsMethod, SmsFallbackUrl, or SmsFallbackMethod\n\n",
        code: 21407,
        log_level: "error",
        last_updated: "2016-03-31T17:14:20.000+0000",
        message: "This Phone Number type does not support SMS",
        secondary_message: "This phone number type does not support SMS.  You cannot set SmsUrl, SmsMethod, SmsFallbackUrl, or SmsFallbackMethod",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:20.000+0000",
        const_partition: "1",
        docs: "## Error - 21406 \n\n### Cannot set SmsFallbackUrl without setting SmsUrl\n\nYou cannot set a fallback URL without specifying a primary URL\n\n\n\n\n",
        code: 21406,
        log_level: "error",
        last_updated: "2016-03-31T17:14:20.000+0000",
        message: "Cannot set SmsFallbackUrl without setting SmsUrl",
        secondary_message: "You cannot set a fallback URL without specifying a primary URL",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:19.000+0000",
        const_partition: "1",
        docs: "## Error - 21405 \n\n### Cannot set VoiceFallbackUrl without setting Url\n\nYou cannot set a fallback URL without specifying a primary URL\n\n\n\n\n",
        code: 21405,
        log_level: "error",
        last_updated: "2016-03-31T17:14:19.000+0000",
        message: "Cannot set VoiceFallbackUrl without setting Url",
        secondary_message: "You cannot set a fallback URL without specifying a primary URL",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:19.000+0000",
        const_partition: "1",
        docs: "## Warning - 21229\n\n### Invalid SIP Header. Illegal chars in header value\n\nThe header value you passed has characters not allowed in SIP.",
        code: 21229,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:19.000+0000",
        message: "Invalid SIP Header. Illegal chars in header value",
        secondary_message: "The header value you passed has characters not allowed in SIP.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:19.000+0000",
        const_partition: "1",
        docs: "## Warning - 21228\n\n### Invalid SIP Header. Illegal chars in header name\n\nThe header you passed has characters not allowed in SIP.",
        code: 21228,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:19.000+0000",
        message: "Invalid SIP Header. Illegal chars in header name",
        secondary_message: "The header you passed has characters not allowed in SIP.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:19.000+0000",
        const_partition: "1",
        docs: "## Warning - 21227\n\n### Headers portion of SIP URI must be fewer than 1024 chars\n\nThe headers you are sending must be fewer than 1024 characters.",
        code: 21227,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:19.000+0000",
        message: "Headers portion of SIP URI must be fewer than 1024 chars",
        secondary_message: "The headers you are sending must be fewer than 1024 characters.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:18.000+0000",
        const_partition: "1",
        docs: "## Warning - 21226\n\n### SIP calling not enabled for this account\n\nYour account is not enabled for SIP calling.",
        code: 21226,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:18.000+0000",
        message: "SIP calling not enabled for this account",
        secondary_message: "Your account is not enabled for SIP calling.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:18.000+0000",
        const_partition: "1",
        docs: "## Warning - 21225\n\n### SipAuthPassword is required when providing SipAuthUsername\n\nYou must specify a SipAuthPassword if you are also using SipAuthUsername.",
        code: 21225,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:18.000+0000",
        message: "SipAuthPassword is required when providing SipAuthUsername",
        secondary_message: "You must specify a SipAuthPassword if you are also using SipAuthUsername.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:18.000+0000",
        const_partition: "1",
        docs: "## Warning - 21224\n\n### Invalid SipAuthPassword. Illegal chars\n\nThe SipAuthUsername you specified contained characters not allowed in SIP.\n",
        code: 21224,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:18.000+0000",
        message: "Invalid SipAuthPassword. Illegal chars",
        secondary_message: "The SipAuthUsername you specified contained characters not allowed in SIP.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:17.000+0000",
        const_partition: "1",
        docs: "## Warning - 21223\n\n### Invalid SipAuthPassword. Must be fewer than 256 chars\n\nThe SipAuthPassword you specified contained too many characters.\n",
        code: 21223,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:17.000+0000",
        message: "Invalid SipAuthPassword. Must be fewer than 256 chars",
        secondary_message: "The SipAuthPassword you specified contained too many characters.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:17.000+0000",
        const_partition: "1",
        docs: "## Warning - 21222\n\n### Invalid SipAuthUsername. Illegal chars\n\nThe SipAuthUsername you specified contained characters not allowed in SIP.\n",
        code: 21222,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:17.000+0000",
        message: "Invalid SipAuthUsername. Illegal chars",
        secondary_message: "The SipAuthUsername you specified contained characters not allowed in SIP.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:17.000+0000",
        const_partition: "1",
        docs: "## Warning - 21221\n\n### Invalid SipAuthUsername. Must be fewer than 256 chars\n\nThe SipAuthUsername you specified was longer than 255 characters.\n",
        code: 21221,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:17.000+0000",
        message: "Invalid SipAuthUsername. Must be fewer than 256 chars",
        secondary_message: "The SipAuthUsername you specified was longer than 255 characters.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:16.000+0000",
        const_partition: "1",
        docs: "## Error - 21220 \n\n### Invalid call state\n\nYou attempted a realtime operation on a Call that was not in-progress.  Calls that have completed cannot be recorded or redirected.  \n\n\n\n\n\n",
        code: 21220,
        log_level: "error",
        last_updated: "2016-03-31T17:14:16.000+0000",
        message: "Invalid call state",
        secondary_message: "You attempted a realtime operation on a Call that was not in-progress.  Calls that have completed cannot be recorded or redirected.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:16.000+0000",
        const_partition: "1",
        docs: "## Error - 21219\n\n### 'To' phone number not verified\n\nYou attempted to initiate an outbound phone call from a trial account, but the\n'To' number you specified is not a verified number for your account. In order\nto make calls during a free trial, you must first verify your ownership of the\nphone number being called.\n\nYou can verify phone numbers from the [phone numbers\nsection](/user/account/phone-numbers) of your account portal.\n",
        code: 21219,
        log_level: "error",
        last_updated: "2016-03-31T17:14:16.000+0000",
        message: "'To' phone number not verified",
        secondary_message: "You attempted to initiate an outbound phone call from a trial account, but the 'To' number you specified is not a verified number for your account. In order to make calls during a free trial, you must first verify your ownership of the phone number being called.  You can verify phone numbers from the [phone numbers section](/user/account/phone-numbers) of your account portal.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:16.000+0000",
        const_partition: "1",
        docs: "## Error - 21218\n\n### Invalid ApplicationSid\n\nYou attempted to initiate an outbound phone call with an invalid ApplicationSid.\nThe application may not exist anymore or may not be available within your\naccount.\n",
        code: 21218,
        log_level: "error",
        last_updated: "2016-03-31T17:14:16.000+0000",
        message: "Invalid ApplicationSid",
        secondary_message: "You attempted to initiate an outbound phone call with an invalid ApplicationSid. The application may not exist anymore or may not be available within your account.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:15.000+0000",
        const_partition: "1",
        docs: "## Error - 21217\n\n### Phone number does not appear to be valid \n\nYou attempted to initiate an outbound phone call to an invalid phone number.  \nPlease check the phone number and try again.  \n",
        code: 21217,
        log_level: "error",
        last_updated: "2016-03-31T17:14:15.000+0000",
        message: "Phone number does not appear to be valid",
        secondary_message: "You attempted to initiate an outbound phone call to an invalid phone number. Please check the phone number and try again.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:15.000+0000",
        const_partition: "1",
        docs: "## Error - 21216\r\n\r\n### API: Call blocked by Twilio blacklist\r\nThe destination number is blocked by Twilio because this destination has a high-risk of fraud or due to regulatory reasons cannot be enabled by default. If you have a legitimate need to call this number, please email help@twilio.com with an explanation of your use case.\r\n\r\n",
        code: 21216,
        log_level: "ERROR",
        last_updated: "2019-05-08T17:44:03.000+0000",
        message: "API: Call blocked by Twilio blacklist",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:15.000+0000",
        const_partition: "1",
        docs: "## Error - 21215\r\n\r\n### Geo Permission configuration is not permitting call\r\n\r\nYou attempted to initiate an outbound phone call to a phone number that is not enabled on your account. Please check your [Geographic Permissions](https://www.twilio.com/console/voice/calls/geo-permissions), fix it, and try\r\nagain.\r\n\r\n#### Enable international calling permissions\r\n\r\nTwilio supports calling over 200 countries worldwide.",
        code: 21215,
        log_level: "ERROR",
        last_updated: "2018-03-08T00:44:24.000+0000",
        message: "Geo Permission configuration is not permitting call",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:15.000+0000",
        const_partition: "1",
        docs: "## Error - 21214 \n\n### 'To' phone number cannot be reached\n\nYou attempted to initiate an outbound phone call to a phone number that cannot\nbe reached. Please check the number and try again.  \n",
        code: 21214,
        log_level: "error",
        last_updated: "2016-03-31T17:14:15.000+0000",
        message: "'To' phone number cannot be reached",
        secondary_message: "You attempted to initiate an outbound phone call to a phone number that cannot be reached. Please check the number and try again.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:14.000+0000",
        const_partition: "1",
        docs: "## Error - 20008\n\n#### Cannot access this resource with Test Credentials\n\nCurrently only a handful of API resources can be tested with your test\ncredentials. Trying to authenticate with your test credentials to other\nresources will return a Forbidden error message. For a full list of supported\nresources, please see our [Test Credentials](/docs/api/rest/test-credentials)\npage.\n",
        code: 20008,
        log_level: "error",
        last_updated: "2016-03-31T17:14:14.000+0000",
        message: "Test Credentials",
        secondary_message: "Currently only a handful of API resources can be tested with your test credentials. Trying to authenticate with your test credentials to other resources will return a Forbidden error message. For a full list of supported resources, please see our [Test Credentials](/docs/api/rest/test-credentials) page.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:14.000+0000",
        const_partition: "1",
        docs: "## Error - 20006\n\n### Access Denied\n\nYou don't have sufficient privileges to access the requested resource. The user\non whose behalf you are attempting to access the API may have revoked your\nprivileges, or you may need to request greater privileges from the user.\n\n",
        code: 20006,
        log_level: "error",
        last_updated: "2016-03-31T17:14:14.000+0000",
        message: "Access Denied",
        secondary_message: "You don't have sufficient privileges to access the requested resource. The user on whose behalf you are attempting to access the API may have revoked your privileges, or you may need to request greater privileges from the user.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:14.000+0000",
        solutions: "Ensure your application responds to callbacks with: \r\n\r\n*  200 OK  \r\n*  Content-Type: text/xml \r\n*  Valid TwiML\r\n\r\nOr respond with 204 No Content and an empty response body.",
        causes: "*  Your application returned a 4xx or 5xx HTTP response to Twilio.",
        description: null,
        const_partition: "1",
        docs: "## WARNING - 15003\r\n\r\n### Call Progress: Warning Response to Callback URL\r\n\r\nGot an HTTP warning in response to the callback URL. \r\n\r\n#### Possible Causes\r\n*  Your application returned a 4xx or 5xx HTTP response to Twilio.\r\n\r\n#### Possible Solutions\r\nEnsure your application responds to callbacks with: \r\n\r\n*  200 OK  \r\n*  Content-Type: text/xml \r\n*  Valid TwiML\r\n\r\nOr respond with 204 No Content and an empty response body.",
        code: 15003,
        log_level: "WARNING",
        last_updated: "2020-01-15T23:55:39.000+0000",
        message: "Call Progress: Warning Response to Callback URL",
        log_type: "APPLICATION",
        secondary_message: "Got an HTTP warning in response to the callback URL.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:14.000+0000",
        const_partition: "1",
        docs: "## Error - 15002\n\n### Call Progress: Queue Timeout\n\nA callback request timed out in the callback queue.\n\n#### Possible Causes\n\n*  Your application is not responding to Call Progress Events in a timely manner leading to queued callbacks expiring before they are sent.\n*  There was a network disruption between Twilio and your web server.\n\n#### Possible Solutions\n\n*   Please ensure your application is responding to callbacks in a timely manner.",
        code: 15002,
        log_level: "error",
        last_updated: "2016-03-31T17:14:14.000+0000",
        message: "Call Progress: Queue Timeout",
        secondary_message: "A callback request timed out in the callback queue.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:13.000+0000",
        const_partition: "1",
        docs: '## Error - 15000\n\n### Call Progress: Internal Twilio Error\n\nAn internal error has occurred that prevented Twilio from processing your Call Progress Event.\n\n#### Possible Solutions\n\n*   If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it!\n*   Note the time of the error and what you were trying to do when it occurred!',
        code: 15000,
        log_level: "error",
        last_updated: "2016-03-31T17:14:13.000+0000",
        message: "Call Progress: Internal Twilio Error",
        secondary_message: "An internal error has occurred that prevented Twilio from processing your Call Progress Event.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:13.000+0000",
        const_partition: "1",
        docs: "## Error - 14223\n\n### Enqueue: Unable to cleanup task\n\nUnable to cancel the task created by Enqueue upon a TwimL error or task hangup.\n",
        code: 14223,
        log_level: "error",
        last_updated: "2016-03-31T17:14:13.000+0000",
        message: "Enqueue: Unable to cleanup task",
        secondary_message: "Unable to cancel the task created by Enqueue upon a TwimL error or task hangup.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:13.000+0000",
        const_partition: "1",
        docs: "## Error - 14221\n\n### Enqueue: Provided Attributes JSON was not valid\n\nProvided Attributes is not valid JSON.\n",
        code: 14221,
        log_level: "error",
        last_updated: "2016-03-31T17:14:13.000+0000",
        message: "Enqueue: Provided Attributes JSON was not valid",
        secondary_message: "Provided Attributes is not valid JSON.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:13.000+0000",
        const_partition: "1",
        docs: "## Error - 14220\n\n### Enqueue: Provided Workflow was not a valid sid\n\nProvided Workflow is invalid.\n",
        code: 14220,
        log_level: "error",
        last_updated: "2016-03-31T17:14:13.000+0000",
        message: "Enqueue: Provided Workflow was not a valid sid",
        secondary_message: "Provided workflow sid was not valid.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:12.000+0000",
        const_partition: "1",
        docs: "## Error - 14215\n\n### Dial->Queue: Invalid ReservationSid. Unable to dequeue\n\nProvided ReservationSid is invalid.\n",
        code: 14215,
        log_level: "error",
        last_updated: "2016-03-31T17:14:12.000+0000",
        message: "Dial->Queue: Invalid ReservationSid. Unable to dequeue",
        secondary_message: "Provided ReservationSid is invalid.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:12.000+0000",
        const_partition: "1",
        docs: "## Error - 14213 \n\n### Dial->Queue: queue name too long\n\nThe name of the queue must be shorter than 64 characters.\n",
        code: 14213,
        log_level: "error",
        last_updated: "2016-03-31T17:14:12.000+0000",
        message: "Dial->Queue: queue name too long",
        secondary_message: "The name of the queue must be shorter than 64 characters.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:12.000+0000",
        const_partition: "1",
        docs: "## Error - 14212\n\n### Dial->Queue: queue name too short\n\nThe name of the queue must be at least 1 character long.\n",
        code: 14212,
        log_level: "error",
        last_updated: "2016-03-31T17:14:12.000+0000",
        message: "Dial->Queue: queue name too short",
        secondary_message: "The name of the queue must be at least 1 character long.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:11.000+0000",
        const_partition: "1",
        docs: "## Error - 14211\n\n### Dial->Queue: Invalid whisper url\n\nThe whisper url is invalid.\n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n",
        code: 14211,
        log_level: "error",
        last_updated: "2016-03-31T17:14:11.000+0000",
        message: "Dial->Queue: Invalid whisper url",
        secondary_message: "The whisper url is invalid.  #### Possible Solutions  Make sure you submit a fully qualified URL including:  *   protocol (http:// or https://) *   hostname *   file path *   properly url-encoded query parameters  Twilio must be able to reach this URL over the public Internet.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:11.000+0000",
        const_partition: "1",
        docs: "## Error - 14210\n\n### Dial->Queue: Invalid whisper method\n\nThe whisper method is invalid. You must specify one of 'GET' or 'POST'.\n\n",
        code: 14210,
        log_level: "error",
        last_updated: "2016-03-31T17:14:11.000+0000",
        message: "Dial->Queue: Invalid whisper method",
        secondary_message: "The whisper method is invalid. You must specify one of 'GET' or 'POST'.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:11.000+0000",
        const_partition: "1",
        docs: "## Error - 14206\n\n### Enqueue: Invalid waitUrlMethod value\n\nThe waitUrlMethod value is invalid. You must specify one of 'GET' or 'POST'.\n",
        code: 14206,
        log_level: "error",
        last_updated: "2016-03-31T17:14:11.000+0000",
        message: "Enqueue: Invalid waitUrlMethod value",
        secondary_message: "The waitUrlMethod value is invalid. You must specify one of 'GET' or 'POST'.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:11.000+0000",
        const_partition: "1",
        docs: "## Error - 14205\n\n### Enqueue: Queue name too long\n\nThe queue name must be less than 64 characters in length.\n",
        code: 14205,
        log_level: "error",
        last_updated: "2016-03-31T17:14:11.000+0000",
        message: "Enqueue: Queue name too long",
        secondary_message: "The queue name must be less than 64 characters in length.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:10.000+0000",
        const_partition: "1",
        docs: "## Error - 14204\n\n### Enqueue: Queue name too short\n\nThe queue name must be at least one character long.\n",
        code: 14204,
        log_level: "error",
        last_updated: "2016-03-31T17:14:10.000+0000",
        message: "Enqueue: Queue name too short",
        secondary_message: "The queue name must be at least one character long.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:10.000+0000",
        const_partition: "1",
        docs: "## Error - 14203\n\n### Enqueue: Invalid Enqueue action url\n\nThe action URL for the Enqueue verb is invalid.\n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n",
        code: 14203,
        log_level: "error",
        last_updated: "2016-03-31T17:14:10.000+0000",
        message: "Enqueue: Invalid Enqueue action url",
        secondary_message: "The action URL for the Enqueue verb is invalid.  #### Possible Solutions  Make sure you submit a fully qualified URL including:  *   protocol (http:// or https://) *   hostname *   file path *   properly url-encoded query parameters  Twilio must be able to reach this URL over the public Internet.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:10.000+0000",
        const_partition: "1",
        docs: "## Error - 14202\n\n### Enqueue: Invalid waitUrl\n\nThe waitUrl for the Enqueue verb is invalid.\n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n",
        code: 14202,
        log_level: "error",
        last_updated: "2016-03-31T17:14:10.000+0000",
        message: "Enqueue: Invalid waitUrl",
        secondary_message: "The waitUrl for the Enqueue verb is invalid.  #### Possible Solutions  Make sure you submit a fully qualified URL including:  *   protocol (http:// or https://) *   hostname *   file path *   properly url-encoded query parameters  Twilio must be able to reach this URL over the public Internet.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:09.000+0000",
        const_partition: "1",
        docs: "## Error - 14201\n\n### Enqueue: Invalid method value\n\nThe method is invalid. You must specify one of 'GET' or 'POST'.\n",
        code: 14201,
        log_level: "error",
        last_updated: "2016-03-31T17:14:09.000+0000",
        message: "Enqueue: Invalid method value",
        secondary_message: "The method is invalid. You must specify one of 'GET' or 'POST'.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:09.000+0000",
        const_partition: "1",
        docs: '## Warning - 13616 \n\n### Record: playBeep must be true or false\n\nThe playBeep attribute must have a value of "true" or "false"\n\n',
        code: 13616,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:09.000+0000",
        message: "Record: playBeep must be true or false",
        secondary_message: 'The playBeep attribute must have a value of "true" or "false"',
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:09.000+0000",
        const_partition: "1",
        docs: "## Warning - 13253\n\n### Dial: Header is too long\n\nYou sent a header that is too long.\n\n",
        code: 13253,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:09.000+0000",
        message: "Dial: Header is too long",
        secondary_message: "You sent a header that is too long.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:09.000+0000",
        const_partition: "1",
        docs: "## Warning - 13252\n\n### Dial: Invalid header name\n\nYou named your header something invalid.\n\n",
        code: 13252,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:09.000+0000",
        message: "Dial: Invalid header name",
        secondary_message: "You named your header something invalid.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:08.000+0000",
        const_partition: "1",
        docs: "## Warning - 13251 \n\n### Dial: Too many headers passed\n\nYou sent too many header elements.\n\n\n",
        code: 13251,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:08.000+0000",
        message: "Dial: Too many headers passed",
        secondary_message: "You sent too many header elements.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:08.000+0000",
        const_partition: "1",
        docs: "## Warning - 13250 \n\n### Dial: Too many URIs passed\n\nYou specified too many URI elements.\n\n\n",
        code: 13250,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:08.000+0000",
        message: "Dial: Too many URIs passed",
        secondary_message: "You specified too many URI elements.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:08.000+0000",
        const_partition: "1",
        docs: "## Warning - 13249 \n\n### Dial: Invalid username or password attribute\n\nYour username or password are invalid.\n\n\n",
        code: 13249,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:08.000+0000",
        message: "Dial: Invalid username or password attribute",
        secondary_message: "Your username or password are invalid.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:07.000+0000",
        const_partition: "1",
        docs: "## Warning - 13248 \n\n### Dial: Invalid callerID, too long\n\nYour callerID contains too many characters.\n\n\n\n",
        code: 13248,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:07.000+0000",
        message: "Dial: Invalid callerID, too long",
        secondary_message: "Your callerID contains too many characters.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:07.000+0000",
        solutions: "Make sure the number was entered correctly.\r\n\r\n[E.164 format](https://en.wikipedia.org/wiki/E.164)\r\n\r\n[North American Numbering Plan](https://en.wikipedia.org/wiki/North_American_Numbering_Plan)",
        causes: "Incorrect From number entered",
        description: "From number (caller ID) must be valid, assigned and not on the do-not-originate (DNO) list.\r\n\r\n\r\n\r\n",
        const_partition: "1",
        docs: "## ERROR - 13247\r\n\r\n### Dial: Invalid From number (caller ID)\r\n\r\n From number (caller ID) must be valid, assigned and not on the do-not-originate (DNO) list.\r\n\r\n\r\n\r\n\r\n\r\n#### Possible Causes\r\nIncorrect From number entered\r\n\r\n#### Possible Solutions\r\nMake sure the number was entered correctly.\r\n\r\n[E.164 format](https://en.wikipedia.org/wiki/E.164)\r\n\r\n[North American Numbering Plan](https://en.wikipedia.org/wiki/North_American_Numbering_Plan)",
        code: 13247,
        log_level: "ERROR",
        last_updated: "2019-12-18T00:58:24.000+0000",
        message: "Dial: Invalid From number (caller ID)",
        log_type: "APPLICATION",
        secondary_message: null,
        product: "Programmable Voice",
    },
    {
        date_created: "2016-03-31T17:14:07.000+0000",
        const_partition: "1",
        docs: "## Warning - 13246\n\n### Dial: SIP dialing not enabled for this account.\n\nYour account is not enabled for SIP dialing.\n\n\n\n\n",
        code: 13246,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:07.000+0000",
        message: "Dial: SIP dialing not enabled for this account",
        secondary_message: "Your account is not enabled for SIP dialing.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:07.000+0000",
        const_partition: "1",
        docs: "## Warning - 13245 \n\n### Dial: Not allowed in this API version.\n\nYour version of the API does not support this feature.\n\n\n\n\n",
        code: 13245,
        log_level: "warning",
        last_updated: "2016-03-31T17:14:07.000+0000",
        message: "Dial: Not allowed in this API version",
        secondary_message: "Your version of the API does not support this feature.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:06.000+0000",
        const_partition: "1",
        docs: "## Error - 21626\n\n### Invalid 'StatusCallbackEvent'\n\nOne or more of the StatusCallbackEvents provided were invalid.\n",
        code: 21626,
        log_level: "error",
        last_updated: "2016-03-31T17:14:06.000+0000",
        message: "Invalid 'StatusCallbackEvent'",
        secondary_message: "One or more of the StatusCallbackEvents provided were invalid.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:06.000+0000",
        const_partition: "1",
        docs: "## Error - 21609\n\n### Invalid StatusCallback URL\n\nThe `StatusCallback` URL provided is not a valid URL. \n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n",
        code: 21609,
        log_level: "error",
        last_updated: "2016-03-31T17:14:06.000+0000",
        message: "Invalid 'StatusCallback'",
        secondary_message: "StatusCallback must be a valid HTTP(s) URL.  The maximum length of the StatusCallback is 4000 characters.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:06.000+0000",
        const_partition: "1",
        docs: "## Error - 21608\r\n\r\n### This number can send messages only to verified numbers\r\n\r\nYou have attempted to send a message to an unverified phone number while using a trial account.\r\n\r\nTo prevent spam, trial accounts can only send messages to phone numbers you've verified with Twilio. You must upgrade your account to remove this restriction.\r\n\r\n### Possible solutions\r\n* Verify the phone number you wish to reach via the [Twilio console](https://www.twilio.com/console/phone-numbers/verified). See step-by-step instructions in our [guide to working with your trial account](https://www.twilio.com/docs/usage/tutorials/how-to-use-your-free-trial-account#verify-your-personal-phone-number). _Note that you will need access to this device to receive the call or text with your verification code._\r\n*  Upgrade your Twilio trial account to a full paid account to remove this restriction by providing your payment information via credit card or Paypal on the [console billing page](https://www.twilio.com/console/billing). \r\n",
        code: 21608,
        log_level: "ERROR",
        last_updated: "2018-09-06T16:03:44.000+0000",
        message: "The 'to' phone number provided is not yet verified for this account.",
        secondary_message: "While your account is in Trial Mode, you may only send SMS messages to verified numbers.  Upgrade to a Full Twilio account to send to any phone number.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:06.000+0000",
        const_partition: "1",
        docs: "## Error - 11770\n\n### Empty response body\n\nTwilio received a HTTP response with Transfer-encoding: chunked but an empty body.\n\n#### Possible Causes \n\n*   Server misconfiguration\n*   Network disruptions\n\n\n#### Possible Solutions\n\n*   Verify that the server is serving a non-empty HTTP response\n*   Verify that the network connection is stable\n\n",
        code: 11770,
        log_level: "error",
        last_updated: "2016-03-31T17:14:06.000+0000",
        message: "Empty response body",
        secondary_message: "Twilio received a HTTP response with Transfer-encoding: chunked but an empty body.  #### Possible Causes  *   Server misconfiguration *   Network disruptions   #### Possible Solutions  *   Verify that the server is serving a non-empty HTTP response *   Verify that the network connection is stable",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:05.000+0000",
        const_partition: "1",
        docs: "## Error - 21607\n\n### The 'From' number is not a valid, SMS-capable Twilio number\n\nWhile your account is in Trial mode, you can only send SMS messages from your\nfree trial number, or the Twilio Sandbox Number. To remove this restriction,\n[upgrade to a full account](/user/billing/upgrade).\n\n",
        code: 21607,
        log_level: "error",
        last_updated: "2016-03-31T17:14:05.000+0000",
        message: "The 'from' phone number must be the sandbox phone number for trial accounts.",
        secondary_message: "You can only send SMS messages from the sandbox phone number while your account is in the free trial.  Upgrade your account to a Full Twilio account to send and receive from your own phone numbers.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:05.000+0000",
        const_partition: "1",
        docs: "## Error - 21606\r\n\r\n### The 'From' phone number provided is not a valid, message-capable Twilio phone number.\r\n\r\nYou can only send SMS messages from a phone number or [short\r\ncode](https://www.twilio.com/docs/glossary/what-is-a-short-code) provided by or ported to Twilio, and\r\nthat phone number must be SMS-capable.\r\n\r\nVisit the [phone numbers page](https://www.twilio.com/console/phone-numbers/incoming) of your account portal to view a list\r\nof phone numbers that you own and to determine whether they are\r\nSMS-capable.\r\n\r\nDue to anti-spam regulations, the number a user sees when you send an SMS using\r\nyour application must be the same Twilio number associated with that account.\r\nThis differs from voice calls, where it is possible to display a verified\r\ncaller ID other than your Twilio number.\r\n\r\n### Possible solutions\r\n*  Check that you are using a Twilio phone number with SMS capabilities. You can see your purchased phone numbers and their capabilities in the [Twilio console](https://www.twilio.com/console/phone-numbers/incoming).\r\n*  If sending the message globally, verify that your `From` phone number is capable of sending messages and you have enabled [geographic permissions](https://www.twilio.com/console/sms/settings/geo-permissions) for your account.\r\n*  If you are sending messages with test credentials, verify that you are using one of the [available test credential \"magic phone numbers\"](https://www.twilio.com/docs/iam/test-credentials#test-sms-messages-parameters-From)\r\n\r\n#### Sending global SMS\r\n\r\nOnly certain countries and phone numbers are currently able to send\r\nglobal SMS messages. You may have received this error while trying\r\nto send from a number which is not capable of sending Global SMS\r\nmessages. For more information, including an up to date list of countries\r\nthat can send messages globally, please see our [FAQ page on Global\r\nSMS](https://support.twilio.com/hc/en-us/articles/223133947-What-is-Global-SMS-and-how-does-it-work).\r\n\r\n#### Test Credentials\r\n\r\nIf you received this error while trying to authenticate with your Test\r\nCredentials, you probably tried to send a message with a `From` number from\r\nyour live account. \r\n\r\nThe only number that can be used to send `successful`\r\nmessages with your Test Credentials is `+15005550006`. \r\n\r\nFor more information,\r\nread our documentation on [the `From` number for sending SMS with your test\r\ncredentials][from-test-credentials] and check out this blog post on [using Twilio's test credentials with magic numbers](https://www.twilio.com/blog/2018/04/twilio-test-credentials-magic-numbers.html).\r\n\r\n[from-test-credentials]: https://www.twilio.com/docs/iam/test-credentials#test-sms-messages-parameters-From\r\n",
        code: 21606,
        log_level: "ERROR",
        last_updated: "2018-09-06T17:04:38.000+0000",
        message: 'The "From" phone number provided is not a valid, SMS-capable inbound phone number for your account.',
        secondary_message: "You can only send SMS messages from an incoming phone number provided by Twilio, and that phone number must be SMS enabled. Visit the phone numbers page on your account portal to view a list of phone numbers that you own, and whether or not they are enabled for SMS.",
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:03.000+0000",
        const_partition: "1",
        docs: "## Error - 21605\r\n\r\n### Maximum body length is 160 characters\r\n\r\nThis error is specific to the deprecated /SMS/Messages API endpoint. When using this endpoint, your message body must be 160 characters or less. \r\n\r\nYou can send messages up to 1600 characters long by using the [/Messages](https://www.twilio.com/docs/sms/api/message#create-a-message-resource) API endpoint.\r\n\r\nFor more info, please refer to [our FAQ on message size constraints](https://www.twilio.com/help/faq/sms/can-i-send-text-and-pictures-in-the-same-message-what-is-the-size-limit-for-sending-picture-messages).",
        code: 21605,
        log_level: "ERROR",
        last_updated: "2018-08-13T21:07:57.000+0000",
        message: "Maximum body length is 160 characters (old API endpoint)",
        secondary_message: "You are using the deprecated /SMS/Messages API endpoint, which supports up to 160 characters per message. To send up to 1600 characters per message, switch to our upgraded /Messages endpoint.",
        product: "Programmable SMS",
    },
    {
        date_created: "2016-03-31T17:14:03.000+0000",
        const_partition: "1",
        docs: "## Error - 21604\n\n### 'To' phone number is required to send a Message\n\nMake sure to specify a valid phone number as the recipient of the message.\n\n",
        code: 21604,
        log_level: "error",
        last_updated: "2016-03-31T17:14:03.000+0000",
        message: "The destination 'To' phone number is required to send an SMS",
        secondary_message: "Make sure to specify a valid phone number as the recipient of the SMS.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:03.000+0000",
        const_partition: "1",
        docs: "## Error - 21603\n\n### 'From' phone number is required to send a Message \n\nMake sure to specify a valid [Twilio Number](/user/account/phone-numbers/) as\nthe 'From' number in your outgoing messages.\n\t\n",
        code: 21603,
        log_level: "error",
        last_updated: "2016-03-31T17:14:03.000+0000",
        message: "The source 'From' phone number is required to send an SMS",
        secondary_message: "Make sure to specify a valid Twilio-provided IncomingPhoneNumber as the From in your outgoing SMSes.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:02.000+0000",
        solutions: " Retry your message including a body or a link to some media. For sample code that shows how to send an SMS message with Twilio's supported helper libraries, cURL, or the Twilio CLI, please see [this short tutorial](https://www.twilio.com/docs/sms/send-messages)",
        causes: "You may have attempted to send a message without a `Body` or `MediaURL` parameter.",
        description: "The `Body` OR `MediaURL` parameter is required to send a Message with Twilio.",
        const_partition: "1",
        docs: "## ERROR - 21602\r\n\r\n### Message body is required\r\n\r\nYou must specify content (text or media) for your message. The `Body` OR `MediaURL` parameter is required to send a Message with Twilio.\r\n\r\n#### Possible Causes\r\nYou may have attempted to send a message without a `Body` or `MediaURL` parameter.\r\n\r\n#### Possible Solutions\r\n Retry your message including a body or a link to some media. For sample code that shows how to send an SMS message with Twilio's supported helper libraries, cURL, or the Twilio CLI, please see [this short tutorial](https://www.twilio.com/docs/sms/send-messages)",
        code: 21602,
        log_level: "ERROR",
        last_updated: "2019-08-14T18:38:01.000+0000",
        message: "Message body is required",
        log_type: "APPLICATION",
        secondary_message: "You must specify content (text or media) for your message.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:02.000+0000",
        const_partition: "1",
        docs: "## Error - 21504 \n\n### RecordingSid is required.\n\nYou POSTed to the /Accounts/{AccountSid}/Transcriptions resource, but you did not include a RecordingSid.\n\n\n\n\n\n",
        code: 21504,
        log_level: "error",
        last_updated: "2016-03-31T17:14:02.000+0000",
        message: "RecordingSid is required.",
        secondary_message: "You POSTed to the /Accounts/{AccountSid}/Transcriptions resource, but you did not include a RecordingSid.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:02.000+0000",
        const_partition: "1",
        docs: '## Error - 21503 \n\n### Invalid transcription type\n\nThe transcription value you provided is invalid.  You may use one of: "true" or "false".\n\n\n\n\n\n',
        code: 21503,
        log_level: "error",
        last_updated: "2016-03-31T17:14:02.000+0000",
        message: "Invalid transcription type",
        secondary_message: "The transcription type you provided is not a valid choice.  You may use one of: fast, accurate or all.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:02.000+0000",
        const_partition: "1",
        docs: "## Error - 21502 \n\n### Invalid callback url\n\nThe callback url provided is not a valid URL.\n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n\n\n",
        code: 21502,
        log_level: "error",
        last_updated: "2016-03-31T17:14:02.000+0000",
        message: "Invalid callback url",
        secondary_message: "The callback url provided is not a valid URL.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:01.000+0000",
        const_partition: "1",
        docs: "## Error - 21501 \n\n### Resource not available\n\nThe resource you requested is not (yet) available.\n\n#### Possible Causes \n*  Most likely you're fetching a Recording resource that is temporarily performing some post-processing, and will be available momentarily.\n\n\n#### Possible Solutions\n*  Retry the HTTP request again.  The Retry-After header will tell you when to retry.  Within a couple seconds should be ample.\t\n\n\n\n\n",
        code: 21501,
        log_level: "error",
        last_updated: "2016-03-31T17:14:01.000+0000",
        message: "Resource not available",
        secondary_message: "The resource you requested is not (yet) available.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:01.000+0000",
        const_partition: "1",
        docs: "## Error - 21456 \n\n### Invalid CallbackUrl\n\nThe callback URL given to callback after validation isn't a valid URL.\n\n#### Possible Causes \n\n\n\n\n\n\n",
        code: 21456,
        log_level: "error",
        last_updated: "2016-03-31T17:14:01.000+0000",
        message: "Invalid CallbackUrl",
        secondary_message: "CallbackUrl must be a valid URL using the HTTP or HTTPS protol.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:01.000+0000",
        const_partition: "1",
        docs: "## Error - 21455 \n\n### Invalid PlayUrl\n\nThe URL given to play during validation isn't a valid URL.\n\n#### Possible Causes \n\n",
        code: 21455,
        log_level: "error",
        last_updated: "2016-03-31T17:14:01.000+0000",
        message: "Invalid PlayUrl",
        secondary_message: "PlayUrl must be a valid URL using the HTTP or HTTPS protocol.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:00.000+0000",
        const_partition: "1",
        docs: "## Error - 21454 \n\n### Invalid CallDelay\n\nCall delay specified must be an integer between 0 and 60, specifying the number of seconds to delay before initiating the validation call.\n\n#### Possible Causes \n*  Make sure to enter an integer between 0 and 60.\n\n\n\n\n\n",
        code: 21454,
        log_level: "error",
        last_updated: "2016-03-31T17:14:00.000+0000",
        message: "Invalid CallDelay",
        secondary_message: "Call delay specified must be an integer between 0 and 60, specifying the number of seconds to delay before initiating the validation call.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:00.000+0000",
        const_partition: "1",
        docs: "## Error - 21453 \n\n### Phone number already verified for another account\n\nYou attempted to verify your phone number to activate your Twilio Free Trial Account, but that phone number is already associated with another Free Trial Account.  You can only open one Free Trial Account per phone number.\n\n\n\n\n\n",
        code: 21453,
        log_level: "error",
        last_updated: "2016-03-31T17:14:00.000+0000",
        message: "Phone number already validated on another account",
        secondary_message: "You attempted to validate your phone number to activate your Twilio Free Trial Account, but that phone number is already associated with another Free Trial Account.  You can only open one Free Trial Account per phone number.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:00.000+0000",
        const_partition: "1",
        docs: "## Error - 21452 \n\n### No phone numbers found in area code\n\nYou attempted to get a phone number for your account, but Twilio couldn't find any numbers in the area you specified.  You may try again with a different <span class='rest-attribute'>AreaCode</span> or contact us to request a number in a certain area.  We can usually accommodate such requests within a few days.\n\n\n\n\n\n",
        code: 21452,
        log_level: "error",
        last_updated: "2016-03-31T17:14:00.000+0000",
        message: "No phone numbers found in area code",
        secondary_message: "You attempted to get a phone number for your account, but Twilio couldn't find any numbers in the area you specified.  You may try again with a different <span class='rest-attribute'>AreaCode</span> or contact us to request a number in a certain area.  We can usually accommodate such requests within a few days.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:14:00.000+0000",
        const_partition: "1",
        docs: "## Error - 21451 \n\n### Invalid area code\n\nYou attempted to get a phone number for your account, but the <span class='rest-attribute'>AreaCode</span> parameter you specified was not a valid North American area code.  <span class='rest-attribute'>AreaCode</span> is optional, and for Local phone numbers, may be any US or Canadian area code, or for TollFree numbers, may be one of 800,888,877 or 866.\n\n\n\n\n\n",
        code: 21451,
        log_level: "error",
        last_updated: "2016-03-31T17:14:00.000+0000",
        message: "Invalid area code",
        secondary_message: "You attempted to get a phone number for your account, but the <span class='rest-attribute'>AreaCode</span> parameter you specified was not a valid North American area code.  <span class='rest-attribute'>AreaCode</span> is optional, and for Local phone numbers, may be any US or Canadian area code, or for TollFree numbers, may be one of 800,888,877 or 866.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:59.000+0000",
        const_partition: "1",
        docs: "## Error - 21450\n\n### Phone number already verified for your account\n\nYou attempted to verify a phone number for your account, but that number is\nalready verified for your account.\n",
        code: 21450,
        log_level: "error",
        last_updated: "2016-03-31T17:13:59.000+0000",
        message: "Phone number already validated on your account",
        secondary_message: "You attempted to add an Outgoing Caller ID to your account, but that number is already verified as an Outgoing Caller ID on your account.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:59.000+0000",
        const_partition: "1",
        docs: "## Error - 21409\n\n### VoiceCallerIdLookup cannot be set for this phone number\n\nYou attempted to set the VoiceCallerIdLookup for a phone number using the REST API, but the number does not support this feature.\n",
        code: 21409,
        log_level: "error",
        last_updated: "2016-03-31T17:13:59.000+0000",
        message: "VoiceCallerIdLookup cannot be set for this phone number",
        secondary_message: "You attempted to set the VoiceCallerIdLookup for a phone number using the REST API, but the number does not support this feature.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:59.000+0000",
        const_partition: "1",
        docs: "## Error - 21404\n\n### Inbound phone numbers not available to trial accounts\n\nPurchasing phone numbers is a feature that is only available for upgraded\naccounts. Please upgrade to a Full Twilio Account in order to purchase numbers.\n\nYou can upgrade from the [billing section](/user/billing) of your account\nportal. \n",
        code: 21404,
        log_level: "error",
        last_updated: "2016-03-31T17:13:59.000+0000",
        message: "Inbound Phone number not available to trial account",
        secondary_message: "You attempted to get a phone number using the REST API, but your Twilio Free Trial Account does not support having your own phone number.  Please upgrade to a Full Twilio Account in order to enable this feature.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:59.000+0000",
        const_partition: "1",
        docs: "## Error - 21403 \n\n### Invalid Method\n\nYou attempted to update the HTTP method that Twilio uses when somebody calls your phone number, but the <span class='rest-attribute'>Method</span> you supplied was not valid.  Valid <span class='rest-attribute'>Method</span> values are GET or POST.\n\n\n\n\n\n",
        code: 21403,
        log_level: "error",
        last_updated: "2016-03-31T17:13:59.000+0000",
        message: "Invalid Method",
        secondary_message: "You attempted to update the HTTP method that Twilio uses when somebody calls your phone number, but the <span class='rest-attribute'>Method</span> you supplied was not valid.  Valid <span class='rest-attribute'>Method</span> values are GET or POST.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:58.000+0000",
        const_partition: "1",
        docs: "## Error - 21402 \n\n### Invalid URL\n\nYou attempted to update the URL handler associated with a phone number, but the URL you specified was not valid. \n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n",
        code: 21402,
        log_level: "error",
        last_updated: "2016-03-31T17:13:58.000+0000",
        message: "Invalid Url",
        secondary_message: "You attempted to update the URL handler associated with a phone number, but the URL you specified was not valid.  You must specify a valid URL, beginning with http or https, such as http://mycompany.com/callHandler",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:58.000+0000",
        const_partition: "1",
        docs: "## Error - 21401\n\n### Invalid Phone Number\n\nThe phone number you specified was not a valid SMS-enabled phone number or alphanumeric sender ID.\n\nIf a phone number was used, this number must be one you have purchased from or ported to Twilio in [E.164 format][e164].\n\nAlphanumeric sender IDs can only be used with [accepted characters][alpha-sender-id] when messaging [countries where this feature is supported][alphanumeric-countries].\n\n[e164]: http://en.wikipedia.org/wiki/E.164\n[alphanumeric-countries]: /help/faq/sms/what-countries-does-twilio-support-alphanumeric-sender-id\n[alpha-sender-id]: /docs/api/rest/sending-messages#alpha-sender-id",
        code: 21401,
        log_level: "error",
        last_updated: "2016-03-31T17:13:58.000+0000",
        message: "Invalid Phone Number",
        secondary_message: 'The phone number you specified was not a valid North American (US or Canadian) number.  Twilio accepts only 10 digit US domestic and Canadian phone numbers, with or without a leading "1" or "+1", with any combination of character separators.  For example, these are all valid: 415-867-5309, 4158675309, +1 (415) 867 5309.',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:58.000+0000",
        const_partition: "1",
        docs: "## Error - 21213 \n\n### 'From' phone number is required\n\nYou attempted to initiate an outbound phone call, but you forgot to include a\n'From' parameter. The 'From' parameter is required, and tells Twilio what Caller\nID to use for the phone call.\n\n\n\n\n\n",
        code: 21213,
        log_level: "error",
        last_updated: "2016-03-31T17:13:58.000+0000",
        message: "Caller phone number is required",
        secondary_message: "You attempted to initiate an outbound phone call, but you forgot to send a <span class='rest-attribute'>Caller</span> parameter.  <span class='rest-attribute'>Caller</span> is required, and tells Twilio what Caller ID to use for the phone call.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:57.000+0000",
        solutions: "Inspect the `From` number:\r\n* Format the number using  [E.164\r\nformat](https://www.twilio.com/docs/glossary/what-e164)\r\n* If the `From` address is an [alphanumeric sender ID](https://www.twilio.com/docs/glossary/what-alphanumeric-sender-id), make sure that the country where you're sending your message supports this feature by looking at [the list of supported countries](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n* Double-check that your `From` number is assigned and not on the do-not-originate (DNO) list.",
        causes: 'Twilio accepts phone numbers in [E.164\r\nformat](https://www.twilio.com/docs/glossary/what-e164) (i.e. "+1 format"), 10-digit US\r\nand Canadian numbers with any combination of non-digit separators, or up to 11 alphanumeric characters [a-zA-Z0-9]. The number must not be on the do-not-originate (DNO) list.',
        description: "You attempted to initiate an outbound phone call or message, but the 'From' parameter\r\nyou supplied was not a valid phone number or alphanumeric sender ID.",
        const_partition: "1",
        docs: "## ERROR - 21212\r\n\r\n### Invalid From Number (caller ID)\r\n\r\n You attempted to initiate an outbound phone call or message, but the 'From' parameter\r\nyou supplied was not a valid phone number or alphanumeric sender ID.\r\n\r\n#### Possible Causes\r\nTwilio accepts phone numbers in [E.164\r\nformat](https://www.twilio.com/docs/glossary/what-e164) (i.e. \"+1 format\"), 10-digit US\r\nand Canadian numbers with any combination of non-digit separators, or up to 11 alphanumeric characters [a-zA-Z0-9]. The number must not be on the do-not-originate (DNO) list.\r\n\r\n#### Possible Solutions\r\nInspect the `From` number:\r\n* Format the number using  [E.164\r\nformat](https://www.twilio.com/docs/glossary/what-e164)\r\n* If the `From` address is an [alphanumeric sender ID](https://www.twilio.com/docs/glossary/what-alphanumeric-sender-id), make sure that the country where you're sending your message supports this feature by looking at [the list of supported countries](https://support.twilio.com/hc/en-us/articles/223133767-International-support-for-Alphanumeric-Sender-ID).\r\n* Double-check that your `From` number is assigned and not on the do-not-originate (DNO) list.",
        code: 21212,
        log_level: "ERROR",
        last_updated: "2019-12-18T01:01:05.000+0000",
        message: "Invalid From Number (caller ID)",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:57.000+0000",
        const_partition: "1",
        docs: "## Error - 21211 \r\n\r\n### Invalid 'To' Phone Number\r\n\r\nYou attempted to initiate an outbound phone call, but the `To` phone number you\r\nsupplied was not a valid phone number. \r\n\r\nTwilio accepts phone numbers in [E164\r\nformat](https://www.twilio.com/docs/glossary/what-e164): `[+] [country code] [subscriber number including area code]`\r\n\r\nYou can find a full list of country codes for phone numbers on [this Wikipedia page](https://en.wikipedia.org/wiki/List_of_country_calling_codes#Alphabetical_listing_by_country_or_region).\r\n",
        code: 21211,
        log_level: "ERROR",
        last_updated: "2018-09-06T16:39:03.000+0000",
        message: "Invalid Called Phone Number",
        secondary_message: 'You attempted to initiate an outbound phone call, but the <span class=\'rest-attribute\'>Called</span> phone number you supplied was not a valid phone number.  Twilio accepts only 10 digit US domestic and Canadian phone numbers, with or without a leading "1" or "+1", with any combination of character separators.  For example, these are all valid: 415-867-5309, 4158675309, +1 (415) 867 5309.',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:56.000+0000",
        solutions: " [phone number verification on Console](https://www.twilio.com/console/phone-numbers/verified)",
        causes: "The From number used to make outbound call not a Twilio number or not a verified caller ID",
        description: "You attempted to initiate an outbound phone call, but the\r\n'From' number you specified is not a verified\r\nnumber for your account. In order to use a phone number as the Caller ID on\r\noutgoing calls, you must first verify your ownership of that phone number.\r\n\r\nYou can verify phone numbers in the Console [here](https://www.twilio.com/console/phone-numbers/verified).\r\n\r\n### Test Credentials\r\n\r\nIf you received this error while trying to authenticate with your Test\r\nCredentials, you probably tried to make a test call with a `From` number from\r\nyour live account. The only number that can be used to queue `successful`\r\ncalls with your Test Credentials is `+15005550006`. For more information,\r\nread our documentation on [the `From` number for making calls with your test\r\ncredentials][from-test-credentials].\r\n\r\n[from-test-credentials]: /docs/api/rest/test-credentials#test-calls-parameters-From\r\n",
        const_partition: "1",
        docs: "## ERROR - 21210\r\n\r\n### 'From' phone number not verified\r\n\r\n You attempted to initiate an outbound phone call, but the\r\n'From' number you specified is not a verified\r\nnumber for your account. In order to use a phone number as the Caller ID on\r\noutgoing calls, you must first verify your ownership of that phone number.\r\n\r\nYou can verify phone numbers in the Console [here](https://www.twilio.com/console/phone-numbers/verified).\r\n\r\n### Test Credentials\r\n\r\nIf you received this error while trying to authenticate with your Test\r\nCredentials, you probably tried to make a test call with a `From` number from\r\nyour live account. The only number that can be used to queue `successful`\r\ncalls with your Test Credentials is `+15005550006`. For more information,\r\nread our documentation on [the `From` number for making calls with your test\r\ncredentials][from-test-credentials].\r\n\r\n[from-test-credentials]: /docs/api/rest/test-credentials#test-calls-parameters-From\r\n\r\n\r\n#### Possible Causes\r\nThe From number used to make outbound call not a Twilio number or not a verified caller ID\r\n\r\n#### Possible Solutions\r\n [phone number verification on Console](https://www.twilio.com/console/phone-numbers/verified)",
        code: 21210,
        log_level: "ERROR",
        last_updated: "2019-08-16T18:33:15.000+0000",
        message: "'From' phone number not verified",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:56.000+0000",
        const_partition: "1",
        docs: "## Error - 21209 \n\n### Invalid Method\n\nYou attempted to initiate an outbound phone call, but you sent a <span class='rest-attribute'>Method</span> parameter that was invalid.  <span class='rest-attribute'>Method</span> specifies what HTTP method Twilio should use in contacting your web server.  Possible values are GET and POST.\n\n\n\n\n\n",
        code: 21209,
        log_level: "error",
        last_updated: "2016-03-31T17:13:56.000+0000",
        message: "Invalid Method",
        secondary_message: "You attempted to initiate an outbound phone call, but you sent a <span class='rest-attribute'>Method</span> paramter that was invalid.  <span class='rest-attribute'>Method</span> specifies what HTTP method Twilio should use in contacting your web server.  Possible values are GET and POST.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:55.000+0000",
        const_partition: "1",
        docs: "## Error - 21208 \n\n### Invalid Timeout\n\nYou attempted to initiate an outbound phone call, but you sent an invalid <span class='rest-attribute'>Timeout</span> parameter. The timeout specifes how long Twilio should let the phone ring before giving up, and is useful if you want to have Twilio hangup before an answering machine picks up. You may specify any positive, whole integer for the <span class='rest-attribute'>Timeout</span> parameter.\n\n",
        code: 21208,
        log_level: "error",
        last_updated: "2016-03-31T17:13:55.000+0000",
        message: "Invalid Timeout",
        secondary_message: "You attempted to initiate an outbound phone call, but you sent an invalid <span class='rest-attribute'>Timeout</span> parameter.  The timeoutspecifes how long Twilio should let the phone ring before giving up, and is useful if you want to have Twilio hangup before an answering machine picks up.  You may specify any positive, whole integer for the <span class='rest-attribute'>Timeout</span> parameter.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:55.000+0000",
        const_partition: "1",
        docs: '## Error - 21207 \n\n### Invalid IfMachine\n\nYou attempted to initiate an outbound phone call, but you sent an invalid <span class=\'rest-attribute\'>IfMachine</span> parameter.  Twilio can determine if an answering machine or voicemail has answered the call, and behave differently if it has.  Valid options for <span class=\'rest-attribute\'>IfMachine</span> are "Continue" (continue with the call, progressing after the beep), "Hangup" (immediately hangup the call) or "False" (don\'t determine if a machine has answered).\n\n\n\n\n\n',
        code: 21207,
        log_level: "error",
        last_updated: "2016-03-31T17:13:55.000+0000",
        message: "Invalid IfMachine",
        secondary_message: 'You attempted to initiate an outbound phone call, but you sent an invalid <span class=\'rest-attribute\'>IfMachine</span> parameter.  Twilio can determine if an answering machine or voicemail has answered the call, and behave differently if it has.  Valid options for <span class=\'rest-attribute\'>IfMachine</span> are "Continue" (continue with the call, progressing after the beep), "Hangup" (immediately hangup the call) or "False" (don\'t determine if a machine has answered).',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:54.000+0000",
        const_partition: "1",
        docs: "## Error - 21206 \n\n### Invalid SendDigits\n\nYou attempted to initiate an outbound phone call, and you included a <span class='rest-attribute'>SendDigits</span> parameter that wasn't valid. <span class='rest-attribute'>SendDigits</span> is optional, and specifies that Twilio should simulate sending keypad digits when the party answers.  It is useful for navigating a phone tree, reaching an extension or entering a password in a voicemail system.  <span class='rest-attribute'>SendDigits</span> may contain numbers, the # and * characters, as well as the \"w\" character to \"wait\" for half a second.\n\n\n\n\n\n",
        code: 21206,
        log_level: "error",
        last_updated: "2016-03-31T17:13:54.000+0000",
        message: "Invalid SendDigits",
        secondary_message: "You attempted to initiate an outbound phone call, and you included a <span class='rest-attribute'>SendDigits</span> parameter that wasn't valid. <span class='rest-attribute'>SendDigits</span> is optional, and specifies that Twilio should simulate sending keypad digits when the party answers.  It is useful for navigating a phone tree, reaching an extension or entering a password in a voicemail system.  <span class='rest-attribute'>SendDigits</span> may contain numbers, the # and * characters, as well as the \"w\" character to \"wait\" for half a second.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:54.000+0000",
        const_partition: "1",
        docs: "## Error - 21205\n\n### Invalid URL\n\nYou attempted to initiate an outbound phone call, but the URL you specified to\nhandle the call was not a valid URL.\n\nIf you specified an Application Sid for your outbound phone call, the\napplication must have a valid VoiceUrl or the call will fail.\n\n#### Possible Solutions\n\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n",
        code: 21205,
        log_level: "error",
        last_updated: "2016-03-31T17:13:54.000+0000",
        message: "Invalid URL",
        secondary_message: "You attempted to initiate an outbound phone call, but the URL you specified to handle the call was not a valid URL.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:54.000+0000",
        const_partition: "1",
        docs: "## Error - 21204 \n\n### Call already initiated\n\nYou should never receive this error\n\n\n\n\n\n",
        code: 21204,
        log_level: "error",
        last_updated: "2016-03-31T17:13:54.000+0000",
        message: "Call already initiated",
        secondary_message: "You should never receive this error",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:54.000+0000",
        const_partition: "1",
        docs: "## Error - 21203 \n\n### International calling not enabled\n\nYou attempted to initiate an outbound phone call to an international phone number, which is not currently supported.\n\n\n\n\n\n",
        code: 21203,
        log_level: "error",
        last_updated: "2016-03-31T17:13:54.000+0000",
        message: "International calling not enabled",
        secondary_message: "You attempted to initiate an outbound phone call to an international phone number, which is not currently supported.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:53.000+0000",
        const_partition: "1",
        docs: "## Error - 21202 \n\n### 'To' number is a premium number\n\nYou attempted to initiate an outbound phone call to a \"premium\" phone number, such as a toll 976 line.\n",
        code: 21202,
        log_level: "error",
        last_updated: "2016-03-31T17:13:53.000+0000",
        message: "Called number is a premium number",
        secondary_message: 'You attempted to initiate an outboud phone call to a "premium" phone number, such as a toll 976 line.',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:53.000+0000",
        const_partition: "1",
        docs: "## Error - 21201 \n\n### No 'To' number specified\n\nYou attempted to initiate an outbound phone call, but you did not specify what number to call in the 'To' POST parameter\n",
        code: 21201,
        log_level: "error",
        last_updated: "2016-03-31T17:13:53.000+0000",
        message: "No Called number specified",
        secondary_message: "You attempted to initiate an outbound phone call, but you did not specify what number to call in the <span class='rest-attribute'>Called</span> POST parameter",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:53.000+0000",
        const_partition: "1",
        docs: "## Error - 21200 \n\n### Calls Resource\n\nErrors related to the Calls resource\n\n\n\n\n\n",
        code: 21200,
        log_level: "error",
        last_updated: "2016-03-31T17:13:53.000+0000",
        message: "Calls Resource",
        secondary_message: "Errors related to the Calls resource",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:52.000+0000",
        const_partition: "1",
        docs: null,
        code: 21101,
        log_level: "error",
        last_updated: "2016-03-31T17:13:52.000+0000",
        message: "Subaccounts cannot contain subaccounts",
        secondary_message: "A subaccount cannot contain nested subaccounts.  Only a root account may contain subaccounts.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:52.000+0000",
        const_partition: "1",
        docs: "## Error - 21100 \n\n### Accounts Resource\n\nErrors related to the Accounts resource\n\n\n\n\n\n",
        code: 21100,
        log_level: "error",
        last_updated: "2016-03-31T17:13:52.000+0000",
        message: "Accounts Resource",
        secondary_message: "Errors related to the Accounts resource",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:52.000+0000",
        const_partition: "1",
        docs: "# Error - 20429\n\n## Too Many Requests\n\nYour account is sending too many concurrent requests to the Twilio API. Please\nwait for a short period of time and make the request again, or alter your\nclient's settings to issue fewer concurrent requests to the Twilio API.\n\nTwilio Support can provide advice for architecting your application to avoid\n429 errors. For more information, [contact support](/help/contact).\n\nA 429 request is never processed and is always safe to retry.\n",
        code: 20429,
        log_level: "error",
        last_updated: "2016-03-31T17:13:52.000+0000",
        message: "Too Many Requests",
        secondary_message: "Your account is sending too many concurrent requests to the Twilio API. Please wait for a short period of time and make the request again, or alter your client's settings to issue fewer concurrent requests to the Twilio API. Twilio Support can provide advice for architecting your application to avoid 429 errors. For more information, contact support. A 429 request is never processed and is always safe to retry.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:52.000+0000",
        const_partition: "1",
        docs: "## Error - 20005 \n\n### Account not active\n\nYour Twilio account is not active, potentially because you ran out of funds, or you have not yet activated your free trial.\n",
        code: 20005,
        log_level: "error",
        last_updated: "2016-03-31T17:13:52.000+0000",
        message: "Account not active",
        secondary_message: "Your Twilio account is not active, potentially because you ran out of funds, or you have not yet activated your free trial.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:51.000+0000",
        const_partition: "1",
        docs: "## Error - 20004 \n\n### Method not allowed\n\nThe resource you accessed is valid, but the HTTP method you attempted to use is not supported for the resource.  For example, you cannot DELETE your own account.\n\n\n\n\n\n",
        code: 20004,
        log_level: "error",
        last_updated: "2016-03-31T17:13:51.000+0000",
        message: "Method not allowed",
        secondary_message: "The resource you accessed is valid, but the HTTP method you attempted to use is not supported for the resource.  For example, you cannot DELETE your own account.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:51.000+0000",
        solutions: "* Verify the Account SID and Auth Token are correct\r\n* Verify the correct Account is being accessed\r\n* Ensure the Account is active, not suspended or closed\r\n* Ensure no extra characters or spaces are being included\r\n* Ensure JWT is only used with API Key",
        causes: "* Using the wrong combination of Account SID and Auth Token \r\n* Using Test Credentials to access your Live Account\r\n* Using subaccount credentials to access master account\r\n* Previous Auth Token has been deleted\r\n* Attempted API Key has been deleted\r\n* Account is suspended or closed\r\n* Extra characters or spaces in the supplied credentials\r\n* Web proxy is stripping out credentials before forwarding to Twilio\r\n* Using JWT with Auth Token rather than API Key",
        description: "\r\n#### Authenticating requests to the Twilio API\r\n\r\nAll requests to sensitive areas of the Twilio API must use [HTTP Basic\r\nAuthentication][auth]. Authenticate using your Account SID as the username,\r\nand your Auth Token as the password. Both can be found in the [Twilio\r\nConsole](/console/account/settings).\r\n\r\nYou can also generate revocable [API Keys](/docs/api/rest/keys) to authenticate.\r\n\r\nYou may want to consider using a [Twilio helper library](/docs/libraries)\r\n(available in PHP, .NET, Java, Ruby, Python and Node.js) as they will take care of\r\nauthentication for you.\r\n\r\n[auth]: http://en.wikipedia.org/wiki/Basic_access_authentication",
        const_partition: "1",
        docs: "## ERROR - 20003\r\n\r\n### Permission Denied\r\n\r\nYou lack permission to the resource and method you requested. \r\n#### Authenticating requests to the Twilio API\r\n\r\nAll requests to sensitive areas of the Twilio API must use [HTTP Basic\r\nAuthentication][auth]. Authenticate using your Account SID as the username,\r\nand your Auth Token as the password. Both can be found in the [Twilio\r\nConsole](/console/account/settings).\r\n\r\nYou can also generate revocable [API Keys](/docs/api/rest/keys) to authenticate.\r\n\r\nYou may want to consider using a [Twilio helper library](/docs/libraries)\r\n(available in PHP, .NET, Java, Ruby, Python and Node.js) as they will take care of\r\nauthentication for you.\r\n\r\n[auth]: http://en.wikipedia.org/wiki/Basic_access_authentication\r\n\r\n#### Possible Causes\r\n* Using the wrong combination of Account SID and Auth Token \r\n* Using Test Credentials to access your Live Account\r\n* Using subaccount credentials to access master account\r\n* Previous Auth Token has been deleted\r\n* Attempted API Key has been deleted\r\n* Account is suspended or closed\r\n* Extra characters or spaces in the supplied credentials\r\n* Web proxy is stripping out credentials before forwarding to Twilio\r\n* Using JWT with Auth Token rather than API Key\r\n\r\n#### Possible Solutions\r\n* Verify the Account SID and Auth Token are correct\r\n* Verify the correct Account is being accessed\r\n* Ensure the Account is active, not suspended or closed\r\n* Ensure no extra characters or spaces are being included\r\n* Ensure JWT is only used with API Key",
        code: 20003,
        log_level: "ERROR",
        last_updated: "2019-07-24T23:21:52.000+0000",
        message: "Permission Denied",
        log_type: "APPLICATION",
        secondary_message: "You lack permission to the resource and method you requested.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:51.000+0000",
        const_partition: "1",
        docs: '## Error - 20002 \n\n### Invalid FriendlyName\n\nMany Twilio resources take descriptive names to help you remember what they are.  However, such "FriendlyNames" must be between 1 and 64 characters long.\n\n\n\n\n\n',
        code: 20002,
        log_level: "error",
        last_updated: "2016-03-31T17:13:51.000+0000",
        message: "Invalid FriendlyName",
        secondary_message: 'Many Twilio resources take descriptive names to help you remember what they are.  However, such "FriendlyNames" must be between 1 and 64 characters long.',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:50.000+0000",
        const_partition: "1",
        docs: "## Warning - 20001 \n\n### Unknown parameters\n\nOne or more parameters you sent the REST API were not recognized and were ignored.  No harm done, but make sure that you didn't mis-type the parameter you really wanted to send.\n\n\n\n\n\n",
        code: 20001,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:50.000+0000",
        message: "Unknown parameters",
        secondary_message: "One or more parameters you sent the REST API were not recognized and were ignored.  No harm done, but make sure that you didn't mis-type the parameter you really wanted to send.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:50.000+0000",
        const_partition: "1",
        docs: "## Warning - 14111\n\n### Invalid To phone number for Trial mode\n\n'To' field must be a validated caller ID while in Trial mode\n",
        code: 14111,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:50.000+0000",
        message: "Invalid To phone number for Trial mode",
        secondary_message: "To field must be a validated caller ID while in Trial mode",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:50.000+0000",
        const_partition: "1",
        docs: "## Warning - 14110 \n\n### Invalid Verb for Message Reply\n\nAn Invalid Verb has been passed back in a Message reply.  Valid Verbs are Message, Sms and Redirect\n\n",
        code: 14110,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:50.000+0000",
        message: "Invalid Verb for SMS Reply",
        secondary_message: "An Invalid Verb has been passed back in an SMS reply.  Valid Verbs are Sms and Redirect",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:50.000+0000",
        const_partition: "1",
        docs: "## Warning - 14109 \n\n### Message Reply message limit exceeded\n\nToo many messages have been sent in reply to an incoming message. The current is 10\n\n\n\n\n",
        code: 14109,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:50.000+0000",
        message: "SMS Reply message limit exceeded",
        secondary_message: "Too many messages have been sent in reply to an incoming message. The current is 10",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:49.000+0000",
        const_partition: "1",
        docs: '## Warning - 14108 \n\n### Message "From" Phone Number not message capable\n\nThe From phone number does not appear to be a phone number that you can Message from\n\n#### Possible Causes \n*  Sending from a number that is not SMS or MMS capable\n\n\n#### Possible Solutions\n*  Check to make sure the number is correct\n*  Check to make sure the number is an SMS or MMS capable Twilio Incoming number assigned to your account\n',
        code: 14108,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:49.000+0000",
        message: "From phone number not SMS capable",
        secondary_message: "The From phone number does not appear to be a phone number that you can SMS from",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:49.000+0000",
        solutions: "*  make certain any action or Redirect URL's do not loop back to the same TwiML document.\r\n*  make sure you are not inadvertently sending a large quantity of messages to the same phone number, e.g. a script caught in a loop",
        causes: "*  repeated rapid responses by the end user (less than 15 seconds)\r\n*  infinite loop caused by self referencing Sms or Message verb action URL\r\n*  infinite loop caused by self referencing Redirect verb URL\r\n*  runaway process making repeated outgoing REST API requests",
        description: '\r\nA counter is set for each outbound TwiML reply in a conversation (between two numbers). When the first reply occurs, the counter starts at 1. If the next reply is sent less than 15 seconds after the prior reply, then the counter goes to 2. This will continue if each reply is less than 15 seconds, until the counter surpasses 20; at this time, Twilio will set any further messages in the loop to "failed" status for 30 seconds, with this error code. Messages with the "failed" status are not charged against your account balance.\r\n',
        const_partition: "1",
        docs: '## ERROR - 14107\r\n\r\n### SMS send rate limit exceeded\r\n\r\nToo many messages have been sent between two numbers within a short time period, possibly indicating a runaway job or infinite loop. There is a limit of 20 outbound replies between two phone numbers in a short period. \r\nA counter is set for each outbound TwiML reply in a conversation (between two numbers). When the first reply occurs, the counter starts at 1. If the next reply is sent less than 15 seconds after the prior reply, then the counter goes to 2. This will continue if each reply is less than 15 seconds, until the counter surpasses 20; at this time, Twilio will set any further messages in the loop to "failed" status for 30 seconds, with this error code. Messages with the "failed" status are not charged against your account balance.\r\n\r\n\r\n#### Possible Causes\r\n*  repeated rapid responses by the end user (less than 15 seconds)\r\n*  infinite loop caused by self referencing Sms or Message verb action URL\r\n*  infinite loop caused by self referencing Redirect verb URL\r\n*  runaway process making repeated outgoing REST API requests\r\n\r\n#### Possible Solutions\r\n*  make certain any action or Redirect URL\'s do not loop back to the same TwiML document.\r\n*  make sure you are not inadvertently sending a large quantity of messages to the same phone number, e.g. a script caught in a loop',
        code: 14107,
        log_level: "ERROR",
        last_updated: "2019-07-22T15:47:38.000+0000",
        message: "SMS send rate limit exceeded",
        log_type: "APPLICATION",
        secondary_message: "Too many messages have been sent between two numbers within a short time period, possibly indicating a runaway job or infinite loop. There is a limit of 20 outbound replies between two phone numbers in a short period.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:49.000+0000",
        const_partition: "1",
        docs: "## Warning - 14106 \n\n### Message Reply TwiML document retrieval limit reached\n\nYour Message Reply session has requested too many documents. The limit is 50\n\n#### Possible Causes \n*  infinite loop caused by self referencing Message verb action URL\n*  infinite loop caused by self referencing Redirect verb URL\n\n#### Possible Solutions\n*  make certain any action or Redirect URLs do not loop back to the same TwiML document.\n",
        code: 14106,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:49.000+0000",
        message: "Document retrieval limit reached",
        secondary_message: "Your SMS Reply session has requested too many documents. The limit is 50",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:48.000+0000",
        const_partition: "1",
        docs: "## Warning - 14105 \n\n### Message statusCallback attribute Invalid\n\nThe Message Verb's statusCallback attribute must be a valid URL\n\n",
        code: 14105,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:48.000+0000",
        message: "Invalid statusCallback attribute",
        secondary_message: "The Sms Verb's statusCallback attribute must be a valid URL",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:48.000+0000",
        const_partition: "1",
        docs: '## Warning - 14104 \n\n### Message method attribute invalid\n\nMethod attribute may only be "GET" or "POST"\n\n',
        code: 14104,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:48.000+0000",
        message: "Invalid Method attribute",
        secondary_message: 'method attribute may only be "GET" or "POST"',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:48.000+0000",
        const_partition: "1",
        docs: "## Warning - 14103 \n\n### Message Invalid Body\n\nThe Message body does not contain valid text or a media URL\n\n#### Possible Causes \n*  Empty SMS body with no media URL specified\n*  SMS Body exceeding 1600 characters \n\n\n#### Possible Solutions\n*  Make sure you're not sending a blank message\n*  Make sure the text of the message you are sending is 1600 characters or less.\n\n",
        code: 14103,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:48.000+0000",
        message: "Invalid Body",
        secondary_message: "The SMS body does not contain valid text",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:48.000+0000",
        const_partition: "1",
        docs: '## Warning - 14102 \n\n### Message "From" Attribute is Invalid\n\nThe From phone number does not appear to be a phone number that you can message from\n\n#### Possible Causes \n*  Using a \u2018From\u2019 number that is not assigned to your account\n*  Using a \u2018From\u2019 number that is not SMS/MMS enabled\n\n\n#### Possible Solutions\n*  Check to make sure the number is correct\n*  Check to make sure the number is an SMS/MMS enabled Twilio Incoming number assigned to your account\n\n',
        code: 14102,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:48.000+0000",
        message: 'Invalid "From" attribute',
        secondary_message: "The From phone number does not appear to be a phone number that you can SMS from",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:47.000+0000",
        const_partition: "1",
        docs: '## Warning - 14101 \n\n### "To" Attribute is Invalid\n\nThe To attribute does not appear to be a phone number that you can SMS\n\n#### Possible Causes \n*  Invalid formatted number\n*  SMSing an un-validated number while using a Trial Account\n\n\n#### Possible Solutions\n*  Check the number and make sure it is a valid 10 digit domestic phone number  \n*  Confirm you have validated this number, if you are still using a Trial account, or upgrade your account\n*  Contact Twilio <a href="/help/contact">customer support</a> to inquire further.\n',
        code: 14101,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:47.000+0000",
        message: 'Invalid "To" attribute',
        secondary_message: "The To attribute does not appear to be a phone number that you can SMS",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:47.000+0000",
        const_partition: "1",
        docs: "## Warning - 13910 \n\n### Pause: Invalid length value\n\nThe length attribute must be a positive integer, in seconds. See the <a href='/docs/api/twiml/pause#length'>Pause Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13910,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:47.000+0000",
        message: "Pause: Invalid length value",
        secondary_message: "The length attribute must be a positive integer, in seconds. See the <a href='/docs/api/twiml/pause#length'>Pause Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:47.000+0000",
        const_partition: "1",
        docs: "## Warning - 13710 \n\n### Redirect: Invalid method value\n\nThe method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/redirect#method'>Redirect Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13710,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:47.000+0000",
        message: "Redirect: Invalid method value",
        secondary_message: "The method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/redirect#method'>Redirect Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:46.000+0000",
        const_partition: "1",
        docs: "## Warning - 13618\n\n### Record: Recording not available for transcription\n\n#### Possible Causes \n* The recording was deleted before before Twilio was able to fetch the recording for transcription.\n\n#### Possible Solutions\n* Make a request to delete the recording once you receive the transcribe callback instead of the record callback. This ensures that the recording is available for Twilio to transcribe and still allows you to delete recordings from Twilio.\n",
        code: 13618,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:46.000+0000",
        message: "Record: Recording not available for transcription",
        secondary_message: "The recording was not available when Twilio fetched the recording for transcription",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:46.000+0000",
        const_partition: "1",
        docs: "## Warning - 13617\n\n### Record: Recording length is out of range for transcription\n\nTwilio could not process the transcription because the duration of the recording is either too short or too long. The recording itself will not be affected. \n\n\n#### Possible Solutions\n*  Transcription is currently limited to recordings with a duration greater than 2 seconds and less than 120 seconds. Consider using the maxLength parameter for `<Record>` to limit the duration of the recording. See <a href='/docs/api/twiml/record#attributes-transcribe'>transcription TwiML reference</a> for more information. \n\n",
        code: 13617,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:46.000+0000",
        message: "Record: Recording length is out of range for transcription",
        secondary_message: "Twilio could not process the transcription because the duration of the recording is either too short or too long. The recording itself will not be affected.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:45.000+0000",
        const_partition: "1",
        docs: "## Warning - 13615 \n\n### Record: transcribeCallback URL is invalid\n\nThe transcribeCallback URL provided in the `<Record>` verb is not valid.\n\n\n#### Possible Solutions\nMake sure you submit a fully qualified URL including:\n\n*   protocol (http:// or https://)\n*   hostname\n*   file path\n*   properly url-encoded query parameters\n\nTwilio must be able to reach this URL over the public Internet.\n \t\n\n\n\n\n",
        code: 13615,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:45.000+0000",
        message: "Record: maxLength too high for transcription",
        secondary_message: "If maxLength must be less than or equal to 120 seconds (2 minutes) if transcribe or transcribeCallback attributes are specified, otherwise transcription is disabled.  See the <a href='/docs/api/twiml/record#transcribe'>Record Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:45.000+0000",
        const_partition: "1",
        docs: "## Warning - 13614 \n\n### Record: Invalid transcribe value\n\nThe transcribe attribute of Record must be TRUE or FALSE. See the <a href='/docs/api/twiml/record#transcribe'>Record Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13614,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:45.000+0000",
        message: "Record: Invalid transcribe value",
        secondary_message: "The transcribe attribute of Record must be FAST or ACCURATE. See the <a href='/docs/api/twiml/record#transcribe'>Record Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:45.000+0000",
        const_partition: "1",
        docs: "## Warning - 13613 \n\n### Record: Invalid finishOnKey value\n\nThe value of the finishOnKey attribute must be one of the following characters \"0123456789#*\".  See the <a href='/docs/api/twiml/record#maxLength'>Record Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13613,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:45.000+0000",
        message: "Record: Invalid finishOnKey value",
        secondary_message: "The value of the finishOnKey attribute must be one of the following characters \"0123456789#*\".  See the <a href='/docs/api/twiml/record#maxLength'>Record Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:44.000+0000",
        const_partition: "1",
        docs: "## Warning - 13612 \n\n### Record: Invalid maxLength value\n\nThe maxLength attribute must be a positive integer in seconds. See the <a href='/docs/api/twiml/record#maxLength'>Record Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13612,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:44.000+0000",
        message: "Record: Invalid maxLength value",
        secondary_message: "The maxLength attribute must be a positive integer in seconds. See the <a href='/docs/api/twiml/record#maxLength'>Record Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:44.000+0000",
        const_partition: "1",
        docs: "## Warning - 13611 \n\n### Record: Invalid timeout value\n\ntimeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/record#timeout'>Record Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13611,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:44.000+0000",
        message: "Record: Invalid timeout value",
        secondary_message: "timeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/record#timeout'>Record Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:44.000+0000",
        const_partition: "1",
        docs: "## Warning - 13610 \n\n### Record: Invalid method value\n\nThe method attribute of Record must be GET or POST. See the <a href='/docs/api/twiml/record#method'>Record Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13610,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:44.000+0000",
        message: "Record: Invalid method value",
        secondary_message: "The method attribute of Record must be GET or POST. See the <a href='/docs/api/twiml/record#method'>Record Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:43.000+0000",
        const_partition: "1",
        docs: null,
        code: 13521,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:43.000+0000",
        message: "Say element cannot exceed 4096 characters",
        secondary_message: "The maximum text length inside a Say verb is 4096 characters",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:43.000+0000",
        const_partition: "1",
        docs: "## Warning - 13520 \n\n### Say: Invalid text\n\nThe text of the Say verb was empty or un-parsable. See the <a href='/docs/api/twiml/say'>Say Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13520,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:43.000+0000",
        message: "Say: Invalid text",
        secondary_message: "The text of the Say verb was empty or un-parsable. See the <a href='/docs/api/twiml/say'>Say Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:43.000+0000",
        const_partition: "1",
        docs: null,
        code: 13512,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:43.000+0000",
        message: 'Gather element has an invalid "lang" parameter',
        secondary_message: 'A Gather element cannot have a "lang" parameter setting',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:43.000+0000",
        const_partition: "1",
        docs: '## Warning - 13511 \n\n### Say: Invalid voice value\n\nThe value of the voice attribute must be "man" or "woman". See the <a href=\'/docs/api/twiml/say#voice\'>Say Verb</a> API Reference for more information.\n\n\n\n\n\n',
        code: 13511,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:43.000+0000",
        message: "Say: Invalid voice value",
        secondary_message: 'The value of the voice attribute must be "man" or "woman". See the <a href=\'/docs/api/twiml/say#voice\'>Say Verb</a> API Reference for more information.',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:42.000+0000",
        const_partition: "1",
        docs: "## Warning - 13510 \n\n### Say: Invalid loop value\n\nThe value of the loop attribute must be an integer greater or equal to zero. See the <a href='/docs/api/twiml/say#loop'>Play Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13510,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:42.000+0000",
        message: "Say: Invalid loop value",
        secondary_message: "The value of the loop attribute must be an integer greater or equal to zero. See the <a href='/docs/api/twiml/say#loop'>Play Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:42.000+0000",
        const_partition: "1",
        docs: "## Error - 13420 \n\n### Play: Invalid Content-Type\n\nPlay requires an audio Content-Type\n\n#### Possible Causes \n*  Play references a URL that does not return audio or is returning an invalid Content-Type.\n\n\n#### Possible Solutions\n*  Make certain the URL returns an audio file\t\n*   See the <a href='/docs/api/twiml/play'>Play Verb</a> API Reference for more information on valid Content-Types.\t\n\n\n\n\n",
        code: 13420,
        log_level: "error",
        last_updated: "2016-03-31T17:13:42.000+0000",
        message: "Play: Invalid Content-Type",
        secondary_message: "Play requires an audio Content-Type",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:42.000+0000",
        const_partition: "1",
        docs: "## Warning - 13410 \n\n### Play: Invalid loop value\n\nThe value of the loop attribute must be an integer greater or equal to zero. See the <a href='/docs/api/twiml/play#loop'>Play Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13410,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:42.000+0000",
        message: "Play: Invalid loop value",
        secondary_message: "The value of the loop attribute must be an integer greater or equal to zero. See the <a href='/docs/api/twiml/play#loop'>Play Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:42.000+0000",
        const_partition: "1",
        docs: "## Error - 13325 \n\n### Gather->Play: Invalid Content-Type\n\nPlay requires an audio Content-Type\n\n#### Possible Causes \n*  Play references a URL that does not return audio or is returning an invalid Content-Type.\n\n\n#### Possible Solutions\n*  Make certain the URL returns an audio file\t\n*   See the <a href='/docs/api/twiml/play'>Play Verb</a> API Reference for more information on valid Content-Types.\t\n\n\n\n\n",
        code: 13325,
        log_level: "error",
        last_updated: "2016-03-31T17:13:42.000+0000",
        message: "Gather->Play: Invalid Content-Type",
        secondary_message: "Play requires an audio Content-Type",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:41.000+0000",
        const_partition: "1",
        docs: "## Warning - 13322 \n\n### Gather->Say: Invalid loop value\n\nThe value of the loop attribute must be an integer greater or equal to zero.  See the <a href='/docs/api/twiml/say#loop'>Say Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13322,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:41.000+0000",
        message: "Gather->Say: Invalid loop value",
        secondary_message: "The value of the loop attribute must be an integer greater or equal to zero.  See the <a href='/docs/api/twiml/say#loop'>Say Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:41.000+0000",
        const_partition: "1",
        docs: '## Warning - 13321 \n\n### Gather->Say: Invalid voice value\n\nThe value of the voice attribute must be "man" or "woman". See the <a href=\'/docs/api/twiml/say#voice\'>Say Verb</a> API Reference for more information.\n\n\n\n\n\n',
        code: 13321,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:41.000+0000",
        message: "Gather->Say: Invalid voice value",
        secondary_message: 'The value of the voice attribute must be "man" or "woman". See the <a href=\'/docs/api/twiml/say#voice\'>Say Verb</a> API Reference for more information.',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:41.000+0000",
        const_partition: "1",
        docs: "## Warning - 13320 \n\n### Gather: Invalid nested verb\n\nThe only valid nested elements of the Gather Verb are Say and Play. See the <a href='/docs/api/twiml/gather'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13320,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:41.000+0000",
        message: "Gather: Invalid nested verb",
        secondary_message: "The only valid nested elements of the Gather Verb are Say and Play. See the <a href='/docs/api/twiml/gather'>Gather Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:41.000+0000",
        const_partition: "1",
        docs: "## Warning - 13314 \n\n### Gather: Invalid numDigits value\n\nThe numDigits attribute must be a positive integer. See the <a href='/docs/api/twiml/gather#numDigits'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13314,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:41.000+0000",
        message: "Gather: Invalid numDigits value",
        secondary_message: "The numDigits attribute must be a positive integer. See the <a href='/docs/api/twiml/gather#numDigits'>Gather Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:40.000+0000",
        const_partition: "1",
        docs: "## Warning - 13313 \n\n### Gather: Invalid timeout value\n\ntimeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/gather#timeout'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13313,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:40.000+0000",
        message: "Gather: Invalid timeout value",
        secondary_message: "timeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/gather#timeout'>Gather Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:40.000+0000",
        const_partition: "1",
        docs: "## Warning - 13312 \n\n### Gather: Invalid method value\n\nThe method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/gather#method'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13312,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:40.000+0000",
        message: "Gather: Invalid method value",
        secondary_message: "The method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/gather#method'>Gather Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:40.000+0000",
        const_partition: "1",
        docs: "## Warning - 13311 \n\n### Gather: Invalid finishOnKey value\n\nThe value of the finishOnKey attribute must be one of the following characters \"0123456789#*\". See the <a href='/docs/api/twiml/gather#finishOnKey'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13311,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:40.000+0000",
        message: "Gather: Invalid finishOnKey value",
        secondary_message: "The value of the finishOnKey attribute must be a single character. See the <a href='/docs/api/twiml/gather#finishOnKey'>Gather Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:40.000+0000",
        const_partition: "1",
        docs: "## Warning - 13310 \n\n### Gather: Invalid finishOnKey value\n\nThe value of the finishOnKey attribute must be one of the following characters \"0123456789#*\". See the <a href='/docs/api/twiml/gather#finishOnKey'>Gather Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13310,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:40.000+0000",
        message: "Gather: Invalid finishOnKey value",
        secondary_message: "The value of the finishOnKey attribute must be one of the following characters \"0123456789#*\". See the <a href='/docs/api/twiml/gather#finishOnKey'>Gather Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:39.000+0000",
        solutions: "- ",
        causes: "- ",
        description: "A feature added to the 2010 Conference API was requested via the 2008 Twilio API. Please upgrade to the latest version of the conference API.",
        const_partition: "1",
        docs: "## ERROR - 13299\r\n\r\n### 2010 Conference API feature requested using 2008 API\r\n\r\nA feature added to the 2010 Conference API was requested via the 2008 Twilio API. Please upgrade to the latest version of the conference API. A feature added to the 2010 Conference API was requested via the 2008 Twilio API. Please upgrade to the latest version of the conference API.\r\n\r\n#### Possible Causes\r\n- \r\n\r\n#### Possible Solutions\r\n- ",
        code: 13299,
        log_level: "ERROR",
        last_updated: "2019-07-22T18:04:02.000+0000",
        message: "2010 Conference API feature requested using 2008 API",
        log_type: "APPLICATION",
        secondary_message: "A feature added to the 2010 Conference API was requested via the 2008 Twilio API. Please upgrade to the latest version of the conference API.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:39.000+0000",
        const_partition: "1",
        docs: "## Warning - 13244 \n\n### Dial: No SIP Authorization\n\nYour account is not authorized to make SIP calls\n\n\n\n\n\n",
        code: 13244,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:39.000+0000",
        message: "Dial: No SIP Authorization",
        secondary_message: "Your account is not authorized to make SIP calls",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:39.000+0000",
        const_partition: "1",
        docs: "## Warning - 13243 \n\n### Dial->SIP: Invalid SIP URI\n\nThe provided SIP URI is not formatted properly.\n\n\n\n\n\n",
        code: 13243,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:39.000+0000",
        message: "Dial->SIP: Invalid SIP URI",
        secondary_message: "The provided SIP URI is not formatted properly.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:38.000+0000",
        const_partition: "1",
        docs: '## Warning - 13242 \n\n### Dial->SIP: Invalid sendDigits value\n\nsendDigits attribute may only contain the following characters "0123456789*#w"\n\n\n\n\n\n',
        code: 13242,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:38.000+0000",
        message: "Dial->SIP: Invalid sendDigits value",
        secondary_message: 'sendDigits attribute may only contain the following characters "0123456789*#w"',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:38.000+0000",
        const_partition: "1",
        docs: "## Warning - 13241 \n\n### Dial->SIP: Invalid method value\n\nThe method attribute of Number must be GET or POST\n\n\n\n\n\n",
        code: 13241,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:38.000+0000",
        message: "Dial->SIP: Invalid method value",
        secondary_message: "The method attribute of Number must be GET or POST",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:38.000+0000",
        const_partition: "1",
        docs: "## Error - 13238\n\n### Dial->Conference: Invalid verb for waitUrl TwiML\n\nThe TwiML that executes via the waitUrl can only contain Say, Play, and Redirect verbs.  Dial, Gather, and Record are not allowed. \n\n",
        code: 13238,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:38.000+0000",
        message: "Dial->Conference: Invalid Verb used in waitUrl TwiML",
        secondary_message: "placeholder",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:38.000+0000",
        const_partition: "1",
        docs: "## Error - 13237\n\n### Dial->Conference: Invalid conference name \n\nThe conference name you attempted to Dial is invalid.  Conference names must be between 1 and 128 characters. \n",
        code: 13237,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:38.000+0000",
        message: "Dial->Conference: Invalid Conference Name",
        secondary_message: "placeholder",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:37.000+0000",
        const_partition: "1",
        docs: "## Error - 13236\n\n### Dial->Conference: Invalid Conference Sid value\n\nYou attempted to dial a Conference Sid that does not exist or has already been completed. \n",
        code: 13236,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:37.000+0000",
        message: "Dial->Conference: Invalid Conference Sid",
        secondary_message: "placeholder",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:37.000+0000",
        const_partition: "1",
        docs: '## Warning - 13235\n\n### Dial->Conference: Invalid beep value\n\nbeep must be either "true" or false".\n',
        code: 13235,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:37.000+0000",
        message: "Dial->Conference: Invalid beep value",
        secondary_message: "placeholder",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:37.000+0000",
        const_partition: "1",
        docs: "## Warning - 13234\n\n### Dial->Conference: Invalid waitMethod value\n\nwaitMethod must be either GET or POST\n",
        code: 13234,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:37.000+0000",
        message: "Dial->Conference: Invalid waitMethod",
        secondary_message: "placeholder",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:36.000+0000",
        const_partition: "1",
        docs: '## Error - 13233\n\n### Dial->Conference: Invalid waitUrl value\n\nwaitUrl must be either a well formed URL or the empty string ""\n',
        code: 13233,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:36.000+0000",
        message: "Dial->Conference: Invalid waitUrl",
        secondary_message: "placeholder",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:36.000+0000",
        const_partition: "1",
        docs: '## Warning - 13232\n\n### Dial->Conference: Invalid startConferenceOnEnter value\n\nstartConferenceOnEnter must be either "true" or false".\n',
        code: 13232,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:36.000+0000",
        message: "Dial->Conference: Invalid startConferenceOnEnter value",
        secondary_message: "placeholder",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:36.000+0000",
        const_partition: "1",
        docs: '## Error - 13231\r\n\r\n### Dial->Conference: Invalid endConferenceOnExit value\r\n\r\nendConferenceOnExit must be either "true" or false".\r\n',
        code: 13231,
        log_level: "ERROR",
        last_updated: "2017-09-07T19:25:41.000+0000",
        message: "Dial->Conference: Invalid endConferenceOnExit value",
        secondary_message: "placeholder",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:35.000+0000",
        const_partition: "1",
        docs: '## Warning - 13230 \n\n### Dial->Conference: Invalid muted value\n\nmuted must be either "true" or false".\n',
        code: 13230,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:35.000+0000",
        message: "Dial->Conference: Invalid muted value",
        secondary_message: "placeholder",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:35.000+0000",
        solutions: "Please check your [Voice Dialing Geographic Permissions](https://www.twilio.com/console/voice/calls/geo-permissions), fix it, and try\r\nagain.",
        causes: "User dialed a destination your application is not enabled to support calling to.\r\n\r\nUser misdialed a destination.",
        description: "You attempted to initiate an outbound phone call to a phone number that is not enabled on your account.",
        const_partition: "1",
        docs: "## ERROR - 13227\r\n\r\n### Geo Permission configuration is not permitting call\r\n\r\n You attempted to initiate an outbound phone call to a phone number that is not enabled on your account.\r\n\r\n#### Possible Causes\r\nUser dialed a destination your application is not enabled to support calling to.\r\n\r\nUser misdialed a destination.\r\n\r\n#### Possible Solutions\r\nPlease check your [Voice Dialing Geographic Permissions](https://www.twilio.com/console/voice/calls/geo-permissions), fix it, and try\r\nagain.",
        code: 13227,
        log_level: "ERROR",
        last_updated: "2019-11-25T08:26:37.000+0000",
        message: "Geo Permission configuration is not permitting call",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:35.000+0000",
        const_partition: "1",
        docs: "## Warning - 13226 \n\n### Dial: Invalid country code\n\nThe country code of the provided phone number is unknown\n\n\n\n\n\n",
        code: 13226,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:35.000+0000",
        message: "Dial: Invalid country code",
        secondary_message: "The country code of the provided phone number is unknown",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:34.000+0000",
        const_partition: "1",
        docs: "## Warning - 13225 \r\n\r\n### Dial: Call blocked by Twilio blacklist\r\n\r\nThe destination number is blocked by Twilio because this destination has a high-risk of fraud or due to regulatory reasons cannot be enabled by default. If you have a legitimate need to call this number, please email help@twilio.com with an explanation of your use case.\r\n\r\n\r\n\r\n\r\n\r\n",
        code: 13225,
        log_level: "ERROR",
        last_updated: "2019-05-08T18:14:48.000+0000",
        message: "Dial: Call blocked by Twilio blacklist",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:34.000+0000",
        const_partition: "1",
        docs: "## Warning - 13224 \r\n\r\n### Dial: Twilio does not support calling this number or the number is invalid\r\n\r\nThis error occurs when the provided number is not in E.164 format; for example using local dialing pattern 01234567890 instead of the full E.164 address +441234567890. This can also occur when calls are attempted to non-existent country codes, area codes, or exchanges. For example, there is no +693 country code, no +1238 US area code, and no 555 US exchange.\r\n\r\nThis can also occur with properly-formatted, valid destinations if none of Twilio\u2019s carrier partners are able to deliver the call; for example a telecom network outage in the phone number\u2019s local area.",
        code: 13224,
        log_level: "ERROR",
        last_updated: "2017-08-09T20:31:11.000+0000",
        message: "Dial: Twilio does not support calling this number or the number is invalid",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:34.000+0000",
        const_partition: "1",
        docs: "## Warning - 13223 \n\n### Dial: Invalid phone number format\n\nPhone Numbers must be in the format XXXXXXXXXX, or 1XXXXXXXXXX, +1international\n\n\n\n\n\n",
        code: 13223,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:34.000+0000",
        message: "Dial: Invalid phone number format",
        secondary_message: "Phone Numbers must be in the format XXXXXXXXXX, or 1XXXXXXXXXX, +1international",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:34.000+0000",
        const_partition: "1",
        docs: "## Warning - 13222 \n\n### Dial->Number: Invalid sendDigits value\n\nsendDigits attribute may only contain the following characters \"0123456789*#w\". See the <a href='/docs/api/twiml/dial'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13222,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:34.000+0000",
        message: "Dial->Number: Invalid sendDigits value",
        secondary_message: "sendDigits attribute may only contain the following characters \"0123456789*#w\". See the <a href='/docs/api/twiml/dial'>Dial Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:33.000+0000",
        const_partition: "1",
        docs: "## Warning - 13221 \n\n### Dial->Number: Invalid method value\n\nThe method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/dial'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13221,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:33.000+0000",
        message: "Dial->Number: Invalid method value",
        secondary_message: "The method attribute of Number must be GET or POST. See the <a href='/docs/api/twiml/dial'>Dial Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:33.000+0000",
        const_partition: "1",
        docs: '## Warning - 13217 \n\n### Dial: Invalid record value\n\nrecord must be "true" or "false".\n\n',
        code: 13217,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:33.000+0000",
        message: "Dial: Invalid record value",
        secondary_message: 'record must be "true" or "false".',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:33.000+0000",
        const_partition: "1",
        docs: "## Warning - 13216 \n\n### Dial: Invalid timeLimit value\n\ntimeLimit must be a positive integer, in seconds. See the <a href='/docs/api/twiml/dial#timeLimit'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13216,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:33.000+0000",
        message: "Dial: Invalid timeLimit value",
        secondary_message: "timeLimit must be a positive integer, in seconds. See the <a href='/docs/api/twiml/dial#timeLimit'>Dial Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:33.000+0000",
        const_partition: "1",
        docs: "## Warning - 13215 \n\n### Dial: Invalid nested element\n\nThe only valid nested element for Dial is Number. See the <a href='/docs/api/twiml/dial'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13215,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:33.000+0000",
        message: "Dial: Invalid nested element",
        secondary_message: "The only valid nested element for Dial is Number. See the <a href='/docs/api/twiml/dial'>Dial Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:32.000+0000",
        const_partition: "1",
        docs: "## Warning - 13214 \n\n### Dial: Invalid callerId value\n\ncallerId must be the calling number, called number, or a validated outgoing number.  Additionally,\nif the calling leg is a client leg, the caller ID is required and must be a validated outgoing number. \nSee the <a href='/docs/api/twiml/dial#callerId'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13214,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:32.000+0000",
        message: "Dial: Invalid callerId value",
        secondary_message: "callerId must be the calling number, called number, or a validated outgoing number. See the <a href='/docs/api/twiml/dial#callerId'>Dial Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:32.000+0000",
        const_partition: "1",
        docs: '## Warning - 13213 \n\n### Dial: Invalid hangupOnStar value\n\nhangupOnStar must be "true" or "false". See the <a href=\'/docs/api/twiml/dial#hangupOnStar\'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n',
        code: 13213,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:32.000+0000",
        message: "Dial: Invalid hangupOnStar value",
        secondary_message: 'hangupOnStar must be "true" or "false". See the <a href=\'/docs/api/twiml/dial#hangupOnStar\'>Dial Verb</a> API Reference for more information.',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:32.000+0000",
        const_partition: "1",
        docs: "## Warning - 13212 \n\n### Dial: Invalid timeout value\n\ntimeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/dial#timeout'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13212,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:32.000+0000",
        message: "Dial: Invalid timeout value",
        secondary_message: "timeout must be a positive integer, in seconds.  See the <a href='/docs/api/twiml/dial#timeout'>Dial Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:31.000+0000",
        const_partition: "1",
        docs: '## Warning - 13211 \n\n### Dial: Invalid ifMachine value\n\nifMachine must be either "hangup","continue", or "false".\n\n\n\n\n\n',
        code: 13211,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:31.000+0000",
        message: "Dial: Invalid ifMachine value",
        secondary_message: 'ifMachine must be either "hangup","continue", or "false".',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:31.000+0000",
        const_partition: "1",
        docs: "## Warning - 13210 \n\n### Dial: Invalid method value\n\nYou have provided an invalid value for the \"method\" attribute.  Valid values are GET or POST.  See the <a href='/docs/api/twiml/dial#method'>Dial Verb</a> API Reference for more information.\n\n\n\n\n\n",
        code: 13210,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:31.000+0000",
        message: "Dial: Invalid method value",
        secondary_message: "You have provided an invalid value for the \"method\" attribute.  Valid values are GET or POST.  See the <a href='/docs/api/twiml/dial#method'>Dial Verb</a> API Reference for more information.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:31.000+0000",
        const_partition: "1",
        docs: "## Error - 13201 \n\n### Dial: Cannot Dial out from a Dial Call Segment\n\nTwiML documents that execute on the called party's end (via the Dial->Number URL attribute, before the parties are bridged) cannot issue a new Dial.\n\n\n\n\n\n",
        code: 13201,
        log_level: "error",
        last_updated: "2016-03-31T17:13:31.000+0000",
        message: "Dial: Cannot Dial out from a Dial Call Segment",
        secondary_message: "TwiML documents that execute on the called party's end (via the Dial->Number url attribute, before the parties are bridged) cannot issue a new Dial.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:31.000+0000",
        const_partition: "1",
        docs: "## Error - 13120 \n\n### Annotate->BillingReferenceTag cannot be over 128 characters\n\nBillingReferenceTag cannot be over 128 characters\n\n\n\n\n\n",
        code: 13120,
        log_level: "error",
        last_updated: "2016-03-31T17:13:31.000+0000",
        message: "Annotate->BillingReferenceTag cannot be over 128 characters",
        secondary_message: "BillingReferenceTag cannot be over 128 characters",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:30.000+0000",
        const_partition: "1",
        docs: "## Warning - 13112 \n\n### Annotate: Invalid nested element\n\nYou may only nest BillingReferenceTag elements in Annotate\n\n\n\n\n\n",
        code: 13112,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:30.000+0000",
        message: "Annotate: Invalid nested element",
        secondary_message: "You may only nest BillingReferenceTag elements in Annotate",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:30.000+0000",
        const_partition: "1",
        docs: "## Error - 13111 \n\n### Annotate: Annotate must contain only one of element X\n\nAnnotate must contain only one of element X\n\n\n\n\n\n",
        code: 13111,
        log_level: "error",
        last_updated: "2016-03-31T17:13:30.000+0000",
        message: "Annotate: Annotate must contain only one of element X",
        secondary_message: "Annotate must contain only one of element X",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:30.000+0000",
        const_partition: "1",
        docs: "## Error - 13110 \n\n### Annotate: Annotate must contain one valid nested element\n\nAnnotate must contain one valid nested element\n\n\n\n\n\n",
        code: 13110,
        log_level: "error",
        last_updated: "2016-03-31T17:13:30.000+0000",
        message: "Annotate: Annotate must contain one valid nested element",
        secondary_message: "Annotate must contain one valid nested element",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:30.000+0000",
        const_partition: "1",
        docs: null,
        code: 13000,
        log_level: "warning",
        last_updated: "2016-03-31T17:13:30.000+0000",
        message: "Conference Noun cannot be mixed with Number nouns",
        secondary_message: "The Conference noun can only be used once inside a Dial verb",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:29.000+0000",
        const_partition: "1",
        docs: '## Error - 12400 \r\n\r\n### Internal Failure\r\n\r\nAn internal error has occurred that prevented Twilio from processing your response.\r\n\r\n#### Possible Causes \r\n*  We screwed up. Sorry!\r\n\r\n\r\n#### Possible Solutions\r\n*   If the error persists, please <a href="/help/contact">contact us</a> to figure out what has happened and how to fix it.\r\n*   Note the time of the error and what you were trying to do when it occurred.\r\n\r\n\r\n\r\n\r\n',
        code: 12400,
        log_level: "ERROR",
        last_updated: "2019-01-30T17:59:06.000+0000",
        message: "Internal Failure",
        secondary_message: "An internal error has occurred that prevented Twilio from processing your response.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:29.000+0000",
        solutions: "* Verify that that your web server is returning a Content-Type and it is the expected value\r\n* Make sure the URL noted refers to a valid resource\r\n* Make sure messages to or from your Twilio phone number are using a supported content-type. See the [full list of supported content types](https://www.twilio.com/docs/sms/accepted-mime-types).\r\n* Use one of the [supported request types](https://www.twilio.com/docs/runtime/functions/request-flow#supported-requests) to call a Twilio function.",
        causes: "* Having a phone number, outgoing call request or action attribute refer to a non-XML or audio resource.\r\n* Having a Play verb attempt to play non-audio content, such as XML or text.",
        description: "You must return a Content-Type for all requests. Requests without a\r\nContent-Type will appear in the [Debugger](/console/runtime/debugger) as a\r\n502 Bad Gateway error.\r\n\r\n",
        const_partition: "1",
        docs: '## ERROR - 12300\r\n\r\n### Invalid Content-Type\r\n\r\nTwilio is unable to process the Content-Type of the provided URL. Please see Twilio\'s <a href="https://www.twilio.com/docs/sms/accepted-mime-types"> documentation on accepted content types </a> for more information on valid Content-Types. You must return a Content-Type for all requests. Requests without a\r\nContent-Type will appear in the [Debugger](/console/runtime/debugger) as a\r\n502 Bad Gateway error.\r\n\r\n\r\n\r\n#### Possible Causes\r\n* Having a phone number, outgoing call request or action attribute refer to a non-XML or audio resource.\r\n* Having a Play verb attempt to play non-audio content, such as XML or text.\r\n\r\n#### Possible Solutions\r\n* Verify that that your web server is returning a Content-Type and it is the expected value\r\n* Make sure the URL noted refers to a valid resource\r\n* Make sure messages to or from your Twilio phone number are using a supported content-type. See the [full list of supported content types](https://www.twilio.com/docs/sms/accepted-mime-types).\r\n* Use one of the [supported request types](https://www.twilio.com/docs/runtime/functions/request-flow#supported-requests) to call a Twilio function.',
        code: 12300,
        log_level: "ERROR",
        last_updated: "2019-10-29T22:22:09.000+0000",
        message: "Invalid Content-Type",
        log_type: "APPLICATION",
        secondary_message: 'Twilio is unable to process the Content-Type of the provided URL. Please see Twilio\'s <a href="https://www.twilio.com/docs/sms/accepted-mime-types"> documentation on accepted content types </a> for more information on valid Content-Types.',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:29.000+0000",
        const_partition: "1",
        docs: "## Warning - 12200 \r\n\r\n### Schema validation warning\r\n\r\nThe provided XML does not conform to the Twilio Markup XML schema.  Please refer to the specific error and correct the problem.\r\n\r\n#### Possible Causes \r\n*  misspelled verbs\r\n*   incorrect case for verbs; TwiML is case-sensitive, so &lt;Say&gt; works, but &lt;say&gt; will not\r\n*   misspelled or unknown attributes\r\n*   unknown or unexpected nested elements.\r\n\r\n\r\n#### Possible Solutions\r\n*  check the line and column reported by the warning to see what part of your XML response caused the complaint\r\n*  verify that your application server is accepting and properly responding to any [custom parameters](https://support.twilio.com/hc/en-us/articles/115011213347) you may be passing\r\n\r\n\r\n\r\n\r\n",
        code: 12200,
        log_level: "ERROR",
        last_updated: "2017-08-07T15:46:34.000+0000",
        message: "Schema validation warning",
        secondary_message: "The provided XML does not conform to the Twilio Markup XML schema.  Please refer to the specific error and correct the problem.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:28.000+0000",
        const_partition: "1",
        docs: '## Error - 12102 \n\n### The root element must be Response\n\nThe root element of a Twilio Markup XML document *must* be <a href="/docs/api/twiml/response">Response</a>\n\n\n\n\n\n',
        code: 12102,
        log_level: "error",
        last_updated: "2016-03-31T17:13:28.000+0000",
        message: "The root element must be Response",
        secondary_message: 'The root element of a Twilio Markup XML document *must* be <a href="/docs/api/twiml/response">Response</a>',
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:28.000+0000",
        const_partition: "1",
        docs: '## Error - 12101 \n\n### Invalid Twilio Markup XML version\n\nThe version attribute of the Response root element is not valid.\n\n#### Possible Causes \n*  an invalid value was provided for the "version" attribute of the <a href=\'/docs/api/twiml/response\'>Response</a> root element.\n\n\n#### Possible Solutions\n*  refer to the <a href="/docs/api/twiml/response">versions</a> documentation for information on valid version values.\t\n\n\n\n\n',
        code: 12101,
        log_level: "error",
        last_updated: "2016-03-31T17:13:28.000+0000",
        message: "Invalid Twilio Markup XML version",
        secondary_message: "The version attribute of the Response root element is not valid.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:27.000+0000",
        const_partition: "1",
        docs: '## Error - 12100\n\n### Document parse failure\n\nTwilio was unable to parse the provided XML Document.\n\nYour TwiML document must be a valid XML Document, or Twilio will not\nbe able to read your document. You can debug XML parsing errors by\ngetting the response body in the [debugger](/user/account/debugger),\nand then using an online validation tool like the\n[W3C Validation Service](http://validator.w3.org/#validate_by_input).\n\n#### Possible Causes\n*   There is a leading space, or an empty line, before the XML type header (i.e. ` <?xml version="1.0" encoding="UTF-8"?>`)\n*   The root `<Response>` element is missing\n*   There is an unclosed element\n*   There is an unquoted attribute\n*   There is an improperly nested element\n\n#### Possible Solutions\n*   Make sure there is no extra space or line at the beginning of the file before the type header\n*   Make sure your root element is &lt;Response&gt;\n*   XML is case sensitive, make sure your start and end elements match case. (Twilio elements begin with a capital letter)\n*   Make sure characters such as &lt; &gt; and &amp; are escaped properly, as `&lt; &gt; and &amp;`.\n\n[redirect]:/docs/api/twiml/redirect\n',
        code: 12100,
        log_level: "error",
        last_updated: "2016-03-31T17:13:27.000+0000",
        message: "Document parse failure",
        secondary_message: "Twilio was unable to parse the provided XML Document.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:27.000+0000",
        const_partition: "1",
        docs: "## Error - 11320 \n\n### Invalid template unclosed brackets\n\nThe provided URL template has an invalid format. Please check to see if you have unclosed brackets.\n\n\n\n\n\n",
        code: 11320,
        log_level: "error",
        last_updated: "2016-03-31T17:13:27.000+0000",
        message: "Invalid template unclosed brackets",
        secondary_message: "The provided URL template has an invalid format. Please check to see if you have unclosed brackets.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:27.000+0000",
        const_partition: "1",
        docs: "## Error - 11310 \n\n### Invalid template token\n\nThe provided URL template references a nonexistent token.\n\n\n\n\n\n",
        code: 11310,
        log_level: "error",
        last_updated: "2016-03-31T17:13:27.000+0000",
        message: "Invalid template token",
        secondary_message: "The provided URL template references a nonexistent token.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:26.000+0000",
        const_partition: "1",
        docs: "## Error - 11300 \n\n### Invalid template URL\n\nThe provided URL template has an invalid format. Please check to see if you have unclosed brackets.\n\n\n\n\n\n",
        code: 11300,
        log_level: "error",
        last_updated: "2016-03-31T17:13:26.000+0000",
        message: "Invalid template URL",
        secondary_message: "The provided URL template has an invalid format. Please check to see if you have unclosed brackets.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:26.000+0000",
        const_partition: "1",
        docs: null,
        code: 11251,
        log_level: "error",
        last_updated: "2016-03-31T17:13:26.000+0000",
        message: "Fatal protocol violation",
        secondary_message: "There was an HTTP protocol violation speaking to the target URL.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:26.000+0000",
        const_partition: "1",
        docs: "## Error - 11237\r\n\r\n### Certificate Invalid - Could not find path to certificate\r\n\r\nTwilio tried to validate your SSL certificate but was unable to find it in our certificate store.\r\n\r\n#### Possible Causes\r\n*  You are using a self signed certificate.\r\n*  The certificate authority you are using is not on our list of approved certificate authorities.\r\n* Your certificate chain is incomplete and requires an additional download.\r\n\r\n#### Possible Solutions\r\n*  Do not use a self signed certificate.\r\n* Concatenate your certificate chain so that no additional download is required.\r\n*  Twilio uses CAs that are approved by Mozilla, you can find the full list [here](https://ccadb-public.secure.force.com/mozilla/IncludedCACertificateReport).\r\n* For testing purposes you can [disable SSL Certificate Validation in Console](https://www.twilio.com/console/project/settings).\r\n",
        code: 11237,
        log_level: "ERROR",
        last_updated: "2018-08-22T20:17:29.000+0000",
        message: "Certificate Invalid - Could not find path to certificate",
        secondary_message: "Twilio tried to validate your SSL certificate but was unable to find it in our certificate store.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:25.000+0000",
        const_partition: "1",
        docs: "## Error - 11236\n\n### Certificate Invalid - Certificate Expired\n\nTwilio tried to validate your SSL certificate but your certificate has expired.\n\n#### Possible Causes\n*  Your SSL certificate has expired.\n\n#### Possible Solutions\n*  Renew your SSL certificate.\n",
        code: 11236,
        log_level: "error",
        last_updated: "2016-03-31T17:13:25.000+0000",
        message: "Certificate Invalid - Certificate Expired",
        secondary_message: "Twilio tried to validate your SSL certificate but your certificate has expired.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:25.000+0000",
        const_partition: "1",
        docs: "## Error - 11235\n\n### Certificate Invalid - Domain Mismatch\n\nTwilio tried to validate your SSL certificate but your certificate has a domain name that does not match the domain we requested.\n\n#### Possible Causes\n*  Your Certificate Name or Certificate Alternate Name on your SSL certificate does not match the domain Twilio requested.\n\n\n#### Possible Solutions\n*  Obtain a SSL certificate with a Certificate Name or Certificate Alternate Name that matches this domain.\n",
        code: 11235,
        log_level: "error",
        last_updated: "2016-03-31T17:13:25.000+0000",
        message: "Certificate Invalid - Domain Mismatch",
        secondary_message: "Twilio tried to validate your SSL certificate but your certificate has a domain name that does not match the domain we requested.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:25.000+0000",
        const_partition: "1",
        docs: "## Error - 11220\r\n\r\n### SSL/TLS Handshake Error\r\n\r\nDuring SSL/TLS negotiation, Twilio experienced a connection reset.\r\n\r\n#### Possible Causes\r\n*  Incompatible cipher suites in use by the client and the server. This would require the client to use (or enable) a cipher suite that is supported by the server.\r\n\r\n\r\n#### Possible Solutions\r\n*  Verify cipher suites in-use are up to date. Twilio-supported ciphers can be found [here](https://support.twilio.com/hc/en-us/articles/360002288554)\r\n*  Use compatible version of TLS, Twilio supports TLS 1.0,1.1,1.2.",
        code: 11220,
        log_level: "ERROR",
        last_updated: "2018-03-23T06:06:07.000+0000",
        message: "SSL/TLS Handshake Error",
        secondary_message: "During SSL/TLS negotiation, Twilio experienced a connection reset.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:25.000+0000",
        const_partition: "1",
        docs: "## Error - 11215 \n\n### HTTP too many redirects\n\nthis request has been redirected too many times and may be in a loop.\n\n#### Possible Causes \n*  Twilio received too many HTTP redirect messages in a row for this request.\n\n\n#### Possible Solutions\n*  Make certain your code is not stuck in an infinite loop.\n\n",
        code: 11215,
        log_level: "error",
        last_updated: "2016-03-31T17:13:25.000+0000",
        message: "HTTP too many redirects",
        secondary_message: "this request has been redirected too many times and may be in a loop.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:24.000+0000",
        solutions: "* Verify the hostname of the URL has a valid DNS record the can be resolved by the public",
        causes: "*  URL references a locally defined hostname (/etc/hosts)\r\n*  URL references an undefined hostname",
        description: "The DNS entry for the URL's host cannot be resolved.\r\n",
        const_partition: "1",
        docs: "## ERROR - 11210\r\n\r\n### HTTP bad host name\r\n\r\n The DNS entry for the URL's host cannot be resolved.\r\n\r\n\r\n#### Possible Causes\r\n*  URL references a locally defined hostname (/etc/hosts)\r\n*  URL references an undefined hostname\r\n\r\n#### Possible Solutions\r\n* Verify the hostname of the URL has a valid DNS record the can be resolved by the public",
        code: 11210,
        log_level: "ERROR",
        last_updated: "2020-01-11T00:24:26.000+0000",
        message: "HTTP bad host name",
        log_type: "APPLICATION",
        secondary_message: null,
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:24.000+0000",
        const_partition: "1",
        docs: "## Error - 11206 \n\n### HTTP protocol violation\n\nThere was an error speaking HTTP to the target URL.\n\n#### Possible Causes \n*  Server misconfiguration\n*   Network disruption\n*   Making HTTP connections to an HTTPS port\n\n\n#### Possible Solutions\n*  verify your web server is serving valid HTTP for the URL\t\n*   verify the network connection to your server is stable\t\n*   verify the URL is not directing you to an SSL port\t\n\n\n\n\n",
        code: 11206,
        log_level: "error",
        last_updated: "2016-03-31T17:13:24.000+0000",
        message: "HTTP protocol violation",
        secondary_message: "There was an error speaking HTTP to the target URL.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:23.000+0000",
        const_partition: "1",
        docs: "## Error - 11205 \r\n\r\n### HTTP connection failure\r\n\r\nThere was a network failure attempting to connect to this URL. Twilio will try for 10 seconds to establish a TCP connection to your URL (two 5 second attempts). Twilio will wait for a total of 15 seconds to receive an HTTP response, this includes the TCP connection time, so if it took six seconds to establish a TCP connection, your server would have 9 seconds to deliver an HTTP response. If either of those timers expire we fail the request, fire a notification, and try your Fallback URL, if one is specified.\r\n\r\n#### Possible Causes \r\n*  network outages between Twilio and your web server\r\n*  URLs that reference private IP addresses or localhost\r\n*  Twilio's TCP timeout is 10 seconds; so if you see an error in Request Inspector after > 10000 milliseconds Twilio could locate your server, but could not establish a TCP connection with it. \r\n*  Twilio's HTTP timeout is 15 seconds; if you see an error in Request Inspector returned after > 15000 milliseconds, Twilio was able to establish a TCP connection with your server, but the HTTP response from the server failed.\r\n\r\n\r\n#### Possible Solutions\r\n*  verify the URL provided is accessible to the public internet\t\r\n*  verify network connectivity to your web server\r\n*  check your TCP logs to verify inbound connection attempts are successful\r\n*  check HTTP server logs to verify a response was generated and returned within the timeout\r\n*  check your edge element logs to verify responses are making it out of your infrastructure",
        code: 11205,
        log_level: "ERROR",
        last_updated: "2017-12-12T21:52:28.000+0000",
        message: "HTTP connection failure",
        secondary_message: "There was a network failure attempting to connect to this URL",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:23.000+0000",
        solutions: "* Double check that your TwiML URL does not return a 4xx or 5xx error\r\n* Make certain that the URL does not perform a 302 redirect to an invalid URL\r\n* Confirm the URL requested is not protected by HTTP Auth\r\n* Make sure your web server allows HTTP POST requests to static resources (if\r\nthe URL refers to .xml or .html files)\r\n* Verify your web server is up and responsive\r\n* Check to see that the URL host is not a private or local IP address\r\n* Verify the ping times and packet loss between your web server and www.twilio.com",
        causes: "* Web server returned a 4xx or 5xx HTTP response to Twilio\r\n* Misconfigured Web Server\r\n* Network disruptions between Twilio and your web server\r\n* No Content-Type header attached to response\r\n* Content-Type doesn't match actual content, e.g. an MP3 file that is being\r\nserved with `Content-Type: audio/x-wav`, instead of `Content-Type: audio/mpeg`",
        description: "An 11200 error is an indicator of a connection failure between Twilio and your\r\nservice. When Twilio requests a page from your server, we wait a maximum of\r\n15 seconds for a response. A connection failure will occur if no response is\r\nreturned in that time.\r\n\r\nThere are many reasons a connection timeout can occur; common causes are long\r\nrunning database queries or outside processes and calls to external systems\r\ntaking a long time to return. It may be possible your application experienced\r\none of these issues. If you are encountering this error only intermittently, it\r\nis possible that your web server was temporarily unavailable or experiencing a\r\nnetwork outage.\r\n\r\n### 502 Bad Gateway errors\r\n\r\nIf your [debugger](/user/account/debugger) is reporting a 502 Bad\r\nGateway error, this may mean that Twilio\u2019s internal server had trouble\r\nretrieving content from your website. Your request must contain a\r\n[Content-Type](/docs/errors/12300) that is valid. Twilio may also have had\r\nproblems resolving your DNS name to an IP address, or issues with the network\r\nconnection. Check that your web server is started, and is available over the\r\npublic Internet.",
        const_partition: "1",
        docs: "## ERROR - 11200\r\n\r\n### HTTP retrieval failure\r\n\r\nThere was a failure attempting to retrieve the contents of this URL. An 11200 error is an indicator of a connection failure between Twilio and your\r\nservice. When Twilio requests a page from your server, we wait a maximum of\r\n15 seconds for a response. A connection failure will occur if no response is\r\nreturned in that time.\r\n\r\nThere are many reasons a connection timeout can occur; common causes are long\r\nrunning database queries or outside processes and calls to external systems\r\ntaking a long time to return. It may be possible your application experienced\r\none of these issues. If you are encountering this error only intermittently, it\r\nis possible that your web server was temporarily unavailable or experiencing a\r\nnetwork outage.\r\n\r\n### 502 Bad Gateway errors\r\n\r\nIf your [debugger](/user/account/debugger) is reporting a 502 Bad\r\nGateway error, this may mean that Twilio\u2019s internal server had trouble\r\nretrieving content from your website. Your request must contain a\r\n[Content-Type](/docs/errors/12300) that is valid. Twilio may also have had\r\nproblems resolving your DNS name to an IP address, or issues with the network\r\nconnection. Check that your web server is started, and is available over the\r\npublic Internet.\r\n\r\n#### Possible Causes\r\n* Web server returned a 4xx or 5xx HTTP response to Twilio\r\n* Misconfigured Web Server\r\n* Network disruptions between Twilio and your web server\r\n* No Content-Type header attached to response\r\n* Content-Type doesn't match actual content, e.g. an MP3 file that is being\r\nserved with `Content-Type: audio/x-wav`, instead of `Content-Type: audio/mpeg`\r\n\r\n#### Possible Solutions\r\n* Double check that your TwiML URL does not return a 4xx or 5xx error\r\n* Make certain that the URL does not perform a 302 redirect to an invalid URL\r\n* Confirm the URL requested is not protected by HTTP Auth\r\n* Make sure your web server allows HTTP POST requests to static resources (if\r\nthe URL refers to .xml or .html files)\r\n* Verify your web server is up and responsive\r\n* Check to see that the URL host is not a private or local IP address\r\n* Verify the ping times and packet loss between your web server and www.twilio.com",
        code: 11200,
        log_level: "ERROR",
        last_updated: "2019-09-06T22:26:46.000+0000",
        message: "HTTP retrieval failure",
        log_type: "APPLICATION",
        secondary_message: "There was a failure attempting to retrieve the contents of this URL.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:23.000+0000",
        const_partition: "1",
        docs: "## Error - 11100 \r\n\r\n### Invalid URL format\r\n\r\nThe format of the provided URL is invalid.\r\n\r\n#### Possible Causes \r\n\r\n*   Bad URL for phone number configuration\r\n*   Bad URL passed to outgoing call REST request\r\n*   Bad URL in Play or Redirect Verb Body\r\n*   Bad URL provided for a verb's action attribute\r\n*   Unsupported characters in auth portion of URL\r\n\r\n\r\n#### Possible Solutions\r\n\r\nMake sure you submit a fully qualified URL including:\r\n\r\n*   protocol (http:// or https://)\r\n*   hostname\r\n*   file path\r\n*   properly url-encoded query parameters\r\n\r\nTwilio must be able to reach this URL over the public Internet.\r\n\r\n",
        code: 11100,
        log_level: "ERROR",
        last_updated: "2018-04-23T20:16:09.000+0000",
        message: "Invalid URL format",
        secondary_message: "The format of the provided URL is invalid.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:22.000+0000",
        solutions: '*  Check your account balance.  Refill funds if necessary.\t\r\n*  Contact Twilio <a href="/help/contact">customer support</a> to inquire further.',
        causes: "*  Lack of funds\r\n*  Violation of the Terms of Service or Acceptable Use Policy",
        description: null,
        const_partition: "1",
        docs: '## ERROR - 10003\r\n\r\n### Incoming call rejected due to inactive account\r\n\r\nAn incoming call was made to your application, but was not answered because your account was not active at the time. \r\n\r\n#### Possible Causes\r\n*  Lack of funds\r\n*  Violation of the Terms of Service or Acceptable Use Policy\r\n\r\n#### Possible Solutions\r\n*  Check your account balance.  Refill funds if necessary.\t\r\n*  Contact Twilio <a href="/help/contact">customer support</a> to inquire further.',
        code: 10003,
        log_level: "ERROR",
        last_updated: "2019-09-27T22:26:13.000+0000",
        message: "Incoming call rejected due to inactive account",
        log_type: "APPLICATION",
        secondary_message: "An incoming call was made to your application, but was not answered because your account was not active at the time.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:22.000+0000",
        const_partition: "1",
        docs: "## Error - 10002 \r\n\r\n### Trial account does not support this feature\r\n\r\nYour account is currently in Trial mode and does not have access to this\r\nfeature.\r\n\r\n#### Possible Causes\r\n\r\n* Attempting to use a premium feature with a trial account\r\n* Attempting to place too many verification calls in a 72 hour period\r\n\r\n\r\n#### Possible Solutions\r\n\r\n*  Upgrade to a full account to use premium features, and remove the\r\n   restrictions on verification calls per day.\r\n\r\n\r\n",
        code: 10002,
        log_level: "ERROR",
        last_updated: "2018-03-14T20:58:11.000+0000",
        message: "Trial account does not support this feature",
        secondary_message: "Your account is currently in Trial mode and does not have access to this feature.",
        product: null,
    },
    {
        date_created: "2016-03-31T17:13:21.000+0000",
        const_partition: "1",
        docs: '## Error - 10001 \r\n\r\n### Account is not active\r\n\r\nThis account has been disabled and may not be used until it is reactivated.\r\n\r\n#### Possible Causes \r\n*  Lack of funds\r\n*   Violation of the Terms of Service or Acceptable Use Policy\r\n\r\n\r\n#### Possible Solutions\r\n*  Check your account balance.  Refill funds if necessary.\t\r\n*  Contact Twilio <a href="/help/contact">customer support</a> to inquire further.\r\n\r\n\r\n\r\n\r\n',
        code: 10001,
        log_level: "ERROR",
        last_updated: "2017-06-23T16:39:03.000+0000",
        message: "Account is not active",
        secondary_message: "This account has been disabled and may not be used until it is reactived.",
        product: null,
    },
];
export default errorCodes;
